import { n as e, t } from "./rolldown-runtime-CbXtAM7H.js";
import { u as n } from "./forms-D-uIurhY.js";
var r = t(e => {
  function t(e, t) {
    var n = e.length;
    e.push(t);
    a: while (n > 0) {
      var r = n - 1 >>> 1;
      var a = e[r];
      if (i(a, t) > 0) {
        e[r] = t;
        e[n] = a;
        n = r;
      } else {
        break a;
      }
    }
  }
  function n(e) {
    if (e.length === 0) {
      return null;
    } else {
      return e[0];
    }
  }
  function r(e) {
    if (e.length === 0) {
      return null;
    }
    var t = e[0];
    var n = e.pop();
    if (n !== t) {
      e[0] = n;
      a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
        var s = (r + 1) * 2 - 1;
        var c = e[s];
        var l = s + 1;
        var u = e[l];
        if (i(c, n) < 0) {
          if (l < a && i(u, c) < 0) {
            e[r] = u;
            e[l] = n;
            r = l;
          } else {
            e[r] = c;
            e[s] = n;
            r = s;
          }
        } else if (l < a && i(u, n) < 0) {
          e[r] = u;
          e[l] = n;
          r = l;
        } else {
          break a;
        }
      }
    }
    return t;
  }
  function i(e, t) {
    var n = e.sortIndex - t.sortIndex;
    if (n === 0) {
      return e.id - t.id;
    } else {
      return n;
    }
  }
  e.unstable_now = undefined;
  if (typeof performance == `object` && typeof performance.now == `function`) {
    var a = performance;
    e.unstable_now = function () {
      return a.now();
    };
  } else {
    var o = Date;
    var s = o.now();
    e.unstable_now = function () {
      return o.now() - s;
    };
  }
  var c = [];
  var l = [];
  var u = 1;
  var d = null;
  var f = 3;
  var p = false;
  var m = false;
  var h = false;
  var g = false;
  var _ = typeof setTimeout == `function` ? setTimeout : null;
  var v = typeof clearTimeout == `function` ? clearTimeout : null;
  var y = typeof setImmediate < `u` ? setImmediate : null;
  function b(e) {
    for (var i = n(l); i !== null;) {
      if (i.callback === null) {
        r(l);
      } else if (i.startTime <= e) {
        r(l);
        i.sortIndex = i.expirationTime;
        t(c, i);
      } else {
        break;
      }
      i = n(l);
    }
  }
  function x(e) {
    h = false;
    b(e);
    if (!m) {
      if (n(c) !== null) {
        m = true;
        if (!ee) {
          ee = true;
          ae();
        }
      } else {
        var t = n(l);
        if (t !== null) {
          ce(x, t.startTime - e);
        }
      }
    }
  }
  var ee = false;
  var te = -1;
  var ne = 5;
  var re = -1;
  function ie() {
    if (g) {
      return true;
    } else {
      return !(e.unstable_now() - re < ne);
    }
  }
  function S() {
    g = false;
    if (ee) {
      var t = e.unstable_now();
      re = t;
      var i = true;
      try {
        a: {
          m = false;
          if (h) {
            h = false;
            v(te);
            te = -1;
          }
          p = true;
          var a = f;
          try {
            b: {
              b(t);
              d = n(c);
              while (d !== null && (!(d.expirationTime > t) || !ie())) {
                var o = d.callback;
                if (typeof o == `function`) {
                  d.callback = null;
                  f = d.priorityLevel;
                  var s = o(d.expirationTime <= t);
                  t = e.unstable_now();
                  if (typeof s == `function`) {
                    d.callback = s;
                    b(t);
                    i = true;
                    break b;
                  }
                  if (d === n(c)) {
                    r(c);
                  }
                  b(t);
                } else {
                  r(c);
                }
                d = n(c);
              }
              if (d !== null) {
                i = true;
              } else {
                var u = n(l);
                if (u !== null) {
                  ce(x, u.startTime - t);
                }
                i = false;
              }
            }
            break a;
          } finally {
            d = null;
            f = a;
            p = false;
          }
          i = undefined;
        }
      } finally {
        if (i) {
          ae();
        } else {
          ee = false;
        }
      }
    }
  }
  var ae;
  if (typeof y == `function`) {
    ae = function () {
      y(S);
    };
  } else if (typeof MessageChannel < `u`) {
    var oe = new MessageChannel();
    var se = oe.port2;
    oe.port1.onmessage = S;
    ae = function () {
      se.postMessage(null);
    };
  } else {
    ae = function () {
      _(S, 0);
    };
  }
  function ce(t, n) {
    te = _(function () {
      t(e.unstable_now());
    }, n);
  }
  e.unstable_IdlePriority = 5;
  e.unstable_ImmediatePriority = 1;
  e.unstable_LowPriority = 4;
  e.unstable_NormalPriority = 3;
  e.unstable_Profiling = null;
  e.unstable_UserBlockingPriority = 2;
  e.unstable_cancelCallback = function (e) {
    e.callback = null;
  };
  e.unstable_forceFrameRate = function (e) {
    if (e < 0 || e > 125) {
      console.error(`forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported`);
    } else {
      ne = e > 0 ? Math.floor(1000 / e) : 5;
    }
  };
  e.unstable_getCurrentPriorityLevel = function () {
    return f;
  };
  e.unstable_next = function (e) {
    switch (f) {
      case 1:
      case 2:
      case 3:
        var t = 3;
        break;
      default:
        t = f;
    }
    var n = f;
    f = t;
    try {
      return e();
    } finally {
      f = n;
    }
  };
  e.unstable_requestPaint = function () {
    g = true;
  };
  e.unstable_runWithPriority = function (e, t) {
    switch (e) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        e = 3;
    }
    var n = f;
    f = e;
    try {
      return t();
    } finally {
      f = n;
    }
  };
  e.unstable_scheduleCallback = function (r, i, a) {
    var o = e.unstable_now();
    if (typeof a == `object` && a) {
      a = a.delay;
      a = typeof a == `number` && a > 0 ? o + a : o;
    } else {
      a = o;
    }
    switch (r) {
      case 1:
        var s = -1;
        break;
      case 2:
        s = 250;
        break;
      case 5:
        s = 1073741823;
        break;
      case 4:
        s = 10000;
        break;
      default:
        s = 5000;
    }
    s = a + s;
    r = {
      id: u++,
      callback: i,
      priorityLevel: r,
      startTime: a,
      expirationTime: s,
      sortIndex: -1
    };
    if (a > o) {
      r.sortIndex = a;
      t(l, r);
      if (n(c) === null && r === n(l)) {
        if (h) {
          v(te);
          te = -1;
        } else {
          h = true;
        }
        ce(x, a - o);
      }
    } else {
      r.sortIndex = s;
      t(c, r);
      if (!m && !p) {
        m = true;
        if (!ee) {
          ee = true;
          ae();
        }
      }
    }
    return r;
  };
  e.unstable_shouldYield = ie;
  e.unstable_wrapCallback = function (e) {
    var t = f;
    return function () {
      var n = f;
      f = t;
      try {
        return e.apply(this, arguments);
      } finally {
        f = n;
      }
    };
  };
});
var i = t((e, t) => {
  t.exports = r();
});
var a = t(e => {
  var t = n();
  function r(e) {
    var t = `https://react.dev/errors/${e}`;
    if (arguments.length > 1) {
      t += `?args[]=${encodeURIComponent(arguments[1])}`;
      for (var n = 2; n < arguments.length; n++) {
        t += `&args[]=${encodeURIComponent(arguments[n])}`;
      }
    }
    return `Minified React error #${e}; visit ${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`;
  }
  function i() {}
  var a = {
    d: {
      f: i,
      r: function () {
        throw Error(r(522));
      },
      D: i,
      C: i,
      L: i,
      m: i,
      X: i,
      S: i,
      M: i
    },
    p: 0,
    findDOMNode: null
  };
  var o = Symbol.for(`react.portal`);
  var s = Symbol.for(`react.recoverable`);
  var c = Symbol.for(`react.optimistic_key`);
  function l(e, t, n, r = null) {
    return {
      $$typeof: o,
      key: r == null ? null : r === c ? c : `${r}`,
      children: e,
      containerInfo: t,
      implementation: n
    };
  }
  var u = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function d(e, t) {
    if (e === `font`) {
      return ``;
    }
    if (typeof t == `string`) {
      if (t === `use-credentials`) {
        return t;
      } else {
        return ``;
      }
    }
  }
  e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = a;
  e.browser = function (e) {
    return {
      $$typeof: s,
      _reason: e
    };
  };
  e.createPortal = function (e, t, n = null) {
    if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) {
      throw Error(r(299));
    }
    return l(e, t, null, n);
  };
  e.flushSync = function (e) {
    var t = u.T;
    var n = a.p;
    try {
      u.T = null;
      a.p = 2;
      if (e) {
        return e();
      }
    } finally {
      u.T = t;
      a.p = n;
      a.d.f();
    }
  };
  e.preconnect = function (e, t) {
    if (typeof e == `string`) {
      if (t) {
        t = t.crossOrigin;
        t = typeof t == `string` ? t === `use-credentials` ? t : `` : undefined;
      } else {
        t = null;
      }
      a.d.C(e, t);
    }
  };
  e.prefetchDNS = function (e) {
    if (typeof e == `string`) {
      a.d.D(e);
    }
  };
  e.preinit = function (e, t) {
    if (typeof e == `string` && t && typeof t.as == `string`) {
      var n = t.as;
      var r = d(n, t.crossOrigin);
      var i = typeof t.integrity == `string` ? t.integrity : undefined;
      var o = typeof t.fetchPriority == `string` ? t.fetchPriority : undefined;
      if (n === `style`) {
        a.d.S(e, typeof t.precedence == `string` ? t.precedence : undefined, {
          crossOrigin: r,
          integrity: i,
          fetchPriority: o
        });
      } else if (n === `script`) {
        a.d.X(e, {
          crossOrigin: r,
          integrity: i,
          fetchPriority: o,
          nonce: typeof t.nonce == `string` ? t.nonce : undefined
        });
      }
    }
  };
  e.preinitModule = function (e, t) {
    if (typeof e == `string`) {
      if (typeof t == `object` && t) {
        if (t.as == null || t.as === `script`) {
          var n = d(t.as, t.crossOrigin);
          a.d.M(e, {
            crossOrigin: n,
            integrity: typeof t.integrity == `string` ? t.integrity : undefined,
            nonce: typeof t.nonce == `string` ? t.nonce : undefined,
            fetchPriority: typeof t.fetchPriority == `string` ? t.fetchPriority : undefined
          });
        }
      } else {
        t ?? a.d.M(e);
      }
    }
  };
  e.preload = function (e, t) {
    if (typeof e == `string` && typeof t == `object` && t && typeof t.as == `string`) {
      var n = t.as;
      var r = d(n, t.crossOrigin);
      a.d.L(e, n, {
        crossOrigin: r,
        integrity: typeof t.integrity == `string` ? t.integrity : undefined,
        nonce: typeof t.nonce == `string` ? t.nonce : undefined,
        type: typeof t.type == `string` ? t.type : undefined,
        fetchPriority: typeof t.fetchPriority == `string` ? t.fetchPriority : undefined,
        referrerPolicy: typeof t.referrerPolicy == `string` ? t.referrerPolicy : undefined,
        imageSrcSet: typeof t.imageSrcSet == `string` ? t.imageSrcSet : undefined,
        imageSizes: typeof t.imageSizes == `string` ? t.imageSizes : undefined,
        media: typeof t.media == `string` ? t.media : undefined
      });
    }
  };
  e.preloadModule = function (e, t) {
    if (typeof e == `string`) {
      if (t) {
        var n = d(t.as, t.crossOrigin);
        a.d.m(e, {
          as: typeof t.as == `string` && t.as !== `script` ? t.as : undefined,
          crossOrigin: n,
          integrity: typeof t.integrity == `string` ? t.integrity : undefined,
          nonce: typeof t.nonce == `string` ? t.nonce : undefined,
          fetchPriority: typeof t.fetchPriority == `string` ? t.fetchPriority : undefined
        });
      } else {
        a.d.m(e);
      }
    }
  };
  e.requestFormReset = function (e) {
    a.d.r(e);
  };
  e.unstable_batchedUpdates = function (e, t) {
    return e(t);
  };
  e.useFormState = function (e, t, n) {
    return u.H.useFormState(e, t, n);
  };
  e.useFormStatus = function () {
    return u.H.useHostTransitionStatus();
  };
  e.version = `19.3.0`;
});
var o = t((e, t) => {
  function n() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < `u` && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == `function`) {
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (e) {
        console.error(e);
      }
    }
  }
  n();
  t.exports = a();
});
var s = t(e => {
  var t = i();
  var r = n();
  var a = o();
  function s(e) {
    var t = `https://react.dev/errors/${e}`;
    if (arguments.length > 1) {
      t += `?args[]=${encodeURIComponent(arguments[1])}`;
      for (var n = 2; n < arguments.length; n++) {
        t += `&args[]=${encodeURIComponent(arguments[n])}`;
      }
    }
    return `Minified React error #${e}; visit ${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`;
  }
  function c(e) {
    return !!e && (e.nodeType === 1 || e.nodeType === 9 || e.nodeType === 11);
  }
  function l(e) {
    var t = e;
    for (var n = t; n && !n.alternate;) {
      t = n;
      if (t.flags & 4098) {
        e = t.return;
      }
      n = t.return;
    }
    while (t.return) {
      t = t.return;
    }
    if (t.tag === 3) {
      return e;
    } else {
      return null;
    }
  }
  function u(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null) {
        e = e.alternate;
        if (e !== null) {
          t = e.memoizedState;
        }
      }
      if (t !== null) {
        return t.dehydrated;
      }
    }
    return null;
  }
  function d(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if (t === null) {
        e = e.alternate;
        if (e !== null) {
          t = e.memoizedState;
        }
      }
      if (t !== null) {
        return t.dehydrated;
      }
    }
    return null;
  }
  function f(e) {
    if (l(e) !== e) {
      throw Error(s(188));
    }
  }
  function p(e) {
    var t = e.alternate;
    if (!t) {
      t = l(e);
      if (t === null) {
        throw Error(s(188));
      }
      if (t === e) {
        return e;
      } else {
        return null;
      }
    }
    var n = e;
    var r = t;
    while (true) {
      var i = n.return;
      if (i === null) {
        break;
      }
      var a = i.alternate;
      if (a === null) {
        r = i.return;
        if (r !== null) {
          n = r;
          continue;
        }
        break;
      }
      if (i.child === a.child) {
        for (a = i.child; a;) {
          if (a === n) {
            f(i);
            return e;
          }
          if (a === r) {
            f(i);
            return t;
          }
          a = a.sibling;
        }
        throw Error(s(188));
      }
      if (n.return !== r.return) {
        n = i;
        r = a;
      } else {
        var o = false;
        for (var c = i.child; c;) {
          if (c === n) {
            o = true;
            n = i;
            r = a;
            break;
          }
          if (c === r) {
            o = true;
            r = i;
            n = a;
            break;
          }
          c = c.sibling;
        }
        if (!o) {
          for (c = a.child; c;) {
            if (c === n) {
              o = true;
              n = a;
              r = i;
              break;
            }
            if (c === r) {
              o = true;
              r = a;
              n = i;
              break;
            }
            c = c.sibling;
          }
          if (!o) {
            throw Error(s(189));
          }
        }
      }
      if (n.alternate !== r) {
        throw Error(s(190));
      }
    }
    if (n.tag !== 3) {
      throw Error(s(188));
    }
    if (n.stateNode.current === n) {
      return e;
    } else {
      return t;
    }
  }
  function m(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) {
      return e;
    }
    for (e = e.child; e !== null;) {
      t = m(e);
      if (t !== null) {
        return t;
      }
      e = e.sibling;
    }
    return null;
  }
  function h(e, t, n, r, i, a) {
    while (e !== null) {
      if ((e.tag === 5 || e.tag === 27 || e.tag === 6) && n(e, r, i, a) || (e.tag !== 22 || e.memoizedState === null) && (t || e.tag !== 5 && e.tag !== 27) && h(e.child, t, n, r, i, a)) {
        return true;
      }
      e = e.sibling;
    }
    return false;
  }
  function g(e) {
    for (e = e.return; e !== null;) {
      if (e.tag === 3 || e.tag === 5 || e.tag === 27) {
        return e;
      }
      e = e.return;
    }
    return null;
  }
  function _(e) {
    var t = false;
    for (e = e.return; e !== null && (e.tag === 4 && (t = true), e.tag !== 3 && e.tag !== 5 && e.tag !== 27);) {
      e = e.return;
    }
    return t;
  }
  function v(e) {
    var t = [null, null];
    var n = g(e);
    if (n !== null) {
      y(t, e, n.child, {
        foundSelf: false
      });
    }
    return t;
  }
  function y(e, t, n, r) {
    while (n !== null) {
      if (n === t) {
        r.foundSelf = true;
      } else if (n.tag === 5 || n.tag === 27 || n.tag === 6) {
        if (r.foundSelf) {
          e[1] = n;
          return true;
        }
        e[0] = n;
      } else if ((n.tag !== 22 || n.memoizedState === null) && y(e, t, n.child, r)) {
        return true;
      }
      n = n.sibling;
    }
    return false;
  }
  function b(e) {
    switch (e.tag) {
      case 5:
      case 27:
      case 6:
        return e.stateNode;
      case 3:
        return e.stateNode.containerInfo;
      default:
        throw Error(s(559));
    }
  }
  var x = null;
  var ee = null;
  function te(e, t, n) {
    return e === n || e === t && (x = e, true);
  }
  function ne(e, t, n) {
    if (e === n) {
      ee = e;
      return false;
    } else {
      return e === t && (ee !== null && (x = e), true);
    }
  }
  function re(e) {
    if (e === null) {
      return null;
    }
    do {
      e = e === null ? null : e.return;
    } while (e && e.tag !== 5 && e.tag !== 27 && e.tag !== 3);
    return e || null;
  }
  function ie(e, t, n) {
    var r = 0;
    for (var i = e; i; i = n(i)) {
      r++;
    }
    i = 0;
    for (var a = t; a; a = n(a)) {
      i++;
    }
    while (r - i > 0) {
      e = n(e);
      r--;
    }
    while (i - r > 0) {
      t = n(t);
      i--;
    }
    while (r--) {
      if (e === t || t !== null && e === t.alternate) {
        return e;
      }
      e = n(e);
      t = n(t);
    }
    return null;
  }
  var S = Object.assign;
  var ae = Symbol.for(`react.element`);
  var oe = Symbol.for(`react.transitional.element`);
  var se = Symbol.for(`react.portal`);
  var ce = Symbol.for(`react.fragment`);
  var le = Symbol.for(`react.strict_mode`);
  var ue = Symbol.for(`react.profiler`);
  var de = Symbol.for(`react.consumer`);
  var fe = Symbol.for(`react.context`);
  var pe = Symbol.for(`react.forward_ref`);
  var me = Symbol.for(`react.suspense`);
  var he = Symbol.for(`react.suspense_list`);
  var ge = Symbol.for(`react.memo`);
  var _e = Symbol.for(`react.lazy`);
  var ve = Symbol.for(`react.activity`);
  var ye = Symbol.for(`react.legacy_hidden`);
  var be = Symbol.for(`react.memo_cache_sentinel`);
  var xe = Symbol.for(`react.view_transition`);
  var Se = Symbol.for(`react.recoverable`);
  var Ce = Symbol.iterator;
  function we(e) {
    if (typeof e != `object` || !e) {
      return null;
    } else {
      e = Ce && e[Ce] || e[`@@iterator`];
      if (typeof e == `function`) {
        return e;
      } else {
        return null;
      }
    }
  }
  var Te = Symbol.for(`react.client.reference`);
  function Ee(e) {
    if (e == null) {
      return null;
    }
    if (typeof e == `function`) {
      if (e.$$typeof === Te) {
        return null;
      } else {
        return e.displayName || e.name || null;
      }
    }
    if (typeof e == `string`) {
      return e;
    }
    switch (e) {
      case ce:
        return `Fragment`;
      case ue:
        return `Profiler`;
      case le:
        return `StrictMode`;
      case me:
        return `Suspense`;
      case he:
        return `SuspenseList`;
      case ve:
        return `Activity`;
      case xe:
        return `ViewTransition`;
    }
    if (typeof e == `object`) {
      switch (e.$$typeof) {
        case se:
          return `Portal`;
        case fe:
          return e.displayName || `Context`;
        case de:
          return `${e._context.displayName || `Context`}.Consumer`;
        case pe:
          var t = e.render;
          e = e.displayName;
          e ||= (e = t.displayName || t.name || ``, e === `` ? `ForwardRef` : `ForwardRef(${e})`);
          return e;
        case ge:
          t = e.displayName || null;
          if (t === null) {
            return Ee(e.type) || `Memo`;
          } else {
            return t;
          }
        case _e:
          t = e._payload;
          e = e._init;
          try {
            return Ee(e(t));
          } catch {}
      }
    }
    return null;
  }
  var De = Array.isArray;
  var C = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  var w = a.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  var Oe = {
    pending: false,
    data: null,
    method: null,
    action: null
  };
  var ke = [];
  var Ae = -1;
  function je(e) {
    return {
      current: e
    };
  }
  function T(e) {
    if (!(Ae < 0)) {
      e.current = ke[Ae];
      ke[Ae] = null;
      Ae--;
    }
  }
  function E(e, t) {
    Ae++;
    ke[Ae] = e.current;
    e.current = t;
  }
  var Me = je(null);
  var Ne = je(null);
  var Pe = je(null);
  var Fe = je(null);
  function Ie(e, t) {
    E(Pe, t);
    E(Ne, e);
    E(Me, null);
    switch (t.nodeType) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? up(e) : 0;
        break;
      default:
        e = t.tagName;
        if (t = t.namespaceURI) {
          t = up(t);
          e = dp(t, e);
        } else {
          switch (e) {
            case `svg`:
              e = 1;
              break;
            case `math`:
              e = 2;
              break;
            default:
              e = 0;
          }
        }
    }
    T(Me);
    E(Me, e);
  }
  function Le() {
    T(Me);
    T(Ne);
    T(Pe);
  }
  function Re(e) {
    var t = e.memoizedState;
    if (t !== null) {
      sh._currentValue = t.memoizedState;
      E(Fe, e);
    }
    t = Me.current;
    var n = dp(t, e.type);
    if (t !== n) {
      E(Ne, e);
      E(Me, n);
    }
  }
  function ze(e) {
    if (Ne.current === e) {
      T(Me);
      T(Ne);
    }
    if (Fe.current === e) {
      T(Fe);
      sh._currentValue = Oe;
    }
  }
  var Be;
  var Ve;
  function He(e) {
    if (Be === undefined) {
      try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        Be = t && t[1] || ``;
        Ve = e.stack.indexOf(`
    at`) > -1 ? ` (<anonymous>)` : e.stack.indexOf(`@`) > -1 ? `@unknown:0:0` : ``;
      }
    }
    return `
${Be}${e}${Ve}`;
  }
  var Ue = false;
  function We(e, t) {
    if (!e || Ue) {
      return ``;
    }
    Ue = true;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = undefined;
    try {
      var r = {
        DetermineComponentFrameRoot: function () {
          try {
            if (t) {
              function n() {
                throw Error();
              }
              Object.defineProperty(n.prototype, "props", {
                set: function () {
                  throw Error();
                }
              });
              if (typeof Reflect == `object` && Reflect.construct) {
                try {
                  Reflect.construct(n, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], n);
              } else {
                try {
                  n.call();
                } catch (e) {
                  r = e;
                }
                n = false;
                try {
                  var i = Object.getOwnPropertyDescriptor(e.prototype, `props`);
                  Object.defineProperty(e.prototype, "props", {
                    configurable: true,
                    set: function () {
                      throw Error();
                    }
                  });
                  n = true;
                  new e();
                } finally {
                  if (n) {
                    if (i === undefined) {
                      delete e.prototype.props;
                    } else {
                      Object.defineProperty(e.prototype, "props", i);
                    }
                  }
                }
              }
            } else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              if ((n = e()) && typeof n.catch == `function`) {
                n.catch(function () {});
              }
            }
          } catch (e) {
            if (e && r && typeof e.stack == `string`) {
              return [e.stack, r.stack];
            }
          }
          return [null, null];
        }
      };
      r.DetermineComponentFrameRoot.displayName = `DetermineComponentFrameRoot`;
      var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, `name`);
      if (i && i.configurable) {
        Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
          value: `DetermineComponentFrameRoot`
        });
      }
      var a = r.DetermineComponentFrameRoot();
      var o = a[0];
      var s = a[1];
      if (o && s) {
        var c = o.split(`
`);
        var l = s.split(`
`);
        for (i = r = 0; r < c.length && !c[r].includes(`DetermineComponentFrameRoot`);) {
          r++;
        }
        while (i < l.length && !l[i].includes(`DetermineComponentFrameRoot`)) {
          i++;
        }
        if (r === c.length || i === l.length) {
          r = c.length - 1;
          i = l.length - 1;
          while (r >= 1 && i >= 0 && c[r] !== l[i]) {
            i--;
          }
        }
        for (; r >= 1 && i >= 0; r--, i--) {
          if (c[r] !== l[i]) {
            if (r !== 1 || i !== 1) {
              do {
                r--;
                i--;
                if (i < 0 || c[r] !== l[i]) {
                  var u = `
${c[r].replace(` at new `, ` at `)}`;
                  if (e.displayName && u.includes(`<anonymous>`)) {
                    u = u.replace(`<anonymous>`, e.displayName);
                  }
                  return u;
                }
              } while (r >= 1 && i >= 0);
            }
            break;
          }
        }
      }
    } finally {
      Ue = false;
      Error.prepareStackTrace = n;
    }
    if (n = e ? e.displayName || e.name : ``) {
      return He(n);
    } else {
      return ``;
    }
  }
  function Ge(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return He(e.type);
      case 16:
        return He(`Lazy`);
      case 13:
        if (e.child !== t && t !== null) {
          return He(`Suspense Fallback`);
        } else {
          return He(`Suspense`);
        }
      case 19:
        return He(`SuspenseList`);
      case 0:
      case 15:
        return We(e.type, false);
      case 11:
        return We(e.type.render, false);
      case 1:
        return We(e.type, true);
      case 31:
        return He(`Activity`);
      case 30:
        return He(`ViewTransition`);
      default:
        return ``;
    }
  }
  function Ke(e) {
    try {
      var t = ``;
      var n = null;
      do {
        t += Ge(e, n);
        n = e;
        e = e.return;
      } while (e);
      return t;
    } catch (e) {
      return `
Error generating stack: ${e.message}
${e.stack}`;
    }
  }
  var qe = Object.prototype.hasOwnProperty;
  var Je = t.unstable_scheduleCallback;
  var Ye = t.unstable_cancelCallback;
  var Xe = t.unstable_shouldYield;
  var Ze = t.unstable_requestPaint;
  var Qe = t.unstable_now;
  var $e = t.unstable_getCurrentPriorityLevel;
  var et = t.unstable_ImmediatePriority;
  var tt = t.unstable_UserBlockingPriority;
  var nt = t.unstable_NormalPriority;
  var rt = t.unstable_LowPriority;
  var it = t.unstable_IdlePriority;
  var at = t.log;
  var ot = t.unstable_setDisableYieldValue;
  var st = null;
  var ct = null;
  function lt(e) {
    if (typeof at == `function`) {
      ot(e);
    }
    if (ct && typeof ct.setStrictMode == `function`) {
      try {
        ct.setStrictMode(st, e);
      } catch {}
    }
  }
  var ut = Math.clz32 ? Math.clz32 : pt;
  var dt = Math.log;
  var ft = Math.LN2;
  function pt(e) {
    e >>>= 0;
    if (e === 0) {
      return 32;
    } else {
      return 31 - (dt(e) / ft | 0) | 0;
    }
  }
  var mt = 256;
  var ht = 262144;
  var gt = 4194304;
  function _t(e) {
    var t = e & 42;
    if (t !== 0) {
      return t;
    }
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & -e;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function vt(e, t, n) {
    var r = e.pendingLanes;
    if (r === 0) {
      return 0;
    }
    var i = 0;
    var a = e.suspendedLanes;
    var o = e.pingedLanes;
    e = e.warmLanes;
    var s = r & 134217727;
    if (s === 0) {
      s = r & ~a;
      if (s === 0) {
        if (o === 0) {
          if (!n) {
            n = r & ~e;
            if (n !== 0) {
              i = _t(n);
            }
          }
        } else {
          i = _t(o);
        }
      } else {
        i = _t(s);
      }
    } else {
      r = s & ~a;
      if (r === 0) {
        o &= s;
        if (o === 0) {
          if (!n) {
            n = s & ~e;
            if (n !== 0) {
              i = _t(n);
            }
          }
        } else {
          i = _t(o);
        }
      } else {
        i = _t(r);
      }
    }
    if (i === 0) {
      return 0;
    } else if (t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048)) {
      return t;
    } else {
      return i;
    }
  }
  function yt(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function bt(e, t) {
    if (t & 8) {
      t |= t & 32;
    }
    var n = e.entangledLanes;
    if (n !== 0) {
      e = e.entanglements;
      n &= t;
      while (n > 0) {
        var r = 31 - ut(n);
        var i = 1 << r;
        t |= e[r];
        n &= ~i;
      }
    }
    return t;
  }
  function xt(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5000;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function St() {
    var e = gt;
    gt <<= 1;
    if (!(gt & 62914560)) {
      gt = 4194304;
    }
    return e;
  }
  function Ct(e) {
    var t = [];
    for (var n = 0; n < 31; n++) {
      t.push(e);
    }
    return t;
  }
  function wt(e, t) {
    e.pendingLanes |= t;
    if (t !== 268435456) {
      e.suspendedLanes = 0;
      e.pingedLanes = 0;
      e.warmLanes = 0;
    }
  }
  function Tt(e, t, n, r, i, a) {
    var o = e.pendingLanes;
    e.pendingLanes = n;
    e.suspendedLanes = 0;
    e.pingedLanes = 0;
    e.warmLanes = 0;
    e.expiredLanes &= n;
    e.entangledLanes &= n;
    e.errorRecoveryDisabledLanes &= n;
    e.shellSuspendCounter = 0;
    var s = e.entanglements;
    var c = e.expirationTimes;
    var l = e.hiddenUpdates;
    for (n = o & ~n; n > 0;) {
      var u = 31 - ut(n);
      var d = 1 << u;
      s[u] = 0;
      c[u] = -1;
      var f = l[u];
      if (f !== null) {
        l[u] = null;
        u = 0;
        for (; u < f.length; u++) {
          var p = f[u];
          if (p !== null) {
            p.lane &= -536870913;
          }
        }
      }
      n &= ~d;
    }
    if (r !== 0) {
      Et(e, r, 0);
    }
    if (a !== 0 && i === 0 && e.tag !== 0) {
      e.suspendedLanes |= a & ~(o & ~t);
    }
  }
  function Et(e, t, n) {
    e.pendingLanes |= t;
    e.suspendedLanes &= ~t;
    var r = 31 - ut(t);
    e.entangledLanes |= t;
    e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
  }
  function Dt(e, t) {
    var n = e.entangledLanes |= t;
    for (e = e.entanglements; n;) {
      var r = 31 - ut(n);
      var i = 1 << r;
      if (i & t | e[r] & t) {
        e[r] |= t;
      }
      n &= ~i;
    }
  }
  function Ot(e, t) {
    var n = t & -t;
    n = n & 42 ? 1 : kt(n);
    if ((n & (e.suspendedLanes | t)) === 0) {
      return n;
    } else {
      return 0;
    }
  }
  function kt(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function At(e) {
    e &= -e;
    if (e > 2) {
      if (e > 8) {
        if (e & 134217727) {
          return 32;
        } else {
          return 268435456;
        }
      } else {
        return 8;
      }
    } else {
      return 2;
    }
  }
  function jt() {
    var e = w.p;
    if (e === 0) {
      e = window.event;
      if (e === undefined) {
        return 32;
      } else {
        return Ch(e.type);
      }
    } else {
      return e;
    }
  }
  function Mt(e, t) {
    var n = w.p;
    try {
      w.p = e;
      return t();
    } finally {
      w.p = n;
    }
  }
  var Nt = Math.random().toString(36).slice(2);
  var Pt = `__reactFiber$${Nt}`;
  var Ft = `__reactProps$${Nt}`;
  var It = `__reactContainer$${Nt}`;
  var Lt = `__reactEvents$${Nt}`;
  var Rt = `__reactListeners$${Nt}`;
  var zt = `__reactHandles$${Nt}`;
  var Bt = `__reactResources$${Nt}`;
  var Vt = `__reactMarker$${Nt}`;
  var Ht = `__reactLoad$${Nt}`;
  function Ut(e) {
    delete e[Pt];
    delete e[Ft];
    delete e[Rt];
    delete e[zt];
  }
  function Wt(e) {
    var t;
    if (t = e[Pt]) {
      return t;
    }
    for (var n = e.parentNode; n;) {
      if (t = n[It] || n[Pt]) {
        n = t.alternate;
        if (t.child !== null || n !== null && n.child !== null) {
          for (e = fm(e); e !== null;) {
            if (n = e[Pt]) {
              return n;
            }
            e = fm(e);
          }
        }
        return t;
      }
      e = n;
      n = e.parentNode;
    }
    return null;
  }
  function Gt(e) {
    if (e = e[Pt] || e[It]) {
      var t = e.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) {
        return e;
      }
    }
    return null;
  }
  function Kt(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) {
      return e.stateNode;
    }
    throw Error(s(33));
  }
  function qt(e) {
    var t = e[Bt];
    t ||= e[Bt] = {
      hoistableStyles: new Map(),
      hoistableScripts: new Map()
    };
    return t;
  }
  function D(e) {
    e[Vt] = true;
  }
  function Jt(e) {
    e[Ht] = undefined;
  }
  var Yt = new Set();
  var Xt = {};
  function Zt(e, t) {
    Qt(e, t);
    Qt(`${e}Capture`, t);
  }
  function Qt(e, t) {
    Xt[e] = t;
    e = 0;
    for (; e < t.length; e++) {
      Yt.add(t[e]);
    }
  }
  var $t = RegExp(`^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$`);
  var en = {};
  var tn = {};
  function nn(e) {
    if (qe.call(tn, e)) {
      return true;
    } else if (qe.call(en, e)) {
      return false;
    } else if ($t.test(e)) {
      return tn[e] = true;
    } else {
      en[e] = true;
      return false;
    }
  }
  var O = false;
  function rn() {
    var e = O;
    O = false;
    return e;
  }
  function an(e, t, n) {
    if (nn(t)) {
      if (n === null) {
        e.removeAttribute(t);
      } else {
        switch (typeof n) {
          case `undefined`:
          case `function`:
          case `symbol`:
            e.removeAttribute(t);
            return;
          case `boolean`:
            var r = t.toLowerCase().slice(0, 5);
            if (r !== `data-` && r !== `aria-`) {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, n);
      }
    }
  }
  function on(e, t, n) {
    if (n === null) {
      e.removeAttribute(t);
    } else {
      switch (typeof n) {
        case `undefined`:
        case `function`:
        case `symbol`:
        case `boolean`:
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, n);
    }
  }
  function sn(e, t, n, r) {
    if (r === null) {
      e.removeAttribute(n);
    } else {
      switch (typeof r) {
        case `undefined`:
        case `function`:
        case `symbol`:
        case `boolean`:
          e.removeAttribute(n);
          return;
      }
      e.setAttributeNS(t, n, r);
    }
  }
  function cn(e) {
    switch (typeof e) {
      case `bigint`:
      case `boolean`:
      case `number`:
      case `string`:
      case `undefined`:
        return e;
      case `object`:
        return e;
      default:
        return ``;
    }
  }
  function ln(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === `input` && (t === `checkbox` || t === `radio`);
  }
  function un(e, t, n) {
    var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
    if (!e.hasOwnProperty(t) && r !== undefined && typeof r.get == `function` && typeof r.set == `function`) {
      var i = r.get;
      var a = r.set;
      Object.defineProperty(e, t, {
        configurable: true,
        get: function () {
          return i.call(this);
        },
        set: function (e) {
          n = `${e}`;
          a.call(this, e);
        }
      });
      Object.defineProperty(e, t, {
        enumerable: r.enumerable
      });
      return {
        getValue: function () {
          return n;
        },
        setValue: function (e) {
          n = `${e}`;
        },
        stopTracking: function () {
          e._valueTracker = null;
          delete e[t];
        }
      };
    }
  }
  function dn(e) {
    if (!e._valueTracker) {
      var t = ln(e) ? `checked` : `value`;
      e._valueTracker = un(e, t, `${e[t]}`);
    }
  }
  function fn(e) {
    if (!e) {
      return false;
    }
    var t = e._valueTracker;
    if (!t) {
      return true;
    }
    var n = t.getValue();
    var r = ``;
    if (e) {
      r = ln(e) ? e.checked ? `true` : `false` : e.value;
    }
    e = r;
    return e !== n && (t.setValue(e), true);
  }
  var pn = /[\n"\\]/g;
  function mn(e) {
    return e.replace(pn, function (e) {
      return `\\${e.charCodeAt(0).toString(16)} `;
    });
  }
  function hn(e, t, n, r, i, a, o, s) {
    e.name = ``;
    if (o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean`) {
      e.type = o;
    } else {
      e.removeAttribute(`type`);
    }
    if (t == null) {
      if (o === `submit` || o === `reset`) {
        e.removeAttribute(`value`);
      }
    } else if (o === `number`) {
      if (t === 0 && e.value === `` || e.value != t) {
        e.value = `${cn(t)}`;
      }
    } else if (e.value !== `${cn(t)}`) {
      e.value = `${cn(t)}`;
    }
    if (t == null) {
      if (n == null) {
        if (r != null) {
          e.removeAttribute(`value`);
        }
      } else {
        _n(e, cn(n));
      }
    } else if (o === `number` && e.value == t) {
      _n(e, cn(e.value));
    } else {
      _n(e, cn(t));
    }
    if (i == null && a != null) {
      e.defaultChecked = !!a;
    }
    if (i != null) {
      e.checked = i && typeof i != `function` && typeof i != `symbol`;
    }
    if (s != null && typeof s != `function` && typeof s != `symbol` && typeof s != `boolean`) {
      e.name = `${cn(s)}`;
    } else {
      e.removeAttribute(`name`);
    }
  }
  function gn(e, t, n, r, i, a, o, s) {
    if (a != null && typeof a != `function` && typeof a != `symbol` && typeof a != `boolean`) {
      e.type = a;
    }
    if (t != null || n != null) {
      if ((a === `submit` || a === `reset`) && t == null) {
        dn(e);
        return;
      }
      n = n == null ? `` : `${cn(n)}`;
      t = t == null ? n : `${cn(t)}`;
      if (!s && t !== e.value) {
        e.value = t;
      }
      e.defaultValue = t;
    }
    r ??= i;
    r = typeof r != `function` && typeof r != `symbol` && !!r;
    e.checked = s ? e.checked : !!r;
    e.defaultChecked = !!r;
    if (o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean`) {
      e.name = o;
    }
    dn(e);
  }
  function _n(e, t) {
    if (e.defaultValue !== `${t}`) {
      e.defaultValue = `${t}`;
    }
  }
  function vn(e, t, n, r) {
    e = e.options;
    if (t) {
      t = {};
      for (var i = 0; i < n.length; i++) {
        t[`$${n[i]}`] = true;
      }
      for (n = 0; n < e.length; n++) {
        i = t.hasOwnProperty(`$${e[n].value}`);
        if (e[n].selected !== i) {
          e[n].selected = i;
        }
        if (i && r) {
          e[n].defaultSelected = true;
        }
      }
    } else {
      n = `${cn(n)}`;
      t = null;
      i = 0;
      for (; i < e.length; i++) {
        if (e[i].value === n) {
          e[i].selected = true;
          if (r) {
            e[i].defaultSelected = true;
          }
          return;
        }
        if (t === null && !e[i].disabled) {
          t = e[i];
        }
      }
      if (t !== null) {
        t.selected = true;
      }
    }
  }
  function yn(e, t, n) {
    if (t != null && (t = `${cn(t)}`, t !== e.value && (e.value = t), n == null)) {
      if (e.defaultValue !== t) {
        e.defaultValue = t;
      }
      return;
    }
    e.defaultValue = n == null ? `` : `${cn(n)}`;
  }
  function bn(e, t, n, r) {
    if (t == null) {
      if (r != null) {
        if (n != null) {
          throw Error(s(92));
        }
        if (De(r)) {
          if (r.length > 1) {
            throw Error(s(93));
          }
          r = r[0];
        }
        n = r;
      }
      n ??= ``;
      t = n;
    }
    n = cn(t);
    e.defaultValue = n;
    r = e.textContent;
    if (r === n && r !== `` && r !== null) {
      e.value = r;
    }
    dn(e);
  }
  function xn(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && n.nodeType === 3) {
        n.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var Sn = new Set(`animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp`.split(` `));
  function Cn(e, t, n) {
    var r = t.indexOf(`--`) === 0;
    if (n == null || typeof n == `boolean` || n === ``) {
      if (r) {
        e.setProperty(t, ``);
      } else if (t === `float`) {
        e.cssFloat = ``;
      } else {
        e[t] = ``;
      }
    } else if (r) {
      e.setProperty(t, n);
    } else if (typeof n != `number` || n === 0 || Sn.has(t)) {
      if (t === `float`) {
        e.cssFloat = n;
      } else {
        e[t] = `${n}`.trim();
      }
    } else {
      e[t] = `${n}px`;
    }
  }
  function wn(e, t, n) {
    if (t != null && typeof t != `object`) {
      throw Error(s(62));
    }
    e = e.style;
    if (n != null) {
      for (var r in n) {
        if (!!n.hasOwnProperty(r) && (t == null || !t.hasOwnProperty(r))) {
          if (r.indexOf(`--`) === 0) {
            e.setProperty(r, ``);
          } else if (r === `float`) {
            e.cssFloat = ``;
          } else {
            e[r] = ``;
          }
          O = true;
        }
      }
      for (var i in t) {
        r = t[i];
        if (t.hasOwnProperty(i) && n[i] !== r) {
          Cn(e, i, r);
          O = true;
        }
      }
    } else {
      for (var a in t) {
        if (t.hasOwnProperty(a)) {
          Cn(e, a, t[a]);
        }
      }
    }
  }
  function Tn(e) {
    if (e.indexOf(`-`) === -1) {
      return false;
    }
    switch (e) {
      case `annotation-xml`:
      case `color-profile`:
      case `font-face`:
      case `font-face-src`:
      case `font-face-uri`:
      case `font-face-format`:
      case `font-face-name`:
      case `missing-glyph`:
        return false;
      default:
        return true;
    }
  }
  var En = new Map([[`acceptCharset`, `accept-charset`], [`htmlFor`, `for`], [`httpEquiv`, `http-equiv`], [`crossOrigin`, `crossorigin`], [`accentHeight`, `accent-height`], [`alignmentBaseline`, `alignment-baseline`], [`arabicForm`, `arabic-form`], [`baselineShift`, `baseline-shift`], [`capHeight`, `cap-height`], [`clipPath`, `clip-path`], [`clipRule`, `clip-rule`], [`colorInterpolation`, `color-interpolation`], [`colorInterpolationFilters`, `color-interpolation-filters`], [`colorProfile`, `color-profile`], [`colorRendering`, `color-rendering`], [`dominantBaseline`, `dominant-baseline`], [`enableBackground`, `enable-background`], [`fillOpacity`, `fill-opacity`], [`fillRule`, `fill-rule`], [`floodColor`, `flood-color`], [`floodOpacity`, `flood-opacity`], [`fontFamily`, `font-family`], [`fontSize`, `font-size`], [`fontSizeAdjust`, `font-size-adjust`], [`fontStretch`, `font-stretch`], [`fontStyle`, `font-style`], [`fontVariant`, `font-variant`], [`fontWeight`, `font-weight`], [`glyphName`, `glyph-name`], [`glyphOrientationHorizontal`, `glyph-orientation-horizontal`], [`glyphOrientationVertical`, `glyph-orientation-vertical`], [`horizAdvX`, `horiz-adv-x`], [`horizOriginX`, `horiz-origin-x`], [`imageRendering`, `image-rendering`], [`letterSpacing`, `letter-spacing`], [`lightingColor`, `lighting-color`], [`markerEnd`, `marker-end`], [`markerMid`, `marker-mid`], [`markerStart`, `marker-start`], [`maskType`, `mask-type`], [`overlinePosition`, `overline-position`], [`overlineThickness`, `overline-thickness`], [`paintOrder`, `paint-order`], [`panose-1`, `panose-1`], [`pointerEvents`, `pointer-events`], [`renderingIntent`, `rendering-intent`], [`shapeRendering`, `shape-rendering`], [`stopColor`, `stop-color`], [`stopOpacity`, `stop-opacity`], [`strikethroughPosition`, `strikethrough-position`], [`strikethroughThickness`, `strikethrough-thickness`], [`strokeDasharray`, `stroke-dasharray`], [`strokeDashoffset`, `stroke-dashoffset`], [`strokeLinecap`, `stroke-linecap`], [`strokeLinejoin`, `stroke-linejoin`], [`strokeMiterlimit`, `stroke-miterlimit`], [`strokeOpacity`, `stroke-opacity`], [`strokeWidth`, `stroke-width`], [`textAnchor`, `text-anchor`], [`textDecoration`, `text-decoration`], [`textRendering`, `text-rendering`], [`transformOrigin`, `transform-origin`], [`underlinePosition`, `underline-position`], [`underlineThickness`, `underline-thickness`], [`unicodeBidi`, `unicode-bidi`], [`unicodeRange`, `unicode-range`], [`unitsPerEm`, `units-per-em`], [`vAlphabetic`, `v-alphabetic`], [`vHanging`, `v-hanging`], [`vIdeographic`, `v-ideographic`], [`vMathematical`, `v-mathematical`], [`vectorEffect`, `vector-effect`], [`vertAdvY`, `vert-adv-y`], [`vertOriginX`, `vert-origin-x`], [`vertOriginY`, `vert-origin-y`], [`wordSpacing`, `word-spacing`], [`writingMode`, `writing-mode`], [`xmlnsXlink`, `xmlns:xlink`], [`xHeight`, `x-height`]]);
  var Dn = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function On(e) {
    if (Dn.test(`${e}`)) {
      return `javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')`;
    } else {
      return e;
    }
  }
  function kn() {}
  var An = null;
  function jn(e) {
    e = e.target || e.srcElement || window;
    if (e.correspondingUseElement) {
      e = e.correspondingUseElement;
    }
    if (e.nodeType === 3) {
      return e.parentNode;
    } else {
      return e;
    }
  }
  var Mn = null;
  var Nn = null;
  function Pn(e) {
    var t = Gt(e);
    if (t && (e = t.stateNode)) {
      var n = e[Ft] || null;
      e = t.stateNode;
      a: switch (t.type) {
        case `input`:
          hn(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name);
          t = n.name;
          if (n.type === `radio` && t != null) {
            for (n = e; n.parentNode;) {
              n = n.parentNode;
            }
            n = n.querySelectorAll(`input[name="${mn(`${t}`)}"][type="radio"]`);
            t = 0;
            for (; t < n.length; t++) {
              var r = n[t];
              if (r !== e && r.form === e.form) {
                var i = r[Ft] || null;
                if (!i) {
                  throw Error(s(90));
                }
                hn(r, i.value, i.defaultValue, i.defaultValue, i.checked, i.defaultChecked, i.type, i.name);
              }
            }
            for (t = 0; t < n.length; t++) {
              r = n[t];
              if (r.form === e.form) {
                fn(r);
              }
            }
          }
          break a;
        case `textarea`:
          yn(e, n.value, n.defaultValue);
          break a;
        case `select`:
          t = n.value;
          if (t != null) {
            vn(e, !!n.multiple, t, false);
          }
      }
    }
  }
  var Fn = false;
  function In(e, t, n) {
    if (Fn) {
      return e(t, n);
    }
    Fn = true;
    try {
      return e(t);
    } finally {
      Fn = false;
      if ((Mn !== null || Nn !== null) && (zd(), Mn && (t = Mn, e = Nn, Nn = Mn = null, Pn(t), e))) {
        for (t = 0; t < e.length; t++) {
          Pn(e[t]);
        }
      }
    }
  }
  function Ln(e, t) {
    var n = e.stateNode;
    if (n === null) {
      return null;
    }
    var r = n[Ft] || null;
    if (r === null) {
      return null;
    }
    n = r[t];
    a: switch (t) {
      case `onClick`:
      case `onClickCapture`:
      case `onDoubleClick`:
      case `onDoubleClickCapture`:
      case `onMouseDown`:
      case `onMouseDownCapture`:
      case `onMouseMove`:
      case `onMouseMoveCapture`:
      case `onMouseUp`:
      case `onMouseUpCapture`:
      case `onMouseEnter`:
        if (!(r = !r.disabled)) {
          e = e.type;
          r = e !== `button` && e !== `input` && e !== `select` && e !== `textarea`;
        }
        e = !r;
        break a;
      default:
        e = false;
    }
    if (e) {
      return null;
    }
    if (n && typeof n != `function`) {
      throw Error(s(231, t, typeof n));
    }
    return n;
  }
  var Rn = typeof window < `u` && window.document !== undefined && window.document.createElement !== undefined;
  var zn = false;
  if (Rn) {
    try {
      var Bn = {};
      Object.defineProperty(Bn, "passive", {
        get: function () {
          zn = true;
        }
      });
      window.addEventListener(`test`, Bn, Bn);
      window.removeEventListener(`test`, Bn, Bn);
    } catch {
      zn = false;
    }
  }
  var Vn = null;
  var Hn = null;
  var Un = null;
  function Wn() {
    if (Un) {
      return Un;
    }
    var e;
    var t = Hn;
    var n = t.length;
    var r;
    var i = `value` in Vn ? Vn.value : Vn.textContent;
    var a = i.length;
    for (e = 0; e < n && t[e] === i[e]; e++);
    var o = n - e;
    for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
    return Un = i.slice(e, r > 1 ? 1 - r : undefined);
  }
  function Gn(e) {
    var t = e.keyCode;
    if (`charCode` in e) {
      e = e.charCode;
      if (e === 0 && t === 13) {
        e = 13;
      }
    } else {
      e = t;
    }
    if (e === 10) {
      e = 13;
    }
    if (e >= 32 || e === 13) {
      return e;
    } else {
      return 0;
    }
  }
  function Kn() {
    return true;
  }
  function qn() {
    return false;
  }
  function Jn(e) {
    function t(t, n, r, i, a) {
      this._reactName = t;
      this._targetInst = r;
      this.type = n;
      this.nativeEvent = i;
      this.target = a;
      this.currentTarget = null;
      for (var o in e) {
        if (e.hasOwnProperty(o)) {
          t = e[o];
          this[o] = t ? t(i) : i[o];
        }
      }
      this.isDefaultPrevented = (i.defaultPrevented == null ? i.returnValue === false : i.defaultPrevented) ? Kn : qn;
      this.isPropagationStopped = qn;
      return this;
    }
    S(t.prototype, {
      preventDefault: function () {
        this.defaultPrevented = true;
        var e = this.nativeEvent;
        if (e) {
          if (e.preventDefault) {
            e.preventDefault();
          } else if (typeof e.returnValue != `unknown`) {
            e.returnValue = false;
          }
          this.isDefaultPrevented = Kn;
        }
      },
      stopPropagation: function () {
        var e = this.nativeEvent;
        if (e) {
          if (e.stopPropagation) {
            e.stopPropagation();
          } else if (typeof e.cancelBubble != `unknown`) {
            e.cancelBubble = true;
          }
          this.isPropagationStopped = Kn;
        }
      },
      persist: function () {},
      isPersistent: Kn
    });
    return t;
  }
  var Yn = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  };
  var Xn = Jn(Yn);
  var Zn = S({}, Yn, {
    view: 0,
    detail: 0
  });
  var Qn = Jn(Zn);
  var $n;
  var er;
  var tr;
  var nr = S({}, Zn, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: pr,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      if (e.relatedTarget === undefined) {
        if (e.fromElement === e.srcElement) {
          return e.toElement;
        } else {
          return e.fromElement;
        }
      } else {
        return e.relatedTarget;
      }
    },
    movementX: function (e) {
      if (`movementX` in e) {
        return e.movementX;
      } else {
        if (e !== tr) {
          if (tr && e.type === `mousemove`) {
            $n = e.screenX - tr.screenX;
            er = e.screenY - tr.screenY;
          } else {
            er = $n = 0;
          }
          tr = e;
        }
        return $n;
      }
    },
    movementY: function (e) {
      if (`movementY` in e) {
        return e.movementY;
      } else {
        return er;
      }
    }
  });
  var rr = Jn(nr);
  var ir = Jn(S({}, nr, {
    dataTransfer: 0
  }));
  var ar = Jn(S({}, Zn, {
    relatedTarget: 0
  }));
  var or = Jn(S({}, Yn, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }));
  var sr = Jn(S({}, Yn, {
    clipboardData: function (e) {
      if (`clipboardData` in e) {
        return e.clipboardData;
      } else {
        return window.clipboardData;
      }
    }
  }));
  var cr = Jn(S({}, Yn, {
    data: 0
  }));
  var lr = {
    Esc: `Escape`,
    Spacebar: ` `,
    Left: `ArrowLeft`,
    Up: `ArrowUp`,
    Right: `ArrowRight`,
    Down: `ArrowDown`,
    Del: `Delete`,
    Win: `OS`,
    Menu: `ContextMenu`,
    Apps: `ContextMenu`,
    Scroll: `ScrollLock`,
    MozPrintableKey: `Unidentified`
  };
  var ur = {
    8: `Backspace`,
    9: `Tab`,
    12: `Clear`,
    13: `Enter`,
    16: `Shift`,
    17: `Control`,
    18: `Alt`,
    19: `Pause`,
    20: `CapsLock`,
    27: `Escape`,
    32: ` `,
    33: `PageUp`,
    34: `PageDown`,
    35: `End`,
    36: `Home`,
    37: `ArrowLeft`,
    38: `ArrowUp`,
    39: `ArrowRight`,
    40: `ArrowDown`,
    45: `Insert`,
    46: `Delete`,
    112: `F1`,
    113: `F2`,
    114: `F3`,
    115: `F4`,
    116: `F5`,
    117: `F6`,
    118: `F7`,
    119: `F8`,
    120: `F9`,
    121: `F10`,
    122: `F11`,
    123: `F12`,
    144: `NumLock`,
    145: `ScrollLock`,
    224: `Meta`
  };
  var dr = {
    Alt: `altKey`,
    Control: `ctrlKey`,
    Meta: `metaKey`,
    Shift: `shiftKey`
  };
  function fr(e) {
    var t = this.nativeEvent;
    if (t.getModifierState) {
      return t.getModifierState(e);
    } else if (e = dr[e]) {
      return !!t[e];
    } else {
      return false;
    }
  }
  function pr() {
    return fr;
  }
  var mr = Jn(S({}, Zn, {
    key: function (e) {
      if (e.key) {
        var t = lr[e.key] || e.key;
        if (t !== `Unidentified`) {
          return t;
        }
      }
      if (e.type === `keypress`) {
        e = Gn(e);
        if (e === 13) {
          return `Enter`;
        } else {
          return String.fromCharCode(e);
        }
      } else if (e.type === `keydown` || e.type === `keyup`) {
        return ur[e.keyCode] || `Unidentified`;
      } else {
        return ``;
      }
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: pr,
    charCode: function (e) {
      if (e.type === `keypress`) {
        return Gn(e);
      } else {
        return 0;
      }
    },
    keyCode: function (e) {
      if (e.type === `keydown` || e.type === `keyup`) {
        return e.keyCode;
      } else {
        return 0;
      }
    },
    which: function (e) {
      if (e.type === `keypress`) {
        return Gn(e);
      } else if (e.type === `keydown` || e.type === `keyup`) {
        return e.keyCode;
      } else {
        return 0;
      }
    }
  }));
  var hr = Jn(S({}, nr, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }));
  var gr = Jn(S({}, Yn, {
    submitter: 0
  }));
  var _r = Jn(S({}, Zn, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: pr
  }));
  var vr = Jn(S({}, Yn, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }));
  var yr = Jn(S({}, nr, {
    deltaX: function (e) {
      if (`deltaX` in e) {
        return e.deltaX;
      } else if (`wheelDeltaX` in e) {
        return -e.wheelDeltaX;
      } else {
        return 0;
      }
    },
    deltaY: function (e) {
      if (`deltaY` in e) {
        return e.deltaY;
      } else if (`wheelDeltaY` in e) {
        return -e.wheelDeltaY;
      } else if (`wheelDelta` in e) {
        return -e.wheelDelta;
      } else {
        return 0;
      }
    },
    deltaZ: 0,
    deltaMode: 0
  }));
  var br = Jn(S({}, Yn, {
    newState: 0,
    oldState: 0,
    source: 0
  }));
  var xr = [9, 13, 27, 32];
  var Sr = Rn && `CompositionEvent` in window;
  var Cr = null;
  if (Rn && `documentMode` in document) {
    Cr = document.documentMode;
  }
  var wr = Rn && `TextEvent` in window && !Cr;
  var Tr = Rn && (!Sr || Cr && Cr > 8 && Cr <= 11);
  var Er = ` `;
  var Dr = false;
  function Or(e, t) {
    switch (e) {
      case `keyup`:
        return xr.indexOf(t.keyCode) !== -1;
      case `keydown`:
        return t.keyCode !== 229;
      case `keypress`:
      case `mousedown`:
      case `focusout`:
        return true;
      default:
        return false;
    }
  }
  function kr(e) {
    e = e.detail;
    if (typeof e == `object` && `data` in e) {
      return e.data;
    } else {
      return null;
    }
  }
  var Ar = false;
  function jr(e, t) {
    switch (e) {
      case `compositionend`:
        return kr(t);
      case `keypress`:
        if (t.which === 32) {
          Dr = true;
          return Er;
        } else {
          return null;
        }
      case `textInput`:
        e = t.data;
        if (e === Er && Dr) {
          return null;
        } else {
          return e;
        }
      default:
        return null;
    }
  }
  function Mr(e, t) {
    if (Ar) {
      if (e === `compositionend` || !Sr && Or(e, t)) {
        e = Wn();
        Un = Hn = Vn = null;
        Ar = false;
        return e;
      } else {
        return null;
      }
    }
    switch (e) {
      case `paste`:
        return null;
      case `keypress`:
        if (!t.ctrlKey && !t.altKey && !t.metaKey || t.ctrlKey && t.altKey) {
          if (t.char && t.char.length > 1) {
            return t.char;
          }
          if (t.which) {
            return String.fromCharCode(t.which);
          }
        }
        return null;
      case `compositionend`:
        if (Tr && t.locale !== `ko`) {
          return null;
        } else {
          return t.data;
        }
      default:
        return null;
    }
  }
  var Nr = {
    color: true,
    date: true,
    datetime: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    password: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true
  };
  function Pr(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    if (t === `input`) {
      return !!Nr[e.type];
    } else {
      return t === `textarea`;
    }
  }
  function Fr(e, t, n, r) {
    if (Mn) {
      if (Nn) {
        Nn.push(r);
      } else {
        Nn = [r];
      }
    } else {
      Mn = r;
    }
    t = Jf(t, `onChange`);
    if (t.length > 0) {
      n = new Xn(`onChange`, `change`, null, n, r);
      e.push({
        event: n,
        listeners: t
      });
    }
  }
  var Ir = null;
  var Lr = null;
  function Rr(e) {
    Vf(e, 0);
  }
  function zr(e) {
    if (fn(Kt(e))) {
      return e;
    }
  }
  function Br(e, t) {
    if (e === `change`) {
      return t;
    }
  }
  var Vr = false;
  if (Rn) {
    var Hr;
    if (Rn) {
      var Ur = `oninput` in document;
      if (!Ur) {
        var Wr = document.createElement(`div`);
        Wr.setAttribute(`oninput`, `return;`);
        Ur = typeof Wr.oninput == `function`;
      }
      Hr = Ur;
    } else {
      Hr = false;
    }
    Vr = Hr && (!document.documentMode || document.documentMode > 9);
  }
  function Gr() {
    if (Ir) {
      Ir.detachEvent(`onpropertychange`, Kr);
      Lr = Ir = null;
    }
  }
  function Kr(e) {
    if (e.propertyName === `value` && zr(Lr)) {
      var t = [];
      Fr(t, Lr, e, jn(e));
      In(Rr, t);
    }
  }
  function qr(e, t, n) {
    if (e === `focusin`) {
      Gr();
      Ir = t;
      Lr = n;
      Ir.attachEvent(`onpropertychange`, Kr);
    } else if (e === `focusout`) {
      Gr();
    }
  }
  function Jr(e) {
    if (e === `selectionchange` || e === `keyup` || e === `keydown`) {
      return zr(Lr);
    }
  }
  function Yr(e, t) {
    if (e === `click`) {
      return zr(t);
    }
  }
  function Xr(e, t) {
    if (e === `input` || e === `change`) {
      return zr(t);
    }
  }
  function Zr(e, t) {
    return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
  }
  var Qr = typeof Object.is == `function` ? Object.is : Zr;
  function $r(e, t) {
    if (Qr(e, t)) {
      return true;
    }
    if (typeof e != `object` || !e || typeof t != `object` || !t) {
      return false;
    }
    var n = Object.keys(e);
    var r = Object.keys(t);
    if (n.length !== r.length) {
      return false;
    }
    for (r = 0; r < n.length; r++) {
      var i = n[r];
      if (!qe.call(t, i) || !Qr(e[i], t[i])) {
        return false;
      }
    }
    return true;
  }
  function ei(e) {
    e ||= typeof document < `u` ? document : undefined;
    if (e === undefined) {
      return null;
    }
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  function ti(e) {
    while (e && e.firstChild) {
      e = e.firstChild;
    }
    return e;
  }
  function ni(e, t) {
    var n = ti(e);
    e = 0;
    var r;
    for (; n;) {
      if (n.nodeType === 3) {
        r = e + n.textContent.length;
        if (e <= t && r >= t) {
          return {
            node: n,
            offset: t - e
          };
        }
        e = r;
      }
      a: {
        while (n) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break a;
          }
          n = n.parentNode;
        }
        n = undefined;
      }
      n = ti(n);
    }
  }
  function ri(e, t) {
    if (e && t) {
      if (e === t) {
        return true;
      } else if (e && e.nodeType === 3) {
        return false;
      } else if (t && t.nodeType === 3) {
        return ri(e, t.parentNode);
      } else if (`contains` in e) {
        return e.contains(t);
      } else if (e.compareDocumentPosition) {
        return !!(e.compareDocumentPosition(t) & 16);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  function ii(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var t = ei(e.document); t instanceof e.HTMLIFrameElement;) {
      try {
        var n = typeof t.contentWindow.location.href == `string`;
      } catch {
        n = false;
      }
      if (n) {
        e = t.contentWindow;
      } else {
        break;
      }
      t = ei(e.document);
    }
    return t;
  }
  function ai(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === `input` && (e.type === `text` || e.type === `search` || e.type === `tel` || e.type === `url` || e.type === `password`) || t === `textarea` || e.contentEditable === `true`);
  }
  var oi = Rn && `documentMode` in document && document.documentMode <= 11;
  var si = null;
  var ci = null;
  var li = null;
  var ui = false;
  function di(e, t, n) {
    var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    if (!ui && si != null && si === ei(r)) {
      r = si;
      if (`selectionStart` in r && ai(r)) {
        r = {
          start: r.selectionStart,
          end: r.selectionEnd
        };
      } else {
        r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection();
        r = {
          anchorNode: r.anchorNode,
          anchorOffset: r.anchorOffset,
          focusNode: r.focusNode,
          focusOffset: r.focusOffset
        };
      }
      if (!li || !$r(li, r)) {
        li = r;
        r = Jf(ci, `onSelect`);
        if (r.length > 0) {
          t = new Xn(`onSelect`, `select`, null, t, n);
          e.push({
            event: t,
            listeners: r
          });
          t.target = si;
        }
      }
    }
  }
  function fi(e, t) {
    var n = {};
    n[e.toLowerCase()] = t.toLowerCase();
    n[`Webkit${e}`] = `webkit${t}`;
    n[`Moz${e}`] = `moz${t}`;
    return n;
  }
  var pi = {
    animationend: fi(`Animation`, `AnimationEnd`),
    animationiteration: fi(`Animation`, `AnimationIteration`),
    animationstart: fi(`Animation`, `AnimationStart`),
    transitionrun: fi(`Transition`, `TransitionRun`),
    transitionstart: fi(`Transition`, `TransitionStart`),
    transitioncancel: fi(`Transition`, `TransitionCancel`),
    transitionend: fi(`Transition`, `TransitionEnd`)
  };
  var mi = {};
  var hi = {};
  if (Rn) {
    hi = document.createElement(`div`).style;
    if (!(`AnimationEvent` in window)) {
      delete pi.animationend.animation;
      delete pi.animationiteration.animation;
      delete pi.animationstart.animation;
    }
    if (!(`TransitionEvent` in window)) {
      delete pi.transitionend.transition;
    }
  }
  function gi(e) {
    if (mi[e]) {
      return mi[e];
    }
    if (!pi[e]) {
      return e;
    }
    var t = pi[e];
    var n;
    for (n in t) {
      if (t.hasOwnProperty(n) && n in hi) {
        return mi[e] = t[n];
      }
    }
    return e;
  }
  var _i = gi(`animationend`);
  var vi = gi(`animationiteration`);
  var yi = gi(`animationstart`);
  var bi = gi(`transitionrun`);
  var xi = gi(`transitionstart`);
  var Si = gi(`transitioncancel`);
  var Ci = gi(`transitionend`);
  var wi = new Map();
  var Ti = `abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel`.split(` `);
  Ti.push(`scrollEnd`);
  function Ei(e, t) {
    wi.set(e, t);
    Zt(t, [e]);
  }
  var Di = 0;
  function Oi(e, t) {
    if (e.name != null && e.name !== `auto`) {
      return e.name;
    }
    if (t.autoName !== null) {
      return t.autoName;
    }
    e = bd.identifierPrefix;
    var n = Di++;
    e = `_${e}t_${n.toString(32)}_`;
    return t.autoName = e;
  }
  function ki(e) {
    if (e == null || typeof e == `string`) {
      return e;
    }
    var t = null;
    var n = Od;
    if (n !== null) {
      for (var r = 0; r < n.length; r++) {
        var i = e[n[r]];
        if (i != null) {
          if (i === `none`) {
            return `none`;
          }
          t = t == null ? i : `${t} ${i}`;
        }
      }
    }
    return t ?? e.default;
  }
  function Ai(e, t) {
    e = ki(e);
    t = ki(t);
    if (t == null) {
      if (e === `auto`) {
        return null;
      } else {
        return e;
      }
    } else if (t === `auto`) {
      return null;
    } else {
      return t;
    }
  }
  var ji = typeof reportError == `function` ? reportError : function (e) {
    if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
      var t = new window.ErrorEvent(`error`, {
        bubbles: true,
        cancelable: true,
        message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) {
        return;
      }
    } else if (typeof process == `object` && typeof process.emit == `function`) {
      process.emit(`uncaughtException`, e);
      return;
    }
    console.error(e);
  };
  var Mi = [];
  var Ni = 0;
  var Pi = 0;
  function Fi() {
    for (var e = Ni, t = Pi = Ni = 0; t < e;) {
      var n = Mi[t];
      Mi[t++] = null;
      var r = Mi[t];
      Mi[t++] = null;
      var i = Mi[t];
      Mi[t++] = null;
      var a = Mi[t];
      Mi[t++] = null;
      if (r !== null && i !== null) {
        var o = r.pending;
        if (o === null) {
          i.next = i;
        } else {
          i.next = o.next;
          o.next = i;
        }
        r.pending = i;
      }
      if (a !== 0) {
        zi(n, i, a);
      }
    }
  }
  function Ii(e, t, n, r) {
    Mi[Ni++] = e;
    Mi[Ni++] = t;
    Mi[Ni++] = n;
    Mi[Ni++] = r;
    Pi |= r;
    e.lanes |= r;
    e = e.alternate;
    if (e !== null) {
      e.lanes |= r;
    }
  }
  function Li(e, t, n, r) {
    Ii(e, t, n, r);
    return Bi(e);
  }
  function Ri(e, t) {
    Ii(e, null, null, t);
    return Bi(e);
  }
  function zi(e, t, n) {
    e.lanes |= n;
    var r = e.alternate;
    if (r !== null) {
      r.lanes |= n;
    }
    var i = false;
    for (var a = e.return; a !== null;) {
      a.childLanes |= n;
      r = a.alternate;
      if (r !== null) {
        r.childLanes |= n;
      }
      if (a.tag === 22) {
        e = a.stateNode;
        if (e !== null && !(e._visibility & 1)) {
          i = true;
        }
      }
      e = a;
      a = a.return;
    }
    if (e.tag === 3) {
      a = e.stateNode;
      if (i && t !== null) {
        i = 31 - ut(n);
        e = a.hiddenUpdates;
        r = e[i];
        if (r === null) {
          e[i] = [t];
        } else {
          r.push(t);
        }
        t.lane = n | 536870912;
      }
      return a;
    } else {
      return null;
    }
  }
  function Bi(e) {
    if (kd > 50) {
      kd = 0;
      Ad = null;
      throw Error(s(185));
    }
    for (var t = e.return; t !== null;) {
      e = t;
      t = e.return;
    }
    if (e.tag === 3) {
      return e.stateNode;
    } else {
      return null;
    }
  }
  var Vi = {};
  function Hi(e, t, n, r) {
    this.tag = e;
    this.key = n;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = t;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = r;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function Ui(e, t, n, r) {
    return new Hi(e, t, n, r);
  }
  function Wi(e) {
    e = e.prototype;
    return !!e && !!e.isReactComponent;
  }
  function Gi(e, t) {
    var n = e.alternate;
    if (n === null) {
      n = Ui(e.tag, t, e.key, e.mode);
      n.elementType = e.elementType;
      n.type = e.type;
      n.stateNode = e.stateNode;
      n.alternate = e;
      e.alternate = n;
    } else {
      n.pendingProps = t;
      n.type = e.type;
      n.flags = 0;
      n.subtreeFlags = 0;
      n.deletions = null;
    }
    n.flags = e.flags & 1206910976;
    n.childLanes = e.childLanes;
    n.lanes = e.lanes;
    n.child = e.child;
    n.memoizedProps = e.memoizedProps;
    n.memoizedState = e.memoizedState;
    n.updateQueue = e.updateQueue;
    t = e.dependencies;
    n.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    };
    n.sibling = e.sibling;
    n.index = e.index;
    n.ref = e.ref;
    n.refCleanup = e.refCleanup;
    return n;
  }
  function Ki(e, t) {
    e.flags &= 1206910978;
    var n = e.alternate;
    if (n === null) {
      e.childLanes = 0;
      e.lanes = t;
      e.child = null;
      e.subtreeFlags = 0;
      e.memoizedProps = null;
      e.memoizedState = null;
      e.updateQueue = null;
      e.dependencies = null;
      e.stateNode = null;
    } else {
      e.childLanes = n.childLanes;
      e.lanes = n.lanes;
      e.child = n.child;
      e.subtreeFlags = 0;
      e.deletions = null;
      e.memoizedProps = n.memoizedProps;
      e.memoizedState = n.memoizedState;
      e.updateQueue = n.updateQueue;
      e.type = n.type;
      t = n.dependencies;
      e.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext
      };
    }
    return e;
  }
  function qi(e, t, n, r, i, a) {
    var o = 0;
    r = e;
    if (typeof r == `function`) {
      if (Wi(r)) {
        o = 1;
      }
    } else if (typeof r == `string`) {
      o = qm(e, n, Me.current) ? 26 : e === `html` || e === `head` || e === `body` ? 27 : 5;
    } else {
      a: switch (r) {
        case ve:
          e = Ui(31, n, t, i);
          e.elementType = ve;
          e.lanes = a;
          return e;
        case ce:
          return Ji(n.children, i, a, t);
        case le:
          o = 8;
          i |= 24;
          break;
        case ue:
          e = Ui(12, n, t, i | 2);
          e.elementType = ue;
          e.lanes = a;
          return e;
        case me:
          e = Ui(13, n, t, i);
          e.elementType = me;
          e.lanes = a;
          return e;
        case he:
          e = Ui(19, n, t, i);
          e.elementType = he;
          e.lanes = a;
          return e;
        case ye:
        case xe:
          e = i | 32;
          e = Ui(30, n, t, e);
          e.elementType = xe;
          e.lanes = a;
          e.stateNode = {
            autoName: null,
            paired: null,
            clones: null,
            ref: null
          };
          return e;
        default:
          if (typeof r == `object` && r) {
            switch (r.$$typeof) {
              case fe:
                o = 10;
                break a;
              case de:
                o = 9;
                break a;
              case pe:
                o = 11;
                break a;
              case ge:
                o = 14;
                break a;
              case _e:
                o = 16;
                r = null;
                break a;
            }
          }
          o = 29;
          n = Error(s(130, e === null ? `null` : typeof e, ``));
          r = null;
      }
    }
    t = Ui(o, n, t, i);
    t.elementType = e;
    t.type = r;
    t.lanes = a;
    return t;
  }
  function Ji(e, t, n, r) {
    e = Ui(7, e, r, t);
    e.lanes = n;
    return e;
  }
  function Yi(e, t, n) {
    e = Ui(6, e, null, t);
    e.lanes = n;
    return e;
  }
  function Xi(e) {
    var t = Ui(18, null, null, 0);
    t.stateNode = e;
    return t;
  }
  function Zi(e, t, n) {
    t = Ui(4, e.children === null ? [] : e.children, e.key, t);
    t.lanes = n;
    t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    };
    return t;
  }
  var Qi = new WeakMap();
  function $i(e, t) {
    if (typeof e == `object` && e) {
      var n = Qi.get(e);
      if (n === undefined) {
        t = {
          value: e,
          source: t,
          stack: Ke(t)
        };
        Qi.set(e, t);
        return t;
      } else {
        return n;
      }
    }
    return {
      value: e,
      source: t,
      stack: Ke(t)
    };
  }
  var ea = [];
  var ta = 0;
  var na = null;
  var ra = 0;
  var ia = [];
  var aa = 0;
  var oa = null;
  var sa = 1;
  var ca = ``;
  function la(e, t) {
    ea[ta++] = ra;
    ea[ta++] = na;
    na = e;
    ra = t;
  }
  function ua(e, t, n) {
    ia[aa++] = sa;
    ia[aa++] = ca;
    ia[aa++] = oa;
    oa = e;
    var r = sa;
    e = ca;
    var i = 32 - ut(r) - 1;
    r &= ~(1 << i);
    n += 1;
    var a = 32 - ut(t) + i;
    if (a > 30) {
      var o = i - i % 5;
      a = (r & (1 << o) - 1).toString(32);
      r >>= o;
      i -= o;
      sa = 1 << 32 - ut(t) + i | n << i | r;
      ca = a + e;
    } else {
      sa = 1 << a | n << i | r;
      ca = e;
    }
  }
  function da(e) {
    if (e.return !== null) {
      la(e, 1);
      ua(e, 1, 0);
    }
  }
  function fa(e) {
    while (e === na) {
      na = ea[--ta];
      ea[ta] = null;
      ra = ea[--ta];
      ea[ta] = null;
    }
    while (e === oa) {
      oa = ia[--aa];
      ia[aa] = null;
      ca = ia[--aa];
      ia[aa] = null;
      sa = ia[--aa];
      ia[aa] = null;
    }
  }
  function pa(e, t) {
    ia[aa++] = sa;
    ia[aa++] = ca;
    ia[aa++] = oa;
    sa = t.id;
    ca = t.overflow;
    oa = e;
  }
  var k = null;
  var A = null;
  var j = false;
  var ma = null;
  var ha = false;
  var ga = Error(s(519));
  function _a(e) {
    Ca($i(Error(s(418, arguments.length > 1 && arguments[1] !== undefined && arguments[1] ? `text` : `HTML`, ``)), e));
    throw ga;
  }
  function va(e) {
    var t = e.stateNode;
    var n = e.type;
    var r = e.memoizedProps;
    t[Pt] = e;
    t[Ft] = r;
    switch (n) {
      case `dialog`:
        Q(`cancel`, t);
        Q(`close`, t);
        break;
      case `iframe`:
      case `object`:
      case `embed`:
        Q(`load`, t);
        break;
      case `video`:
      case `audio`:
        for (n = 0; n < zf.length; n++) {
          Q(zf[n], t);
        }
        break;
      case `source`:
        Q(`error`, t);
        break;
      case `img`:
      case `image`:
      case `link`:
        Q(`error`, t);
        Q(`load`, t);
        break;
      case `details`:
        Q(`toggle`, t);
        break;
      case `input`:
        Q(`invalid`, t);
        gn(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, true);
        break;
      case `select`:
        Q(`invalid`, t);
        break;
      case `textarea`:
        Q(`invalid`, t);
        bn(t, r.value, r.defaultValue, r.children);
    }
    n = r.children;
    if (typeof n != `string` && typeof n != `number` && typeof n != `bigint` || t.textContent === `${n}` || r.suppressHydrationWarning === true || ep(t.textContent, n)) {
      if (r.popover != null) {
        Q(`beforetoggle`, t);
        Q(`toggle`, t);
      }
      if (r.onScroll != null) {
        Q(`scroll`, t);
      }
      if (r.onScrollEnd != null) {
        Q(`scrollend`, t);
      }
      if (r.onClick != null) {
        t.onclick = kn;
      }
      t = true;
    } else {
      t = false;
    }
    if (!t) {
      _a(e, true);
    }
  }
  function ya(e) {
    for (k = e.return; k;) {
      switch (k.tag) {
        case 5:
        case 31:
        case 13:
          ha = false;
          return;
        case 27:
        case 3:
          ha = true;
          return;
        default:
          k = k.return;
      }
    }
  }
  function ba(e) {
    if (e !== k) {
      return false;
    }
    if (!j) {
      ya(e);
      j = true;
      return false;
    }
    var t = e.tag;
    var n;
    if (n = t !== 3 && t !== 27) {
      if (n = t === 5) {
        n = e.type;
        n = n === `form` || n === `button` || pp(e.type, e.memoizedProps);
      }
      n = !n;
    }
    if (n && A) {
      _a(e);
    }
    ya(e);
    if (t === 13) {
      e = e.memoizedState;
      e = e === null ? null : e.dehydrated;
      if (!e) {
        throw Error(s(317));
      }
      A = dm(e);
    } else if (t === 31) {
      e = e.memoizedState;
      e = e === null ? null : e.dehydrated;
      if (!e) {
        throw Error(s(317));
      }
      A = dm(e);
    } else if (t === 27) {
      t = A;
      if (Sp(e.type)) {
        e = um;
        um = null;
        A = e;
      } else {
        A = t;
      }
    } else {
      A = k ? lm(e.stateNode.nextSibling) : null;
    }
    return true;
  }
  function xa() {
    A = k = null;
    j = false;
  }
  function Sa() {
    var e = ma;
    if (e !== null) {
      if (pd === null) {
        pd = e;
      } else {
        pd.push.apply(pd, e);
      }
      ma = null;
    }
    return e;
  }
  function Ca(e) {
    if (ma === null) {
      ma = [e];
    } else {
      ma.push(e);
    }
  }
  var wa = je(null);
  var Ta = null;
  var Ea = null;
  function Da(e, t, n) {
    E(wa, t._currentValue);
    t._currentValue = n;
  }
  function Oa(e) {
    e._currentValue = wa.current;
    T(wa);
  }
  function ka(e, t, n) {
    while (e !== null) {
      var r = e.alternate;
      if ((e.childLanes & t) === t) {
        if (r !== null && (r.childLanes & t) !== t) {
          r.childLanes |= t;
        }
      } else {
        e.childLanes |= t;
        if (r !== null) {
          r.childLanes |= t;
        }
      }
      if (e === n) {
        break;
      }
      e = e.return;
    }
  }
  function Aa(e, t, n, r) {
    var i = e.child;
    for (i !== null && (i.return = e); i !== null;) {
      var a = i.dependencies;
      if (a !== null) {
        var o = i.child;
        a = a.firstContext;
        a: while (a !== null) {
          var c = a;
          a = i;
          for (var l = 0; l < t.length; l++) {
            if (c.context === t[l]) {
              a.lanes |= n;
              c = a.alternate;
              if (c !== null) {
                c.lanes |= n;
              }
              ka(a.return, n, e);
              if (!r) {
                o = null;
              }
              break a;
            }
          }
          a = c.next;
        }
      } else if (i.tag === 18) {
        o = i.return;
        if (o === null) {
          throw Error(s(341));
        }
        o.lanes |= n;
        a = o.alternate;
        if (a !== null) {
          a.lanes |= n;
        }
        ka(o, n, e);
        o = null;
      } else if (i.tag === 13 && i.memoizedState !== null && i.memoizedState.dehydrated === null) {
        i.lanes |= n;
        o = i.alternate;
        if (o !== null) {
          o.lanes |= n;
        }
        ka(i.return, n, e);
        o = i.child;
        o = o === null ? null : o.sibling;
      } else {
        o = i.child;
      }
      if (o !== null) {
        o.return = i;
      } else {
        for (o = i; o !== null;) {
          if (o === e) {
            o = null;
            break;
          }
          i = o.sibling;
          if (i !== null) {
            i.return = o.return;
            o = i;
            break;
          }
          o = o.return;
        }
      }
      i = o;
    }
  }
  function ja(e, t, n, r) {
    e = null;
    for (var i = t, a = false; i !== null;) {
      if (!a) {
        if (i.flags & 524288) {
          a = true;
        } else if (i.flags & 262144) {
          break;
        }
      }
      if (i.tag === 10) {
        var o = i.alternate;
        if (o === null) {
          throw Error(s(387));
        }
        o = o.memoizedProps;
        if (o !== null) {
          var c = i.type;
          if (!Qr(i.pendingProps.value, o.value)) {
            if (e === null) {
              e = [c];
            } else {
              e.push(c);
            }
          }
        }
      } else if (i === Fe.current) {
        o = i.alternate;
        if (o === null) {
          throw Error(s(387));
        }
        if (o.memoizedState.memoizedState !== i.memoizedState.memoizedState) {
          if (e === null) {
            e = [sh];
          } else {
            e.push(sh);
          }
        }
      }
      i = i.return;
    }
    if (e !== null) {
      Aa(t, e, n, r);
    }
    t.flags |= 262144;
    return e !== null;
  }
  function Ma(e) {
    for (e = e.firstContext; e !== null;) {
      if (!Qr(e.context._currentValue, e.memoizedValue)) {
        return true;
      }
      e = e.next;
    }
    return false;
  }
  function Na(e) {
    Ta = e;
    Ea = null;
    e = e.dependencies;
    if (e !== null) {
      e.firstContext = null;
    }
  }
  function Pa(e) {
    return Ia(Ta, e);
  }
  function Fa(e, t) {
    if (Ta === null) {
      Na(e);
    }
    return Ia(e, t);
  }
  function Ia(e, t) {
    var n = t._currentValue;
    t = {
      context: t,
      memoizedValue: n,
      next: null
    };
    if (Ea === null) {
      if (e === null) {
        throw Error(s(308));
      }
      Ea = t;
      e.dependencies = {
        lanes: 0,
        firstContext: t
      };
      e.flags |= 524288;
    } else {
      Ea = Ea.next = t;
    }
    return n;
  }
  var La = typeof AbortController < `u` ? AbortController : function () {
    var e = [];
    var t = this.signal = {
      aborted: false,
      addEventListener: function (t, n) {
        e.push(n);
      }
    };
    this.abort = function () {
      t.aborted = true;
      e.forEach(function (e) {
        return e();
      });
    };
  };
  var Ra = t.unstable_scheduleCallback;
  var za = t.unstable_NormalPriority;
  var M = {
    $$typeof: fe,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Ba() {
    return {
      controller: new La(),
      data: new Map(),
      refCount: 0
    };
  }
  function Va(e) {
    e.refCount--;
    if (e.refCount === 0) {
      Ra(za, function () {
        e.controller.abort();
      });
    }
  }
  function Ha(e, t) {
    if (e.pendingLanes & 4194048) {
      var n = e.transitionTypes;
      if (n === null) {
        n = e.transitionTypes = [];
      }
      e = 0;
      for (; e < t.length; e++) {
        var r = t[e];
        if (n.indexOf(r) === -1) {
          n.push(r);
        }
      }
    }
  }
  var Ua = null;
  function Wa(e) {
    var t = e.transitionTypes;
    e.transitionTypes = null;
    return t;
  }
  var Ga = null;
  var Ka = 0;
  var qa = 0;
  var Ja = null;
  function Ya(e, t) {
    if (Ga === null) {
      var n = Ga = [];
      Ka = 0;
      qa = Pf();
      Ja = {
        status: `pending`,
        value: undefined,
        then: function (e) {
          n.push(e);
        }
      };
    }
    Ka++;
    t.then(Xa, Xa);
    return t;
  }
  function Xa() {
    if (--Ka === 0 && (Ua = null, Ga !== null)) {
      if (Ja !== null) {
        Ja.status = `fulfilled`;
      }
      var e = Ga;
      Ga = null;
      qa = 0;
      Ja = null;
      for (var t = 0; t < e.length; t++) {
        (0, e[t])();
      }
    }
  }
  function Za(e, t) {
    var n = [];
    var r = {
      status: `pending`,
      value: null,
      reason: null,
      then: function (e) {
        n.push(e);
      }
    };
    e.then(function () {
      r.status = `fulfilled`;
      r.value = t;
      for (var e = 0; e < n.length; e++) {
        (0, n[e])(t);
      }
    }, function (e) {
      r.status = `rejected`;
      r.reason = e;
      e = 0;
      for (; e < n.length; e++) {
        (0, n[e])(undefined);
      }
    });
    return r;
  }
  var Qa = C.S;
  C.S = function (e, t) {
    gd = Qe();
    if (typeof t == `object` && t && typeof t.then == `function`) {
      Ya(e, t);
    }
    if (Ua !== null) {
      for (var n = bf; n !== null;) {
        Ha(n, Ua);
        n = n.next;
      }
    }
    n = e.types;
    if (n !== null) {
      for (var r = bf; r !== null;) {
        Ha(r, n);
        r = r.next;
      }
      if (qa !== 0) {
        r = Ua;
        if (r === null) {
          r = Ua = [];
        }
        for (var i = 0; i < n.length; i++) {
          var a = n[i];
          if (r.indexOf(a) === -1) {
            r.push(a);
          }
        }
      }
    }
    if (Qa !== null) {
      Qa(e, t);
    }
  };
  var $a = je(null);
  function eo() {
    var e = $a.current;
    if (e === null) {
      return G.pooledCache;
    } else {
      return e;
    }
  }
  function to(e, t) {
    if (t === null) {
      E($a, $a.current);
    } else {
      E($a, t.pool);
    }
  }
  function no() {
    var e = eo();
    if (e === null) {
      return null;
    } else {
      return {
        parent: M._currentValue,
        pool: e
      };
    }
  }
  var ro = Error(s(460));
  var io = Error(s(474));
  var ao = Error(s(542));
  var oo = {
    then: function () {}
  };
  function so(e) {
    e = e.status;
    return e === `fulfilled` || e === `rejected`;
  }
  function co(e, t, n) {
    n = e[n];
    if (n === undefined) {
      e.push(t);
    } else if (n !== t) {
      t.then(kn, kn);
      t = n;
    }
    switch (t.status) {
      case `fulfilled`:
        return t.value;
      case `rejected`:
        e = t.reason;
        po(e);
        throw e === undefined && !(`reason` in t) ? Error(s(600)) : e;
      default:
        if (typeof t.status == `string`) {
          t.then(kn, kn);
        } else {
          e = G;
          if (e !== null && e.shellSuspendCounter > 100) {
            throw Error(s(482));
          }
          e = t;
          e.status = `pending`;
          e.then(function (e) {
            if (t.status === `pending`) {
              var n = t;
              n.status = `fulfilled`;
              n.value = e;
            }
          }, function (e) {
            if (t.status === `pending`) {
              var n = t;
              n.status = `rejected`;
              n.reason = e;
            }
          });
        }
        switch (t.status) {
          case `fulfilled`:
            return t.value;
          case `rejected`:
            e = t.reason;
            po(e);
            throw e;
        }
        uo = t;
        throw ro;
    }
  }
  function lo(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (e) {
      throw typeof e == `object` && e && typeof e.then == `function` ? (uo = e, ro) : e;
    }
  }
  var uo = null;
  function fo() {
    if (uo === null) {
      throw Error(s(459));
    }
    var e = uo;
    uo = null;
    return e;
  }
  function po(e) {
    if (e === ro || e === ao) {
      throw Error(s(483));
    }
  }
  var mo = null;
  var ho = 0;
  function go(e) {
    var t = ho;
    ho += 1;
    if (mo === null) {
      mo = [];
    }
    return co(mo, e, t);
  }
  function _o(e, t) {
    t = t.props.ref;
    e.ref = t === undefined ? null : t;
  }
  function vo(e, t) {
    throw t.$$typeof === ae ? Error(s(525)) : (e = Object.prototype.toString.call(t), Error(s(31, e === `[object Object]` ? `object with keys {${Object.keys(t).join(`, `)}}` : e)));
  }
  function yo(e) {
    function t(t, n) {
      if (e) {
        var r = t.deletions;
        if (r === null) {
          t.deletions = [n];
          t.flags |= 16;
        } else {
          r.push(n);
        }
      }
    }
    function n(n, r) {
      if (!e) {
        return null;
      }
      while (r !== null) {
        t(n, r);
        r = r.sibling;
      }
      return null;
    }
    function r(e) {
      var t = new Map();
      for (; e !== null;) {
        if (e.key === null) {
          t.set(e.index, e);
        } else {
          t.set(e.key, e);
        }
        e = e.sibling;
      }
      return t;
    }
    function i(e, t) {
      e = Gi(e, t);
      e.index = 0;
      e.sibling = null;
      return e;
    }
    function a(t, n, r) {
      t.index = r;
      if (e) {
        r = t.alternate;
        if (r === null) {
          t.flags |= 134217730;
          return n;
        } else {
          r = r.index;
          if (r < n) {
            t.flags |= 2;
            return n;
          } else {
            return r;
          }
        }
      } else {
        t.flags |= 1048576;
        return n;
      }
    }
    function o(t) {
      if (e && t.alternate === null) {
        t.flags |= 134217730;
      }
      return t;
    }
    function c(e, t, n, r) {
      if (t === null || t.tag !== 6) {
        t = Yi(n, e.mode, r);
        t.return = e;
        return t;
      } else {
        t = i(t, n);
        t.return = e;
        return t;
      }
    }
    function l(e, t, n, r) {
      var a = n.type;
      if (a === ce) {
        e = d(e, t, n.props.children, r, n.key);
        _o(e, n);
        return e;
      } else if (t !== null && (t.elementType === a || typeof a == `object` && a && a.$$typeof === _e && lo(a) === t.type)) {
        t = i(t, n.props);
        _o(t, n);
        t.return = e;
        return t;
      } else {
        t = qi(n.type, n.key, n.props, null, e.mode, r);
        _o(t, n);
        t.return = e;
        return t;
      }
    }
    function u(e, t, n, r) {
      if (t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation) {
        t = Zi(n, e.mode, r);
        t.return = e;
        return t;
      } else {
        t = i(t, n.children || []);
        t.return = e;
        return t;
      }
    }
    function d(e, t, n, r, a) {
      if (t === null || t.tag !== 7) {
        t = Ji(n, e.mode, r, a);
        t.return = e;
        return t;
      } else {
        t = i(t, n);
        t.return = e;
        return t;
      }
    }
    function f(e, t, n) {
      if (typeof t == `string` && t !== `` || typeof t == `number` || typeof t == `bigint`) {
        t = Yi(`${t}`, e.mode, n);
        t.return = e;
        return t;
      }
      if (typeof t == `object` && t) {
        switch (t.$$typeof) {
          case oe:
            n = qi(t.type, t.key, t.props, null, e.mode, n);
            _o(n, t);
            n.return = e;
            return n;
          case se:
            t = Zi(t, e.mode, n);
            t.return = e;
            return t;
          case _e:
            t = lo(t);
            return f(e, t, n);
        }
        if (De(t) || we(t)) {
          t = Ji(t, e.mode, n, null);
          t.return = e;
          return t;
        }
        if (typeof t.then == `function`) {
          return f(e, go(t), n);
        }
        if (t.$$typeof === fe) {
          return f(e, Fa(e, t), n);
        }
        vo(e, t);
      }
      return null;
    }
    function p(e, t, n, r) {
      var i = t === null ? null : t.key;
      if (typeof n == `string` && n !== `` || typeof n == `number` || typeof n == `bigint`) {
        if (i === null) {
          return c(e, t, `${n}`, r);
        } else {
          return null;
        }
      }
      if (typeof n == `object` && n) {
        switch (n.$$typeof) {
          case oe:
            if (n.key === i) {
              return l(e, t, n, r);
            } else {
              return null;
            }
          case se:
            if (n.key === i) {
              return u(e, t, n, r);
            } else {
              return null;
            }
          case _e:
            n = lo(n);
            return p(e, t, n, r);
        }
        if (De(n) || we(n)) {
          if (i === null) {
            return d(e, t, n, r, null);
          } else {
            return null;
          }
        }
        if (typeof n.then == `function`) {
          return p(e, t, go(n), r);
        }
        if (n.$$typeof === fe) {
          return p(e, t, Fa(e, n), r);
        }
        vo(e, n);
      }
      return null;
    }
    function m(e, t, n, r, i) {
      if (typeof r == `string` && r !== `` || typeof r == `number` || typeof r == `bigint`) {
        e = e.get(n) || null;
        return c(t, e, `${r}`, i);
      }
      if (typeof r == `object` && r) {
        switch (r.$$typeof) {
          case oe:
            e = e.get(r.key === null ? n : r.key) || null;
            return l(t, e, r, i);
          case se:
            e = e.get(r.key === null ? n : r.key) || null;
            return u(t, e, r, i);
          case _e:
            r = lo(r);
            return m(e, t, n, r, i);
        }
        if (De(r) || we(r)) {
          e = e.get(n) || null;
          return d(t, e, r, i, null);
        }
        if (typeof r.then == `function`) {
          return m(e, t, n, go(r), i);
        }
        if (r.$$typeof === fe) {
          return m(e, t, n, Fa(t, r), i);
        }
        vo(t, r);
      }
      return null;
    }
    function h(i, o, s, c) {
      var l = null;
      var u = null;
      for (var d = o, h = o = 0, g = null; d !== null && h < s.length; h++) {
        if (d.index > h) {
          g = d;
          d = null;
        } else {
          g = d.sibling;
        }
        var _ = p(i, d, s[h], c);
        if (_ === null) {
          if (d === null) {
            d = g;
          }
          break;
        }
        if (e && d && _.alternate === null) {
          t(i, d);
        }
        o = a(_, o, h);
        if (u === null) {
          l = _;
        } else {
          u.sibling = _;
        }
        u = _;
        d = g;
      }
      if (h === s.length) {
        n(i, d);
        if (j) {
          la(i, h);
        }
        return l;
      }
      if (d === null) {
        for (; h < s.length; h++) {
          d = f(i, s[h], c);
          if (d !== null) {
            o = a(d, o, h);
            if (u === null) {
              l = d;
            } else {
              u.sibling = d;
            }
            u = d;
          }
        }
        if (j) {
          la(i, h);
        }
        return l;
      }
      for (d = r(d); h < s.length; h++) {
        g = m(d, i, h, s[h], c);
        if (g !== null) {
          if (e) {
            _ = g.alternate;
            if (_ !== null) {
              d.delete(_.key === null ? h : _.key);
            }
          }
          o = a(g, o, h);
          if (u === null) {
            l = g;
          } else {
            u.sibling = g;
          }
          u = g;
        }
      }
      if (e) {
        d.forEach(function (e) {
          return t(i, e);
        });
      }
      if (j) {
        la(i, h);
      }
      return l;
    }
    function g(i, o, c, l) {
      if (c == null) {
        throw Error(s(151));
      }
      var u = null;
      var d = null;
      for (var h = o, g = o = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
        if (h.index > g) {
          _ = h;
          h = null;
        } else {
          _ = h.sibling;
        }
        var y = p(i, h, v.value, l);
        if (y === null) {
          if (h === null) {
            h = _;
          }
          break;
        }
        if (e && h && y.alternate === null) {
          t(i, h);
        }
        o = a(y, o, g);
        if (d === null) {
          u = y;
        } else {
          d.sibling = y;
        }
        d = y;
        h = _;
      }
      if (v.done) {
        n(i, h);
        if (j) {
          la(i, g);
        }
        return u;
      }
      if (h === null) {
        for (; !v.done; g++, v = c.next()) {
          v = f(i, v.value, l);
          if (v !== null) {
            o = a(v, o, g);
            if (d === null) {
              u = v;
            } else {
              d.sibling = v;
            }
            d = v;
          }
        }
        if (j) {
          la(i, g);
        }
        return u;
      }
      for (h = r(h); !v.done; g++, v = c.next()) {
        v = m(h, i, g, v.value, l);
        if (v !== null) {
          if (e) {
            _ = v.alternate;
            if (_ !== null) {
              h.delete(_.key === null ? g : _.key);
            }
          }
          o = a(v, o, g);
          if (d === null) {
            u = v;
          } else {
            d.sibling = v;
          }
          d = v;
        }
      }
      if (e) {
        h.forEach(function (e) {
          return t(i, e);
        });
      }
      if (j) {
        la(i, g);
      }
      return u;
    }
    function _(e, r, a, c) {
      if (typeof a == `object` && a && a.type === ce && a.key === null && a.props.ref === undefined) {
        a = a.props.children;
      }
      if (typeof a == `object` && a) {
        switch (a.$$typeof) {
          case oe:
            a: {
              var l = a.key;
              for (; r !== null;) {
                if (r.key === l) {
                  l = a.type;
                  if (l === ce) {
                    if (r.tag === 7) {
                      n(e, r.sibling);
                      c = i(r, a.props.children);
                      _o(c, a);
                      c.return = e;
                      e = c;
                      break a;
                    }
                  } else if (r.elementType === l || typeof l == `object` && l && l.$$typeof === _e && lo(l) === r.type) {
                    n(e, r.sibling);
                    c = i(r, a.props);
                    _o(c, a);
                    c.return = e;
                    e = c;
                    break a;
                  }
                  n(e, r);
                  break;
                }
                t(e, r);
                r = r.sibling;
              }
              if (a.type === ce) {
                c = Ji(a.props.children, e.mode, c, a.key);
                _o(c, a);
                c.return = e;
                e = c;
              } else {
                c = qi(a.type, a.key, a.props, null, e.mode, c);
                _o(c, a);
                c.return = e;
                e = c;
              }
            }
            return o(e);
          case se:
            a: {
              for (l = a.key; r !== null;) {
                if (r.key === l) {
                  if (r.tag === 4 && r.stateNode.containerInfo === a.containerInfo && r.stateNode.implementation === a.implementation) {
                    n(e, r.sibling);
                    c = i(r, a.children || []);
                    c.return = e;
                    e = c;
                    break a;
                  }
                  n(e, r);
                  break;
                }
                t(e, r);
                r = r.sibling;
              }
              c = Zi(a, e.mode, c);
              c.return = e;
              e = c;
            }
            return o(e);
          case _e:
            a = lo(a);
            return _(e, r, a, c);
        }
        if (De(a)) {
          return h(e, r, a, c);
        }
        if (we(a)) {
          l = we(a);
          if (typeof l != `function`) {
            throw Error(s(150));
          }
          a = l.call(a);
          return g(e, r, a, c);
        }
        if (typeof a.then == `function`) {
          return _(e, r, go(a), c);
        }
        if (a.$$typeof === fe) {
          return _(e, r, Fa(e, a), c);
        }
        vo(e, a);
      }
      if (typeof a == `string` && a !== `` || typeof a == `number` || typeof a == `bigint`) {
        a = `${a}`;
        if (r !== null && r.tag === 6) {
          n(e, r.sibling);
          c = i(r, a);
          c.return = e;
          e = c;
        } else {
          n(e, r);
          c = Yi(a, e.mode, c);
          c.return = e;
          e = c;
        }
        return o(e);
      } else {
        return n(e, r);
      }
    }
    return function (e, t, n, r) {
      try {
        ho = 0;
        var i = _(e, t, n, r);
        mo = null;
        return i;
      } catch (t) {
        if (t === ro || t === ao) {
          throw t;
        }
        var a = Ui(29, t, null, e.mode);
        a.lanes = r;
        a.return = e;
        return a;
      }
    };
  }
  var bo = yo(true);
  var xo = yo(false);
  var So = false;
  function Co(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        lanes: 0,
        hiddenCallbacks: null
      },
      callbacks: null
    };
  }
  function wo(e, t) {
    e = e.updateQueue;
    if (t.updateQueue === e) {
      t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        callbacks: null
      };
    }
  }
  function To(e) {
    return {
      lane: e,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function Eo(e, t, n) {
    var r = e.updateQueue;
    if (r === null) {
      return null;
    }
    r = r.shared;
    if (W & 2) {
      var i = r.pending;
      if (i === null) {
        t.next = t;
      } else {
        t.next = i.next;
        i.next = t;
      }
      r.pending = t;
      t = Bi(e);
      zi(e, null, n);
      return t;
    }
    Ii(e, r, t, n);
    return Bi(e);
  }
  function Do(e, t, n) {
    t = t.updateQueue;
    if (t !== null && (t = t.shared, n & 4194048)) {
      var r = t.lanes;
      r &= e.pendingLanes;
      n |= r;
      t.lanes = n;
      Dt(e, n);
    }
  }
  function Oo(e, t) {
    var n = e.updateQueue;
    var r = e.alternate;
    if (r !== null && (r = r.updateQueue, n === r)) {
      var i = null;
      var a = null;
      n = n.firstBaseUpdate;
      if (n !== null) {
        do {
          var o = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          if (a === null) {
            i = a = o;
          } else {
            a = a.next = o;
          }
          n = n.next;
        } while (n !== null);
        if (a === null) {
          i = a = t;
        } else {
          a = a.next = t;
        }
      } else {
        i = a = t;
      }
      n = {
        baseState: r.baseState,
        firstBaseUpdate: i,
        lastBaseUpdate: a,
        shared: r.shared,
        callbacks: r.callbacks
      };
      e.updateQueue = n;
      return;
    }
    e = n.lastBaseUpdate;
    if (e === null) {
      n.firstBaseUpdate = t;
    } else {
      e.next = t;
    }
    n.lastBaseUpdate = t;
  }
  var ko = false;
  function Ao() {
    if (ko) {
      var e = Ja;
      if (e !== null) {
        throw e;
      }
    }
  }
  function jo(e, t, n, r) {
    ko = false;
    var i = e.updateQueue;
    So = false;
    var a = i.firstBaseUpdate;
    var o = i.lastBaseUpdate;
    var s = i.shared.pending;
    if (s !== null) {
      i.shared.pending = null;
      var c = s;
      var l = c.next;
      c.next = null;
      if (o === null) {
        a = l;
      } else {
        o.next = l;
      }
      o = c;
      var u = e.alternate;
      if (u !== null) {
        u = u.updateQueue;
        s = u.lastBaseUpdate;
        if (s !== o) {
          if (s === null) {
            u.firstBaseUpdate = l;
          } else {
            s.next = l;
          }
          u.lastBaseUpdate = c;
        }
      }
    }
    if (a !== null) {
      var d = i.baseState;
      o = 0;
      u = l = c = null;
      s = a;
      do {
        var f = s.lane & -536870913;
        var p = f !== s.lane;
        if (p ? (q & f) === f : (r & f) === f) {
          if (f !== 0 && f === qa) {
            ko = true;
          }
          if (u !== null) {
            u = u.next = {
              lane: 0,
              tag: s.tag,
              payload: s.payload,
              callback: null,
              next: null
            };
          }
          a: {
            var m = e;
            var h = s;
            f = t;
            var g = n;
            switch (h.tag) {
              case 1:
                m = h.payload;
                if (typeof m == `function`) {
                  d = m.call(g, d, f);
                  break a;
                }
                d = m;
                break a;
              case 3:
                m.flags = m.flags & -65537 | 128;
              case 0:
                m = h.payload;
                f = typeof m == `function` ? m.call(g, d, f) : m;
                if (f == null) {
                  break a;
                }
                d = S({}, d, f);
                break a;
              case 2:
                So = true;
            }
          }
          f = s.callback;
          if (f !== null) {
            e.flags |= 64;
            if (p) {
              e.flags |= 8192;
            }
            p = i.callbacks;
            if (p === null) {
              i.callbacks = [f];
            } else {
              p.push(f);
            }
          }
        } else {
          p = {
            lane: f,
            tag: s.tag,
            payload: s.payload,
            callback: s.callback,
            next: null
          };
          if (u === null) {
            l = u = p;
            c = d;
          } else {
            u = u.next = p;
          }
          o |= f;
        }
        s = s.next;
        if (s === null) {
          s = i.shared.pending;
          if (s === null) {
            break;
          }
          p = s;
          s = p.next;
          p.next = null;
          i.lastBaseUpdate = p;
          i.shared.pending = null;
        }
      } while (1);
      if (u === null) {
        c = d;
      }
      i.baseState = c;
      i.firstBaseUpdate = l;
      i.lastBaseUpdate = u;
      if (a === null) {
        i.shared.lanes = 0;
      }
      sd |= o;
      e.lanes = o;
      e.memoizedState = d;
    }
  }
  function Mo(e, t) {
    if (typeof e != `function`) {
      throw Error(s(191, e));
    }
    e.call(t);
  }
  function No(e, t) {
    var n = e.callbacks;
    if (n !== null) {
      e.callbacks = null;
      e = 0;
      for (; e < n.length; e++) {
        Mo(n[e], t);
      }
    }
  }
  var Po = je(null);
  var Fo = je(0);
  function Io(e, t) {
    e = od;
    E(Fo, e);
    E(Po, t);
    od = e | t.baseLanes;
  }
  function Lo() {
    E(Fo, od);
    E(Po, Po.current);
  }
  function Ro() {
    od = Fo.current;
    T(Po);
    T(Fo);
  }
  var zo = je(null);
  var Bo = null;
  function Vo(e) {
    var t = e.alternate;
    E(Ko, Ko.current & 1);
    E(zo, e);
    if (Bo === null && (t === null || Po.current !== null || t.memoizedState !== null)) {
      Bo = e;
    }
  }
  function Ho(e) {
    E(Ko, Ko.current);
    E(zo, e);
    if (Bo === null) {
      Bo = e;
    }
  }
  function Uo(e) {
    if (e.tag === 22) {
      E(Ko, Ko.current);
      E(zo, e);
      if (Bo === null) {
        Bo = e;
      }
    } else {
      Wo();
    }
  }
  function Wo() {
    E(Ko, Ko.current);
    E(zo, zo.current);
  }
  function Go(e) {
    T(zo);
    if (Bo === e) {
      Bo = null;
    }
    T(Ko);
  }
  var Ko = je(0);
  function qo(e, t) {
    E(zo, zo.current);
    E(Ko, t);
  }
  function Jo(e) {
    T(Ko);
    T(zo);
    if (Bo === e) {
      Bo = null;
    }
  }
  function Yo(e) {
    for (var t = e; t !== null;) {
      if (t.tag === 13) {
        var n = t.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || om(n) || sm(n))) {
          return t;
        }
      } else if (t.tag === 19 && t.memoizedProps.revealOrder !== `independent`) {
        if (t.flags & 128) {
          return t;
        }
      } else if (t.child !== null) {
        t.child.return = t;
        t = t.child;
        continue;
      }
      if (t === e) {
        break;
      }
      while (t.sibling === null) {
        if (t.return === null || t.return === e) {
          return null;
        }
        t = t.return;
      }
      t.sibling.return = t.return;
      t = t.sibling;
    }
    return null;
  }
  var Xo = 0;
  var N = null;
  var P = null;
  var F = null;
  var Zo = false;
  var Qo = false;
  var $o = false;
  var es = 0;
  var ts = 0;
  var ns = null;
  var rs = 0;
  function I() {
    throw Error(s(321));
  }
  function is(e, t) {
    if (t === null) {
      return false;
    }
    for (var n = 0; n < t.length && n < e.length; n++) {
      if (!Qr(e[n], t[n])) {
        return false;
      }
    }
    return true;
  }
  function as(e, t, n, r, i, a) {
    Xo = a;
    N = t;
    t.memoizedState = null;
    t.updateQueue = null;
    t.lanes = 0;
    C.H = e === null || e.memoizedState === null ? xc : Sc;
    $o = false;
    a = n(r, i);
    $o = false;
    if (Qo) {
      a = ss(t, n, r, i);
    }
    os(e);
    return a;
  }
  function os(e) {
    C.H = bc;
    var t = P !== null && P.next !== null;
    Xo = 0;
    F = P = N = null;
    Zo = false;
    ts = 0;
    ns = null;
    if (t) {
      throw Error(s(300));
    }
    if (e !== null && !R) {
      e = e.dependencies;
      if (e !== null && Ma(e)) {
        R = true;
      }
    }
  }
  function ss(e, t, n, r) {
    N = e;
    var i = 0;
    do {
      if (Qo) {
        ns = null;
      }
      ts = 0;
      Qo = false;
      if (i >= 25) {
        throw Error(s(301));
      }
      i += 1;
      F = P = null;
      if (e.updateQueue != null) {
        var a = e.updateQueue;
        a.lastEffect = null;
        a.events = null;
        a.stores = null;
        if (a.memoCache != null) {
          a.memoCache.index = 0;
        }
      }
      C.H = Cc;
      a = t(n, r);
    } while (Qo);
    return a;
  }
  function cs() {
    var e = C.H;
    var t = e.useState()[0];
    t = typeof t.then == `function` ? ms(t) : t;
    e = e.useState()[0];
    if ((P === null ? null : P.memoizedState) !== e) {
      N.flags |= 1024;
    }
    return t;
  }
  function ls() {
    var e = es !== 0;
    es = 0;
    return e;
  }
  function us(e, t, n) {
    t.updateQueue = e.updateQueue;
    t.flags &= -2053;
    e.lanes &= ~n;
  }
  function ds(e) {
    if (Zo) {
      for (e = e.memoizedState; e !== null;) {
        var t = e.queue;
        if (t !== null) {
          t.pending = null;
        }
        e = e.next;
      }
      Zo = false;
    }
    Xo = 0;
    F = P = N = null;
    Qo = false;
    ts = es = 0;
    ns = null;
  }
  function fs() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    if (F === null) {
      N.memoizedState = F = e;
    } else {
      F = F.next = e;
    }
    return F;
  }
  function L() {
    if (P === null) {
      var e = N.alternate;
      e = e === null ? null : e.memoizedState;
    } else {
      e = P.next;
    }
    var t = F === null ? N.memoizedState : F.next;
    if (t !== null) {
      F = t;
      P = e;
    } else {
      if (e === null) {
        throw N.alternate === null ? Error(s(467)) : Error(s(310));
      }
      P = e;
      e = {
        memoizedState: P.memoizedState,
        baseState: P.baseState,
        baseQueue: P.baseQueue,
        queue: P.queue,
        next: null
      };
      if (F === null) {
        N.memoizedState = F = e;
      } else {
        F = F.next = e;
      }
    }
    return F;
  }
  function ps() {
    return {
      lastEffect: null,
      events: null,
      stores: null,
      memoCache: null
    };
  }
  function ms(e) {
    var t = ts;
    ts += 1;
    if (ns === null) {
      ns = [];
    }
    e = co(ns, e, t);
    t = N;
    if ((F === null ? t.memoizedState : F.next) === null) {
      t = t.alternate;
      C.H = t === null || t.memoizedState === null ? xc : Sc;
    }
    return e;
  }
  function hs(e) {
    if (typeof e == `object` && e) {
      if (typeof e.then == `function`) {
        return ms(e);
      }
      if (e.$$typeof === Se) {
        return;
      }
      if (e.$$typeof === fe) {
        return Pa(e);
      }
    }
    throw Error(s(438, String(e)));
  }
  function gs(e) {
    var t = null;
    var n = N.updateQueue;
    if (n !== null) {
      t = n.memoCache;
    }
    if (t == null) {
      var r = N.alternate;
      if (r !== null) {
        r = r.updateQueue;
        if (r !== null) {
          r = r.memoCache;
          if (r != null) {
            t = {
              data: r.data.map(function (e) {
                return e.slice();
              }),
              index: 0
            };
          }
        }
      }
    }
    t ??= {
      data: [],
      index: 0
    };
    if (n === null) {
      n = ps();
      N.updateQueue = n;
    }
    n.memoCache = t;
    n = t.data[t.index];
    if (n === undefined) {
      n = t.data[t.index] = Array(e);
      r = 0;
      for (; r < e; r++) {
        n[r] = be;
      }
    }
    t.index++;
    return n;
  }
  function _s(e, t) {
    if (typeof t == `function`) {
      return t(e);
    } else {
      return t;
    }
  }
  function vs(e) {
    return ys(L(), P, e);
  }
  function ys(e, t, n) {
    var r = e.queue;
    if (r === null) {
      throw Error(s(311));
    }
    r.lastRenderedReducer = n;
    var i = e.baseQueue;
    var a = r.pending;
    if (a !== null) {
      if (i !== null) {
        var o = i.next;
        i.next = a.next;
        a.next = o;
      }
      t.baseQueue = i = a;
      r.pending = null;
    }
    a = e.baseState;
    if (i === null) {
      e.memoizedState = a;
    } else {
      t = i.next;
      var c = o = null;
      var l = null;
      var u = t;
      var d = false;
      do {
        var f = u.lane & -536870913;
        if (f === u.lane ? (Xo & f) === f : (q & f) === f) {
          var p = u.revertLane;
          if (p === 0) {
            if (l !== null) {
              l = l.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: u.action,
                hasEagerState: u.hasEagerState,
                eagerState: u.eagerState,
                next: null
              };
            }
            if (f === qa) {
              d = true;
            }
          } else if ((Xo & p) === p) {
            u = u.next;
            if (p === qa) {
              d = true;
            }
            continue;
          } else {
            f = {
              lane: 0,
              revertLane: u.revertLane,
              gesture: null,
              action: u.action,
              hasEagerState: u.hasEagerState,
              eagerState: u.eagerState,
              next: null
            };
            if (l === null) {
              c = l = f;
              o = a;
            } else {
              l = l.next = f;
            }
            N.lanes |= p;
            sd |= p;
          }
          f = u.action;
          if ($o) {
            n(a, f);
          }
          a = u.hasEagerState ? u.eagerState : n(a, f);
        } else {
          p = {
            lane: f,
            revertLane: u.revertLane,
            gesture: u.gesture,
            action: u.action,
            hasEagerState: u.hasEagerState,
            eagerState: u.eagerState,
            next: null
          };
          if (l === null) {
            c = l = p;
            o = a;
          } else {
            l = l.next = p;
          }
          N.lanes |= f;
          sd |= f;
        }
        u = u.next;
      } while (u !== null && u !== t);
      if (l === null) {
        o = a;
      } else {
        l.next = c;
      }
      if (!Qr(a, e.memoizedState) && (R = true, d && (n = Ja, n !== null))) {
        throw n;
      }
      e.memoizedState = a;
      e.baseState = o;
      e.baseQueue = l;
      r.lastRenderedState = a;
    }
    if (i === null) {
      r.lanes = 0;
    }
    return [e.memoizedState, r.dispatch];
  }
  function bs(e) {
    var t = L();
    var n = t.queue;
    if (n === null) {
      throw Error(s(311));
    }
    n.lastRenderedReducer = e;
    var r = n.dispatch;
    var i = n.pending;
    var a = t.memoizedState;
    if (i !== null) {
      n.pending = null;
      var o = i = i.next;
      do {
        a = e(a, o.action);
        o = o.next;
      } while (o !== i);
      if (!Qr(a, t.memoizedState)) {
        R = true;
      }
      t.memoizedState = a;
      if (t.baseQueue === null) {
        t.baseState = a;
      }
      n.lastRenderedState = a;
    }
    return [a, r];
  }
  function xs(e, t, n) {
    var r = N;
    var i = L();
    var a = j;
    if (a) {
      if (n === undefined) {
        throw Error(s(407));
      }
      n = n();
    } else {
      n = t();
    }
    var o = !Qr((P || i).memoizedState, n);
    if (o) {
      i.memoizedState = n;
      R = true;
    }
    i = i.queue;
    Ks(ws.bind(null, r, i, e), [e]);
    e = i.getSnapshot !== t || o || F !== null && !!(F.memoizedState.tag & 1);
    Vs(e ? 9 : 8, {
      destroy: undefined
    }, Cs.bind(null, r, i, n, t), null);
    if (e) {
      r.flags |= 2048;
      if (G === null) {
        throw Error(s(349));
      }
      if (!a && !(Xo & 127)) {
        Ss(r, t, n);
      }
    }
    return n;
  }
  function Ss(e, t, n) {
    e.flags |= 16384;
    e = {
      getSnapshot: t,
      value: n
    };
    t = N.updateQueue;
    if (t === null) {
      t = ps();
      N.updateQueue = t;
      t.stores = [e];
    } else {
      n = t.stores;
      if (n === null) {
        t.stores = [e];
      } else {
        n.push(e);
      }
    }
  }
  function Cs(e, t, n, r) {
    t.value = n;
    t.getSnapshot = r;
    if (Ts(t)) {
      Es(e);
    }
  }
  function ws(e, t, n) {
    return n(function () {
      if (Ts(t)) {
        Es(e);
      }
    });
  }
  function Ts(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var n = t();
      return !Qr(e, n);
    } catch {
      return true;
    }
  }
  function Es(e) {
    var t = Ri(e, 2);
    if (t !== null) {
      Pd(t, e, 2);
    }
  }
  function Ds(e) {
    var t = fs();
    if (typeof e == `function`) {
      var n = e;
      e = n();
      if ($o) {
        lt(true);
        try {
          n();
        } finally {
          lt(false);
        }
      }
    }
    t.memoizedState = t.baseState = e;
    t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: _s,
      lastRenderedState: e
    };
    return t;
  }
  function Os(e, t, n, r) {
    e.baseState = n;
    return ys(e, P, typeof r == `function` ? r : _s);
  }
  function ks(e, t, n, r, i) {
    if (_c(e)) {
      throw Error(s(485));
    }
    e = t.action;
    if (e !== null) {
      var a = {
        payload: i,
        action: e,
        next: null,
        isTransition: true,
        status: `pending`,
        value: null,
        reason: null,
        listeners: [],
        then: function (e) {
          a.listeners.push(e);
        }
      };
      if (C.T === null) {
        a.isTransition = false;
      } else {
        n(true);
      }
      r(a);
      n = t.pending;
      if (n === null) {
        a.next = t.pending = a;
        As(t, a);
      } else {
        a.next = n.next;
        t.pending = n.next = a;
      }
    }
  }
  function As(e, t) {
    var n = t.action;
    var r = t.payload;
    var i = e.state;
    if (t.isTransition) {
      var a = C.T;
      var o = {
        types: a === null ? null : a.types
      };
      C.T = o;
      try {
        var s = n(i, r);
        var c = C.S;
        if (c !== null) {
          c(o, s);
        }
        js(e, t, s);
      } catch (n) {
        Ns(e, t, n);
      } finally {
        if (a !== null && o.types !== null) {
          a.types = o.types;
        }
        C.T = a;
      }
    } else {
      try {
        a = n(i, r);
        js(e, t, a);
      } catch (n) {
        Ns(e, t, n);
      }
    }
  }
  function js(e, t, n) {
    if (typeof n == `object` && n && typeof n.then == `function`) {
      n.then(function (n) {
        Ms(e, t, n);
      }, function (n) {
        return Ns(e, t, n);
      });
    } else {
      Ms(e, t, n);
    }
  }
  function Ms(e, t, n) {
    t.status = `fulfilled`;
    t.value = n;
    Ps(t);
    e.state = n;
    t = e.pending;
    if (t !== null) {
      n = t.next;
      if (n === t) {
        e.pending = null;
      } else {
        n = n.next;
        t.next = n;
        As(e, n);
      }
    }
  }
  function Ns(e, t, n) {
    var r = e.pending;
    e.pending = null;
    if (r !== null) {
      r = r.next;
      do {
        t.status = `rejected`;
        t.reason = n;
        Ps(t);
        t = t.next;
      } while (t !== r);
    }
    e.action = null;
  }
  function Ps(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) {
      (0, e[t])();
    }
  }
  function Fs(e, t) {
    return t;
  }
  function Is(e, t) {
    if (j) {
      var n = G.formState;
      if (n !== null) {
        a: {
          var r = N;
          if (j) {
            if (A) {
              b: {
                for (var i = A, a = ha; i.nodeType !== 8;) {
                  if (!a) {
                    i = null;
                    break b;
                  }
                  i = lm(i.nextSibling);
                  if (i === null) {
                    i = null;
                    break b;
                  }
                }
                a = i.data;
                i = a === `F!` || a === `F` ? i : null;
              }
              if (i) {
                A = lm(i.nextSibling);
                r = i.data === `F!`;
                break a;
              }
            }
            _a(r);
          }
          r = false;
        }
        if (r) {
          t = n[0];
        }
      }
    }
    n = fs();
    n.memoizedState = n.baseState = t;
    r = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Fs,
      lastRenderedState: t
    };
    n.queue = r;
    n = mc.bind(null, N, r);
    r.dispatch = n;
    r = Ds(false);
    a = gc.bind(null, N, false, r.queue);
    r = fs();
    i = {
      state: t,
      dispatch: null,
      action: e,
      pending: null
    };
    r.queue = i;
    n = ks.bind(null, N, i, a, n);
    i.dispatch = n;
    r.memoizedState = e;
    return [t, n, false];
  }
  function Ls(e) {
    return Rs(L(), P, e);
  }
  function Rs(e, t, n) {
    t = ys(e, t, Fs)[0];
    e = vs(_s)[0];
    if (typeof t == `object` && t && typeof t.then == `function`) {
      try {
        var r = ms(t);
      } catch (e) {
        throw e === ro ? ao : e;
      }
    } else {
      r = t;
    }
    t = L();
    var i = t.queue;
    var a = i.dispatch;
    if (n !== t.memoizedState) {
      N.flags |= 2048;
      Vs(9, {
        destroy: undefined
      }, zs.bind(null, i, n), null);
    }
    return [r, a, e];
  }
  function zs(e, t) {
    e.action = t;
  }
  function Bs(e) {
    var t = L();
    var n = P;
    if (n !== null) {
      return Rs(t, n, e);
    }
    L();
    t = t.memoizedState;
    n = L();
    var r = n.queue.dispatch;
    n.memoizedState = e;
    return [t, r, false];
  }
  function Vs(e, t, n, r) {
    e = {
      tag: e,
      create: n,
      deps: r,
      inst: t,
      next: null
    };
    t = N.updateQueue;
    if (t === null) {
      t = ps();
      N.updateQueue = t;
    }
    n = t.lastEffect;
    if (n === null) {
      t.lastEffect = e.next = e;
    } else {
      r = n.next;
      n.next = e;
      e.next = r;
      t.lastEffect = e;
    }
    return e;
  }
  function Hs() {
    return L().memoizedState;
  }
  function Us(e, t, n, r) {
    var i = fs();
    N.flags |= e;
    i.memoizedState = Vs(t | 1, {
      destroy: undefined
    }, n, r === undefined ? null : r);
  }
  function Ws(e, t, n, r) {
    var i = L();
    r = r === undefined ? null : r;
    var a = i.memoizedState.inst;
    if (P !== null && r !== null && is(r, P.memoizedState.deps)) {
      i.memoizedState = Vs(t, a, n, r);
    } else {
      N.flags |= e;
      i.memoizedState = Vs(t | 1, a, n, r);
    }
  }
  function Gs(e, t) {
    Us(8390656, 8, e, t);
  }
  function Ks(e, t) {
    Ws(2048, 8, e, t);
  }
  function qs(e) {
    N.flags |= 4;
    var t = N.updateQueue;
    if (t === null) {
      t = ps();
      N.updateQueue = t;
      t.events = [e];
    } else {
      var n = t.events;
      if (n === null) {
        t.events = [e];
      } else {
        n.push(e);
      }
    }
  }
  function Js(e) {
    var t = L().memoizedState;
    qs({
      ref: t,
      nextImpl: e
    });
    return function () {
      if (W & 2) {
        throw Error(s(440));
      }
      return t.impl.apply(undefined, arguments);
    };
  }
  function Ys(e, t) {
    return Ws(4, 2, e, t);
  }
  function Xs(e, t) {
    return Ws(4, 4, e, t);
  }
  function Zs(e, t) {
    if (typeof t == `function`) {
      e = e();
      var n = t(e);
      return function () {
        if (typeof n == `function`) {
          n();
        } else {
          t(null);
        }
      };
    }
    if (t != null) {
      e = e();
      t.current = e;
      return function () {
        t.current = null;
      };
    }
  }
  function Qs(e, t, n) {
    n = n == null ? null : n.concat([e]);
    Ws(4, 4, Zs.bind(null, t, e), n);
  }
  function $s() {}
  function ec(e, t) {
    var n = L();
    t = t === undefined ? null : t;
    var r = n.memoizedState;
    if (t !== null && is(t, r[1])) {
      return r[0];
    } else {
      n.memoizedState = [e, t];
      return e;
    }
  }
  function tc(e, t) {
    var n = L();
    t = t === undefined ? null : t;
    var r = n.memoizedState;
    if (t !== null && is(t, r[1])) {
      return r[0];
    }
    r = e();
    if ($o) {
      lt(true);
      try {
        e();
      } finally {
        lt(false);
      }
    }
    n.memoizedState = [r, t];
    return r;
  }
  function nc(e, t, n) {
    if (n === undefined || Xo & 1073741824 && !(q & 261930)) {
      return e.memoizedState = t;
    } else {
      e.memoizedState = n;
      e = Md();
      N.lanes |= e;
      sd |= e;
      return n;
    }
  }
  function rc(e, t, n, r) {
    if (Qr(n, t)) {
      return n;
    } else if (Po.current === null) {
      if (!(Xo & 106) || Xo & 1073741824 && !(q & 261930)) {
        R = true;
        return e.memoizedState = n;
      } else {
        e = Md();
        N.lanes |= e;
        sd |= e;
        return t;
      }
    } else {
      e = nc(e, n, r);
      if (!Qr(e, t)) {
        R = true;
      }
      return e;
    }
  }
  function ic(e, t, n, r, i) {
    var a = w.p;
    w.p = a !== 0 && a < 8 ? a : 8;
    var o = C.T;
    var s = {
      types: o === null ? null : o.types
    };
    C.T = s;
    gc(e, false, t, n);
    try {
      var c = i();
      var l = C.S;
      if (l !== null) {
        l(s, c);
      }
      if (typeof c == `object` && c && typeof c.then == `function`) {
        hc(e, t, Za(c, r), jd(e));
      } else {
        hc(e, t, r, jd(e));
      }
    } catch (n) {
      hc(e, t, {
        then: function () {},
        status: `rejected`,
        reason: n
      }, jd());
    } finally {
      w.p = a;
      if (o !== null && s.types !== null) {
        o.types = s.types;
      }
      C.T = o;
    }
  }
  function ac() {}
  function oc(e, t, n, r) {
    if (e.tag !== 5) {
      throw Error(s(476));
    }
    var i = sc(e).queue;
    ic(e, i, t, Oe, n === null ? ac : function () {
      cc(e);
      return n(r);
    });
  }
  function sc(e) {
    var t = e.memoizedState;
    if (t !== null) {
      return t;
    }
    t = {
      memoizedState: Oe,
      baseState: Oe,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: _s,
        lastRenderedState: Oe
      },
      next: null
    };
    var n = {};
    t.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: _s,
        lastRenderedState: n
      },
      next: null
    };
    e.memoizedState = t;
    e = e.alternate;
    if (e !== null) {
      e.memoizedState = t;
    }
    return t;
  }
  function cc(e) {
    var t = sc(e);
    if (t.next === null) {
      t = e.alternate.memoizedState;
    }
    hc(e, t.next.queue, {}, jd());
  }
  function lc() {
    return Pa(sh);
  }
  function uc() {
    return L().memoizedState;
  }
  function dc() {
    return L().memoizedState;
  }
  function fc(e) {
    for (var t = e.return; t !== null;) {
      switch (t.tag) {
        case 24:
        case 3:
          var n = jd();
          e = To(n);
          var r = Eo(t, e, n);
          if (r !== null) {
            Pd(r, t, n);
            Do(r, t, n);
          }
          t = {
            cache: Ba()
          };
          e.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function pc(e, t, n) {
    var r = jd();
    n = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (_c(e)) {
      vc(t, n);
    } else {
      n = Li(e, t, n, r);
      if (n !== null) {
        Pd(n, e, r);
        yc(n, t, r);
      }
    }
  }
  function mc(e, t, n) {
    hc(e, t, n, jd());
  }
  function hc(e, t, n, r) {
    var i = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (_c(e)) {
      vc(t, i);
    } else {
      var a = e.alternate;
      if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) {
        try {
          var o = t.lastRenderedState;
          var s = a(o, n);
          i.hasEagerState = true;
          i.eagerState = s;
          if (Qr(s, o)) {
            Ii(e, t, i, 0);
            if (G === null) {
              Fi();
            }
            return false;
          }
        } catch {}
      }
      n = Li(e, t, i, r);
      if (n !== null) {
        Pd(n, e, r);
        yc(n, t, r);
        return true;
      }
    }
    return false;
  }
  function gc(e, t, n, r) {
    r = {
      lane: 2,
      revertLane: Pf(),
      gesture: null,
      action: r,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (_c(e)) {
      if (t) {
        throw Error(s(479));
      }
    } else {
      t = Li(e, n, r, 2);
      if (t !== null) {
        Pd(t, e, 2);
      }
    }
  }
  function _c(e) {
    var t = e.alternate;
    return e === N || t !== null && t === N;
  }
  function vc(e, t) {
    Qo = Zo = true;
    var n = e.pending;
    if (n === null) {
      t.next = t;
    } else {
      t.next = n.next;
      n.next = t;
    }
    e.pending = t;
  }
  function yc(e, t, n) {
    if (n & 4194048) {
      var r = t.lanes;
      r &= e.pendingLanes;
      n |= r;
      t.lanes = n;
      Dt(e, n);
    }
  }
  var bc = {
    readContext: Pa,
    use: hs,
    useCallback: I,
    useContext: I,
    useEffect: I,
    useImperativeHandle: I,
    useLayoutEffect: I,
    useInsertionEffect: I,
    useMemo: I,
    useReducer: I,
    useRef: I,
    useState: I,
    useDebugValue: I,
    useDeferredValue: I,
    useTransition: I,
    useSyncExternalStore: I,
    useId: I,
    useHostTransitionStatus: I,
    useFormState: I,
    useActionState: I,
    useOptimistic: I,
    useMemoCache: I,
    useCacheRefresh: I,
    useEffectEvent: I
  };
  var xc = {
    readContext: Pa,
    use: hs,
    useCallback: function (e, t) {
      fs().memoizedState = [e, t === undefined ? null : t];
      return e;
    },
    useContext: Pa,
    useEffect: Gs,
    useImperativeHandle: function (e, t, n) {
      n = n == null ? null : n.concat([e]);
      Us(4194308, 4, Zs.bind(null, t, e), n);
    },
    useLayoutEffect: function (e, t) {
      return Us(4194308, 4, e, t);
    },
    useInsertionEffect: function (e, t) {
      Us(4, 2, e, t);
    },
    useMemo: function (e, t) {
      var n = fs();
      t = t === undefined ? null : t;
      var r = e();
      if ($o) {
        lt(true);
        try {
          e();
        } finally {
          lt(false);
        }
      }
      n.memoizedState = [r, t];
      return r;
    },
    useReducer: function (e, t, n) {
      var r = fs();
      if (n !== undefined) {
        var i = n(t);
        if ($o) {
          lt(true);
          try {
            n(t);
          } finally {
            lt(false);
          }
        }
      } else {
        i = t;
      }
      r.memoizedState = r.baseState = i;
      e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: i
      };
      r.queue = e;
      e = e.dispatch = pc.bind(null, N, e);
      return [r.memoizedState, e];
    },
    useRef: function (e) {
      var t = fs();
      e = {
        current: e
      };
      return t.memoizedState = e;
    },
    useState: function (e) {
      e = Ds(e);
      var t = e.queue;
      var n = mc.bind(null, N, t);
      t.dispatch = n;
      return [e.memoizedState, n];
    },
    useDebugValue: $s,
    useDeferredValue: function (e, t) {
      return nc(fs(), e, t);
    },
    useTransition: function () {
      var e = Ds(false);
      e = ic.bind(null, N, e.queue, true, false);
      fs().memoizedState = e;
      return [false, e];
    },
    useSyncExternalStore: function (e, t, n) {
      var r = N;
      var i = fs();
      if (j) {
        if (n === undefined) {
          throw Error(s(407));
        }
        n = n();
      } else {
        n = t();
        if (G === null) {
          throw Error(s(349));
        }
        if (!(q & 127)) {
          Ss(r, t, n);
        }
      }
      i.memoizedState = n;
      var a = {
        value: n,
        getSnapshot: t
      };
      i.queue = a;
      Gs(ws.bind(null, r, a, e), [e]);
      r.flags |= 2048;
      Vs(9, {
        destroy: undefined
      }, Cs.bind(null, r, a, n, t), null);
      return n;
    },
    useId: function () {
      var e = fs();
      var t = G.identifierPrefix;
      if (j) {
        var n = ca;
        var r = sa;
        n = (r & ~(1 << 32 - ut(r) - 1)).toString(32) + n;
        t = `_${t}R_${n}`;
        n = es++;
        if (n > 0) {
          t += `H${n.toString(32)}`;
        }
        t += `_`;
      } else {
        n = rs++;
        t = `_${t}r_${n.toString(32)}_`;
      }
      return e.memoizedState = t;
    },
    useHostTransitionStatus: lc,
    useFormState: Is,
    useActionState: Is,
    useOptimistic: function (e) {
      var t = fs();
      t.memoizedState = t.baseState = e;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      t.queue = n;
      t = gc.bind(null, N, true, n);
      n.dispatch = t;
      return [e, t];
    },
    useMemoCache: gs,
    useCacheRefresh: function () {
      return fs().memoizedState = fc.bind(null, N);
    },
    useEffectEvent: function (e) {
      var t = fs();
      var n = {
        impl: e
      };
      t.memoizedState = n;
      return function () {
        if (W & 2) {
          throw Error(s(440));
        }
        return n.impl.apply(undefined, arguments);
      };
    }
  };
  var Sc = {
    readContext: Pa,
    use: hs,
    useCallback: ec,
    useContext: Pa,
    useEffect: Ks,
    useImperativeHandle: Qs,
    useInsertionEffect: Ys,
    useLayoutEffect: Xs,
    useMemo: tc,
    useReducer: vs,
    useRef: Hs,
    useState: function () {
      return vs(_s);
    },
    useDebugValue: $s,
    useDeferredValue: function (e, t) {
      return rc(L(), P.memoizedState, e, t);
    },
    useTransition: function () {
      var e = vs(_s)[0];
      var t = L().memoizedState;
      return [typeof e == `boolean` ? e : ms(e), t];
    },
    useSyncExternalStore: xs,
    useId: uc,
    useHostTransitionStatus: lc,
    useFormState: Ls,
    useActionState: Ls,
    useOptimistic: function (e, t) {
      return Os(L(), P, e, t);
    },
    useMemoCache: gs,
    useCacheRefresh: dc,
    useEffectEvent: Js
  };
  var Cc = {
    readContext: Pa,
    use: hs,
    useCallback: ec,
    useContext: Pa,
    useEffect: Ks,
    useImperativeHandle: Qs,
    useInsertionEffect: Ys,
    useLayoutEffect: Xs,
    useMemo: tc,
    useReducer: bs,
    useRef: Hs,
    useState: function () {
      return bs(_s);
    },
    useDebugValue: $s,
    useDeferredValue: function (e, t) {
      var n = L();
      if (P === null) {
        return nc(n, e, t);
      } else {
        return rc(n, P.memoizedState, e, t);
      }
    },
    useTransition: function () {
      var e = bs(_s)[0];
      var t = L().memoizedState;
      return [typeof e == `boolean` ? e : ms(e), t];
    },
    useSyncExternalStore: xs,
    useId: uc,
    useHostTransitionStatus: lc,
    useFormState: Bs,
    useActionState: Bs,
    useOptimistic: function (e, t) {
      var n = L();
      if (P === null) {
        n.baseState = e;
        return [e, n.queue.dispatch];
      } else {
        return Os(n, P, e, t);
      }
    },
    useMemoCache: gs,
    useCacheRefresh: dc,
    useEffectEvent: Js
  };
  function wc(e, t, n, r) {
    t = e.memoizedState;
    n = n(r, t);
    n = n == null ? t : S({}, t, n);
    e.memoizedState = n;
    if (e.lanes === 0) {
      e.updateQueue.baseState = n;
    }
  }
  var Tc = {
    enqueueSetState: function (e, t, n) {
      e = e._reactInternals;
      var r = jd();
      var i = To(r);
      i.payload = t;
      if (n != null) {
        i.callback = n;
      }
      t = Eo(e, i, r);
      if (t !== null) {
        Pd(t, e, r);
        Do(t, e, r);
      }
    },
    enqueueReplaceState: function (e, t, n) {
      e = e._reactInternals;
      var r = jd();
      var i = To(r);
      i.tag = 1;
      i.payload = t;
      if (n != null) {
        i.callback = n;
      }
      t = Eo(e, i, r);
      if (t !== null) {
        Pd(t, e, r);
        Do(t, e, r);
      }
    },
    enqueueForceUpdate: function (e, t) {
      e = e._reactInternals;
      var n = jd();
      var r = To(n);
      r.tag = 2;
      if (t != null) {
        r.callback = t;
      }
      t = Eo(e, r, n);
      if (t !== null) {
        Pd(t, e, n);
        Do(t, e, n);
      }
    }
  };
  function Ec(e, t, n, r, i, a, o) {
    e = e.stateNode;
    if (typeof e.shouldComponentUpdate == `function`) {
      return e.shouldComponentUpdate(r, a, o);
    } else if (t.prototype && t.prototype.isPureReactComponent) {
      return !$r(n, r) || !$r(i, a);
    } else {
      return true;
    }
  }
  function Dc(e, t, n, r) {
    e = t.state;
    if (typeof t.componentWillReceiveProps == `function`) {
      t.componentWillReceiveProps(n, r);
    }
    if (typeof t.UNSAFE_componentWillReceiveProps == `function`) {
      t.UNSAFE_componentWillReceiveProps(n, r);
    }
    if (t.state !== e) {
      Tc.enqueueReplaceState(t, t.state, null);
    }
  }
  function Oc(e, t) {
    var n = t;
    if (`ref` in t) {
      n = {};
      for (var r in t) {
        if (r !== `ref`) {
          n[r] = t[r];
        }
      }
    }
    if (e = e.defaultProps) {
      if (n === t) {
        n = S({}, n);
      }
      for (var i in e) {
        if (n[i] === undefined) {
          n[i] = e[i];
        }
      }
    }
    return n;
  }
  function kc(e) {
    ji(e);
  }
  function Ac(e) {
    console.error(e);
  }
  function jc(e) {
    ji(e);
  }
  function Mc(e, t) {
    try {
      var n = e.onUncaughtError;
      n(t.value, {
        componentStack: t.stack
      });
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function Nc(e, t, n) {
    try {
      var r = e.onCaughtError;
      r(n.value, {
        componentStack: n.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function Pc(e, t, n) {
    n = To(n);
    n.tag = 3;
    n.payload = {
      element: null
    };
    n.callback = function () {
      Mc(e, t);
    };
    return n;
  }
  function Fc(e) {
    e = To(e);
    e.tag = 3;
    return e;
  }
  function Ic(e, t, n, r) {
    var i = n.type.getDerivedStateFromError;
    if (typeof i == `function`) {
      var a = r.value;
      e.payload = function () {
        return i(a);
      };
      e.callback = function () {
        Nc(t, n, r);
      };
    }
    var o = n.stateNode;
    if (o !== null && typeof o.componentDidCatch == `function`) {
      e.callback = function () {
        Nc(t, n, r);
        if (typeof i != `function`) {
          if (yd === null) {
            yd = new Set([this]);
          } else {
            yd.add(this);
          }
        }
        var e = r.stack;
        this.componentDidCatch(r.value, {
          componentStack: e === null ? `` : e
        });
      };
    }
  }
  function Lc(e, t, n, r, i) {
    n.flags |= 32768;
    if (typeof r == `object` && r && typeof r.then == `function`) {
      t = n.alternate;
      if (t !== null) {
        ja(t, n, i, true);
      }
      n = zo.current;
      if (n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
          case 19:
            if (Bo === null) {
              Kd();
            } else if (n.alternate === null && Y === 0) {
              Y = 3;
            }
            n.flags &= -257;
            n.flags |= 65536;
            n.lanes = i;
            if (r === oo) {
              n.flags |= 16384;
            } else {
              t = n.updateQueue;
              if (t === null) {
                n.updateQueue = new Set([r]);
              } else {
                t.add(r);
              }
              mf(e, r, i);
            }
            return false;
          case 22:
            n.flags |= 65536;
            if (r === oo) {
              n.flags |= 16384;
            } else {
              t = n.updateQueue;
              if (t === null) {
                t = {
                  transitions: null,
                  markerInstances: null,
                  retryQueue: new Set([r])
                };
                n.updateQueue = t;
              } else {
                n = t.retryQueue;
                if (n === null) {
                  t.retryQueue = new Set([r]);
                } else {
                  n.add(r);
                }
              }
              mf(e, r, i);
            }
            return false;
        }
        throw Error(s(435, n.tag));
      }
      mf(e, r, i);
      Kd();
      return false;
    }
    if (j) {
      t = zo.current;
      if (t === null) {
        if (r !== ga) {
          t = Error(s(423), {
            cause: r
          });
          Ca($i(t, n));
        }
        e = e.current.alternate;
        e.flags |= 65536;
        i &= -i;
        e.lanes |= i;
        r = $i(r, n);
        i = Pc(e.stateNode, r, i);
        Oo(e, i);
        if (Y !== 4) {
          Y = 2;
        }
      } else {
        if (!(t.flags & 65536)) {
          t.flags |= 256;
        }
        t.flags |= 65536;
        t.lanes = i;
        if (r !== ga) {
          e = Error(s(422), {
            cause: r
          });
          Ca($i(e, n));
        }
      }
      return false;
    }
    var a = Error(s(520), {
      cause: r
    });
    a = $i(a, n);
    if (fd === null) {
      fd = [a];
    } else {
      fd.push(a);
    }
    if (Y !== 4) {
      Y = 2;
    }
    if (t === null) {
      return true;
    }
    r = $i(r, n);
    n = t;
    do {
      switch (n.tag) {
        case 3:
          n.flags |= 65536;
          e = i & -i;
          n.lanes |= e;
          e = Pc(n.stateNode, r, e);
          Oo(n, e);
          return false;
        case 1:
          t = n.type;
          a = n.stateNode;
          if (!(n.flags & 128) && (typeof t.getDerivedStateFromError == `function` || a !== null && typeof a.componentDidCatch == `function` && (yd === null || !yd.has(a)))) {
            n.flags |= 65536;
            i &= -i;
            n.lanes |= i;
            i = Fc(i);
            Ic(i, e, n, r);
            Oo(n, i);
            return false;
          }
          break;
        case 22:
          if (n.memoizedState !== null) {
            n.flags |= 65536;
            return false;
          }
      }
      n = n.return;
    } while (n !== null);
    return false;
  }
  var Rc = Error(s(461));
  var R = false;
  function z(e, t, n, r) {
    t.child = e === null ? xo(t, null, n, r) : bo(t, e.child, n, r);
  }
  function zc(e, t, n, r, i) {
    n = n.render;
    var a = t.ref;
    if (`ref` in r) {
      var o = {};
      for (var s in r) {
        if (s !== `ref`) {
          o[s] = r[s];
        }
      }
    } else {
      o = r;
    }
    Na(t);
    r = as(e, t, n, o, a, i);
    s = ls();
    if (e !== null && !R) {
      us(e, t, i);
      return pl(e, t, i);
    } else {
      if (j && s) {
        da(t);
      }
      t.flags |= 1;
      z(e, t, r, i);
      return t.child;
    }
  }
  function Bc(e, t, n, r, i) {
    if (e === null) {
      var a = n.type;
      if (typeof a == `function` && !Wi(a) && a.defaultProps === undefined && n.compare === null) {
        t.tag = 15;
        t.type = a;
        return Vc(e, t, a, r, i);
      } else {
        e = qi(n.type, null, r, t, t.mode, i);
        e.ref = t.ref;
        e.return = t;
        return t.child = e;
      }
    }
    a = e.child;
    if (!ml(e, i)) {
      var o = a.memoizedProps;
      n = n.compare;
      n = n === null ? $r : n;
      if (n(o, r) && e.ref === t.ref) {
        return pl(e, t, i);
      }
    }
    t.flags |= 1;
    e = Gi(a, r);
    e.ref = t.ref;
    e.return = t;
    return t.child = e;
  }
  function Vc(e, t, n, r, i) {
    if (e !== null) {
      var a = e.memoizedProps;
      if ($r(a, r) && e.ref === t.ref) {
        R = false;
        t.pendingProps = r = a;
        if (ml(e, i)) {
          if (e.flags & 131072) {
            R = true;
          }
        } else {
          t.lanes = e.lanes;
          return pl(e, t, i);
        }
      }
    }
    return Yc(e, t, n, r, i);
  }
  function Hc(e, t, n, r) {
    var i = r.children;
    var a = e === null ? null : e.memoizedState;
    if (e === null && t.stateNode === null) {
      t.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      };
    }
    if (r.mode === `hidden`) {
      if (t.flags & 128) {
        a = a === null ? n : a.baseLanes | n;
        if (e !== null) {
          r = t.child = e.child;
          i = 0;
          while (r !== null) {
            i = i | r.lanes | r.childLanes;
            r = r.sibling;
          }
          r = i & ~a;
        } else {
          r = 0;
          t.child = null;
        }
        return Wc(e, t, a, n, r);
      }
      if (n & 536870912) {
        t.memoizedState = {
          baseLanes: 0,
          cachePool: null
        };
        if (e !== null) {
          to(t, a === null ? null : a.cachePool);
        }
        if (a === null) {
          Lo();
        } else {
          Io(t, a);
        }
        Uo(t);
      } else {
        r = t.lanes = 536870912;
        return Wc(e, t, a === null ? n : a.baseLanes | n, n, r);
      }
    } else if (a === null) {
      if (e !== null) {
        to(t, null);
      }
      Lo();
      Wo();
    } else {
      to(t, a.cachePool);
      Io(t, a);
      Wo();
      t.memoizedState = null;
    }
    z(e, t, i, n);
    return t.child;
  }
  function Uc(e, t) {
    if ((e === null || e.tag !== 22) && t.stateNode === null) {
      t.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      };
    }
    return t.sibling;
  }
  function Wc(e, t, n, r, i) {
    var a = eo();
    a = a === null ? null : {
      parent: M._currentValue,
      pool: a
    };
    t.memoizedState = {
      baseLanes: n,
      cachePool: a
    };
    if (e !== null) {
      to(t, null);
    }
    Lo();
    Uo(t);
    if (e !== null) {
      ja(e, t, r, true);
    }
    t.childLanes = i;
    return null;
  }
  function Gc(e, t) {
    t = il({
      mode: t.mode,
      children: t.children
    }, e.mode);
    t.ref = e.ref;
    e.child = t;
    t.return = e;
    return t;
  }
  function Kc(e, t, n) {
    bo(t, e.child, null, n);
    e = Gc(t, t.pendingProps);
    e.flags |= 2;
    Go(t);
    t.memoizedState = null;
    return e;
  }
  function qc(e, t, n) {
    var r = t.pendingProps;
    var i = !!(t.flags & 128);
    t.flags &= -129;
    if (e === null) {
      if (j) {
        if (r.mode === `hidden`) {
          e = Gc(t, r);
          t.lanes = 536870912;
          e.memoizedState = {
            baseLanes: 0,
            cachePool: null
          };
          return Uc(null, e);
        }
        Ho(t);
        if (e = A) {
          e = am(e, ha);
          e = e !== null && e.data === `&` ? e : null;
          if (e !== null) {
            t.memoizedState = {
              dehydrated: e,
              treeContext: oa === null ? null : {
                id: sa,
                overflow: ca
              },
              retryLane: 536870912,
              hydrationErrors: null
            };
            n = Xi(e);
            n.return = t;
            t.child = n;
            k = t;
            A = null;
          }
        } else {
          e = null;
        }
        if (e === null) {
          throw _a(t);
        }
        t.lanes = 536870912;
        return null;
      }
      return Gc(t, r);
    }
    var a = e.memoizedState;
    if (a !== null) {
      var o = a.dehydrated;
      Ho(t);
      if (i) {
        if (t.flags & 256) {
          t.flags &= -257;
          t = Kc(e, t, n);
        } else if (t.memoizedState !== null) {
          t.child = e.child;
          t.flags |= 128;
          t = null;
        } else {
          throw Error(s(558));
        }
      } else {
        if (!R) {
          ja(e, t, n, false);
        }
        i = (n & e.childLanes) !== 0;
        if (R || i) {
          if (Po.current === null) {
            r = G;
            if (r !== null && (o = Ot(r, n), o !== 0 && o !== a.retryLane)) {
              a.retryLane = o;
              Ri(e, o);
              Pd(r, e, o);
              throw Rc;
            }
            Kd();
          }
          t = Kc(e, t, n);
        } else {
          e = a.treeContext;
          A = lm(o.nextSibling);
          k = t;
          j = true;
          ma = null;
          ha = false;
          if (e !== null) {
            pa(t, e);
          }
          t = Gc(t, r);
          t.flags |= 134221824;
        }
      }
      return t;
    }
    e = Gi(e.child, {
      mode: r.mode,
      children: r.children
    });
    e.ref = t.ref;
    t.child = e;
    e.return = t;
    return e;
  }
  function Jc(e, t) {
    var n = t.ref;
    if (n === null) {
      if (e !== null && e.ref !== null) {
        t.flags |= 4194816;
      }
    } else {
      if (typeof n != `function` && typeof n != `object`) {
        throw Error(s(284));
      }
      if (e === null || e.ref !== n) {
        t.flags |= 4194816;
      }
    }
  }
  function Yc(e, t, n, r, i) {
    Na(t);
    n = as(e, t, n, r, undefined, i);
    r = ls();
    if (e !== null && !R) {
      us(e, t, i);
      return pl(e, t, i);
    } else {
      if (j && r) {
        da(t);
      }
      t.flags |= 1;
      z(e, t, n, i);
      return t.child;
    }
  }
  function Xc(e, t, n, r, i, a) {
    Na(t);
    t.updateQueue = null;
    n = ss(t, r, n, i);
    os(e);
    r = ls();
    if (e !== null && !R) {
      us(e, t, a);
      return pl(e, t, a);
    } else {
      if (j && r) {
        da(t);
      }
      t.flags |= 1;
      z(e, t, n, a);
      return t.child;
    }
  }
  function Zc(e, t, n, r, i) {
    Na(t);
    if (t.stateNode === null) {
      var a = Vi;
      var o = n.contextType;
      if (typeof o == `object` && o) {
        a = Pa(o);
      }
      a = new n(r, a);
      t.memoizedState = a.state ?? null;
      a.updater = Tc;
      t.stateNode = a;
      a._reactInternals = t;
      a = t.stateNode;
      a.props = r;
      a.state = t.memoizedState;
      a.refs = {};
      Co(t);
      o = n.contextType;
      a.context = typeof o == `object` && o ? Pa(o) : Vi;
      a.state = t.memoizedState;
      o = n.getDerivedStateFromProps;
      if (typeof o == `function`) {
        wc(t, n, o, r);
        a.state = t.memoizedState;
      }
      if (typeof n.getDerivedStateFromProps != `function` && typeof a.getSnapshotBeforeUpdate != `function` && (typeof a.UNSAFE_componentWillMount == `function` || typeof a.componentWillMount == `function`)) {
        o = a.state;
        if (typeof a.componentWillMount == `function`) {
          a.componentWillMount();
        }
        if (typeof a.UNSAFE_componentWillMount == `function`) {
          a.UNSAFE_componentWillMount();
        }
        if (o !== a.state) {
          Tc.enqueueReplaceState(a, a.state, null);
        }
        jo(t, r, a, i);
        Ao();
        a.state = t.memoizedState;
      }
      if (typeof a.componentDidMount == `function`) {
        t.flags |= 4194308;
      }
      r = true;
    } else if (e === null) {
      a = t.stateNode;
      var s = t.memoizedProps;
      var c = Oc(n, s);
      a.props = c;
      var l = a.context;
      var u = n.contextType;
      o = Vi;
      if (typeof u == `object` && u) {
        o = Pa(u);
      }
      var d = n.getDerivedStateFromProps;
      u = typeof d == `function` || typeof a.getSnapshotBeforeUpdate == `function`;
      s = t.pendingProps !== s;
      if (!u && (typeof a.UNSAFE_componentWillReceiveProps == `function` || typeof a.componentWillReceiveProps == `function`)) {
        if (s || l !== o) {
          Dc(t, a, r, o);
        }
      }
      So = false;
      var f = t.memoizedState;
      a.state = f;
      jo(t, r, a, i);
      Ao();
      l = t.memoizedState;
      if (s || f !== l || So) {
        if (typeof d == `function`) {
          wc(t, n, d, r);
          l = t.memoizedState;
        }
        if (c = So || Ec(t, n, c, r, f, l, o)) {
          if (!u && (typeof a.UNSAFE_componentWillMount == `function` || typeof a.componentWillMount == `function`)) {
            if (typeof a.componentWillMount == `function`) {
              a.componentWillMount();
            }
            if (typeof a.UNSAFE_componentWillMount == `function`) {
              a.UNSAFE_componentWillMount();
            }
          }
          if (typeof a.componentDidMount == `function`) {
            t.flags |= 4194308;
          }
        } else {
          if (typeof a.componentDidMount == `function`) {
            t.flags |= 4194308;
          }
          t.memoizedProps = r;
          t.memoizedState = l;
        }
        a.props = r;
        a.state = l;
        a.context = o;
        r = c;
      } else {
        if (typeof a.componentDidMount == `function`) {
          t.flags |= 4194308;
        }
        r = false;
      }
    } else {
      a = t.stateNode;
      wo(e, t);
      o = t.memoizedProps;
      u = Oc(n, o);
      a.props = u;
      d = t.pendingProps;
      f = a.context;
      l = n.contextType;
      c = Vi;
      if (typeof l == `object` && l) {
        c = Pa(l);
      }
      s = n.getDerivedStateFromProps;
      if (!(l = typeof s == `function` || typeof a.getSnapshotBeforeUpdate == `function`) && (typeof a.UNSAFE_componentWillReceiveProps == `function` || typeof a.componentWillReceiveProps == `function`)) {
        if (o !== d || f !== c) {
          Dc(t, a, r, c);
        }
      }
      So = false;
      f = t.memoizedState;
      a.state = f;
      jo(t, r, a, i);
      Ao();
      var p = t.memoizedState;
      if (o !== d || f !== p || So || e !== null && e.dependencies !== null && Ma(e.dependencies)) {
        if (typeof s == `function`) {
          wc(t, n, s, r);
          p = t.memoizedState;
        }
        if (u = So || Ec(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Ma(e.dependencies)) {
          if (!l && (typeof a.UNSAFE_componentWillUpdate == `function` || typeof a.componentWillUpdate == `function`)) {
            if (typeof a.componentWillUpdate == `function`) {
              a.componentWillUpdate(r, p, c);
            }
            if (typeof a.UNSAFE_componentWillUpdate == `function`) {
              a.UNSAFE_componentWillUpdate(r, p, c);
            }
          }
          if (typeof a.componentDidUpdate == `function`) {
            t.flags |= 4;
          }
          if (typeof a.getSnapshotBeforeUpdate == `function`) {
            t.flags |= 1024;
          }
        } else {
          if (typeof a.componentDidUpdate == `function` && (o !== e.memoizedProps || f !== e.memoizedState)) {
            t.flags |= 4;
          }
          if (typeof a.getSnapshotBeforeUpdate == `function` && (o !== e.memoizedProps || f !== e.memoizedState)) {
            t.flags |= 1024;
          }
          t.memoizedProps = r;
          t.memoizedState = p;
        }
        a.props = r;
        a.state = p;
        a.context = c;
        r = u;
      } else {
        if (typeof a.componentDidUpdate == `function` && (o !== e.memoizedProps || f !== e.memoizedState)) {
          t.flags |= 4;
        }
        if (typeof a.getSnapshotBeforeUpdate == `function` && (o !== e.memoizedProps || f !== e.memoizedState)) {
          t.flags |= 1024;
        }
        r = false;
      }
    }
    a = r;
    Jc(e, t);
    r = !!(t.flags & 128);
    if (a || r) {
      a = t.stateNode;
      n = r && typeof n.getDerivedStateFromError != `function` ? null : a.render();
      t.flags |= 1;
      if (e !== null && r) {
        t.child = bo(t, e.child, null, i);
        t.child = bo(t, null, n, i);
      } else {
        z(e, t, n, i);
      }
      t.memoizedState = a.state;
      e = t.child;
    } else {
      e = pl(e, t, i);
    }
    return e;
  }
  function Qc(e, t, n, r) {
    xa();
    t.flags |= 256;
    z(e, t, n, r);
    return t.child;
  }
  var $c = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function el(e) {
    return {
      baseLanes: e,
      cachePool: no()
    };
  }
  function tl(e, t, n) {
    e = e === null ? 0 : e.childLanes & ~n;
    if (t) {
      e |= ud;
    }
    return e;
  }
  function nl(e, t, n) {
    var r = t.pendingProps;
    var i = false;
    var a = !!(t.flags & 128);
    var o;
    if (!(o = a)) {
      o = e !== null && e.memoizedState === null ? false : !!(Ko.current & 2);
    }
    if (o) {
      i = true;
      t.flags &= -129;
    }
    o = !!(t.flags & 32);
    t.flags &= -33;
    if (e === null) {
      if (j) {
        if (i) {
          Vo(t);
        } else {
          Wo();
        }
        if (e = A) {
          e = am(e, ha);
          e = e !== null && e.data !== `&` ? e : null;
          if (e !== null) {
            t.memoizedState = {
              dehydrated: e,
              treeContext: oa === null ? null : {
                id: sa,
                overflow: ca
              },
              retryLane: 536870912,
              hydrationErrors: null
            };
            n = Xi(e);
            n.return = t;
            t.child = n;
            k = t;
            A = null;
          }
        } else {
          e = null;
        }
        if (e === null) {
          throw _a(t);
        }
        t.lanes = sm(e) ? 32 : 536870912;
        return null;
      }
      a = r.children;
      r = r.fallback;
      if (i) {
        Wo();
        i = t.mode;
        a = il({
          mode: `hidden`,
          children: a
        }, i);
        r = Ji(r, i, n, null);
        a.return = t;
        r.return = t;
        a.sibling = r;
        t.child = a;
        r = t.child;
        r.memoizedState = el(n);
        r.childLanes = tl(e, o, n);
        t.memoizedState = $c;
        return Uc(null, r);
      } else {
        Vo(t);
        return rl(t, a);
      }
    }
    var s = e.memoizedState;
    if (s !== null) {
      var c = s.dehydrated;
      if (c !== null) {
        return ol(e, t, a, o, r, c, s, n);
      }
    }
    if (i) {
      Wo();
      i = r.fallback;
      a = t.mode;
      s = e.child;
      c = s.sibling;
      r = Gi(s, {
        mode: `hidden`,
        children: r.children
      });
      r.subtreeFlags = s.subtreeFlags & 1206910976;
      if (c === null) {
        i = Ji(i, a, n, null);
        i.flags |= 2;
      } else {
        i = Gi(c, i);
      }
      i.return = t;
      r.return = t;
      r.sibling = i;
      t.child = r;
      Uc(null, r);
      r = t.child;
      i = e.child.memoizedState;
      if (i === null) {
        i = el(n);
      } else {
        a = i.cachePool;
        if (a === null) {
          a = no();
        } else {
          s = M._currentValue;
          a = a.parent === s ? a : {
            parent: s,
            pool: s
          };
        }
        i = {
          baseLanes: i.baseLanes | n,
          cachePool: a
        };
      }
      r.memoizedState = i;
      r.childLanes = tl(e, o, n);
      t.memoizedState = $c;
      return Uc(e.child, r);
    } else {
      Vo(t);
      n = e.child;
      e = n.sibling;
      n = Gi(n, {
        mode: `visible`,
        children: r.children
      });
      n.return = t;
      n.sibling = null;
      if (e !== null) {
        o = t.deletions;
        if (o === null) {
          t.deletions = [e];
          t.flags |= 16;
        } else {
          o.push(e);
        }
      }
      t.child = n;
      t.memoizedState = null;
      return n;
    }
  }
  function rl(e, t) {
    t = il({
      mode: `visible`,
      children: t
    }, e.mode);
    t.return = e;
    return e.child = t;
  }
  function il(e, t) {
    e = Ui(22, e, null, t);
    e.lanes = 0;
    return e;
  }
  function al(e, t, n) {
    bo(t, e.child, null, n);
    e = rl(t, t.pendingProps.children);
    e.flags |= 2;
    t.memoizedState = null;
    return e;
  }
  function ol(e, t, n, r, i, a, o, c) {
    if (n) {
      if (t.flags & 256) {
        Vo(t);
        t.flags &= -257;
        return al(e, t, c);
      } else if (t.memoizedState === null) {
        Wo();
        a = i.fallback;
        o = t.mode;
        i = il({
          mode: `visible`,
          children: i.children
        }, o);
        a = Ji(a, o, c, null);
        a.flags |= 2;
        i.return = t;
        a.return = t;
        i.sibling = a;
        t.child = i;
        bo(t, e.child, null, c);
        i = t.child;
        i.memoizedState = el(c);
        i.childLanes = tl(e, r, c);
        t.memoizedState = $c;
        return Uc(null, i);
      } else {
        Wo();
        t.child = e.child;
        t.flags |= 128;
        return null;
      }
    }
    Vo(t);
    if (sm(a)) {
      r = a.nextSibling && a.nextSibling.dataset;
      if (r) {
        var l = r.dgst;
      }
      r = l;
      if (r !== ``) {
        i = Error(s(419));
        i.stack = ``;
        i.digest = r;
        Ca({
          value: i,
          source: null,
          stack: null
        });
      }
      return al(e, t, c);
    }
    if (!R) {
      ja(e, t, c, false);
    }
    r = (c & e.childLanes) !== 0;
    if (R || r) {
      if (Po.current !== null) {
        return al(e, t, c);
      }
      r = G;
      if (r !== null && (i = Ot(r, c), i !== 0 && i !== o.retryLane)) {
        o.retryLane = i;
        Ri(e, i);
        Pd(r, e, i);
        throw Rc;
      }
      if (!om(a)) {
        Kd();
      }
      return al(e, t, c);
    }
    if (om(a)) {
      t.flags |= 192;
      t.child = e.child;
      return null;
    } else {
      e = o.treeContext;
      A = lm(a.nextSibling);
      k = t;
      j = true;
      ma = null;
      ha = false;
      if (e !== null) {
        pa(t, e);
      }
      t = rl(t, i.children);
      t.flags |= 134221824;
      return t;
    }
  }
  function sl(e, t, n) {
    e.lanes |= t;
    var r = e.alternate;
    if (r !== null) {
      r.lanes |= t;
    }
    ka(e.return, t, n);
  }
  function cl(e) {
    var t = null;
    for (; e !== null;) {
      var n = e.alternate;
      if (n !== null && Yo(n) === null) {
        t = e;
      }
      e = e.sibling;
    }
    return t;
  }
  function ll(e, t, n, r, i, a) {
    var o = e.memoizedState;
    if (o === null) {
      e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: n,
        tailMode: i,
        treeForkCount: a
      };
    } else {
      o.isBackwards = t;
      o.rendering = null;
      o.renderingStartTime = 0;
      o.last = r;
      o.tail = n;
      o.tailMode = i;
      o.treeForkCount = a;
    }
  }
  function ul(e) {
    var t = e.child;
    for (e.child = null; t !== null;) {
      var n = t.sibling;
      t.sibling = e.child;
      e.child = t;
      t = n;
    }
  }
  function dl(e, t, n) {
    var r = t.pendingProps;
    var i = r.revealOrder;
    var a = r.tail;
    r = r.children;
    var o = Ko.current;
    if (t.flags & 128) {
      qo(t, o);
      return null;
    }
    var s = !!(o & 2);
    if (s) {
      o = o & 1 | 2;
      t.flags |= 128;
    } else {
      o &= 1;
    }
    qo(t, o);
    if (i === `backwards` && e !== null) {
      ul(e);
      z(e, t, r, n);
      ul(e);
    } else {
      z(e, t, r, n);
    }
    r = j ? ra : 0;
    if (!s && e !== null && e.flags & 128) {
      a: for (e = t.child; e !== null;) {
        if (e.tag === 13) {
          if (e.memoizedState !== null) {
            sl(e, n, t);
          }
        } else if (e.tag === 19) {
          sl(e, n, t);
        } else if (e.child !== null) {
          e.child.return = e;
          e = e.child;
          continue;
        }
        if (e === t) {
          break a;
        }
        while (e.sibling === null) {
          if (e.return === null || e.return === t) {
            break a;
          }
          e = e.return;
        }
        e.sibling.return = e.return;
        e = e.sibling;
      }
    }
    switch (i) {
      case `backwards`:
        n = cl(t.child);
        if (n === null) {
          i = t.child;
          t.child = null;
        } else {
          i = n.sibling;
          n.sibling = null;
          ul(t);
        }
        ll(t, true, i, null, a, r);
        break;
      case `unstable_legacy-backwards`:
        n = null;
        i = t.child;
        t.child = null;
        while (i !== null) {
          e = i.alternate;
          if (e !== null && Yo(e) === null) {
            t.child = i;
            break;
          }
          e = i.sibling;
          i.sibling = n;
          n = i;
          i = e;
        }
        ll(t, true, n, null, a, r);
        break;
      case `together`:
        ll(t, false, null, null, undefined, r);
        break;
      case `independent`:
        t.memoizedState = null;
        break;
      default:
        n = cl(t.child);
        if (n === null) {
          i = t.child;
          t.child = null;
        } else {
          i = n.sibling;
          n.sibling = null;
        }
        ll(t, false, i, n, a, r);
    }
    return t.child;
  }
  function fl(e, t, n) {
    var r = t.pendingProps;
    Da(t, t.type, r.value);
    z(e, t, r.children, n);
    return t.child;
  }
  function pl(e, t, n) {
    if (e !== null) {
      t.dependencies = e.dependencies;
    }
    sd |= t.lanes;
    if ((n & t.childLanes) === 0) {
      if (e !== null) {
        ja(e, t, n, false);
        if ((n & t.childLanes) === 0) {
          return null;
        }
      } else {
        return null;
      }
    }
    if (e !== null && t.child !== e.child) {
      throw Error(s(153));
    }
    if (t.child !== null) {
      e = t.child;
      n = Gi(e, e.pendingProps);
      t.child = n;
      n.return = t;
      while (e.sibling !== null) {
        e = e.sibling;
        n = n.sibling = Gi(e, e.pendingProps);
        n.return = t;
      }
      n.sibling = null;
    }
    return t.child;
  }
  function ml(e, t) {
    return (e.lanes & t) !== 0 || (e = e.dependencies, e !== null && !!Ma(e));
  }
  function hl(e, t, n) {
    switch (t.tag) {
      case 3:
        Ie(t, t.stateNode.containerInfo);
        Da(t, M, e.memoizedState.cache);
        xa();
        break;
      case 27:
      case 5:
        Re(t);
        break;
      case 4:
        Ie(t, t.stateNode.containerInfo);
        break;
      case 10:
        Da(t, t.type, t.memoizedProps.value);
        break;
      case 31:
        if (t.memoizedState !== null) {
          t.flags |= 128;
          Ho(t);
          return null;
        }
        break;
      case 13:
        var r = t.memoizedState;
        if (r !== null) {
          if (r.dehydrated !== null) {
            Vo(t);
            t.flags |= 128;
            return null;
          }
          r = ja(e, t, n, false);
          var i = t.child.childLanes;
          if (r || (n & i) !== 0) {
            return nl(e, t, n);
          } else {
            Vo(t);
            e = pl(e, t, n);
            if (e === null) {
              return null;
            } else {
              return e.sibling;
            }
          }
        }
        Vo(t);
        break;
      case 19:
        if (t.flags & 128) {
          return dl(e, t, n);
        }
        i = !!(e.flags & 128);
        r = (n & t.childLanes) !== 0;
        r ||= (ja(e, t, n, false), (n & t.childLanes) !== 0);
        if (i) {
          if (r) {
            return dl(e, t, n);
          }
          t.flags |= 128;
        }
        i = t.memoizedState;
        if (i !== null) {
          i.rendering = null;
          i.tail = null;
          i.lastEffect = null;
        }
        qo(t, Ko.current);
        if (r) {
          break;
        }
        return null;
      case 22:
        t.lanes = 0;
        return Hc(e, t, n, t.pendingProps);
      case 24:
        Da(t, M, e.memoizedState.cache);
    }
    return pl(e, t, n);
  }
  function gl(e, t, n) {
    if (e !== null) {
      if (e.memoizedProps !== t.pendingProps) {
        R = true;
      } else {
        if (!ml(e, n) && !(t.flags & 128)) {
          R = false;
          return hl(e, t, n);
        }
        R = !!(e.flags & 131072);
      }
    } else {
      R = false;
      if (j && t.flags & 1048576) {
        ua(t, ra, t.index);
      }
    }
    t.lanes = 0;
    switch (t.tag) {
      case 16:
        a: {
          var r = t.pendingProps;
          e = lo(t.elementType);
          t.type = e;
          if (typeof e == `function`) {
            if (Wi(e)) {
              r = Oc(e, r);
              t.tag = 1;
              t = Zc(null, t, e, r, n);
            } else {
              t.tag = 0;
              t = Yc(null, t, e, r, n);
            }
          } else {
            if (e != null) {
              var i = e.$$typeof;
              if (i === pe) {
                t.tag = 11;
                t = zc(null, t, e, r, n);
                break a;
              }
              if (i === ge) {
                t.tag = 14;
                t = Bc(null, t, e, r, n);
                break a;
              }
              if (i === fe) {
                t.tag = 10;
                t.type = e;
                t = fl(null, t, n);
                break a;
              }
            }
            t = Ee(e) || e;
            throw Error(s(306, t, ``));
          }
        }
        return t;
      case 0:
        return Yc(e, t, t.type, t.pendingProps, n);
      case 1:
        r = t.type;
        i = Oc(r, t.pendingProps);
        return Zc(e, t, r, i, n);
      case 3:
        a: {
          Ie(t, t.stateNode.containerInfo);
          if (e === null) {
            throw Error(s(387));
          }
          r = t.pendingProps;
          var a = t.memoizedState;
          i = a.element;
          wo(e, t);
          jo(t, r, null, n);
          var o = t.memoizedState;
          r = o.cache;
          Da(t, M, r);
          if (r !== a.cache) {
            Aa(t, [M], n, true);
          }
          Ao();
          r = o.element;
          if (a.isDehydrated) {
            a = {
              element: r,
              isDehydrated: false,
              cache: o.cache
            };
            t.updateQueue.baseState = a;
            t.memoizedState = a;
            if (t.flags & 256) {
              t = Qc(e, t, r, n);
              break a;
            }
            if (r !== i) {
              i = $i(Error(s(424)), t);
              Ca(i);
              t = Qc(e, t, r, n);
              break a;
            }
            e = t.stateNode.containerInfo;
            switch (e.nodeType) {
              case 9:
                e = e.body;
                break;
              default:
                e = e.nodeName === `HTML` ? e.ownerDocument.body : e;
            }
            A = lm(e.firstChild);
            k = t;
            j = true;
            ma = null;
            ha = true;
            n = xo(t, null, r, n);
            t.child = n;
            while (n) {
              n.flags = n.flags & -3 | 134221824;
              n = n.sibling;
            }
          } else {
            xa();
            if (r === i) {
              t = pl(e, t, n);
              break a;
            }
            z(e, t, r, n);
          }
          t = t.child;
        }
        return t;
      case 26:
        Jc(e, t);
        if (e === null) {
          if (n = Nm(t.type, null, t.pendingProps, null)) {
            t.memoizedState = n;
          } else if (!j) {
            t.stateNode = fp(t.type, t.pendingProps, Pe.current, t);
          }
        } else {
          t.memoizedState = Nm(t.type, e.memoizedProps, t.pendingProps, e.memoizedState);
        }
        return null;
      case 27:
        Re(t);
        if (e === null && j) {
          r = t.stateNode = hm(t.type, t.pendingProps, Pe.current);
          k = t;
          ha = true;
          i = A;
          if (Sp(t.type)) {
            um = i;
            A = lm(r.firstChild);
          } else {
            A = i;
          }
        }
        z(e, t, t.pendingProps.children, n);
        Jc(e, t);
        if (e === null) {
          t.flags |= 4194304;
        }
        return t.child;
      case 5:
        if (e === null && j) {
          if (i = r = A) {
            r = rm(r, t.type, t.pendingProps, ha);
            if (r === null) {
              i = false;
            } else {
              t.stateNode = r;
              k = t;
              A = lm(r.firstChild);
              ha = false;
              i = true;
            }
          }
          if (!i) {
            _a(t);
          }
        }
        Re(t);
        i = t.type;
        a = t.pendingProps;
        o = e === null ? null : e.memoizedProps;
        r = a.children;
        if (pp(i, a)) {
          r = null;
        } else if (o !== null && pp(i, o)) {
          t.flags |= 32;
        }
        if (t.memoizedState !== null) {
          i = as(e, t, cs, null, null, n);
          sh._currentValue = i;
        }
        Jc(e, t);
        z(e, t, r, n);
        return t.child;
      case 6:
        if (e === null && j) {
          if (e = n = A) {
            n = im(n, t.pendingProps, ha);
            if (n === null) {
              e = false;
            } else {
              t.stateNode = n;
              k = t;
              A = null;
              e = true;
            }
          }
          if (!e) {
            _a(t);
          }
        }
        return null;
      case 13:
        return nl(e, t, n);
      case 4:
        Ie(t, t.stateNode.containerInfo);
        r = t.pendingProps;
        if (e === null) {
          t.child = bo(t, null, r, n);
        } else {
          z(e, t, r, n);
        }
        return t.child;
      case 11:
        return zc(e, t, t.type, t.pendingProps, n);
      case 7:
        r = t.pendingProps;
        Jc(e, t);
        z(e, t, r, n);
        return t.child;
      case 8:
        z(e, t, t.pendingProps.children, n);
        return t.child;
      case 12:
        z(e, t, t.pendingProps.children, n);
        return t.child;
      case 10:
        return fl(e, t, n);
      case 9:
        i = t.type._context;
        r = t.pendingProps.children;
        Na(t);
        i = Pa(i);
        r = r(i);
        t.flags |= 1;
        z(e, t, r, n);
        return t.child;
      case 14:
        return Bc(e, t, t.type, t.pendingProps, n);
      case 15:
        return Vc(e, t, t.type, t.pendingProps, n);
      case 19:
        return dl(e, t, n);
      case 31:
        return qc(e, t, n);
      case 22:
        return Hc(e, t, n, t.pendingProps);
      case 24:
        Na(t);
        r = Pa(M);
        if (e === null) {
          i = eo();
          if (i === null) {
            i = G;
            a = Ba();
            i.pooledCache = a;
            a.refCount++;
            if (a !== null) {
              i.pooledCacheLanes |= n;
            }
            i = a;
          }
          t.memoizedState = {
            parent: r,
            cache: i
          };
          Co(t);
          Da(t, M, i);
        } else {
          if ((e.lanes & n) !== 0) {
            wo(e, t);
            jo(t, null, null, n);
            Ao();
          }
          i = e.memoizedState;
          a = t.memoizedState;
          if (i.parent === r) {
            r = a.cache;
            Da(t, M, r);
            if (r !== i.cache) {
              Aa(t, [M], n, true);
            }
          } else {
            i = {
              parent: r,
              cache: r
            };
            t.memoizedState = i;
            if (t.lanes === 0) {
              t.memoizedState = t.updateQueue.baseState = i;
            }
            Da(t, M, r);
          }
        }
        z(e, t, t.pendingProps.children, n);
        return t.child;
      case 30:
        if (t.stateNode === null) {
          t.stateNode = {
            autoName: null,
            paired: null,
            clones: null,
            ref: null
          };
        }
        r = t.pendingProps;
        if (r.name != null && r.name !== `auto`) {
          t.flags |= e === null ? 18882560 : 18874368;
        } else if (j) {
          da(t);
        }
        if (e !== null && e.memoizedProps.name !== r.name) {
          t.flags |= 4194816;
        } else {
          Jc(e, t);
        }
        z(e, t, r.children, n);
        return t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(s(156, t.tag));
  }
  function _l(e) {
    e.flags |= 4;
  }
  function vl(e, t, n, r, i) {
    var a;
    if (a = !!(e.mode & 32)) {
      a = n === null ? Jm(t, r) : Jm(t, r) && (r.src !== n.src || r.srcSet !== n.srcSet);
    }
    if (a) {
      e.flags |= 16777216;
      if ((i & 335544128) === i) {
        if (e.stateNode.complete) {
          e.flags |= 8192;
        } else if (Ud()) {
          e.flags |= 8192;
        } else {
          uo = oo;
          throw io;
        }
      }
    } else {
      e.flags &= -16777217;
    }
  }
  function yl(e, t) {
    if (t.type !== `stylesheet` || t.state.loading & 4) {
      e.flags &= -16777217;
    } else {
      e.flags |= 16777216;
      if (!Ym(t)) {
        if (Ud()) {
          e.flags |= 8192;
        } else {
          uo = oo;
          throw io;
        }
      }
    }
  }
  function bl(e, t) {
    if (t !== null) {
      e.flags |= 4;
    }
    if (e.flags & 16384) {
      t = e.tag === 22 ? 536870912 : St();
      e.lanes |= t;
      dd |= t;
    }
  }
  function xl(e, t) {
    if (!j) {
      switch (e.tailMode) {
        case `visible`:
          break;
        case `collapsed`:
          for (var n = e.tail, r = null; n !== null;) {
            if (n.alternate !== null) {
              r = n;
            }
            n = n.sibling;
          }
          if (r === null) {
            if (t || e.tail === null) {
              e.tail = null;
            } else {
              e.tail.sibling = null;
            }
          } else {
            r.sibling = null;
          }
          break;
        default:
          t = e.tail;
          n = null;
          while (t !== null) {
            if (t.alternate !== null) {
              n = t;
            }
            t = t.sibling;
          }
          if (n === null) {
            e.tail = null;
          } else {
            n.sibling = null;
          }
      }
    }
  }
  function B(e) {
    var t = e.alternate !== null && e.alternate.child === e.child;
    var n = 0;
    var r = 0;
    if (t) {
      for (var i = e.child; i !== null;) {
        n |= i.lanes | i.childLanes;
        r |= i.subtreeFlags & 1206910976;
        r |= i.flags & 1206910976;
        i.return = e;
        i = i.sibling;
      }
    } else {
      for (i = e.child; i !== null;) {
        n |= i.lanes | i.childLanes;
        r |= i.subtreeFlags;
        r |= i.flags;
        i.return = e;
        i = i.sibling;
      }
    }
    e.subtreeFlags |= r;
    e.childLanes = n;
    return t;
  }
  function Sl(e, t, n) {
    var r = t.pendingProps;
    fa(t);
    switch (t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        B(t);
        return null;
      case 1:
        B(t);
        return null;
      case 3:
        n = t.stateNode;
        r = null;
        if (e !== null) {
          r = e.memoizedState.cache;
        }
        if (t.memoizedState.cache !== r) {
          t.flags |= 2048;
        }
        Oa(M);
        Le();
        if (n.pendingContext) {
          n.context = n.pendingContext;
          n.pendingContext = null;
        }
        if (e === null || e.child === null) {
          if (ba(t)) {
            _l(t);
          } else if (e !== null && (!e.memoizedState.isDehydrated || !!(t.flags & 256))) {
            t.flags |= 1024;
            Sa();
          }
        }
        B(t);
        return null;
      case 26:
        var i = t.type;
        var a = t.memoizedState;
        if (e === null) {
          _l(t);
          if (a === null) {
            B(t);
            vl(t, i, null, r, n);
          } else {
            B(t);
            yl(t, a);
          }
        } else if (a) {
          if (a === e.memoizedState) {
            B(t);
            t.flags &= -16777217;
          } else {
            _l(t);
            B(t);
            yl(t, a);
          }
        } else {
          e = e.memoizedProps;
          if (e !== r) {
            _l(t);
          }
          B(t);
          vl(t, i, e, r, n);
        }
        return null;
      case 27:
        ze(t);
        n = Pe.current;
        i = t.type;
        if (e !== null && t.stateNode != null) {
          if (e.memoizedProps !== r) {
            _l(t);
          }
        } else {
          if (!r) {
            if (t.stateNode === null) {
              throw Error(s(166));
            }
            B(t);
            t.subtreeFlags &= -33554433;
            return null;
          }
          e = Me.current;
          if (ba(t)) {
            va(t, e);
          } else {
            e = hm(i, r, n);
            t.stateNode = e;
            _l(t);
          }
        }
        B(t);
        t.subtreeFlags &= -33554433;
        return null;
      case 5:
        ze(t);
        i = t.type;
        if (e !== null && t.stateNode != null) {
          if (e.memoizedProps !== r) {
            _l(t);
          }
        } else {
          if (!r) {
            if (t.stateNode === null) {
              throw Error(s(166));
            }
            B(t);
            t.subtreeFlags &= -33554433;
            return null;
          }
          a = Me.current;
          if (ba(t)) {
            va(t, a);
          } else {
            var o = lp(Pe.current);
            switch (a) {
              case 1:
                a = o.createElementNS(`http://www.w3.org/2000/svg`, i);
                break;
              case 2:
                a = o.createElementNS(`http://www.w3.org/1998/Math/MathML`, i);
                break;
              default:
                switch (i) {
                  case `svg`:
                    a = o.createElementNS(`http://www.w3.org/2000/svg`, i);
                    break;
                  case `math`:
                    a = o.createElementNS(`http://www.w3.org/1998/Math/MathML`, i);
                    break;
                  case `script`:
                    a = o.createElement(`div`);
                    a.innerHTML = `<script><\/script>`;
                    a = a.removeChild(a.firstChild);
                    break;
                  case `select`:
                    a = typeof r.is == `string` ? o.createElement(`select`, {
                      is: r.is
                    }) : o.createElement(`select`);
                    if (r.multiple) {
                      a.multiple = true;
                    } else if (r.size) {
                      a.size = r.size;
                    }
                    break;
                  default:
                    a = typeof r.is == `string` ? o.createElement(i, {
                      is: r.is
                    }) : o.createElement(i);
                }
            }
            a[Pt] = t;
            a[Ft] = r;
            a: for (o = t.child; o !== null;) {
              if (o.tag === 5 || o.tag === 6) {
                a.appendChild(o.stateNode);
              } else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
                o.child.return = o;
                o = o.child;
                continue;
              }
              if (o === t) {
                break a;
              }
              while (o.sibling === null) {
                if (o.return === null || o.return === t) {
                  break a;
                }
                o = o.return;
              }
              o.sibling.return = o.return;
              o = o.sibling;
            }
            t.stateNode = a;
            np(a, i, r);
            a: switch (i) {
              case `button`:
              case `input`:
              case `select`:
              case `textarea`:
                r = !!r.autoFocus;
                break a;
              case `img`:
                r = true;
                break a;
              default:
                r = false;
            }
            if (r) {
              _l(t);
            }
          }
        }
        B(t);
        t.subtreeFlags &= -33554433;
        vl(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n);
        return null;
      case 6:
        if (e && t.stateNode != null) {
          if (e.memoizedProps !== r) {
            _l(t);
          }
        } else {
          if (typeof r != `string` && t.stateNode === null) {
            throw Error(s(166));
          }
          e = Pe.current;
          if (ba(t)) {
            e = t.stateNode;
            n = t.memoizedProps;
            r = null;
            i = k;
            if (i !== null) {
              switch (i.tag) {
                case 27:
                case 5:
                  r = i.memoizedProps;
              }
            }
            e[Pt] = t;
            e = e.nodeValue === n || r !== null && r.suppressHydrationWarning === true || !!ep(e.nodeValue, n);
            if (!e) {
              _a(t, true);
            }
          } else {
            e = lp(e).createTextNode(r);
            e[Pt] = t;
            t.stateNode = e;
          }
        }
        B(t);
        return null;
      case 31:
        n = t.memoizedState;
        if (e === null || e.memoizedState !== null) {
          r = ba(t);
          if (n !== null) {
            if (e === null) {
              if (!r) {
                throw Error(s(318));
              }
              e = t.memoizedState;
              e = e === null ? null : e.dehydrated;
              if (!e) {
                throw Error(s(557));
              }
              e[Pt] = t;
            } else {
              xa();
              if (!(t.flags & 128)) {
                t.memoizedState = null;
              }
              t.flags |= 4;
            }
            B(t);
            e = false;
          } else {
            n = Sa();
            if (e !== null && e.memoizedState !== null) {
              e.memoizedState.hydrationErrors = n;
            }
            e = true;
          }
          if (!e) {
            if (t.flags & 256) {
              Go(t);
              return t;
            } else {
              Go(t);
              return null;
            }
          }
          if (t.flags & 128) {
            throw Error(s(558));
          }
        }
        B(t);
        return null;
      case 13:
        r = t.memoizedState;
        if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          i = ba(t);
          if (r !== null && r.dehydrated !== null) {
            if (e === null) {
              if (!i) {
                throw Error(s(318));
              }
              i = t.memoizedState;
              i = i === null ? null : i.dehydrated;
              if (!i) {
                throw Error(s(317));
              }
              i[Pt] = t;
            } else {
              xa();
              if (!(t.flags & 128)) {
                t.memoizedState = null;
              }
              t.flags |= 4;
            }
            B(t);
            i = false;
          } else {
            i = Sa();
            if (e !== null && e.memoizedState !== null) {
              e.memoizedState.hydrationErrors = i;
            }
            i = true;
          }
          if (!i) {
            if (t.flags & 256) {
              Go(t);
              return t;
            } else {
              Go(t);
              return null;
            }
          }
        }
        Go(t);
        if (t.flags & 128) {
          t.lanes = n;
          return t;
        } else {
          n = r !== null;
          e = e !== null && e.memoizedState !== null;
          if (n) {
            r = t.child;
            i = null;
            if (r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null) {
              i = r.alternate.memoizedState.cachePool.pool;
            }
            a = null;
            if (r.memoizedState !== null && r.memoizedState.cachePool !== null) {
              a = r.memoizedState.cachePool.pool;
            }
            if (a !== i) {
              r.flags |= 2048;
            }
          }
          if (n !== e && n) {
            t.child.flags |= 8192;
          }
          bl(t, t.updateQueue);
          B(t);
          return null;
        }
      case 4:
        Le();
        if (e === null) {
          Wf(t.stateNode.containerInfo);
        }
        t.flags |= 67108864;
        B(t);
        return null;
      case 10:
        Oa(t.type);
        B(t);
        return null;
      case 19:
        Jo(t);
        r = t.memoizedState;
        if (r === null) {
          B(t);
          return null;
        }
        i = !!(t.flags & 128);
        a = r.rendering;
        if (a === null) {
          if (i) {
            xl(r, false);
          } else {
            if (Y !== 0 || e !== null && e.flags & 128) {
              for (e = t.child; e !== null;) {
                a = Yo(e);
                if (a !== null) {
                  t.flags |= 128;
                  xl(r, false);
                  e = a.updateQueue;
                  t.updateQueue = e;
                  bl(t, e);
                  t.subtreeFlags = 0;
                  e = n;
                  n = t.child;
                  while (n !== null) {
                    Ki(n, e);
                    n = n.sibling;
                  }
                  qo(t, Ko.current & 1 | 2);
                  if (j) {
                    la(t, r.treeForkCount);
                  }
                  return t.child;
                }
                e = e.sibling;
              }
            }
            if (r.tail !== null && Qe() > _d) {
              t.flags |= 128;
              i = true;
              xl(r, false);
              t.lanes = 4194304;
            }
          }
        } else {
          if (!i) {
            e = Yo(a);
            if (e !== null) {
              t.flags |= 128;
              i = true;
              e = e.updateQueue;
              t.updateQueue = e;
              bl(t, e);
              xl(r, true);
              if (r.tail === null && r.tailMode !== `collapsed` && r.tailMode !== `visible` && !a.alternate && !j) {
                B(t);
                return null;
              }
            } else if (Qe() * 2 - r.renderingStartTime > _d && n !== 536870912) {
              t.flags |= 128;
              i = true;
              xl(r, false);
              t.lanes = 4194304;
            }
          }
          if (r.isBackwards) {
            a.sibling = t.child;
            t.child = a;
          } else {
            e = r.last;
            if (e === null) {
              t.child = a;
            } else {
              e.sibling = a;
            }
            r.last = a;
          }
        }
        if (r.tail !== null) {
          e = r.tail;
          a: {
            for (n = e; n !== null;) {
              if (n.alternate !== null) {
                n = false;
                break a;
              }
              n = n.sibling;
            }
            n = true;
          }
          r.rendering = e;
          r.tail = e.sibling;
          r.renderingStartTime = Qe();
          e.sibling = null;
          a = Ko.current;
          a = i ? a & 1 | 2 : a & 1;
          if (r.tailMode === `visible` || r.tailMode === `collapsed` || !n || j) {
            qo(t, a);
          } else {
            n = a;
            E(zo, t);
            E(Ko, n);
            if (Bo === null) {
              Bo = t;
            }
          }
          if (j) {
            la(t, r.treeForkCount);
          }
          return e;
        }
        B(t);
        return null;
      case 22:
      case 23:
        Go(t);
        Ro();
        r = t.memoizedState !== null;
        if (e === null) {
          if (r) {
            t.flags |= 8192;
          }
        } else if (e.memoizedState !== null !== r) {
          t.flags |= 8192;
        }
        if (r) {
          if (n & 536870912 && !(t.flags & 128)) {
            B(t);
            if (t.subtreeFlags & 6) {
              t.flags |= 8192;
            }
          }
        } else {
          B(t);
        }
        n = t.updateQueue;
        if (n !== null) {
          bl(t, n.retryQueue);
        }
        n = null;
        if (e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null) {
          n = e.memoizedState.cachePool.pool;
        }
        r = null;
        if (t.memoizedState !== null && t.memoizedState.cachePool !== null) {
          r = t.memoizedState.cachePool.pool;
        }
        if (r !== n) {
          t.flags |= 2048;
        }
        if (e !== null) {
          T($a);
        }
        return null;
      case 24:
        n = null;
        if (e !== null) {
          n = e.memoizedState.cache;
        }
        if (t.memoizedState.cache !== n) {
          t.flags |= 2048;
        }
        Oa(M);
        B(t);
        return null;
      case 25:
        return null;
      case 30:
        t.flags |= 33554432;
        B(t);
        return null;
    }
    throw Error(s(156, t.tag));
  }
  function Cl(e, t) {
    fa(t);
    switch (t.tag) {
      case 1:
        e = t.flags;
        if (e & 65536) {
          t.flags = e & -65537 | 128;
          return t;
        } else {
          return null;
        }
      case 3:
        Oa(M);
        Le();
        e = t.flags;
        if (e & 65536 && !(e & 128)) {
          t.flags = e & -65537 | 128;
          return t;
        } else {
          return null;
        }
      case 26:
      case 27:
      case 5:
        ze(t);
        return null;
      case 31:
        if (t.memoizedState !== null) {
          Go(t);
          if (t.alternate === null) {
            throw Error(s(340));
          }
          xa();
        }
        e = t.flags;
        if (e & 65536) {
          t.flags = e & -65537 | 128;
          return t;
        } else {
          return null;
        }
      case 13:
        Go(t);
        e = t.memoizedState;
        if (e !== null && e.dehydrated !== null) {
          if (t.alternate === null) {
            throw Error(s(340));
          }
          xa();
        }
        e = t.flags;
        if (e & 65536) {
          t.flags = e & -65537 | 128;
          return t;
        } else {
          return null;
        }
      case 19:
        Jo(t);
        e = t.flags;
        if (e & 65536) {
          t.flags = e & -65537 | 128;
          e = t.memoizedState;
          if (e !== null) {
            e.rendering = null;
            e.tail = null;
          }
          t.flags |= 4;
          return t;
        } else {
          return null;
        }
      case 4:
        Le();
        return null;
      case 10:
        Oa(t.type);
        return null;
      case 22:
      case 23:
        Go(t);
        Ro();
        if (e !== null) {
          T($a);
        }
        e = t.flags;
        if (e & 65536) {
          t.flags = e & -65537 | 128;
          return t;
        } else {
          return null;
        }
      case 24:
        Oa(M);
        return null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function wl(e, t) {
    fa(t);
    switch (t.tag) {
      case 3:
        Oa(M);
        Le();
        break;
      case 26:
      case 27:
      case 5:
        ze(t);
        break;
      case 4:
        Le();
        break;
      case 31:
        if (t.memoizedState !== null) {
          Go(t);
        }
        break;
      case 13:
        Go(t);
        break;
      case 19:
        Jo(t);
        break;
      case 10:
        Oa(t.type);
        break;
      case 22:
      case 23:
        Go(t);
        Ro();
        if (e !== null) {
          T($a);
        }
        break;
      case 24:
        Oa(M);
    }
  }
  function Tl(e, t) {
    try {
      var n = t.updateQueue;
      var r = n === null ? null : n.lastEffect;
      if (r !== null) {
        var i = r.next;
        n = i;
        do {
          if ((n.tag & e) === e) {
            r = undefined;
            var a = n.create;
            var o = n.inst;
            r = a();
            o.destroy = r;
          }
          n = n.next;
        } while (n !== i);
      }
    } catch (e) {
      Z(t, t.return, e);
    }
  }
  function El(e, t, n) {
    try {
      var r = t.updateQueue;
      var i = r === null ? null : r.lastEffect;
      if (i !== null) {
        var a = i.next;
        r = a;
        do {
          if ((r.tag & e) === e) {
            var o = r.inst;
            var s = o.destroy;
            if (s !== undefined) {
              o.destroy = undefined;
              i = t;
              var c = n;
              var l = s;
              try {
                l();
              } catch (e) {
                Z(i, c, e);
              }
            }
          }
          r = r.next;
        } while (r !== a);
      }
    } catch (e) {
      Z(t, t.return, e);
    }
  }
  function Dl(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var n = e.stateNode;
      try {
        No(t, n);
      } catch (t) {
        Z(e, e.return, t);
      }
    }
  }
  function Ol(e, t, n) {
    n.props = Oc(e.type, e.memoizedProps);
    n.state = e.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (n) {
      Z(e, t, n);
    }
  }
  function kl(e, t) {
    try {
      var n = e.ref;
      if (n !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var r = e.stateNode;
            break;
          case 30:
            var i = e.stateNode;
            var a = Oi(e.memoizedProps, i);
            if (i.ref === null || i.ref.name !== a) {
              i.ref = Pp(a);
            }
            r = i.ref;
            break;
          case 7:
            if (e.stateNode === null) {
              var o = new Fp(e);
              h(e.child, false, Qp, o, undefined, undefined);
              e.stateNode = o;
            }
            r = e.stateNode;
            break;
          default:
            r = e.stateNode;
        }
        if (typeof n == `function`) {
          e.refCleanup = n(r);
        } else {
          n.current = r;
        }
      }
    } catch (n) {
      Z(e, t, n);
    }
  }
  function Al(e, t) {
    var n = e.ref;
    var r = e.refCleanup;
    if (n !== null) {
      if (typeof r == `function`) {
        try {
          r();
        } catch (n) {
          Z(e, t, n);
        } finally {
          e.refCleanup = null;
          e = e.alternate;
          if (e != null) {
            e.refCleanup = null;
          }
        }
      } else if (typeof n == `function`) {
        try {
          n(null);
        } catch (n) {
          Z(e, t, n);
        }
      } else {
        n.current = null;
      }
    }
  }
  function jl(e, t) {
    if ((e.tag === 5 || e.tag === 27 || e.tag === 6) && e.alternate === null && t !== null) {
      for (var n = 0; n < t.length; n++) {
        em(e.stateNode, t[n]);
      }
    }
  }
  function Ml(e) {
    for (var t = e.return; t !== null && (Fl(t) && em(e.stateNode, t.stateNode), !Pl(t));) {
      t = t.return;
    }
  }
  function Nl(e) {
    for (var t = e.return; t !== null && (Fl(t) && tm(e.stateNode, t.stateNode), !Pl(t));) {
      t = t.return;
    }
  }
  function Pl(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 27;
  }
  function Fl(e) {
    return e && e.tag === 7 && e.stateNode !== null;
  }
  function Il(e) {
    var t = e.type;
    var n = e.memoizedProps;
    var r = e.stateNode;
    try {
      a: switch (t) {
        case `button`:
        case `input`:
        case `select`:
        case `textarea`:
          if (n.autoFocus) {
            r.focus();
          }
          break a;
        case `img`:
          if (n.src) {
            r.src = n.src;
          } else if (n.srcSet) {
            r.srcset = n.srcSet;
          }
      }
    } catch (t) {
      Z(e, e.return, t);
    }
  }
  function Ll(e, t, n) {
    try {
      var r = e.stateNode;
      ip(r, e.type, n, t);
      r[Ft] = t;
    } catch (t) {
      Z(e, e.return, t);
    }
  }
  function Rl(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Sp(e.type) || e.tag === 4;
  }
  function zl(e) {
    a: while (true) {
      while (e.sibling === null) {
        if (e.return === null || Rl(e.return)) {
          return null;
        }
        e = e.return;
      }
      e.sibling.return = e.return;
      e = e.sibling;
      while (e.tag !== 5 && e.tag !== 6 && e.tag !== 18) {
        if (e.tag === 27 && Sp(e.type) || e.flags & 2 || e.child === null || e.tag === 4) {
          continue a;
        }
        e.child.return = e;
        e = e.child;
      }
      if (!(e.flags & 2)) {
        return e.stateNode;
      }
    }
  }
  function Bl(e, t, n, r) {
    var i = e.tag;
    if (i === 5 || i === 6) {
      i = e.stateNode;
      if (t) {
        (n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n).insertBefore(i, t);
      } else {
        t = n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n;
        t.appendChild(i);
        n = n._reactRootContainer;
        if (n == null && t.onclick === null) {
          t.onclick = kn;
        }
      }
      jl(e, r);
      O = true;
    } else if (i !== 4 && (i === 27 && (jl(e, r), r = null, Sp(e.type) && (n = e.stateNode, t = null)), e = e.child, e !== null)) {
      Bl(e, t, n, r);
      e = e.sibling;
      while (e !== null) {
        Bl(e, t, n, r);
        e = e.sibling;
      }
    }
  }
  function Vl(e, t, n, r) {
    var i = e.tag;
    if (i === 5 || i === 6) {
      i = e.stateNode;
      if (t) {
        n.insertBefore(i, t);
      } else {
        n.appendChild(i);
      }
      jl(e, r);
      O = true;
    } else if (i !== 4 && (i === 27 && (jl(e, r), r = null, Sp(e.type) && (n = e.stateNode)), e = e.child, e !== null)) {
      Vl(e, t, n, r);
      e = e.sibling;
      while (e !== null) {
        Vl(e, t, n, r);
        e = e.sibling;
      }
    }
  }
  function Hl(e) {
    var t = e.stateNode;
    var n = e.memoizedProps;
    try {
      var r = e.type;
      for (var i = t.attributes; i.length;) {
        t.removeAttributeNode(i[0]);
      }
      np(t, r, n);
      t[Pt] = e;
      t[Ft] = n;
    } catch (t) {
      Z(e, e.return, t);
    }
  }
  var Ul = false;
  var Wl = null;
  function Gl(e) {
    if (e.tag === 30 || e.subtreeFlags & 33554432) {
      Ul = true;
    }
  }
  var Kl = null;
  function ql() {
    var e = Kl;
    Kl = null;
    return e;
  }
  var Jl = 0;
  function Yl(e, t, n, r, i) {
    Jl = 0;
    return Xl(e.child, t, n, r, i);
  }
  function Xl(e, t, n, r, i) {
    var a = false;
    for (; e !== null;) {
      if (e.tag === 5) {
        var o = e.stateNode;
        if (r !== null) {
          var s = Op(o);
          r.push(s);
          if (s.view) {
            a = true;
          }
        } else if (!a) {
          if (Op(o).view) {
            a = true;
          }
        }
        Ul = true;
        Tp(o, Jl === 0 ? t : `${t}_${Jl}`, n);
        Jl++;
      } else if (e.tag !== 22 || e.memoizedState === null) {
        if (e.tag !== 30 || !i) {
          if (Xl(e.child, t, n, r, i)) {
            a = true;
          }
        }
      }
      e = e.sibling;
    }
    return a;
  }
  function Zl(e, t) {
    while (e !== null) {
      if (e.tag === 5) {
        Ep(e.stateNode, e.memoizedProps);
      } else if (e.tag !== 22 || e.memoizedState === null) {
        if (e.tag !== 30 || !t) {
          Zl(e.child, t);
        }
      }
      e = e.sibling;
    }
  }
  function Ql(e) {
    if (e.subtreeFlags & 18874368) {
      for (e = e.child; e !== null;) {
        if ((e.tag !== 22 || e.memoizedState === null) && (Ql(e), e.tag === 30 && e.flags & 18874368 && e.stateNode.paired)) {
          var t = e.memoizedProps;
          if (t.name == null || t.name === `auto`) {
            throw Error(s(544));
          }
          var n = t.name;
          t = Ai(t.default, t.share);
          if (t !== `none`) {
            if (!Yl(e, n, t, null, false)) {
              Zl(e.child, false);
            }
          }
        }
        e = e.sibling;
      }
    }
  }
  function $l(e, t) {
    if (e.tag === 30) {
      var n = e.stateNode;
      var r = e.memoizedProps;
      var i = Oi(r, n);
      var a = Ai(r.default, n.paired ? r.share : r.enter);
      if (a === `none`) {
        Ql(e);
      } else if (Yl(e, i, a, null, false)) {
        Ql(e);
        if (!n.paired && !t) {
          Nd(e, r.onEnter);
        }
      } else {
        Zl(e.child, false);
      }
    } else if (e.subtreeFlags & 33554432) {
      for (e = e.child; e !== null;) {
        $l(e, t);
        e = e.sibling;
      }
    } else {
      Ql(e);
    }
  }
  function eu(e) {
    if (Wl !== null && Wl.size !== 0) {
      var t = Wl;
      if (e.subtreeFlags & 18874368) {
        for (e = e.child; e !== null;) {
          if (e.tag !== 22 || e.memoizedState === null) {
            if (e.tag === 30 && e.flags & 18874368) {
              var n = e.memoizedProps;
              var r = n.name;
              if (r != null && r !== `auto`) {
                var i = t.get(r);
                if (i !== undefined) {
                  var a = Ai(n.default, n.share);
                  if (a !== `none`) {
                    if (Yl(e, r, a, null, false)) {
                      a = e.stateNode;
                      i.paired = a;
                      a.paired = i;
                      Nd(e, n.onShare);
                    } else {
                      Zl(e.child, false);
                    }
                  }
                  t.delete(r);
                  if (t.size === 0) {
                    break;
                  }
                }
              }
            }
            eu(e);
          }
          e = e.sibling;
        }
      }
    }
  }
  function tu(e) {
    if (e.tag === 30) {
      var t = e.memoizedProps;
      var n = Oi(t, e.stateNode);
      var r = Wl === null ? undefined : Wl.get(n);
      var i = Ai(t.default, r === undefined ? t.exit : t.share);
      if (i !== `none`) {
        if (Yl(e, n, i, null, false)) {
          if (r === undefined) {
            Nd(e, t.onExit);
          } else {
            i = e.stateNode;
            r.paired = i;
            i.paired = r;
            Wl.delete(n);
            Nd(e, t.onShare);
          }
        } else {
          Zl(e.child, false);
        }
      }
      if (Wl !== null) {
        eu(e);
      }
    } else if (e.subtreeFlags & 33554432) {
      for (e = e.child; e !== null;) {
        tu(e);
        e = e.sibling;
      }
    } else if (Wl !== null) {
      eu(e);
    }
  }
  function nu(e) {
    for (e = e.child; e !== null;) {
      if (e.tag === 30) {
        var t = e.memoizedProps;
        var n = Oi(t, e.stateNode);
        t = Ai(t.default, t.update);
        e.flags &= -5;
        if (t !== `none`) {
          Yl(e, n, t, e.memoizedState = [], false);
        }
      } else if (e.subtreeFlags & 33554432) {
        nu(e);
      }
      e = e.sibling;
    }
  }
  function ru(e) {
    if (e.subtreeFlags & 18874368) {
      for (e = e.child; e !== null;) {
        if (e.tag !== 22 || e.memoizedState === null) {
          if (e.tag === 30 && e.flags & 18874368) {
            var t = e.stateNode;
            if (t.paired !== null) {
              t.paired = null;
              Zl(e.child, false);
            }
          }
          ru(e);
        }
        e = e.sibling;
      }
    }
  }
  function iu(e) {
    if (e.tag === 30) {
      e.stateNode.paired = null;
      Zl(e.child, false);
      ru(e);
    } else if (e.subtreeFlags & 33554432) {
      for (e = e.child; e !== null;) {
        iu(e);
        e = e.sibling;
      }
    } else {
      ru(e);
    }
  }
  function au(e) {
    for (e = e.child; e !== null;) {
      if (e.tag === 30) {
        Zl(e.child, false);
      } else if (e.subtreeFlags & 33554432) {
        au(e);
      }
      e = e.sibling;
    }
  }
  function ou(e, t, n, r, i, a, o) {
    var s = false;
    for (; t !== null;) {
      if (t.tag === 5) {
        var c = t.stateNode;
        if (a !== null && Jl < a.length) {
          var l = a[Jl];
          var u = Op(c);
          if (l.view || u.view) {
            s = true;
          }
          var d;
          if (d = !(e.flags & 4)) {
            if (u.clip) {
              d = true;
            } else {
              d = l.rect;
              var f = u.rect;
              d = d.y !== f.y || d.x !== f.x || d.height !== f.height || d.width !== f.width;
            }
          }
          if (d) {
            e.flags |= 4;
          }
          if (u.abs) {
            u = !l.abs;
          } else {
            l = l.rect;
            u = u.rect;
            u = l.height !== u.height || l.width !== u.width;
          }
          if (u) {
            e.flags |= 32;
          }
        } else {
          e.flags |= 32;
        }
        if (e.flags & 4) {
          Tp(c, Jl === 0 ? n : `${n}_${Jl}`, i);
        }
        if (!s || !(e.flags & 4)) {
          if (Kl === null) {
            Kl = [];
          }
          Kl.push(c, Jl === 0 ? r : `${r}_${Jl}`, t.memoizedProps);
        }
        Jl++;
      } else if (t.tag !== 22 || t.memoizedState === null) {
        if (t.tag === 30 && o) {
          e.flags |= t.flags & 32;
        } else if (ou(e, t.child, n, r, i, a, o)) {
          s = true;
        }
      }
      t = t.sibling;
    }
    return s;
  }
  function su(e, t) {
    for (e = e.child; e !== null;) {
      if (e.tag === 30) {
        var n = e.memoizedProps;
        var r = e.stateNode;
        var i = Oi(n, r);
        var a = Ai(n.default, n.update);
        if (t) {
          r = r.clones;
          var o = r === null ? null : r.map(kp);
        } else {
          o = e.memoizedState;
          e.memoizedState = null;
        }
        r = e;
        var s = e.child;
        Jl = 0;
        i = ou(r, s, i, i, a, o, false);
        if (e.flags & 4 && i) {
          if (!t) {
            Nd(e, n.onUpdate);
          }
        }
      } else if (e.subtreeFlags & 33554432) {
        su(e, t);
      }
      e = e.sibling;
    }
  }
  var V = false;
  var H = false;
  var cu = false;
  var lu = false;
  var uu = typeof WeakSet == `function` ? WeakSet : Set;
  var du = null;
  var fu = false;
  var pu = false;
  var mu = false;
  var hu = false;
  function gu(e, t, n) {
    e = e.containerInfo;
    sp = gh;
    e = ii(e);
    if (ai(e)) {
      if (`selectionStart` in e) {
        var r = {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      } else {
        a: {
          r = (r = e.ownerDocument) && r.defaultView || window;
          var i = r.getSelection && r.getSelection();
          if (i && i.rangeCount !== 0) {
            r = i.anchorNode;
            var a = i.anchorOffset;
            var o = i.focusNode;
            i = i.focusOffset;
            try {
              r.nodeType;
              o.nodeType;
            } catch {
              r = null;
              break a;
            }
            var s = 0;
            var c = -1;
            var l = -1;
            var u = 0;
            var d = 0;
            var f = e;
            var p = null;
            b: while (true) {
              for (var m; f !== r || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || i !== 0 && f.nodeType !== 3 || (l = s + i), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) {
                p = f;
                f = m;
              }
              while (true) {
                if (f === e) {
                  break b;
                }
                if (p === r && ++u === a) {
                  c = s;
                }
                if (p === o && ++d === i) {
                  l = s;
                }
                if ((m = f.nextSibling) !== null) {
                  break;
                }
                f = p;
                p = f.parentNode;
              }
              f = m;
            }
            r = c === -1 || l === -1 ? null : {
              start: c,
              end: l
            };
          } else {
            r = null;
          }
        }
      }
      r ||= {
        start: 0,
        end: 0
      };
    } else {
      r = null;
    }
    cp = {
      focusedElem: e,
      selectionRange: r
    };
    gh = false;
    n = (n & 335544064) === n;
    du = t;
    t = n ? 9270 : 1024;
    while (du !== null) {
      e = du;
      if (n && (r = e.deletions, r !== null)) {
        for (a = 0; a < r.length; a++) {
          if (n) {
            tu(r[a]);
          }
        }
      }
      if (e.alternate === null && e.flags & 2) {
        if (n) {
          Gl(e);
        }
        _u(n);
      } else {
        if (e.tag === 22) {
          r = e.alternate;
          if (e.memoizedState !== null) {
            if (r !== null && r.memoizedState === null && n) {
              tu(r);
            }
            _u(n);
            continue;
          }
          if (r !== null && r.memoizedState !== null) {
            if (n) {
              Gl(e);
            }
            _u(n);
            continue;
          }
        }
        r = e.child;
        if ((e.subtreeFlags & t) !== 0 && r !== null) {
          r.return = e;
          du = r;
        } else {
          if (n) {
            nu(e);
          }
          _u(n);
        }
      }
    }
    Wl = null;
  }
  function _u(e) {
    while (du !== null) {
      var t = du;
      var n = e;
      var r = t.alternate;
      var i = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (i & 1024 && r !== null) {
            n = undefined;
            i = r.memoizedProps;
            r = r.memoizedState;
            var a = t.stateNode;
            try {
              var o = Oc(t.type, i);
              n = a.getSnapshotBeforeUpdate(o, r);
              a.__reactInternalSnapshotBeforeUpdate = n;
            } catch (e) {
              Z(t, t.return, e);
            }
          }
          break;
        case 3:
          if (i & 1024) {
            r = t.stateNode.containerInfo;
            n = r.nodeType;
            if (n === 9) {
              nm(r);
            } else if (n === 1) {
              switch (r.nodeName) {
                case `HEAD`:
                case `HTML`:
                case `BODY`:
                  nm(r);
                  break;
                default:
                  r.textContent = ``;
              }
            }
          }
          break;
        case 5:
        case 26:
        case 27:
        case 6:
        case 4:
        case 17:
          break;
        case 30:
          if (n && r !== null) {
            n = Oi(r.memoizedProps, r.stateNode);
            i = t.memoizedProps;
            i = Ai(i.default, i.update);
            if (i !== `none`) {
              Yl(r, n, i, r.memoizedState = [], true);
            }
          }
          break;
        default:
          if (i & 1024) {
            throw Error(s(163));
          }
      }
      r = t.sibling;
      if (r !== null) {
        r.return = t.return;
        du = r;
        break;
      }
      du = t.return;
    }
  }
  function vu(e, t, n) {
    var r = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        Lu(e, n);
        if (r & 4) {
          Tl(5, n);
        }
        break;
      case 1:
        Lu(e, n);
        if (r & 4) {
          e = n.stateNode;
          if (t === null) {
            try {
              e.componentDidMount();
            } catch (e) {
              Z(n, n.return, e);
            }
          } else {
            var i = Oc(n.type, t.memoizedProps);
            t = t.memoizedState;
            try {
              e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
            } catch (e) {
              Z(n, n.return, e);
            }
          }
        }
        if (r & 64) {
          Dl(n);
        }
        if (r & 512) {
          kl(n, n.return);
        }
        break;
      case 3:
        Lu(e, n);
        if (r & 64 && (e = n.updateQueue, e !== null)) {
          t = null;
          if (n.child !== null) {
            switch (n.child.tag) {
              case 27:
              case 5:
                t = n.child.stateNode;
                break;
              case 1:
                t = n.child.stateNode;
            }
          }
          try {
            No(e, t);
          } catch (e) {
            Z(n, n.return, e);
          }
        }
        break;
      case 27:
        if (t === null && r & 4) {
          Hl(n);
        }
      case 26:
      case 5:
        Lu(e, n);
        if (t === null && r & 4) {
          Il(n);
        }
        if (r & 512) {
          kl(n, n.return);
        }
        break;
      case 12:
        Lu(e, n);
        break;
      case 31:
        Lu(e, n);
        if (r & 4) {
          Eu(e, n);
        }
        break;
      case 13:
        Lu(e, n);
        if (r & 4) {
          Du(e, n);
        }
        if (r & 64) {
          e = n.memoizedState;
          if (e !== null) {
            e = e.dehydrated;
            if (e !== null) {
              n = _f.bind(null, n);
              cm(e, n);
            }
          }
        }
        break;
      case 22:
        r = n.memoizedState !== null || V;
        if (!r) {
          var a = t !== null && t.memoizedState !== null || H;
          t = V;
          i = H;
          V = r;
          if ((H = a) && !i) {
            r = 2;
            if (n.subtreeFlags & 8772) {
              r |= 1;
            }
            zu(e, n, r);
          } else {
            Lu(e, n);
          }
          V = t;
          H = i;
        }
        break;
      case 30:
        Lu(e, n);
        if (r & 512) {
          kl(n, n.return);
        }
        break;
      case 7:
        if (r & 512) {
          kl(n, n.return);
        }
      default:
        Lu(e, n);
    }
  }
  function yu(e, t) {
    for (e = e.child; e !== null;) {
      bu(e, t);
      e = e.sibling;
    }
  }
  function bu(e, t) {
    switch (e.tag) {
      case 5:
      case 26:
        try {
          var n = e.stateNode;
          if (t) {
            var r = n.style;
            if (typeof r.setProperty == `function`) {
              r.setProperty(`display`, `none`, `important`);
            } else {
              r.display = `none`;
            }
          } else {
            var i = e.stateNode;
            var a = e.memoizedProps.style;
            var o = a != null && a.hasOwnProperty(`display`) ? a.display : null;
            i.style.display = o == null || typeof o == `boolean` ? `` : `${o}`.trim();
          }
        } catch (t) {
          Z(e, e.return, t);
        }
        xu(e, t);
        break;
      case 6:
        try {
          e.stateNode.nodeValue = t ? `` : e.memoizedProps;
          O = true;
        } catch (t) {
          Z(e, e.return, t);
        }
        break;
      case 18:
        try {
          var s = e.stateNode;
          if (t) {
            wp(s, true);
          } else {
            wp(e.stateNode, false);
          }
        } catch (t) {
          Z(e, e.return, t);
        }
        break;
      case 22:
      case 23:
        if (e.memoizedState === null) {
          yu(e, t);
        }
        break;
      default:
        yu(e, t);
    }
  }
  function xu(e, t) {
    if (e.subtreeFlags & 67108864) {
      for (e = e.child; e !== null;) {
        a: {
          var n = e;
          var r = t;
          switch (n.tag) {
            case 4:
              bu(n, r);
              break a;
            case 22:
              if (n.memoizedState === null) {
                xu(n, r);
              }
              break a;
            default:
              xu(n, r);
          }
        }
        e = e.sibling;
      }
    }
  }
  function Su(e) {
    var t = e.alternate;
    if (t !== null) {
      e.alternate = null;
      Su(t);
    }
    e.child = null;
    e.deletions = null;
    e.sibling = null;
    if (e.tag === 5) {
      t = e.stateNode;
      if (t !== null) {
        Ut(t);
      }
    }
    e.stateNode = null;
    e.return = null;
    e.dependencies = null;
    e.memoizedProps = null;
    e.memoizedState = null;
    e.pendingProps = null;
    e.stateNode = null;
    e.updateQueue = null;
  }
  var U = null;
  var Cu = false;
  function wu(e, t, n) {
    for (n = n.child; n !== null;) {
      Tu(e, t, n);
      n = n.sibling;
    }
  }
  function Tu(e, t, n) {
    if (ct && typeof ct.onCommitFiberUnmount == `function`) {
      try {
        ct.onCommitFiberUnmount(st, n);
      } catch {}
    }
    switch (n.tag) {
      case 26:
        if (!H) {
          Al(n, t);
        }
        wu(e, t, n);
        if (n.memoizedState) {
          n.memoizedState.count--;
        } else if (n.stateNode && !H) {
          n = n.stateNode;
          n.parentNode.removeChild(n);
        }
        break;
      case 27:
        if (!H) {
          Al(n, t);
        }
        Nl(n);
        var r = U;
        var i = Cu;
        if (Sp(n.type)) {
          U = n.stateNode;
          Cu = false;
        }
        wu(e, t, n);
        gm(n.stateNode, n.type, n.memoizedProps);
        U = r;
        Cu = i;
        break;
      case 5:
        if (!H) {
          Al(n, t);
        }
        Nl(n);
      case 6:
        if (n.tag === 6) {
          Nl(n);
        }
        r = U;
        i = Cu;
        U = null;
        wu(e, t, n);
        U = r;
        Cu = i;
        if (U !== null) {
          if (Cu) {
            try {
              (U.nodeType === 9 ? U.body : U.nodeName === `HTML` ? U.ownerDocument.body : U).removeChild(n.stateNode);
              O = true;
            } catch (e) {
              Z(n, t, e);
            }
          } else {
            try {
              U.removeChild(n.stateNode);
              O = true;
            } catch (e) {
              Z(n, t, e);
            }
          }
        }
        break;
      case 18:
        if (U !== null) {
          if (Cu) {
            e = U;
            Cp(e.nodeType === 9 ? e.body : e.nodeName === `HTML` ? e.ownerDocument.body : e, n.stateNode);
            Hh(e);
          } else {
            Cp(U, n.stateNode);
          }
        }
        break;
      case 4:
        r = U;
        i = Cu;
        U = n.stateNode.containerInfo;
        Cu = true;
        wu(e, t, n);
        U = r;
        Cu = i;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        El(2, n, t);
        if (!H) {
          El(4, n, t);
        }
        wu(e, t, n);
        break;
      case 1:
        if (!H) {
          Al(n, t);
          r = n.stateNode;
          if (typeof r.componentWillUnmount == `function`) {
            Ol(n, t, r);
          }
        }
        wu(e, t, n);
        break;
      case 21:
        wu(e, t, n);
        break;
      case 22:
        H = (r = H) || n.memoizedState !== null;
        wu(e, t, n);
        H = r;
        break;
      case 30:
        Al(n, t);
        wu(e, t, n);
        break;
      case 7:
        if (!H) {
          Al(n, t);
        }
        wu(e, t, n);
        break;
      default:
        wu(e, t, n);
    }
  }
  function Eu(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        Hh(e);
      } catch (e) {
        Z(t, t.return, e);
      }
    }
  }
  function Du(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) {
      try {
        Hh(e);
      } catch (e) {
        Z(t, t.return, e);
      }
    }
  }
  function Ou(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        if (t === null) {
          t = e.stateNode = new uu();
        }
        return t;
      case 22:
        e = e.stateNode;
        t = e._retryCache;
        if (t === null) {
          t = e._retryCache = new uu();
        }
        return t;
      default:
        throw Error(s(435, e.tag));
    }
  }
  function ku(e, t) {
    var n = Ou(e);
    t.forEach(function (t) {
      if (!n.has(t)) {
        n.add(t);
        var r = vf.bind(null, e, t);
        t.then(r, r);
      }
    });
  }
  function Au(e, t, n) {
    var r = t.deletions;
    if (r !== null) {
      for (var i = 0; i < r.length; i++) {
        var a = r[i];
        var o = e;
        var c = t;
        var l = c;
        a: while (l !== null) {
          switch (l.tag) {
            case 27:
              if (Sp(l.type)) {
                U = l.stateNode;
                Cu = false;
                break a;
              }
              break;
            case 5:
              U = l.stateNode;
              Cu = false;
              break a;
            case 3:
            case 4:
              U = l.stateNode.containerInfo;
              Cu = true;
              break a;
          }
          l = l.return;
        }
        if (U === null) {
          throw Error(s(160));
        }
        Tu(o, c, a);
        U = null;
        Cu = false;
        o = a.alternate;
        if (o !== null) {
          o.return = null;
        }
        a.return = null;
      }
    }
    if (t.subtreeFlags & 13886) {
      for (t = t.child; t !== null;) {
        Mu(t, e, n);
        t = t.sibling;
      }
    }
  }
  var ju = null;
  function Mu(e, t, n) {
    var r = e.alternate;
    var i = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (i & 4 && (r = e.updateQueue, r = r === null ? null : r.events, r !== null)) {
          for (var a = 0; a < r.length; a++) {
            var o = r[a];
            o.ref.impl = o.nextImpl;
          }
        }
        Au(t, e, n);
        Nu(e);
        if (i & 4) {
          El(3, e, e.return);
          Tl(3, e);
          El(5, e, e.return);
        }
        break;
      case 1:
        Au(t, e, n);
        Nu(e);
        if (i & 512) {
          if (!H && r !== null) {
            Al(r, r.return);
          }
        }
        if (i & 64 && V) {
          e = e.updateQueue;
          if (e !== null) {
            t = e.callbacks;
            if (t !== null) {
              n = e.shared.hiddenCallbacks;
              e.shared.hiddenCallbacks = n === null ? t : n.concat(t);
            }
          }
        }
        break;
      case 26:
        a = ju;
        Au(t, e, n);
        Nu(e);
        if (i & 512) {
          if (!H && r !== null) {
            Al(r, r.return);
          }
        }
        if (i & 4) {
          i = r === null ? null : r.memoizedState;
          n = e.memoizedState;
          if (r === null) {
            if (n === null) {
              if (e.stateNode === null) {
                if (V) {
                  e.stateNode = fp(e.type, e.memoizedProps, t.containerInfo, e);
                } else {
                  a: {
                    t = e.type;
                    n = e.memoizedProps;
                    i = a.ownerDocument || a;
                    b: switch (t) {
                      case `title`:
                        r = i.getElementsByTagName(`title`)[0];
                        if (!r || r[Vt] || r[Pt] || r.namespaceURI === `http://www.w3.org/2000/svg` || r.hasAttribute(`itemprop`)) {
                          r = i.createElement(t);
                          i.head.insertBefore(r, i.querySelector(`head > title`));
                        }
                        np(r, t, n);
                        r[Pt] = e;
                        D(r);
                        t = r;
                        break a;
                      case `link`:
                        if (a = Gm(`link`, `href`, i).get(t + (n.href || ``))) {
                          for (o = 0; o < a.length; o++) {
                            r = a[o];
                            if (r.getAttribute(`href`) === (n.href == null || n.href === `` ? null : n.href) && r.getAttribute(`rel`) === (n.rel == null ? null : n.rel) && r.getAttribute(`title`) === (n.title == null ? null : n.title) && r.getAttribute(`crossorigin`) === (n.crossOrigin == null ? null : n.crossOrigin)) {
                              a.splice(o, 1);
                              break b;
                            }
                          }
                        }
                        r = i.createElement(t);
                        np(r, t, n);
                        i.head.appendChild(r);
                        break;
                      case `meta`:
                        if (a = Gm(`meta`, `content`, i).get(t + (n.content || ``))) {
                          for (o = 0; o < a.length; o++) {
                            r = a[o];
                            if (r.getAttribute(`content`) === (n.content == null ? null : `${n.content}`) && r.getAttribute(`name`) === (n.name == null ? null : n.name) && r.getAttribute(`property`) === (n.property == null ? null : n.property) && r.getAttribute(`http-equiv`) === (n.httpEquiv == null ? null : n.httpEquiv) && r.getAttribute(`charset`) === (n.charSet == null ? null : n.charSet)) {
                              a.splice(o, 1);
                              break b;
                            }
                          }
                        }
                        r = i.createElement(t);
                        np(r, t, n);
                        i.head.appendChild(r);
                        break;
                      default:
                        throw Error(s(468, t));
                    }
                    r[Pt] = e;
                    D(r);
                    t = r;
                  }
                  e.stateNode = t;
                }
              } else if (!V) {
                Km(a, e.type, e.stateNode);
              }
            } else {
              e.stateNode = Bm(a, n, e.memoizedProps);
            }
          } else if (i === n) {
            if (n === null && e.stateNode !== null) {
              Ll(e, e.memoizedProps, r.memoizedProps);
            }
          } else {
            if (i === null) {
              t = r.stateNode;
              if (t !== null && !H) {
                t.parentNode.removeChild(t);
              }
            } else {
              i.count--;
            }
            if (n === null) {
              if (!V) {
                Km(a, e.type, e.stateNode);
              }
            } else {
              Bm(a, n, e.memoizedProps);
            }
          }
        }
        break;
      case 27:
        Au(t, e, n);
        Nu(e);
        if (i & 512) {
          if (!H && r !== null) {
            Al(r, r.return);
          }
        }
        if (r !== null && i & 4) {
          Ll(e, e.memoizedProps, r.memoizedProps);
        }
        break;
      case 5:
        a = cu;
        cu = false;
        Au(t, e, n);
        cu = a;
        Nu(e);
        if (i & 512) {
          if (!H && r !== null) {
            Al(r, r.return);
          }
        }
        if (e.flags & 32) {
          t = e.stateNode;
          try {
            xn(t, ``);
            O = true;
          } catch (t) {
            Z(e, e.return, t);
          }
        }
        if (i & 4 && e.stateNode != null) {
          t = e.memoizedProps;
          Ll(e, t, r === null ? t : r.memoizedProps);
        }
        if (i & 1024) {
          lu = true;
        }
        break;
      case 6:
        Au(t, e, n);
        Nu(e);
        if (i & 4) {
          if (e.stateNode === null) {
            throw Error(s(162));
          }
          t = e.memoizedProps;
          n = e.stateNode;
          try {
            n.nodeValue = t;
            O = true;
          } catch (t) {
            Z(e, e.return, t);
          }
        }
        break;
      case 3:
        O = false;
        Wm = null;
        a = ju;
        ju = bm(t.containerInfo);
        Au(t, e, n);
        ju = a;
        Nu(e);
        if (i & 4 && r !== null && r.memoizedState.isDehydrated) {
          try {
            Hh(t.containerInfo);
          } catch (t) {
            Z(e, e.return, t);
          }
        }
        if (lu) {
          lu = false;
          Pu(e);
        }
        O = false;
        break;
      case 4:
        i = cu;
        cu = V;
        r = rn();
        a = ju;
        ju = bm(e.stateNode.containerInfo);
        Au(t, e, n);
        Nu(e);
        ju = a;
        if (O && pu) {
          mu = true;
        }
        O = r;
        cu = i;
        break;
      case 12:
        Au(t, e, n);
        Nu(e);
        break;
      case 31:
        Au(t, e, n);
        Nu(e);
        if (i & 4) {
          t = e.updateQueue;
          if (t !== null) {
            e.updateQueue = null;
            ku(e, t);
          }
        }
        break;
      case 13:
        Au(t, e, n);
        Nu(e);
        if (e.child.flags & 8192 && e.memoizedState !== null != (r !== null && r.memoizedState !== null)) {
          hd = Qe();
        }
        if (i & 4) {
          t = e.updateQueue;
          if (t !== null) {
            e.updateQueue = null;
            ku(e, t);
          }
        }
        break;
      case 22:
        a = e.memoizedState !== null;
        o = r !== null && r.memoizedState !== null;
        var c = V;
        var l = H;
        var u = cu;
        V = c || a;
        cu = u || a;
        H = l || o;
        Au(t, e, n);
        H = l;
        cu = u;
        V = c;
        Nu(e);
        if (i & 8192) {
          t = e.stateNode;
          t._visibility = a ? t._visibility & -2 : t._visibility | 1;
          if (!!a && r !== null && !o && !V && !H) {
            t = o || H;
            n = V;
            r = H;
            V = a || V;
            H = t;
            Ru(e, 2);
            V = n;
            H = r;
          }
          if (!!a || !cu) {
            yu(e, a);
          }
        }
        if (i & 4) {
          t = e.updateQueue;
          if (t !== null) {
            n = t.retryQueue;
            if (n !== null) {
              t.retryQueue = null;
              ku(e, n);
            }
          }
        }
        break;
      case 19:
        Au(t, e, n);
        Nu(e);
        if (i & 4) {
          t = e.updateQueue;
          if (t !== null) {
            e.updateQueue = null;
            ku(e, t);
          }
        }
        break;
      case 30:
        if (i & 512) {
          if (!H && r !== null) {
            Al(r, r.return);
          }
        }
        i = rn();
        a = pu;
        o = (n & 335544064) === n;
        c = e.memoizedProps;
        pu = o && Ai(c.default, c.update) !== `none`;
        Au(t, e, n);
        Nu(e);
        if (o && r !== null && O) {
          e.flags |= 4;
        }
        pu = a;
        O = i;
        break;
      case 21:
        break;
      case 7:
        if (i & 512) {
          if (!H && r !== null) {
            Al(r, r.return);
          }
        }
        if (r && r.stateNode !== null) {
          r.stateNode._fragmentFiber = e;
        }
      default:
        Au(t, e, n);
        Nu(e);
    }
  }
  function Nu(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        var n;
        for (var r = e.return; r !== null;) {
          if (Rl(r)) {
            n = r;
            break;
          }
          r = r.return;
        }
        r = null;
        for (var i = e.return; i !== null;) {
          if (Fl(i)) {
            var a = i.stateNode;
            if (r === null) {
              r = [a];
            } else {
              r.push(a);
            }
          }
          if (Pl(i)) {
            break;
          }
          i = i.return;
        }
        var o = r;
        if (n == null) {
          throw Error(s(160));
        }
        switch (n.tag) {
          case 27:
            var c = n.stateNode;
            Vl(e, zl(e), c, o);
            break;
          case 5:
            var l = n.stateNode;
            if (n.flags & 32) {
              xn(l, ``);
              n.flags &= -33;
            }
            Vl(e, zl(e), l, o);
            break;
          case 3:
          case 4:
            var u = n.stateNode.containerInfo;
            Bl(e, zl(e), u, o);
            break;
          default:
            throw Error(s(161));
        }
      } catch (t) {
        Z(e, e.return, t);
      }
      e.flags &= -3;
    }
    if (t & 4096) {
      e.flags &= -4097;
    }
  }
  function Pu(e) {
    if (e.subtreeFlags & 1024) {
      for (e = e.child; e !== null;) {
        var t = e;
        Pu(t);
        if (t.tag === 5 && t.flags & 1024) {
          t = t.stateNode;
          gh = true;
          t.reset();
          gh = false;
        }
        e = e.sibling;
      }
    }
  }
  function Fu(e, t) {
    if (t.subtreeFlags & 9270) {
      for (t = t.child; t !== null;) {
        Iu(t, e);
        t = t.sibling;
      }
    } else {
      su(t, false);
    }
  }
  function Iu(e, t) {
    var n = e.alternate;
    if (n === null) {
      $l(e, false);
    } else {
      switch (e.tag) {
        case 3:
          hu = fu = false;
          ql();
          Fu(t, e);
          if (!fu && !mu) {
            e = Kl;
            if (e !== null) {
              for (var r = 0; r < e.length; r += 3) {
                n = e[r];
                var i = e[r + 1];
                Ep(n, e[r + 2]);
                n = n.ownerDocument.documentElement;
                if (n !== null) {
                  n.animate({
                    opacity: [0, 0],
                    pointerEvents: [`none`, `none`]
                  }, {
                    duration: 0,
                    fill: `forwards`,
                    pseudoElement: `::view-transition-group(${i})`
                  });
                }
              }
            }
            e = t.containerInfo;
            e = e.nodeType === 9 ? e.documentElement : e.ownerDocument.documentElement;
            if (e !== null && e.style.viewTransitionName === ``) {
              e.style.viewTransitionName = `none`;
              e.animate({
                opacity: [0, 0],
                pointerEvents: [`none`, `none`]
              }, {
                duration: 0,
                fill: `forwards`,
                pseudoElement: `::view-transition-group(root)`
              });
              e.animate({
                width: [0, 0],
                height: [0, 0]
              }, {
                duration: 0,
                fill: `forwards`,
                pseudoElement: `::view-transition`
              });
            }
            hu = true;
          }
          Kl = null;
          break;
        case 5:
          Fu(t, e);
          break;
        case 4:
          r = fu;
          fu = false;
          Fu(t, e);
          if (fu) {
            mu = true;
          }
          fu = r;
          break;
        case 22:
          if (e.memoizedState === null) {
            if (n.memoizedState === null) {
              Fu(t, e);
            } else {
              $l(e, false);
            }
          }
          break;
        case 30:
          r = fu;
          i = ql();
          fu = false;
          Fu(t, e);
          if (fu) {
            e.flags |= 4;
          }
          var a = e.memoizedProps;
          var o = e.stateNode;
          t = Oi(a, o);
          o = Oi(n.memoizedProps, o);
          var s = Ai(a.default, a.update);
          if (s === `none`) {
            t = false;
          } else {
            a = n.memoizedState;
            n.memoizedState = null;
            n = e.child;
            Jl = 0;
            t = ou(e, n, t, o, s, a, true);
            if (Jl !== (a === null ? 0 : a.length)) {
              e.flags |= 32;
            }
          }
          if (e.flags & 4 && t) {
            Nd(e, e.memoizedProps.onUpdate);
            Kl = i;
          } else if (i !== null) {
            i.push.apply(i, Kl);
            Kl = i;
          }
          fu = e.flags & 32 ? true : r;
          break;
        default:
          Fu(t, e);
      }
    }
  }
  function Lu(e, t) {
    if (t.subtreeFlags & 8772) {
      for (t = t.child; t !== null;) {
        vu(e, t.alternate, t);
        t = t.sibling;
      }
    }
  }
  function Ru(e, t) {
    for (e = e.child; e !== null;) {
      var n = e;
      var r = t;
      switch (n.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          El(4, n, n.return);
          Ru(n, r);
          break;
        case 1:
          Al(n, n.return);
          var i = n.stateNode;
          if (typeof i.componentWillUnmount == `function`) {
            Ol(n, n.return, i);
          }
          Ru(n, r);
          break;
        case 27:
          if (r & 2) {
            gm(n.stateNode, n.type, n.memoizedProps);
          }
        case 5:
          Al(n, n.return);
          if (n.tag === 5 || n.tag === 27) {
            Nl(n);
          }
          Ru(n, r);
          break;
        case 6:
          Nl(n);
          break;
        case 26:
          Al(n, n.return);
          i = n.stateNode;
          if (n.memoizedState === null && i !== null && !H) {
            i.parentNode.removeChild(i);
          }
          Ru(n, r);
          break;
        case 22:
          if (n.memoizedState === null) {
            Ru(n, r);
          }
          break;
        case 30:
          Al(n, n.return);
          Ru(n, r);
          break;
        case 7:
          Al(n, n.return);
        default:
          Ru(n, r);
      }
      e = e.sibling;
    }
  }
  function zu(e, t, n) {
    n = t.subtreeFlags & 8772 ? n : n & -2;
    t = t.child;
    while (t !== null) {
      var r = t.alternate;
      var i = e;
      var a = t;
      var o = a.flags;
      var s = !!(n & 1);
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          zu(i, a, n);
          Tl(4, a);
          break;
        case 1:
          zu(i, a, n);
          r = a;
          i = r.stateNode;
          if (typeof i.componentDidMount == `function`) {
            try {
              i.componentDidMount();
            } catch (e) {
              Z(r, r.return, e);
            }
          }
          r = a;
          i = r.updateQueue;
          if (i !== null) {
            var c = r.stateNode;
            try {
              var l = i.shared.hiddenCallbacks;
              if (l !== null) {
                i.shared.hiddenCallbacks = null;
                i = 0;
                for (; i < l.length; i++) {
                  Mo(l[i], c);
                }
              }
            } catch (e) {
              Z(r, r.return, e);
            }
          }
          if (s && o & 64) {
            Dl(a);
          }
          kl(a, a.return);
          break;
        case 27:
          if (n & 2) {
            Hl(a);
          }
        case 5:
          if (a.tag === 5 || a.tag === 27) {
            Ml(a);
          }
          zu(i, a, n);
          if (s && r === null && o & 4) {
            Il(a);
          }
          kl(a, a.return);
          break;
        case 6:
          Ml(a);
          break;
        case 26:
          c = a.stateNode;
          if (a.memoizedState === null && c !== null && !V) {
            Km(bm(c.ownerDocument), a.type, c);
          }
          zu(i, a, n);
          if (s && r === null && o & 4) {
            Il(a);
          }
          kl(a, a.return);
          break;
        case 12:
          zu(i, a, n);
          break;
        case 31:
          zu(i, a, n);
          if (s && o & 4) {
            Eu(i, a);
          }
          break;
        case 13:
          zu(i, a, n);
          if (s && o & 4) {
            Du(i, a);
          }
          break;
        case 22:
          if (a.memoizedState === null) {
            zu(i, a, n);
          }
          kl(a, a.return);
          break;
        case 30:
          zu(i, a, n);
          kl(a, a.return);
          break;
        case 7:
          kl(a, a.return);
        default:
          zu(i, a, n);
      }
      t = t.sibling;
    }
  }
  function Bu(e, t) {
    var n = null;
    if (e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null) {
      n = e.memoizedState.cachePool.pool;
    }
    e = null;
    if (t.memoizedState !== null && t.memoizedState.cachePool !== null) {
      e = t.memoizedState.cachePool.pool;
    }
    if (e !== n) {
      if (e != null) {
        e.refCount++;
      }
      if (n != null) {
        Va(n);
      }
    }
  }
  function Vu(e, t) {
    e = null;
    if (t.alternate !== null) {
      e = t.alternate.memoizedState.cache;
    }
    t = t.memoizedState.cache;
    if (t !== e) {
      t.refCount++;
      if (e != null) {
        Va(e);
      }
    }
  }
  function Hu(e, t, n, r) {
    var i = (n & 335544064) === n;
    if (t.subtreeFlags & (i ? 10262 : 10256)) {
      for (t = t.child; t !== null;) {
        Uu(e, t, n, r);
        t = t.sibling;
      }
    } else if (i) {
      au(t);
    }
  }
  function Uu(e, t, n, r) {
    var i = (n & 335544064) === n;
    if (i && t.alternate === null && t.return !== null && t.return.alternate !== null) {
      iu(t);
    }
    var a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Hu(e, t, n, r);
        if (a & 2048) {
          Tl(9, t);
        }
        break;
      case 1:
        Hu(e, t, n, r);
        break;
      case 3:
        Hu(e, t, n, r);
        if (i && hu) {
          e = e.containerInfo;
          e = e.nodeType === 9 ? e.body : e.nodeName === `HTML` ? e.ownerDocument.body : e;
          if (e.style.viewTransitionName === `root`) {
            e.style.viewTransitionName = ``;
          }
          e = e.ownerDocument.documentElement;
          if (e !== null && e.style.viewTransitionName === `none`) {
            e.style.viewTransitionName = ``;
          }
        }
        if (a & 2048) {
          a = null;
          if (t.alternate !== null) {
            a = t.alternate.memoizedState.cache;
          }
          t = t.memoizedState.cache;
          if (t !== a) {
            t.refCount++;
            if (a != null) {
              Va(a);
            }
          }
        }
        break;
      case 12:
        if (a & 2048) {
          Hu(e, t, n, r);
          a = t.stateNode;
          try {
            var o = t.memoizedProps;
            var s = o.id;
            var c = o.onPostCommit;
            if (typeof c == `function`) {
              c(s, t.alternate === null ? `mount` : `update`, a.passiveEffectDuration, -0);
            }
          } catch (e) {
            Z(t, t.return, e);
          }
        } else {
          Hu(e, t, n, r);
        }
        break;
      case 31:
        Hu(e, t, n, r);
        break;
      case 13:
        Hu(e, t, n, r);
        break;
      case 23:
        break;
      case 22:
        o = t.stateNode;
        s = t.alternate;
        if (t.memoizedState === null) {
          if (i && s !== null && s.memoizedState !== null) {
            iu(t);
          }
          if (o._visibility & 2) {
            Hu(e, t, n, r);
          } else {
            o._visibility |= 2;
            Wu(e, t, n, r, !!(t.subtreeFlags & 10256) || false);
          }
        } else {
          if (i && s !== null && s.memoizedState === null) {
            iu(s);
          }
          if (o._visibility & 2) {
            Hu(e, t, n, r);
          } else {
            Gu(e, t);
          }
        }
        if (a & 2048) {
          Bu(s, t);
        }
        break;
      case 24:
        Hu(e, t, n, r);
        if (a & 2048) {
          Vu(t.alternate, t);
        }
        break;
      case 30:
        if (i) {
          a = t.alternate;
          if (a !== null) {
            Zl(a.child, true);
            Zl(t.child, true);
          }
        }
        Hu(e, t, n, r);
        break;
      default:
        Hu(e, t, n, r);
    }
  }
  function Wu(e, t, n, r, i) {
    i &&= !!(t.subtreeFlags & 10256) || false;
    t = t.child;
    while (t !== null) {
      var a = e;
      var o = t;
      var s = n;
      var c = r;
      var l = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          Wu(a, o, s, c, i);
          Tl(8, o);
          break;
        case 23:
          break;
        case 22:
          var u = o.stateNode;
          if (o.memoizedState === null) {
            u._visibility |= 2;
            Wu(a, o, s, c, i);
          } else if (u._visibility & 2) {
            Wu(a, o, s, c, i);
          } else {
            Gu(a, o);
          }
          if (i && l & 2048) {
            Bu(o.alternate, o);
          }
          break;
        case 24:
          Wu(a, o, s, c, i);
          if (i && l & 2048) {
            Vu(o.alternate, o);
          }
          break;
        default:
          Wu(a, o, s, c, i);
      }
      t = t.sibling;
    }
  }
  function Gu(e, t) {
    if (t.subtreeFlags & 10256) {
      for (t = t.child; t !== null;) {
        var n = e;
        var r = t;
        var i = r.flags;
        switch (r.tag) {
          case 22:
            Gu(n, r);
            if (i & 2048) {
              Bu(r.alternate, r);
            }
            break;
          case 24:
            Gu(n, r);
            if (i & 2048) {
              Vu(r.alternate, r);
            }
            break;
          default:
            Gu(n, r);
        }
        t = t.sibling;
      }
    }
  }
  var Ku = 8192;
  function qu(e, t, n) {
    if (e.subtreeFlags & Ku) {
      for (e = e.child; e !== null;) {
        Ju(e, t, n);
        e = e.sibling;
      }
    }
  }
  function Ju(e, t, n) {
    switch (e.tag) {
      case 26:
        qu(e, t, n);
        if (e.flags & Ku) {
          if (e.memoizedState === null) {
            e = e.stateNode;
            if ((t & 335544128) === t) {
              Zm(n, e);
            }
          } else {
            Qm(n, ju, e.memoizedState, e.memoizedProps);
          }
        }
        break;
      case 5:
        qu(e, t, n);
        if (e.flags & Ku) {
          e = e.stateNode;
          if ((t & 335544128) === t) {
            Zm(n, e);
          }
        }
        break;
      case 3:
      case 4:
        var r = ju;
        ju = bm(e.stateNode.containerInfo);
        qu(e, t, n);
        ju = r;
        break;
      case 22:
        if (e.memoizedState === null) {
          r = e.alternate;
          if (r !== null && r.memoizedState !== null) {
            r = Ku;
            Ku = 16777216;
            qu(e, t, n);
            Ku = r;
          } else {
            qu(e, t, n);
          }
        }
        break;
      case 30:
        if ((e.flags & Ku) !== 0 && (r = e.memoizedProps.name, r != null && r !== `auto`)) {
          var i = e.stateNode;
          i.paired = null;
          if (Wl === null) {
            Wl = new Map();
          }
          Wl.set(r, i);
        }
        qu(e, t, n);
        break;
      default:
        qu(e, t, n);
    }
  }
  function Yu(e) {
    var t = e.alternate;
    if (t !== null && (e = t.child, e !== null)) {
      t.child = null;
      do {
        t = e.sibling;
        e.sibling = null;
        e = t;
      } while (e !== null);
    }
  }
  function Xu(e) {
    var t = e.deletions;
    if (e.flags & 16) {
      if (t !== null) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          du = r;
          $u(r, e);
        }
      }
      Yu(e);
    }
    if (e.subtreeFlags & 10256) {
      for (e = e.child; e !== null;) {
        Zu(e);
        e = e.sibling;
      }
    }
  }
  function Zu(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Xu(e);
        if (e.flags & 2048) {
          El(9, e, e.return);
        }
        break;
      case 3:
        Xu(e);
        break;
      case 12:
        Xu(e);
        break;
      case 22:
        var t = e.stateNode;
        if (e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13)) {
          t._visibility &= -3;
          Qu(e);
        } else {
          Xu(e);
        }
        break;
      default:
        Xu(e);
    }
  }
  function Qu(e) {
    var t = e.deletions;
    if (e.flags & 16) {
      if (t !== null) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          du = r;
          $u(r, e);
        }
      }
      Yu(e);
    }
    for (e = e.child; e !== null;) {
      t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          El(8, t, t.return);
          Qu(t);
          break;
        case 22:
          n = t.stateNode;
          if (n._visibility & 2) {
            n._visibility &= -3;
            Qu(t);
          }
          break;
        default:
          Qu(t);
      }
      e = e.sibling;
    }
  }
  function $u(e, t) {
    while (du !== null) {
      var n = du;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          El(8, n, t);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var r = n.memoizedState.cachePool.pool;
            if (r != null) {
              r.refCount++;
            }
          }
          break;
        case 24:
          Va(n.memoizedState.cache);
      }
      r = n.child;
      if (r !== null) {
        r.return = n;
        du = r;
      } else {
        a: for (n = e; du !== null;) {
          r = du;
          var i = r.sibling;
          var a = r.return;
          Su(r);
          if (r === n) {
            du = null;
            break a;
          }
          if (i !== null) {
            i.return = a;
            du = i;
            break a;
          }
          du = a;
        }
      }
    }
  }
  var ed = {
    getCacheForType: function (e) {
      var t = Pa(M);
      var n = t.data.get(e);
      if (n === undefined) {
        n = e();
        t.data.set(e, n);
      }
      return n;
    },
    cacheSignal: function () {
      return Pa(M).controller.signal;
    }
  };
  var td = typeof WeakMap == `function` ? WeakMap : Map;
  var W = 0;
  var G = null;
  var K = null;
  var q = 0;
  var J = 0;
  var nd = null;
  var rd = false;
  var id = false;
  var ad = false;
  var od = 0;
  var Y = 0;
  var sd = 0;
  var cd = 0;
  var ld = 0;
  var ud = 0;
  var dd = 0;
  var fd = null;
  var pd = null;
  var md = false;
  var hd = 0;
  var gd = 0;
  var _d = Infinity;
  var vd = null;
  var yd = null;
  var X = 0;
  var bd = null;
  var xd = null;
  var Sd = 0;
  var Cd = 0;
  var wd = null;
  var Td = null;
  var Ed = null;
  var Dd = null;
  var Od = null;
  var kd = 0;
  var Ad = null;
  function jd() {
    if (W & 2 && q !== 0) {
      return q & -q;
    } else if (C.T === null) {
      return jt();
    } else {
      return Pf();
    }
  }
  function Md() {
    if (ud === 0) {
      if (!(q & 536870912) || j) {
        var e = ht;
        ht <<= 1;
        if (!(ht & 3932160)) {
          ht = 262144;
        }
        ud = e;
      } else {
        ud = 536870912;
      }
    }
    e = zo.current;
    if (e !== null) {
      e.flags |= 32;
    }
    return ud;
  }
  function Nd(e, t) {
    if (t != null) {
      var n = e.stateNode;
      var r = n.ref;
      if (r === null) {
        r = n.ref = Pp(Oi(e.memoizedProps, n));
      }
      if (Dd === null) {
        Dd = [];
      }
      Dd.push(t.bind(null, r));
    }
  }
  function Pd(e, t, n) {
    if (e === G && (J === 2 || J === 9) || e.cancelPendingCommit !== null) {
      Vd(e, 0);
      Rd(e, q, ud, false);
    }
    wt(e, n);
    if (!(W & 2) || e !== G) {
      if (e === G) {
        if (!(W & 2)) {
          cd |= n;
        }
        if (Y === 4) {
          Rd(e, q, ud, false);
        }
      }
      Ef(e);
    }
  }
  function Fd(e, t, n) {
    if (W & 6) {
      throw Error(s(327));
    }
    var r = !n && !(t & 127) && (t & e.expiredLanes) === 0 || yt(e, t);
    var i = r ? Yd(e, t) : qd(e, t, true);
    var a = r;
    do {
      if (i === 0) {
        if (id && !r) {
          Rd(e, t, 0, false);
        }
        break;
      }
      n = e.current.alternate;
      if (a && !Ld(n)) {
        i = qd(e, t, false);
        a = false;
        continue;
      }
      if (i === 2) {
        a = t;
        if (e.errorRecoveryDisabledLanes & a) {
          var o = 0;
        } else {
          o = e.pendingLanes & -536870913;
          o = o === 0 ? o & 536870912 ? 536870912 : 0 : o;
        }
        if (o !== 0) {
          t = o;
          a: {
            var c = e;
            i = fd;
            var l = c.current.memoizedState.isDehydrated;
            if (l) {
              Vd(c, o).flags |= 256;
            }
            o = qd(c, o, false);
            if (o !== 2 && o !== 6) {
              if (ad && !l) {
                c.errorRecoveryDisabledLanes |= a;
                cd |= a;
                i = 4;
                break a;
              }
              a = pd;
              pd = i;
              if (a !== null) {
                if (pd === null) {
                  pd = a;
                } else {
                  pd.push.apply(pd, a);
                }
              }
            }
            i = o;
          }
          a = false;
          if (i !== 2) {
            continue;
          }
        }
      }
      if (i === 1) {
        Vd(e, 0);
        Rd(e, t, 0, true);
        break;
      }
      a: {
        r = e;
        a = i;
        switch (a) {
          case 0:
          case 1:
            throw Error(s(345));
          case 4:
            if ((t & 4194048) !== t && (t & 62914560) !== t) {
              break;
            }
          case 6:
            Rd(r, t, ud, !rd);
            break a;
          case 2:
            pd = null;
            break;
          case 3:
          case 5:
            break;
          default:
            throw Error(s(329));
        }
        if ((t & 62914560) === t && (i = hd + 300 - Qe(), i > 10)) {
          Rd(r, t, ud, !rd);
          if (vt(r, 0, true) !== 0) {
            break a;
          }
          Sd = t;
          r.timeoutHandle = gp(Id.bind(null, r, n, pd, vd, md, t, ud, cd, dd, rd, a, `Throttled`, -0, 0), i);
          break a;
        }
        Id(r, n, pd, vd, md, t, ud, cd, dd, rd, a, null, -0, 0);
      }
      break;
    } while (1);
    Ef(e);
  }
  function Id(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
    e.timeoutHandle = -1;
    var m = t.subtreeFlags;
    var h = (a & 335544064) === a;
    d = null;
    if ((h || m & 8192 || (m & 16785408) == 16785408) && (d = {
      stylesheets: null,
      count: 0,
      imgCount: 0,
      imgBytes: 0,
      suspenseyImages: [],
      waitingForImages: true,
      waitingForViewTransition: false,
      unsuspend: kn
    }, Wl = null, Ju(t, a, d), h && (m = d, h = e.containerInfo, h = (h.nodeType === 9 ? h : h.ownerDocument).__reactViewTransition, h != null && (m.count++, m.waitingForViewTransition = true, m = nh.bind(m), h.finished.then(m, m))), m = (a & 62914560) === a ? hd - Qe() : (a & 4194048) === a ? gd - Qe() : 0, m = eh(d, m), m !== null)) {
      Sd = a;
      e.cancelPendingCommit = m(nf.bind(null, e, t, a, n, r, i, o, s, c, l, u, d, null, f, p));
      Rd(e, a, o, !l);
      return;
    }
    nf(e, t, a, n, r, i, o, s, c, l, u, d);
  }
  function Ld(e) {
    var t = e;
    for (;;) {
      var n = t.tag;
      if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) {
        for (var r = 0; r < n.length; r++) {
          var i = n[r];
          var a = i.getSnapshot;
          i = i.value;
          try {
            if (!Qr(a(), i)) {
              return false;
            }
          } catch {
            return false;
          }
        }
      }
      n = t.child;
      if (t.subtreeFlags & 16384 && n !== null) {
        n.return = t;
        t = n;
      } else {
        if (t === e) {
          break;
        }
        while (t.sibling === null) {
          if (t.return === null || t.return === e) {
            return true;
          }
          t = t.return;
        }
        t.sibling.return = t.return;
        t = t.sibling;
      }
    }
    return true;
  }
  function Rd(e, t, n, r) {
    t = bt(e, t);
    t &= ~ld;
    t &= ~cd;
    e.suspendedLanes |= t;
    e.pingedLanes &= ~t;
    if (r) {
      e.warmLanes |= t;
    }
    r = e.expirationTimes;
    for (var i = t; i > 0;) {
      var a = 31 - ut(i);
      var o = 1 << a;
      r[a] = -1;
      i &= ~o;
    }
    if (n !== 0) {
      Et(e, n, t);
    }
  }
  function zd() {
    if (W & 6) {
      return true;
    } else {
      Df(0, false);
      return false;
    }
  }
  function Bd() {
    if (K !== null) {
      if (J === 0) {
        var e = K.return;
      } else {
        e = K;
        Ea = Ta = null;
        ds(e);
        mo = null;
        ho = 0;
        e = K;
      }
      while (e !== null) {
        wl(e.alternate, e);
        e = e.return;
      }
      K = null;
    }
  }
  function Vd(e, t) {
    var n = e.timeoutHandle;
    if (n !== -1) {
      e.timeoutHandle = -1;
      _p(n);
    }
    n = e.cancelPendingCommit;
    if (n !== null) {
      e.cancelPendingCommit = null;
      n();
    }
    Sd = 0;
    Bd();
    G = e;
    K = n = Gi(e.current, null);
    q = t;
    J = 0;
    nd = null;
    rd = false;
    id = yt(e, t);
    ad = false;
    dd = ud = ld = cd = sd = Y = 0;
    pd = fd = null;
    md = false;
    od = bt(e, t);
    Fi();
    return n;
  }
  function Hd(e, t) {
    N = null;
    C.H = bc;
    if (t === ro || t === ao) {
      t = fo();
      J = 3;
    } else if (t === io) {
      t = fo();
      J = 4;
    } else {
      J = t === Rc ? 8 : typeof t == `object` && t && typeof t.then == `function` ? 6 : 1;
    }
    nd = t;
    if (K === null) {
      Y = 1;
      Mc(e, $i(t, e.current));
    }
  }
  function Ud() {
    var e = zo.current;
    if (e === null) {
      return true;
    } else if ((q & 4194048) === q) {
      return Bo === null;
    } else if ((q & 62914560) === q || q & 536870912) {
      return e === Bo;
    } else {
      return false;
    }
  }
  function Wd() {
    var e = C.H;
    C.H = bc;
    if (e === null) {
      return bc;
    } else {
      return e;
    }
  }
  function Gd() {
    var e = C.A;
    C.A = ed;
    return e;
  }
  function Kd() {
    Y = 4;
    if (!rd && ((q & 4194048) === q || zo.current === null)) {
      id = true;
    }
    if ((!!(sd & 134217727) || !!(cd & 134217727)) && G !== null) {
      Rd(G, q, ud, false);
    }
  }
  function qd(e, t, n) {
    var r = W;
    W |= 2;
    var i = Wd();
    var a = Gd();
    if (G !== e || q !== t) {
      vd = null;
      Vd(e, t);
    }
    t = false;
    var o = Y;
    a: do {
      try {
        if (J !== 0 && K !== null) {
          var s = K;
          var c = nd;
          switch (J) {
            case 8:
              Bd();
              o = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              if (zo.current === null) {
                t = true;
              }
              var l = J;
              J = 0;
              nd = null;
              $d(e, s, c, l);
              if (n && id) {
                o = 0;
                break a;
              }
              break;
            default:
              l = J;
              J = 0;
              nd = null;
              $d(e, s, c, l);
          }
        }
        Jd();
        o = Y;
        break;
      } catch (t) {
        Hd(e, t);
      }
    } while (1);
    if (t) {
      e.shellSuspendCounter++;
    }
    Ea = Ta = null;
    W = r;
    C.H = i;
    C.A = a;
    if (K === null) {
      G = null;
      q = 0;
      Fi();
    }
    return o;
  }
  function Jd() {
    while (K !== null) {
      Zd(K);
    }
  }
  function Yd(e, t) {
    var n = W;
    W |= 2;
    var r = Wd();
    var i = Gd();
    if (G !== e || q !== t) {
      vd = null;
      _d = Qe() + 500;
      Vd(e, t);
    } else {
      id = yt(e, t);
    }
    a: do {
      try {
        if (J !== 0 && K !== null) {
          t = K;
          var a = nd;
          b: switch (J) {
            case 1:
              J = 0;
              nd = null;
              $d(e, t, a, 1);
              break;
            case 2:
            case 9:
              if (so(a)) {
                J = 0;
                nd = null;
                Qd(t);
                break;
              }
              t = function () {
                if ((J === 2 || J === 9) && G === e) {
                  J = 7;
                }
                Ef(e);
              };
              a.then(t, t);
              break a;
            case 3:
              J = 7;
              break a;
            case 4:
              J = 5;
              break a;
            case 7:
              if (so(a)) {
                J = 0;
                nd = null;
                Qd(t);
              } else {
                J = 0;
                nd = null;
                $d(e, t, a, 7);
              }
              break;
            case 5:
              var o = null;
              switch (K.tag) {
                case 26:
                  o = K.memoizedState;
                case 5:
                case 27:
                  var c = K;
                  if (o ? Ym(o) : c.stateNode.complete) {
                    J = 0;
                    nd = null;
                    var l = c.sibling;
                    if (l !== null) {
                      K = l;
                    } else {
                      var u = c.return;
                      if (u === null) {
                        K = null;
                      } else {
                        K = u;
                        ef(u);
                      }
                    }
                    break b;
                  }
              }
              J = 0;
              nd = null;
              $d(e, t, a, 5);
              break;
            case 6:
              J = 0;
              nd = null;
              $d(e, t, a, 6);
              break;
            case 8:
              Bd();
              Y = 6;
              break a;
            default:
              throw Error(s(462));
          }
        }
        Xd();
        break;
      } catch (t) {
        Hd(e, t);
      }
    } while (1);
    Ea = Ta = null;
    C.H = r;
    C.A = i;
    W = n;
    if (K === null) {
      G = null;
      q = 0;
      Fi();
      return Y;
    } else {
      return 0;
    }
  }
  function Xd() {
    while (K !== null && !Xe()) {
      Zd(K);
    }
  }
  function Zd(e) {
    var t = gl(e.alternate, e, od);
    e.memoizedProps = e.pendingProps;
    if (t === null) {
      ef(e);
    } else {
      K = t;
    }
  }
  function Qd(e) {
    var t = e;
    var n = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = Xc(n, t, t.pendingProps, t.type, undefined, q);
        break;
      case 11:
        t = Xc(n, t, t.pendingProps, t.type.render, t.ref, q);
        break;
      case 5:
        ds(t);
        var r = t;
        if (r === k) {
          if (j) {
            ya(r);
            if (r.tag === 5 && r.stateNode != null) {
              A = r.stateNode;
            }
          } else {
            ya(r);
            j = true;
          }
        }
      default:
        wl(n, t);
        t = K = Ki(t, od);
        t = gl(n, t, od);
    }
    e.memoizedProps = e.pendingProps;
    if (t === null) {
      ef(e);
    } else {
      K = t;
    }
  }
  function $d(e, t, n, r) {
    Ea = Ta = null;
    ds(t);
    mo = null;
    ho = 0;
    var i = t.return;
    try {
      if (Lc(e, i, t, n, q)) {
        Y = 1;
        Mc(e, $i(n, e.current));
        K = null;
        return;
      }
    } catch (t) {
      if (i !== null) {
        K = i;
        throw t;
      }
      Y = 1;
      Mc(e, $i(n, e.current));
      K = null;
      return;
    }
    if (t.flags & 32768) {
      if (j || r === 1) {
        e = true;
      } else if (id || q & 536870912) {
        e = false;
      } else {
        rd = e = true;
        if (r === 2 || r === 9 || r === 3 || r === 6) {
          r = zo.current;
          if (r !== null && r.tag === 13) {
            r.flags |= 16384;
          }
        }
      }
      tf(t, e);
    } else {
      ef(t);
    }
  }
  function ef(e) {
    var t = e;
    do {
      if (t.flags & 32768) {
        tf(t, rd);
        return;
      }
      e = t.return;
      var n = Sl(t.alternate, t, od);
      if (n !== null) {
        K = n;
        return;
      }
      t = t.sibling;
      if (t !== null) {
        K = t;
        return;
      }
      K = t = e;
    } while (t !== null);
    if (Y === 0) {
      Y = 5;
    }
  }
  function tf(e, t) {
    do {
      var n = Cl(e.alternate, e);
      if (n !== null) {
        n.flags &= 32767;
        K = n;
        return;
      }
      n = e.return;
      if (n !== null) {
        n.flags |= 32768;
        n.subtreeFlags = 0;
        n.deletions = null;
      }
      if (!t && (e = e.sibling, e !== null)) {
        K = e;
        return;
      }
      K = e = n;
    } while (e !== null);
    Y = 6;
    K = null;
  }
  function nf(e, t, n, r, i, a, o, c, l, u, d, f) {
    e.cancelPendingCommit = null;
    do {
      df();
    } while (X !== 0);
    if (W & 6) {
      throw Error(s(327));
    }
    if (t !== null) {
      if (t === e.current) {
        throw Error(s(177));
      }
      if (e === G) {
        K = G = null;
        q = 0;
      }
      xd = t;
      bd = e;
      Sd = n;
      wd = i;
      Td = r;
      rf(e, t, n, o, c, l, f);
    }
  }
  function rf(e, t, n, r, i, a, o) {
    var s = t.lanes | t.childLanes;
    Cd = s;
    s |= Pi;
    Tt(e, n, s, r, i, a);
    Dd = null;
    if ((n & 335544064) === n) {
      Od = Wa(e);
      r = 10262;
    } else {
      Od = null;
      r = 10256;
    }
    if ((t.subtreeFlags & r) !== 0 || (t.flags & r) !== 0) {
      e.callbackNode = null;
      e.callbackPriority = 0;
      yf(nt, function () {
        ff();
        return null;
      });
    } else {
      e.callbackNode = null;
      e.callbackPriority = 0;
    }
    Ul = false;
    r = !!(t.flags & 13878);
    if (t.subtreeFlags & 13878 || r) {
      r = C.T;
      C.T = null;
      i = w.p;
      w.p = 2;
      a = W;
      W |= 4;
      try {
        gu(e, t, n);
      } finally {
        W = a;
        w.p = i;
        C.T = r;
      }
    }
    X = 1;
    if (Ul) {
      Ed = Mp(o, e.containerInfo, Od, sf, cf, of, lf, ff, af, null, null);
    } else {
      sf();
      cf();
      lf();
    }
  }
  function af(e) {
    if (X !== 0) {
      var t = bd.onRecoverableError;
      t(e, {
        componentStack: null
      });
    }
  }
  function of() {
    if (X === 3) {
      X = 0;
      Iu(xd, bd);
      X = 4;
    }
  }
  function sf() {
    if (X === 1) {
      X = 0;
      var e = bd;
      var t = xd;
      var n = Sd;
      var r = !!(t.flags & 13878);
      if (t.subtreeFlags & 13878 || r) {
        r = C.T;
        C.T = null;
        var i = w.p;
        w.p = 2;
        var a = W;
        W |= 4;
        try {
          pu = mu = false;
          Mu(t, e, n);
          n = cp;
          var o = ii(e.containerInfo);
          var s = n.focusedElem;
          var c = n.selectionRange;
          if (o !== s && s && s.ownerDocument && ri(s.ownerDocument.documentElement, s)) {
            if (c !== null && ai(s)) {
              var l = c.start;
              var u = c.end;
              if (u === undefined) {
                u = l;
              }
              if (`selectionStart` in s) {
                s.selectionStart = l;
                s.selectionEnd = Math.min(u, s.value.length);
              } else {
                var d = s.ownerDocument || document;
                var f = d && d.defaultView || window;
                if (f.getSelection) {
                  var p = f.getSelection();
                  var m = s.textContent.length;
                  var h = Math.min(c.start, m);
                  var g = c.end === undefined ? h : Math.min(c.end, m);
                  if (!p.extend && h > g) {
                    o = g;
                    g = h;
                    h = o;
                  }
                  var _ = ni(s, h);
                  var v = ni(s, g);
                  if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
                    var y = d.createRange();
                    y.setStart(_.node, _.offset);
                    p.removeAllRanges();
                    if (h > g) {
                      p.addRange(y);
                      p.extend(v.node, v.offset);
                    } else {
                      y.setEnd(v.node, v.offset);
                      p.addRange(y);
                    }
                  }
                }
              }
            }
            d = [];
            p = s;
            while (p = p.parentNode) {
              if (p.nodeType === 1) {
                d.push({
                  element: p,
                  left: p.scrollLeft,
                  top: p.scrollTop
                });
              }
            }
            if (typeof s.focus == `function`) {
              s.focus();
            }
            s = 0;
            for (; s < d.length; s++) {
              var b = d[s];
              b.element.scrollLeft = b.left;
              b.element.scrollTop = b.top;
            }
          }
          gh = !!sp;
          cp = sp = null;
        } finally {
          W = a;
          w.p = i;
          C.T = r;
        }
      }
      e.current = t;
      X = 2;
    }
  }
  function cf() {
    if (X === 2) {
      X = 0;
      var e = bd;
      var t = xd;
      var n = !!(t.flags & 8772);
      if (t.subtreeFlags & 8772 || n) {
        n = C.T;
        C.T = null;
        var r = w.p;
        w.p = 2;
        var i = W;
        W |= 4;
        try {
          vu(e, t.alternate, t);
        } finally {
          W = i;
          w.p = r;
          C.T = n;
        }
      }
      X = 3;
    }
  }
  function lf() {
    if (X === 4 || X === 3) {
      X = 0;
      var e = Ed;
      Ed = null;
      Ze();
      var t = bd;
      var n = xd;
      var r = Sd;
      var i = Td;
      var a = (r & 335544064) === r ? 10262 : 10256;
      if ((n.subtreeFlags & a) !== 0 || (n.flags & a) !== 0) {
        X = 5;
      } else {
        X = 0;
        xd = bd = null;
        uf(t, t.pendingLanes);
      }
      a = t.pendingLanes;
      if (a === 0) {
        yd = null;
      }
      At(r);
      n = n.stateNode;
      if (ct && typeof ct.onCommitFiberRoot == `function`) {
        try {
          ct.onCommitFiberRoot(st, n, undefined, (n.current.flags & 128) == 128);
        } catch {}
      }
      if (i !== null) {
        n = C.T;
        a = w.p;
        w.p = 2;
        C.T = null;
        try {
          var o = t.onRecoverableError;
          for (var s = 0; s < i.length; s++) {
            var c = i[s];
            o(c.value, {
              componentStack: c.stack
            });
          }
        } finally {
          C.T = n;
          w.p = a;
        }
      }
      i = Dd;
      o = Od;
      Od = null;
      if (i !== null && (Dd = null, o === null && (o = []), e !== null)) {
        for (c = 0; c < i.length; c++) {
          n = (0, i[c])(o);
          if (n !== undefined) {
            e.finished.finally(n);
          }
        }
      }
      if (Sd & 3) {
        df();
      }
      Ef(t);
      a = t.pendingLanes;
      if (r & 261930 && a & 42) {
        if (t === Ad) {
          kd++;
        } else {
          kd = 0;
          Ad = t;
        }
      } else {
        kd = 0;
        Ad = null;
      }
      Df(0, false);
    }
  }
  function uf(e, t) {
    if ((e.pooledCacheLanes &= t) === 0) {
      t = e.pooledCache;
      if (t != null) {
        e.pooledCache = null;
        Va(t);
      }
    }
  }
  function df() {
    if (Ed !== null) {
      Ed.skipTransition();
      Ed = null;
    }
    sf();
    cf();
    lf();
    return ff();
  }
  function ff() {
    if (X !== 5) {
      return false;
    }
    var e = bd;
    var t = Cd;
    Cd = 0;
    var n = At(Sd);
    var r = C.T;
    var i = w.p;
    try {
      w.p = n < 32 ? 32 : n;
      C.T = null;
      n = wd;
      wd = null;
      var a = bd;
      var o = Sd;
      X = 0;
      xd = bd = null;
      Sd = 0;
      if (W & 6) {
        throw Error(s(331));
      }
      var c = W;
      W |= 4;
      Zu(a.current);
      Uu(a, a.current, o, n);
      W = c;
      Df(0, false);
      if (ct && typeof ct.onPostCommitFiberRoot == `function`) {
        try {
          ct.onPostCommitFiberRoot(st, a);
        } catch {}
      }
      return true;
    } finally {
      w.p = i;
      C.T = r;
      uf(e, t);
    }
  }
  function pf(e, t, n) {
    t = $i(n, t);
    t = Pc(e.stateNode, t, 2);
    e = Eo(e, t, 2);
    if (e !== null) {
      wt(e, 2);
      Ef(e);
    }
  }
  function Z(e, t, n) {
    if (e.tag === 3) {
      pf(e, e, n);
    } else {
      while (t !== null) {
        if (t.tag === 3) {
          pf(t, e, n);
          break;
        }
        if (t.tag === 1) {
          var r = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == `function` || typeof r.componentDidCatch == `function` && (yd === null || !yd.has(r))) {
            e = $i(n, e);
            n = Fc(2);
            r = Eo(t, n, 2);
            if (r !== null) {
              Ic(n, r, t, e);
              wt(r, 2);
              Ef(r);
            }
            break;
          }
        }
        t = t.return;
      }
    }
  }
  function mf(e, t, n) {
    var r = e.pingCache;
    if (r === null) {
      r = e.pingCache = new td();
      var i = new Set();
      r.set(t, i);
    } else {
      i = r.get(t);
      if (i === undefined) {
        i = new Set();
        r.set(t, i);
      }
    }
    if (!i.has(n)) {
      ad = true;
      i.add(n);
      e = hf.bind(null, e, t, n);
      t.then(e, e);
    }
  }
  function hf(e, t, n) {
    var r = e.pingCache;
    if (r !== null) {
      r.delete(t);
    }
    e.pingedLanes |= e.suspendedLanes & n;
    e.warmLanes &= ~n;
    if (G === e && (q & n) === n) {
      if (Y === 4 || Y === 3 && (q & 62914560) === q && Qe() - hd < 300) {
        if (W & 2) {
          ld |= n;
        } else {
          Vd(e, 0);
        }
      } else {
        ld |= n;
      }
      if (dd === q) {
        dd = 0;
      }
    }
    Ef(e);
  }
  function gf(e, t) {
    if (t === 0) {
      t = St();
    }
    e = Ri(e, t);
    if (e !== null) {
      wt(e, t);
      Ef(e);
    }
  }
  function _f(e) {
    var t = e.memoizedState;
    var n = 0;
    if (t !== null) {
      n = t.retryLane;
    }
    gf(e, n);
  }
  function vf(e, t) {
    var n = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var r = e.stateNode;
        var i = e.memoizedState;
        if (i !== null) {
          n = i.retryLane;
        }
        break;
      case 19:
        r = e.stateNode;
        break;
      case 22:
        r = e.stateNode._retryCache;
        break;
      default:
        throw Error(s(314));
    }
    if (r !== null) {
      r.delete(t);
    }
    gf(e, n);
  }
  function yf(e, t) {
    return Je(e, t);
  }
  var bf = null;
  var xf = null;
  var Sf = false;
  var Cf = false;
  var wf = false;
  var Tf = 0;
  function Ef(e) {
    if (e !== xf && e.next === null) {
      if (xf === null) {
        bf = xf = e;
      } else {
        xf = xf.next = e;
      }
    }
    Cf = true;
    if (!Sf) {
      Sf = true;
      Nf();
    }
  }
  function Df(e, t) {
    if (!wf && Cf) {
      wf = true;
      do {
        for (var n = false, r = bf; r !== null;) {
          if (!t) {
            if (e !== 0) {
              var i = r.pendingLanes;
              if (i === 0) {
                var a = 0;
              } else {
                var o = r.suspendedLanes;
                var s = r.pingedLanes;
                a = (1 << 31 - ut(e | 42) + 1) - 1;
                a &= i & ~(o & ~s);
                a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
              }
              if (a !== 0) {
                n = true;
                Mf(r, a);
              }
            } else {
              a = q;
              a = vt(r, r === G ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1);
              if (!!(a & 3) && !yt(r, a)) {
                n = true;
                Mf(r, a);
              }
            }
          }
          r = r.next;
        }
      } while (n);
      wf = false;
    }
  }
  function Of() {
    kf();
  }
  function kf() {
    Cf = Sf = false;
    var e = 0;
    if (Tf !== 0 && hp()) {
      e = Tf;
    }
    var t = Qe();
    for (var n = null, r = bf; r !== null;) {
      var i = r.next;
      var a = Af(r, t);
      if (a === 0) {
        r.next = null;
        if (n === null) {
          bf = i;
        } else {
          n.next = i;
        }
        if (i === null) {
          xf = n;
        }
      } else {
        n = r;
        if (e !== 0 || a & 3) {
          Cf = true;
        }
      }
      r = i;
    }
    if (X === 0 || X === 5) {
      Df(e, false);
    }
    if (Tf !== 0) {
      Tf = 0;
    }
  }
  function Af(e, t) {
    var n = e.suspendedLanes;
    var r = e.pingedLanes;
    var i = e.expirationTimes;
    for (var a = e.pendingLanes & -62914561; a > 0;) {
      var o = 31 - ut(a);
      var s = 1 << o;
      var c = i[o];
      if (c === -1) {
        if ((s & n) === 0 || (s & r) !== 0) {
          i[o] = xt(s, t);
        }
      } else if (c <= t) {
        e.expiredLanes |= s;
      }
      a &= ~s;
    }
    t = G;
    n = q;
    n = vt(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1);
    r = e.callbackNode;
    if (n === 0 || e === t && (J === 2 || J === 9) || e.cancelPendingCommit !== null) {
      if (r !== null && r !== null) {
        Ye(r);
      }
      e.callbackNode = null;
      return e.callbackPriority = 0;
    }
    if (!(n & 3) || yt(e, n)) {
      t = n & -n;
      if (t === e.callbackPriority) {
        return t;
      }
      if (r !== null) {
        Ye(r);
      }
      switch (At(n)) {
        case 2:
        case 8:
          n = tt;
          break;
        case 32:
          n = nt;
          break;
        case 268435456:
          n = it;
          break;
        default:
          n = nt;
      }
      r = jf.bind(null, e);
      n = Je(n, r);
      e.callbackPriority = t;
      e.callbackNode = n;
      return t;
    }
    if (r !== null && r !== null) {
      Ye(r);
    }
    e.callbackPriority = 2;
    e.callbackNode = null;
    return 2;
  }
  function jf(e, t) {
    if (X !== 0 && X !== 5) {
      e.callbackNode = null;
      e.callbackPriority = 0;
      return null;
    }
    var n = e.callbackNode;
    if (df() && e.callbackNode !== n) {
      return null;
    }
    var r = q;
    r = vt(e, e === G ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1);
    if (r === 0) {
      return null;
    } else {
      Fd(e, r, t);
      Af(e, Qe());
      if (e.callbackNode != null && e.callbackNode === n) {
        return jf.bind(null, e);
      } else {
        return null;
      }
    }
  }
  function Mf(e, t) {
    if (df()) {
      return null;
    }
    Fd(e, t, true);
  }
  function Nf() {
    bp(function () {
      if (W & 6) {
        Je(et, Of);
      } else {
        kf();
      }
    });
  }
  function Pf() {
    if (Tf === 0) {
      var e = qa;
      if (e === 0) {
        e = mt;
        mt <<= 1;
        if (!(mt & 261888)) {
          mt = 256;
        }
      }
      Tf = e;
    }
    return Tf;
  }
  function Ff(e) {
    if (e == null || typeof e == `symbol` || typeof e == `boolean`) {
      return null;
    } else if (typeof e == `function`) {
      return e;
    } else {
      return On(e);
    }
  }
  function If(e, t, n, r, i) {
    if (t === `submit` && n && n.stateNode === i) {
      var a = Ff((i[Ft] || null).action);
      var o = r.submitter;
      if (o) {
        t = (t = o[Ft] || null) ? Ff(t.formAction) : o.getAttribute(`formAction`);
        if (t !== null) {
          a = t;
          o = null;
        }
      }
      var s = new Xn(`action`, `action`, null, r, i);
      e.push({
        event: s,
        listeners: [{
          instance: null,
          listener: function () {
            if (r.defaultPrevented) {
              if (Tf !== 0) {
                var e = new FormData(i, o);
                oc(n, {
                  pending: true,
                  data: e,
                  method: i.method,
                  action: a
                }, null, e);
              }
            } else if (typeof a == `function`) {
              s.preventDefault();
              e = new FormData(i, o);
              oc(n, {
                pending: true,
                data: e,
                method: i.method,
                action: a
              }, a, e);
            }
          },
          currentTarget: i
        }]
      });
    }
  }
  for (var Lf = 0; Lf < Ti.length; Lf++) {
    var Rf = Ti[Lf];
    Ei(Rf.toLowerCase(), `on${Rf[0].toUpperCase() + Rf.slice(1)}`);
  }
  Ei(_i, `onAnimationEnd`);
  Ei(vi, `onAnimationIteration`);
  Ei(yi, `onAnimationStart`);
  Ei(`dblclick`, `onDoubleClick`);
  Ei(`focusin`, `onFocus`);
  Ei(`focusout`, `onBlur`);
  Ei(bi, `onTransitionRun`);
  Ei(xi, `onTransitionStart`);
  Ei(Si, `onTransitionCancel`);
  Ei(Ci, `onTransitionEnd`);
  Qt(`onMouseEnter`, [`mouseout`, `mouseover`]);
  Qt(`onMouseLeave`, [`mouseout`, `mouseover`]);
  Qt(`onPointerEnter`, [`pointerout`, `pointerover`]);
  Qt(`onPointerLeave`, [`pointerout`, `pointerover`]);
  Zt(`onChange`, `change click focusin focusout input keydown keyup selectionchange`.split(` `));
  Zt(`onSelect`, `focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange`.split(` `));
  Zt(`onBeforeInput`, [`compositionend`, `keypress`, `textInput`, `paste`]);
  Zt(`onCompositionEnd`, `compositionend focusout keydown keypress keyup mousedown`.split(` `));
  Zt(`onCompositionStart`, `compositionstart focusout keydown keypress keyup mousedown`.split(` `));
  Zt(`onCompositionUpdate`, `compositionupdate focusout keydown keypress keyup mousedown`.split(` `));
  var zf = `abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting`.split(` `);
  var Bf = new Set(`beforetoggle cancel close invalid load scroll scrollend toggle`.split(` `).concat(zf));
  function Vf(e, t) {
    t = !!(t & 4);
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      var i = r.event;
      r = r.listeners;
      a: {
        var a = undefined;
        if (t) {
          for (var o = r.length - 1; o >= 0; o--) {
            var s = r[o];
            var c = s.instance;
            var l = s.currentTarget;
            s = s.listener;
            if (c !== a && i.isPropagationStopped()) {
              break a;
            }
            a = s;
            i.currentTarget = l;
            try {
              a(i);
            } catch (e) {
              ji(e);
            }
            i.currentTarget = null;
            a = c;
          }
        } else {
          for (o = 0; o < r.length; o++) {
            s = r[o];
            c = s.instance;
            l = s.currentTarget;
            s = s.listener;
            if (c !== a && i.isPropagationStopped()) {
              break a;
            }
            a = s;
            i.currentTarget = l;
            try {
              a(i);
            } catch (e) {
              ji(e);
            }
            i.currentTarget = null;
            a = c;
          }
        }
      }
    }
  }
  function Q(e, t) {
    var n = t[Lt];
    if (n === undefined) {
      n = t[Lt] = new Set();
    }
    var r = `${e}__bubble`;
    if (!n.has(r)) {
      Gf(t, e, 2, false);
      n.add(r);
    }
  }
  function Hf(e, t, n) {
    var r = 0;
    if (t) {
      r |= 4;
    }
    Gf(n, e, r, t);
  }
  var Uf = `_reactListening${Math.random().toString(36).slice(2)}`;
  function Wf(e) {
    if (!e[Uf]) {
      e[Uf] = true;
      Yt.forEach(function (t) {
        if (t !== `selectionchange`) {
          if (!Bf.has(t)) {
            Hf(t, false, e);
          }
          Hf(t, true, e);
        }
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      if (t !== null && !t[Uf]) {
        t[Uf] = true;
        Hf(`selectionchange`, false, t);
      }
    }
  }
  function Gf(e, t, n, r) {
    switch (Ch(t)) {
      case 2:
        var i = _h;
        break;
      case 8:
        i = vh;
        break;
      default:
        i = yh;
    }
    n = i.bind(null, t, n, e);
    i = undefined;
    if (!!zn && (t === `touchstart` || t === `touchmove` || t === `wheel`)) {
      i = true;
    }
    if (r) {
      if (i === undefined) {
        e.addEventListener(t, n, true);
      } else {
        e.addEventListener(t, n, {
          capture: true,
          passive: i
        });
      }
    } else if (i === undefined) {
      e.addEventListener(t, n, false);
    } else {
      e.addEventListener(t, n, {
        passive: i
      });
    }
  }
  function Kf(e, t, n, r, i) {
    var a = r;
    if (!(t & 1) && !(t & 2) && r !== null) {
      a: while (true) {
        if (r === null) {
          return;
        }
        var o = r.tag;
        if (o === 3 || o === 4) {
          var s = r.stateNode.containerInfo;
          if (s === i) {
            break;
          }
          if (o === 4) {
            for (o = r.return; o !== null;) {
              var c = o.tag;
              if ((c === 3 || c === 4) && o.stateNode.containerInfo === i) {
                return;
              }
              o = o.return;
            }
          }
          while (s !== null) {
            o = Wt(s);
            if (o === null) {
              return;
            }
            c = o.tag;
            if (c === 5 || c === 6 || c === 26 || c === 27) {
              r = a = o;
              continue a;
            }
            s = s.parentNode;
          }
        }
        r = r.return;
      }
    }
    In(function () {
      var r = a;
      var i = jn(n);
      var o = [];
      a: {
        var s = wi.get(e);
        if (s !== undefined) {
          var c = Xn;
          var u = e;
          switch (e) {
            case `keypress`:
              if (Gn(n) === 0) {
                break a;
              }
            case `keydown`:
            case `keyup`:
              c = mr;
              break;
            case `focusin`:
              u = `focus`;
              c = ar;
              break;
            case `focusout`:
              u = `blur`;
              c = ar;
              break;
            case `beforeblur`:
            case `afterblur`:
              c = ar;
              break;
            case `click`:
              if (n.button === 2) {
                break a;
              }
            case `auxclick`:
            case `dblclick`:
            case `mousedown`:
            case `mousemove`:
            case `mouseup`:
            case `mouseout`:
            case `mouseover`:
            case `contextmenu`:
              c = rr;
              break;
            case `drag`:
            case `dragend`:
            case `dragenter`:
            case `dragexit`:
            case `dragleave`:
            case `dragover`:
            case `dragstart`:
            case `drop`:
              c = ir;
              break;
            case `touchcancel`:
            case `touchend`:
            case `touchmove`:
            case `touchstart`:
              c = _r;
              break;
            case _i:
            case vi:
            case yi:
              c = or;
              break;
            case Ci:
              c = vr;
              break;
            case `scroll`:
            case `scrollend`:
              c = Qn;
              break;
            case `wheel`:
              c = yr;
              break;
            case `copy`:
            case `cut`:
            case `paste`:
              c = sr;
              break;
            case `gotpointercapture`:
            case `lostpointercapture`:
            case `pointercancel`:
            case `pointerdown`:
            case `pointermove`:
            case `pointerout`:
            case `pointerover`:
            case `pointerup`:
              c = hr;
              break;
            case `submit`:
              c = gr;
              break;
            case `toggle`:
            case `beforetoggle`:
              c = br;
          }
          var d = !!(t & 4);
          var f = !d && (e === `scroll` || e === `scrollend`);
          var p = d ? s === null ? null : `${s}Capture` : s;
          d = [];
          for (var m = r, h; m !== null;) {
            var g = m;
            h = g.stateNode;
            g = g.tag;
            if ((g === 5 || g === 26 || g === 27) && h !== null && p !== null) {
              g = Ln(m, p);
              if (g != null) {
                d.push(qf(m, g, h));
              }
            }
            if (f) {
              break;
            }
            m = m.return;
          }
          if (d.length > 0) {
            s = new c(s, u, null, n, i);
            o.push({
              event: s,
              listeners: d
            });
          }
        }
      }
      if (!(t & 7)) {
        a: {
          c = e === `mouseover` || e === `pointerover`;
          s = e === `mouseout` || e === `pointerout`;
          if (c && n !== An && (u = n.relatedTarget || n.fromElement) && (Wt(u) || u[It])) {
            break a;
          }
          if (s || c) {
            u = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window;
            if (s) {
              c = n.relatedTarget || n.toElement;
              s = r;
              c = c ? Wt(c) : null;
              if (c !== null && (f = l(c), d = c.tag, c !== f || d !== 5 && d !== 27 && d !== 6)) {
                c = null;
              }
            } else {
              s = null;
              c = r;
            }
            if (s !== c) {
              d = rr;
              g = `onMouseLeave`;
              p = `onMouseEnter`;
              m = `mouse`;
              if (e === `pointerout` || e === `pointerover`) {
                d = hr;
                g = `onPointerLeave`;
                p = `onPointerEnter`;
                m = `pointer`;
              }
              f = s == null ? u : Kt(s);
              h = c == null ? u : Kt(c);
              u = new d(g, `${m}leave`, s, n, i);
              u.target = f;
              u.relatedTarget = h;
              g = null;
              if (Wt(i) === r) {
                d = new d(p, `${m}enter`, c, n, i);
                d.target = h;
                d.relatedTarget = f;
                g = d;
              }
              f = g;
              d = s && c ? ie(s, c, Yf) : null;
              if (s !== null) {
                Xf(o, u, s, d, false);
              }
              if (c !== null && f !== null) {
                Xf(o, f, c, d, true);
              }
            }
          }
        }
        a: {
          s = r ? Kt(r) : window;
          c = s.nodeName && s.nodeName.toLowerCase();
          if (c === `select` || c === `input` && s.type === `file`) {
            var _ = Br;
          } else if (Pr(s)) {
            if (Vr) {
              _ = Xr;
            } else {
              _ = Jr;
              var v = qr;
            }
          } else {
            c = s.nodeName;
            if (!c || c.toLowerCase() !== `input` || s.type !== `checkbox` && s.type !== `radio`) {
              if (r && Tn(r.elementType)) {
                _ = Br;
              }
            } else {
              _ = Yr;
            }
          }
          if (_ &&= _(e, r)) {
            Fr(o, _, n, i);
            break a;
          }
          if (v) {
            v(e, s, r);
          }
        }
        v = r ? Kt(r) : window;
        switch (e) {
          case `focusin`:
            if (Pr(v) || v.contentEditable === `true`) {
              si = v;
              ci = r;
              li = null;
            }
            break;
          case `focusout`:
            li = ci = si = null;
            break;
          case `mousedown`:
            ui = true;
            break;
          case `contextmenu`:
          case `mouseup`:
          case `dragend`:
            ui = false;
            di(o, n, i);
            break;
          case `selectionchange`:
            if (oi) {
              break;
            }
          case `keydown`:
          case `keyup`:
            di(o, n, i);
        }
        var y;
        if (Sr) {
          b: {
            switch (e) {
              case `compositionstart`:
                var b = `onCompositionStart`;
                break b;
              case `compositionend`:
                b = `onCompositionEnd`;
                break b;
              case `compositionupdate`:
                b = `onCompositionUpdate`;
                break b;
            }
            b = undefined;
          }
        } else if (Ar) {
          if (Or(e, n)) {
            b = `onCompositionEnd`;
          }
        } else if (e === `keydown` && n.keyCode === 229) {
          b = `onCompositionStart`;
        }
        if (b) {
          if (Tr && n.locale !== `ko`) {
            if (Ar || b !== `onCompositionStart`) {
              if (b === `onCompositionEnd` && Ar) {
                y = Wn();
              }
            } else {
              Vn = i;
              Hn = `value` in Vn ? Vn.value : Vn.textContent;
              Ar = true;
            }
          }
          v = Jf(r, b);
          if (v.length > 0) {
            b = new cr(b, e, null, n, i);
            o.push({
              event: b,
              listeners: v
            });
            if (y) {
              b.data = y;
            } else {
              y = kr(n);
              if (y !== null) {
                b.data = y;
              }
            }
          }
        }
        if (y = wr ? jr(e, n) : Mr(e, n)) {
          b = Jf(r, `onBeforeInput`);
          if (b.length > 0) {
            v = new cr(`onBeforeInput`, `beforeinput`, null, n, i);
            o.push({
              event: v,
              listeners: b
            });
            v.data = y;
          }
        }
        If(o, e, r, n, i);
      }
      Vf(o, t);
    });
  }
  function qf(e, t, n) {
    return {
      instance: e,
      listener: t,
      currentTarget: n
    };
  }
  function Jf(e, t) {
    var n = `${t}Capture`;
    var r = [];
    for (; e !== null;) {
      var i = e;
      var a = i.stateNode;
      i = i.tag;
      if ((i === 5 || i === 26 || i === 27) && a !== null) {
        i = Ln(e, n);
        if (i != null) {
          r.unshift(qf(e, i, a));
        }
        i = Ln(e, t);
        if (i != null) {
          r.push(qf(e, i, a));
        }
      }
      if (e.tag === 3) {
        return r;
      }
      e = e.return;
    }
    return [];
  }
  function Yf(e) {
    if (e === null) {
      return null;
    }
    do {
      e = e.return;
    } while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function Xf(e, t, n, r, i) {
    var a = t._reactName;
    var o = [];
    for (; n !== null && n !== r;) {
      var s = n;
      var c = s.alternate;
      var l = s.stateNode;
      s = s.tag;
      if (c !== null && c === r) {
        break;
      }
      if ((s === 5 || s === 26 || s === 27) && l !== null) {
        c = l;
        if (i) {
          l = Ln(n, a);
          if (l != null) {
            o.unshift(qf(n, l, c));
          }
        } else if (!i) {
          l = Ln(n, a);
          if (l != null) {
            o.push(qf(n, l, c));
          }
        }
      }
      n = n.return;
    }
    if (o.length !== 0) {
      e.push({
        event: t,
        listeners: o
      });
    }
  }
  var Zf = /\r\n?/g;
  var Qf = /\u0000|\uFFFD/g;
  function $f(e) {
    return (typeof e == `string` ? e : `${e}`).replace(Zf, `
`).replace(Qf, ``);
  }
  function ep(e, t) {
    t = $f(t);
    return $f(e) === t;
  }
  function $(e, t, n, r, i, a) {
    switch (n) {
      case `children`:
        if (typeof r == `string`) {
          if (t !== `body` && (t !== `textarea` || r !== ``)) {
            xn(e, r);
          }
        } else if (typeof r == `number` || typeof r == `bigint`) {
          if (t !== `body`) {
            xn(e, `${r}`);
          }
        } else {
          return;
        }
        break;
      case `className`:
        on(e, `class`, r);
        break;
      case `tabIndex`:
        on(e, `tabindex`, r);
        break;
      case `dir`:
      case `role`:
      case `viewBox`:
      case `width`:
      case `height`:
        on(e, n, r);
        break;
      case `style`:
        wn(e, r, a);
        return;
      case `data`:
        if (t !== `object`) {
          on(e, `data`, r);
          break;
        }
      case `src`:
      case `href`:
        if (r === `` && (t !== `a` || n !== `href`)) {
          e.removeAttribute(n);
          break;
        }
        if (r == null || typeof r == `function` || typeof r == `symbol` || typeof r == `boolean`) {
          e.removeAttribute(n);
          break;
        }
        r = On(r);
        e.setAttribute(n, r);
        break;
      case `action`:
      case `formAction`:
        if (typeof r == `function`) {
          e.setAttribute(n, `javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')`);
          break;
        }
        if (typeof a == `function`) {
          if (n === `formAction`) {
            if (t !== `input`) {
              $(e, t, `name`, i.name, i, null);
            }
            $(e, t, `formEncType`, i.formEncType, i, null);
            $(e, t, `formMethod`, i.formMethod, i, null);
            $(e, t, `formTarget`, i.formTarget, i, null);
          } else {
            $(e, t, `encType`, i.encType, i, null);
            $(e, t, `method`, i.method, i, null);
            $(e, t, `target`, i.target, i, null);
          }
        }
        if (r == null || typeof r == `symbol` || typeof r == `boolean`) {
          e.removeAttribute(n);
          break;
        }
        r = On(r);
        e.setAttribute(n, r);
        break;
      case `onClick`:
        if (r != null) {
          e.onclick = kn;
        }
        return;
      case `onScroll`:
        if (r != null) {
          Q(`scroll`, e);
        }
        return;
      case `onScrollEnd`:
        if (r != null) {
          Q(`scrollend`, e);
        }
        return;
      case `dangerouslySetInnerHTML`:
        if (r != null) {
          if (typeof r != `object` || !(`__html` in r)) {
            throw Error(s(61));
          }
          n = r.__html;
          if (n != null) {
            if (i.children != null) {
              throw Error(s(60));
            }
            if (a?.__html !== n) {
              e.innerHTML = n;
            }
          }
        }
        break;
      case `multiple`:
        e.multiple = r && typeof r != `function` && typeof r != `symbol`;
        break;
      case `muted`:
        e.muted = r && typeof r != `function` && typeof r != `symbol`;
        break;
      case `suppressContentEditableWarning`:
      case `suppressHydrationWarning`:
      case `defaultValue`:
      case `defaultChecked`:
      case `innerHTML`:
      case `ref`:
        break;
      case `autoFocus`:
        break;
      case `xlinkHref`:
        if (r == null || typeof r == `function` || typeof r == `boolean` || typeof r == `symbol`) {
          e.removeAttribute(`xlink:href`);
          break;
        }
        n = On(r);
        e.setAttributeNS(`http://www.w3.org/1999/xlink`, `xlink:href`, n);
        break;
      case `contentEditable`:
      case `spellCheck`:
      case `draggable`:
      case `value`:
      case `autoReverse`:
      case `externalResourcesRequired`:
      case `focusable`:
      case `preserveAlpha`:
        if (r != null && typeof r != `function` && typeof r != `symbol`) {
          e.setAttribute(n, r);
        } else {
          e.removeAttribute(n);
        }
        break;
      case `inert`:
      case `allowFullScreen`:
      case `async`:
      case `autoPlay`:
      case `controls`:
      case `credentialless`:
      case `default`:
      case `defer`:
      case `disabled`:
      case `disablePictureInPicture`:
      case `disableRemotePlayback`:
      case `formNoValidate`:
      case `hidden`:
      case `loop`:
      case `noModule`:
      case `noValidate`:
      case `open`:
      case `playsInline`:
      case `readOnly`:
      case `required`:
      case `reversed`:
      case `scoped`:
      case `seamless`:
      case `itemScope`:
        if (r && typeof r != `function` && typeof r != `symbol`) {
          e.setAttribute(n, ``);
        } else {
          e.removeAttribute(n);
        }
        break;
      case `capture`:
      case `download`:
        if (r === true) {
          e.setAttribute(n, ``);
        } else if (r !== false && r != null && typeof r != `function` && typeof r != `symbol`) {
          e.setAttribute(n, r);
        } else {
          e.removeAttribute(n);
        }
        break;
      case `cols`:
      case `rows`:
      case `size`:
      case `span`:
        if (r != null && typeof r != `function` && typeof r != `symbol` && !isNaN(r) && r >= 1) {
          e.setAttribute(n, r);
        } else {
          e.removeAttribute(n);
        }
        break;
      case `rowSpan`:
      case `start`:
        if (r == null || typeof r == `function` || typeof r == `symbol` || isNaN(r)) {
          e.removeAttribute(n);
        } else {
          e.setAttribute(n, r);
        }
        break;
      case `popover`:
        Q(`beforetoggle`, e);
        Q(`toggle`, e);
        an(e, `popover`, r);
        break;
      case `xlinkActuate`:
        sn(e, `http://www.w3.org/1999/xlink`, `xlink:actuate`, r);
        break;
      case `xlinkArcrole`:
        sn(e, `http://www.w3.org/1999/xlink`, `xlink:arcrole`, r);
        break;
      case `xlinkRole`:
        sn(e, `http://www.w3.org/1999/xlink`, `xlink:role`, r);
        break;
      case `xlinkShow`:
        sn(e, `http://www.w3.org/1999/xlink`, `xlink:show`, r);
        break;
      case `xlinkTitle`:
        sn(e, `http://www.w3.org/1999/xlink`, `xlink:title`, r);
        break;
      case `xlinkType`:
        sn(e, `http://www.w3.org/1999/xlink`, `xlink:type`, r);
        break;
      case `xmlBase`:
        sn(e, `http://www.w3.org/XML/1998/namespace`, `xml:base`, r);
        break;
      case `xmlLang`:
        sn(e, `http://www.w3.org/XML/1998/namespace`, `xml:lang`, r);
        break;
      case `xmlSpace`:
        sn(e, `http://www.w3.org/XML/1998/namespace`, `xml:space`, r);
        break;
      case `is`:
        an(e, `is`, r);
        break;
      case `innerText`:
      case `textContent`:
        return;
      default:
        if (!(n.length > 2) || n[0] !== `o` && n[0] !== `O` || n[1] !== `n` && n[1] !== `N`) {
          n = En.get(n) || n;
          an(e, n, r);
        } else {
          return;
        }
    }
    O = true;
  }
  function tp(e, t, n, r, i, a) {
    switch (n) {
      case `style`:
        wn(e, r, a);
        return;
      case `dangerouslySetInnerHTML`:
        if (r != null) {
          if (typeof r != `object` || !(`__html` in r)) {
            throw Error(s(61));
          }
          n = r.__html;
          if (n != null) {
            if (i.children != null) {
              throw Error(s(60));
            }
            if (a?.__html !== n) {
              e.innerHTML = n;
            }
          }
        }
        break;
      case `children`:
        if (typeof r == `string`) {
          xn(e, r);
        } else if (typeof r == `number` || typeof r == `bigint`) {
          xn(e, `${r}`);
        } else {
          return;
        }
        break;
      case `onScroll`:
        if (r != null) {
          Q(`scroll`, e);
        }
        return;
      case `onScrollEnd`:
        if (r != null) {
          Q(`scrollend`, e);
        }
        return;
      case `onClick`:
        if (r != null) {
          e.onclick = kn;
        }
        return;
      case `suppressContentEditableWarning`:
      case `suppressHydrationWarning`:
      case `innerHTML`:
      case `ref`:
        return;
      case `innerText`:
      case `textContent`:
        return;
      default:
        if (!Xt.hasOwnProperty(n)) {
          a: {
            if (n[0] === `o` && n[1] === `n` && (i = n.endsWith(`Capture`), a = n.slice(2, i ? n.length - 7 : undefined), t = e[Ft] || null, t = t == null ? null : t[n], typeof t == `function` && e.removeEventListener(a, t, i), typeof r == `function`)) {
              if (typeof t != `function` && t !== null) {
                if (n in e) {
                  e[n] = null;
                } else if (e.hasAttribute(n)) {
                  e.removeAttribute(n);
                }
              }
              e.addEventListener(a, r, i);
              break a;
            }
            O = true;
            if (n in e) {
              e[n] = r;
            } else if (r === true) {
              e.setAttribute(n, ``);
            } else {
              an(e, n, r);
            }
          }
        }
        return;
    }
    O = true;
  }
  function np(e, t, n) {
    switch (t) {
      case `div`:
      case `span`:
      case `svg`:
      case `path`:
      case `a`:
      case `g`:
      case `p`:
      case `li`:
        break;
      case `img`:
        Q(`error`, e);
        Q(`load`, e);
        var r = false;
        var i = false;
        var a;
        for (a in n) {
          if (n.hasOwnProperty(a)) {
            var o = n[a];
            if (o != null) {
              switch (a) {
                case `src`:
                  r = true;
                  break;
                case `srcSet`:
                  i = true;
                  break;
                case `children`:
                case `dangerouslySetInnerHTML`:
                  throw Error(s(137, t));
                default:
                  $(e, t, a, o, n, null);
              }
            }
          }
        }
        if (i) {
          $(e, t, `srcSet`, n.srcSet, n, null);
        }
        if (r) {
          $(e, t, `src`, n.src, n, null);
        }
        return;
      case `input`:
        Q(`invalid`, e);
        var c = a = o = i = null;
        var l = null;
        var u = null;
        for (r in n) {
          if (n.hasOwnProperty(r)) {
            var d = n[r];
            if (d != null) {
              switch (r) {
                case `name`:
                  i = d;
                  break;
                case `type`:
                  o = d;
                  break;
                case `checked`:
                  l = d;
                  break;
                case `defaultChecked`:
                  u = d;
                  break;
                case `value`:
                  a = d;
                  break;
                case `defaultValue`:
                  c = d;
                  break;
                case `children`:
                case `dangerouslySetInnerHTML`:
                  if (d != null) {
                    throw Error(s(137, t));
                  }
                  break;
                default:
                  $(e, t, r, d, n, null);
              }
            }
          }
        }
        gn(e, a, c, l, u, o, i, false);
        return;
      case `select`:
        Q(`invalid`, e);
        r = o = a = null;
        for (i in n) {
          if (n.hasOwnProperty(i) && (c = n[i], c != null)) {
            switch (i) {
              case `value`:
                a = c;
                break;
              case `defaultValue`:
                o = c;
                break;
              case `multiple`:
                r = c;
              default:
                $(e, t, i, c, n, null);
            }
          }
        }
        t = a;
        n = o;
        e.multiple = !!r;
        if (t == null) {
          if (n != null) {
            vn(e, !!r, n, true);
          }
        } else {
          vn(e, !!r, t, false);
        }
        return;
      case `textarea`:
        Q(`invalid`, e);
        a = i = r = null;
        for (o in n) {
          if (n.hasOwnProperty(o) && (c = n[o], c != null)) {
            switch (o) {
              case `value`:
                r = c;
                break;
              case `defaultValue`:
                i = c;
                break;
              case `children`:
                a = c;
                break;
              case `dangerouslySetInnerHTML`:
                if (c != null) {
                  throw Error(s(91));
                }
                break;
              default:
                $(e, t, o, c, n, null);
            }
          }
        }
        bn(e, r, i, a);
        return;
      case `option`:
        for (l in n) {
          if (n.hasOwnProperty(l) && (r = n[l], r != null)) {
            switch (l) {
              case `selected`:
                e.selected = r && typeof r != `function` && typeof r != `symbol`;
                break;
              default:
                $(e, t, l, r, n, null);
            }
          }
        }
        return;
      case `dialog`:
        Q(`beforetoggle`, e);
        Q(`toggle`, e);
        Q(`cancel`, e);
        Q(`close`, e);
        break;
      case `iframe`:
      case `object`:
        Q(`load`, e);
        break;
      case `video`:
      case `audio`:
        for (r = 0; r < zf.length; r++) {
          Q(zf[r], e);
        }
        break;
      case `image`:
        Q(`error`, e);
        Q(`load`, e);
        break;
      case `details`:
        Q(`toggle`, e);
        break;
      case `embed`:
      case `source`:
      case `link`:
        Q(`error`, e);
        Q(`load`, e);
      case `area`:
      case `base`:
      case `br`:
      case `col`:
      case `hr`:
      case `keygen`:
      case `meta`:
      case `param`:
      case `track`:
      case `wbr`:
      case `menuitem`:
        for (u in n) {
          if (n.hasOwnProperty(u) && (r = n[u], r != null)) {
            switch (u) {
              case `children`:
              case `dangerouslySetInnerHTML`:
                throw Error(s(137, t));
              default:
                $(e, t, u, r, n, null);
            }
          }
        }
        return;
      default:
        if (Tn(t)) {
          for (d in n) {
            if (n.hasOwnProperty(d)) {
              r = n[d];
              if (r !== undefined) {
                tp(e, t, d, r, n, undefined);
              }
            }
          }
          return;
        }
    }
    for (c in n) {
      if (n.hasOwnProperty(c)) {
        r = n[c];
        if (r != null) {
          $(e, t, c, r, n, null);
        }
      }
    }
  }
  var rp = {};
  function ip(e, t, n, r) {
    switch (t) {
      case `div`:
      case `span`:
      case `svg`:
      case `path`:
      case `a`:
      case `g`:
      case `p`:
      case `li`:
        break;
      case `input`:
        var i = null;
        var a = null;
        var o = null;
        var c = null;
        var l = null;
        var u = null;
        var d = null;
        for (m in n) {
          var f = n[m];
          if (n.hasOwnProperty(m) && f != null) {
            switch (m) {
              case `checked`:
                break;
              case `value`:
                break;
              case `defaultValue`:
                l = f;
              default:
                if (!r.hasOwnProperty(m)) {
                  $(e, t, m, null, r, f);
                }
            }
          }
        }
        for (var p in r) {
          var m = r[p];
          f = n[p];
          if (r.hasOwnProperty(p) && (m != null || f != null)) {
            switch (p) {
              case `type`:
                if (m !== f) {
                  O = true;
                }
                a = m;
                break;
              case `name`:
                if (m !== f) {
                  O = true;
                }
                i = m;
                break;
              case `checked`:
                if (m !== f) {
                  O = true;
                }
                u = m;
                break;
              case `defaultChecked`:
                if (m !== f) {
                  O = true;
                }
                d = m;
                break;
              case `value`:
                if (m !== f) {
                  O = true;
                }
                o = m;
                break;
              case `defaultValue`:
                if (m !== f) {
                  O = true;
                }
                c = m;
                break;
              case `children`:
              case `dangerouslySetInnerHTML`:
                if (m != null) {
                  throw Error(s(137, t));
                }
                break;
              default:
                if (m !== f) {
                  $(e, t, p, m, r, f);
                }
            }
          }
        }
        hn(e, o, c, l, u, d, a, i);
        return;
      case `select`:
        m = o = c = p = null;
        for (a in n) {
          l = n[a];
          if (n.hasOwnProperty(a) && l != null) {
            switch (a) {
              case `value`:
                break;
              case `multiple`:
                m = l;
              default:
                if (!r.hasOwnProperty(a)) {
                  $(e, t, a, null, r, l);
                }
            }
          }
        }
        for (i in r) {
          a = r[i];
          l = n[i];
          if (r.hasOwnProperty(i) && (a != null || l != null)) {
            switch (i) {
              case `value`:
                if (a !== l) {
                  O = true;
                }
                p = a;
                break;
              case `defaultValue`:
                if (a !== l) {
                  O = true;
                }
                c = a;
                break;
              case `multiple`:
                if (a !== l) {
                  O = true;
                }
                o = a;
              default:
                if (a !== l) {
                  $(e, t, i, a, r, l);
                }
            }
          }
        }
        t = c;
        n = o;
        r = m;
        if (p == null) {
          if (!!r != !!n) {
            if (t == null) {
              vn(e, !!n, n ? [] : ``, false);
            } else {
              vn(e, !!n, t, true);
            }
          }
        } else {
          vn(e, !!n, p, false);
        }
        return;
      case `textarea`:
        m = p = null;
        for (c in n) {
          i = n[c];
          if (n.hasOwnProperty(c) && i != null && !r.hasOwnProperty(c)) {
            switch (c) {
              case `value`:
                break;
              case `children`:
                break;
              default:
                $(e, t, c, null, r, i);
            }
          }
        }
        for (o in r) {
          i = r[o];
          a = n[o];
          if (r.hasOwnProperty(o) && (i != null || a != null)) {
            switch (o) {
              case `value`:
                if (i !== a) {
                  O = true;
                }
                p = i;
                break;
              case `defaultValue`:
                if (i !== a) {
                  O = true;
                }
                m = i;
                break;
              case `children`:
                break;
              case `dangerouslySetInnerHTML`:
                if (i != null) {
                  throw Error(s(91));
                }
                break;
              default:
                if (i !== a) {
                  $(e, t, o, i, r, a);
                }
            }
          }
        }
        yn(e, p, m);
        return;
      case `option`:
        for (var h in n) {
          p = n[h];
          if (n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) {
            switch (h) {
              case `selected`:
                e.selected = false;
                break;
              default:
                $(e, t, h, null, r, p);
            }
          }
        }
        for (l in r) {
          p = r[l];
          m = n[l];
          if (r.hasOwnProperty(l) && p !== m && (p != null || m != null)) {
            switch (l) {
              case `selected`:
                if (p !== m) {
                  O = true;
                }
                e.selected = p && typeof p != `function` && typeof p != `symbol`;
                break;
              default:
                $(e, t, l, p, r, m);
            }
          }
        }
        return;
      case `img`:
      case `link`:
      case `area`:
      case `base`:
      case `br`:
      case `col`:
      case `embed`:
      case `hr`:
      case `keygen`:
      case `meta`:
      case `param`:
      case `source`:
      case `track`:
      case `wbr`:
      case `menuitem`:
        for (var g in n) {
          p = n[g];
          if (n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g)) {
            $(e, t, g, null, r, p);
          }
        }
        for (u in r) {
          p = r[u];
          m = n[u];
          if (r.hasOwnProperty(u) && p !== m && (p != null || m != null)) {
            switch (u) {
              case `children`:
              case `dangerouslySetInnerHTML`:
                if (p != null) {
                  throw Error(s(137, t));
                }
                break;
              default:
                $(e, t, u, p, r, m);
            }
          }
        }
        return;
      default:
        if (Tn(t)) {
          for (var _ in n) {
            p = n[_];
            if (n.hasOwnProperty(_) && p !== undefined && !r.hasOwnProperty(_)) {
              tp(e, t, _, undefined, r, p);
            }
          }
          for (d in r) {
            p = r[d];
            m = n[d];
            if (!!r.hasOwnProperty(d) && p !== m && (p !== undefined || m !== undefined)) {
              tp(e, t, d, p, r, m);
            }
          }
          return;
        }
    }
    for (var v in n) {
      p = n[v];
      if (n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v)) {
        $(e, t, v, null, r, p);
      }
    }
    for (f in r) {
      p = r[f];
      m = n[f];
      if (!!r.hasOwnProperty(f) && p !== m && (p != null || m != null)) {
        $(e, t, f, p, r, m);
      }
    }
  }
  function ap(e) {
    switch (e) {
      case `css`:
      case `script`:
      case `font`:
      case `img`:
      case `image`:
      case `input`:
      case `link`:
        return true;
      default:
        return false;
    }
  }
  function op() {
    if (typeof performance.getEntriesByType == `function`) {
      var e = 0;
      var t = 0;
      for (var n = performance.getEntriesByType(`resource`), r = 0; r < n.length; r++) {
        var i = n[r];
        var a = i.transferSize;
        var o = i.initiatorType;
        var s = i.duration;
        if (a && s && ap(o)) {
          o = 0;
          s = i.responseEnd;
          r += 1;
          for (; r < n.length; r++) {
            var c = n[r];
            var l = c.startTime;
            if (l > s) {
              break;
            }
            var u = c.transferSize;
            var d = c.initiatorType;
            if (u && ap(d)) {
              c = c.responseEnd;
              o += u * (c < s ? 1 : (s - l) / (c - l));
            }
          }
          --r;
          t += (a + o) * 8 / (i.duration / 1000);
          e++;
          if (e > 10) {
            break;
          }
        }
      }
      if (e > 0) {
        return t / e / 1000000;
      }
    }
    if (navigator.connection && (e = navigator.connection.downlink, typeof e == `number`)) {
      return e;
    } else {
      return 5;
    }
  }
  var sp = null;
  var cp = null;
  function lp(e) {
    if (e.nodeType === 9) {
      return e;
    } else {
      return e.ownerDocument;
    }
  }
  function up(e) {
    switch (e) {
      case `http://www.w3.org/2000/svg`:
        return 1;
      case `http://www.w3.org/1998/Math/MathML`:
        return 2;
      default:
        return 0;
    }
  }
  function dp(e, t) {
    if (e === 0) {
      switch (t) {
        case `svg`:
          return 1;
        case `math`:
          return 2;
        default:
          return 0;
      }
    }
    if (e === 1 && t === `foreignObject`) {
      return 0;
    } else {
      return e;
    }
  }
  function fp(e, t, n, r) {
    n = lp(n).createElement(e);
    n[Pt] = r;
    n[Ft] = t;
    np(n, e, t);
    D(n);
    return n;
  }
  function pp(e, t) {
    return e === `textarea` || e === `noscript` || typeof t.children == `string` || typeof t.children == `number` || typeof t.children == `bigint` || typeof t.dangerouslySetInnerHTML == `object` && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var mp = null;
  function hp() {
    var e = window.event;
    if (e && e.type === `popstate`) {
      return e !== mp && (mp = e, true);
    } else {
      mp = null;
      return false;
    }
  }
  var gp = typeof setTimeout == `function` ? setTimeout : undefined;
  var _p = typeof clearTimeout == `function` ? clearTimeout : undefined;
  var vp = typeof Promise == `function` ? Promise : undefined;
  var yp = typeof requestAnimationFrame == `function` ? requestAnimationFrame : gp;
  var bp = typeof queueMicrotask == `function` ? queueMicrotask : vp === undefined ? gp : function (e) {
    return vp.resolve(null).then(e).catch(xp);
  };
  function xp(e) {
    setTimeout(function () {
      throw e;
    });
  }
  function Sp(e) {
    return e === `head`;
  }
  function Cp(e, t) {
    var n = t;
    var r = 0;
    do {
      var i = n.nextSibling;
      e.removeChild(n);
      if (i && i.nodeType === 8) {
        n = i.data;
        if (n === `/$` || n === `/&`) {
          if (r === 0) {
            e.removeChild(i);
            Hh(t);
            return;
          }
          r--;
        } else if (n === `$` || n === `$?` || n === `$~` || n === `$!` || n === `&`) {
          r++;
        } else if (n === `html`) {
          _m(e.ownerDocument.documentElement);
        } else if (n === `head`) {
          n = e.ownerDocument.head;
          _m(n);
          for (var a = n.firstChild; a;) {
            var o = a.nextSibling;
            var s = a.nodeName;
            if (!a[Vt] && s !== `SCRIPT` && s !== `STYLE` && (s !== `LINK` || a.rel.toLowerCase() !== `stylesheet`)) {
              n.removeChild(a);
            }
            a = o;
          }
        } else if (n === `body`) {
          _m(e.ownerDocument.body);
        }
      }
      n = i;
    } while (n);
    Hh(t);
  }
  function wp(e, t) {
    var n = e;
    e = 0;
    do {
      var r = n.nextSibling;
      if (n.nodeType === 1) {
        if (t) {
          n._stashedDisplay = n.style.display;
          n.style.display = `none`;
        } else {
          n.style.display = n._stashedDisplay || ``;
          if (n.getAttribute(`style`) === ``) {
            n.removeAttribute(`style`);
          }
        }
      } else if (n.nodeType === 3) {
        if (t) {
          n._stashedText = n.nodeValue;
          n.nodeValue = ``;
        } else {
          n.nodeValue = n._stashedText || ``;
        }
      }
      if (r && r.nodeType === 8) {
        n = r.data;
        if (n === `/$`) {
          if (e === 0) {
            break;
          }
          e--;
        } else if (n === `$` || n === `$?` || n === `$~` || n === `$!`) {
          e++;
        }
      }
      n = r;
    } while (n);
  }
  function Tp(e, t, n) {
    t = CSS.escape(t) === t ? t : `r-${btoa(t).replace(/=/g, ``)}`;
    e.style.viewTransitionName = t;
    if (n != null) {
      e.style.viewTransitionClass = n;
    }
    n = getComputedStyle(e);
    if (n.display === `inline`) {
      t = e.getClientRects();
      if (t.length === 1) {
        var r = 1;
      } else {
        for (var i = r = 0; i < t.length; i++) {
          var a = t[i];
          if (a.width > 0 && a.height > 0) {
            r++;
          }
        }
      }
      if (r === 1) {
        e = e.style;
        e.display = t.length === 1 ? `inline-block` : `block`;
        e.marginTop = `-${n.paddingTop}`;
        e.marginBottom = `-${n.paddingBottom}`;
      }
    }
  }
  function Ep(e, t) {
    e = e.style;
    t = t.style;
    var n = t == null ? null : t.hasOwnProperty(`viewTransitionName`) ? t.viewTransitionName : t.hasOwnProperty(`view-transition-name`) ? t[`view-transition-name`] : null;
    e.viewTransitionName = n == null || typeof n == `boolean` ? `` : `${n}`.trim();
    n = t == null ? null : t.hasOwnProperty(`viewTransitionClass`) ? t.viewTransitionClass : t.hasOwnProperty(`view-transition-class`) ? t[`view-transition-class`] : null;
    e.viewTransitionClass = n == null || typeof n == `boolean` ? `` : `${n}`.trim();
    if (e.display === `inline-block`) {
      if (t == null) {
        e.display = e.margin = ``;
      } else {
        n = t.display;
        e.display = n == null || typeof n == `boolean` ? `` : n;
        n = t.margin;
        if (n == null) {
          n = t.hasOwnProperty(`marginTop`) ? t.marginTop : t[`margin-top`];
          e.marginTop = n == null || typeof n == `boolean` ? `` : n;
          t = t.hasOwnProperty(`marginBottom`) ? t.marginBottom : t[`margin-bottom`];
          e.marginBottom = t == null || typeof t == `boolean` ? `` : t;
        } else {
          e.margin = n;
        }
      }
    }
  }
  function Dp(e, t, n) {
    n = n.ownerDocument.defaultView;
    return {
      rect: e,
      abs: t.position === `absolute` || t.position === `fixed`,
      clip: t.clipPath !== `none` || t.overflow !== `visible` || t.filter !== `none` || t.mask !== `none` || t.mask !== `none` || t.borderRadius !== `0px`,
      view: e.bottom >= 0 && e.right >= 0 && e.top <= n.innerHeight && e.left <= n.innerWidth
    };
  }
  function Op(e) {
    return Dp(e.getBoundingClientRect(), getComputedStyle(e), e);
  }
  function kp(e) {
    var t = e.getBoundingClientRect();
    t = new DOMRect(t.x + 20000, t.y + 20000, t.width, t.height);
    var n = getComputedStyle(e);
    return Dp(t, n, e);
  }
  function Ap(e) {
    return e.documentElement.clientHeight;
  }
  function jp(e) {
    this.addEventListener(`load`, e);
    this.addEventListener(`error`, e);
  }
  function Mp(e, t, n, r, i, a, o, s, c) {
    var l = t.nodeType === 9 ? t : t.ownerDocument;
    try {
      var u = l.startViewTransition({
        update: function () {
          var t = l.defaultView;
          var n = t.navigation && t.navigation.transition;
          var o = l.fonts.status;
          r();
          var s = [];
          if (o === `loaded`) {
            Ap(l);
            if (l.fonts.status === `loading`) {
              s.push(l.fonts.ready);
            }
          }
          o = s.length;
          if (e !== null) {
            for (var c = e.suspenseyImages, u = 0, d = 0; d < c.length; d++) {
              var f = c[d];
              if (!f.complete) {
                var p = f.getBoundingClientRect();
                if (p.bottom > 0 && p.right > 0 && p.top < t.innerHeight && p.left < t.innerWidth) {
                  u += Xm(f);
                  if (u > $m) {
                    s.length = o;
                    break;
                  }
                  f = new Promise(jp.bind(f));
                  s.push(f);
                }
              }
            }
          }
          if (s.length > 0) {
            t = Promise.race([Promise.all(s), new Promise(function (e) {
              return setTimeout(e, 500);
            })]).then(i, i);
            return (n ? Promise.allSettled([n.finished, t]) : t).then(a, a);
          }
          i();
          if (n) {
            return n.finished.then(a, a);
          }
          a();
        },
        types: n
      });
      l.__reactViewTransition = u;
      var d = [];
      u.ready.then(function () {
        for (var e = l.documentElement.getAnimations({
            subtree: true
          }), t = 0; t < e.length; t++) {
          var n = e[t];
          var r = n.effect;
          var i = r.pseudoElement;
          if (i != null && i.startsWith(`::view-transition`)) {
            d.push(n);
            n = r.getKeyframes();
            var a = i = undefined;
            var s = true;
            for (var c = 0; c < n.length; c++) {
              var u = n[c];
              var f = u.width;
              if (i === undefined) {
                i = f;
              } else if (i !== f) {
                s = false;
                break;
              }
              f = u.height;
              if (a === undefined) {
                a = f;
              } else if (a !== f) {
                s = false;
                break;
              }
              delete u.width;
              delete u.height;
              if (u.transform === `none`) {
                delete u.transform;
              }
            }
            if (s && i !== undefined && a !== undefined && (r.setKeyframes(n), s = getComputedStyle(r.target, r.pseudoElement), s.width !== i || s.height !== a)) {
              s = n[0];
              s.width = i;
              s.height = a;
              s = n[n.length - 1];
              s.width = i;
              s.height = a;
              r.setKeyframes(n);
            }
          }
        }
        o();
      }, function (e) {
        if (l.__reactViewTransition === u) {
          l.__reactViewTransition = null;
        }
        try {
          if (typeof e == `object` && e) {
            switch (e.name) {
              case `InvalidStateError`:
                if (e.message === `View transition was skipped because document visibility state is hidden.` || e.message === `Skipping view transition because document visibility state has become hidden.` || e.message === `Skipping view transition because viewport size changed.` || e.message === `Transition was aborted because of invalid state`) {
                  e = null;
                }
            }
          }
          if (e !== null) {
            c(e);
          }
        } finally {
          r();
          i();
          o();
        }
      });
      u.finished.finally(function () {
        for (var e = 0; e < d.length; e++) {
          d[e].cancel();
        }
        if (l.__reactViewTransition === u) {
          l.__reactViewTransition = null;
        }
        s();
      });
      return u;
    } catch {
      r();
      i();
      o();
      return null;
    }
  }
  function Np(e, t) {
    this._scope = document.documentElement;
    this._selector = `::view-transition-${e}(${t})`;
  }
  Np.prototype.animate = function (e, t) {
    t = typeof t == `number` ? {
      duration: t
    } : S({}, t);
    t.pseudoElement = this._selector;
    return this._scope.animate(e, t);
  };
  Np.prototype.getAnimations = function () {
    var e = this._scope;
    var t = this._selector;
    for (var n = e.getAnimations({
        subtree: true
      }), r = [], i = 0; i < n.length; i++) {
      var a = n[i].effect;
      if (a !== null && a.target === e && a.pseudoElement === t) {
        r.push(n[i]);
      }
    }
    return r;
  };
  Np.prototype.getComputedStyle = function () {
    return getComputedStyle(this._scope, this._selector);
  };
  function Pp(e) {
    return {
      name: e,
      group: new Np(`group`, e),
      imagePair: new Np(`image-pair`, e),
      old: new Np(`old`, e),
      new: new Np(`new`, e)
    };
  }
  function Fp(e) {
    this._fragmentFiber = e;
    this._observers = this._eventListeners = null;
  }
  Fp.prototype.addEventListener = function (e, t, n) {
    var r = null;
    var i = null;
    if (n == null || typeof n == `boolean` || !(r = n.signal || null, r !== null && r.aborted)) {
      if (this._eventListeners === null) {
        this._eventListeners = [];
      }
      var a = this._eventListeners;
      if (Bp(a, e, t, n) === -1) {
        var o = this;
        var s = t;
        if (n != null && typeof n != `boolean` && n.once === true) {
          s = function (r) {
            o.removeEventListener(e, t, n);
            if (typeof t == `function`) {
              t.call(this, r);
            } else {
              t.handleEvent(r);
            }
          };
        }
        if (r !== null) {
          i = o.removeEventListener.bind(o, e, t, n);
          r.addEventListener(`abort`, i, {
            once: true
          });
          i = r.removeEventListener.bind(r, `abort`, i);
        }
        r = Rp(n);
        a.push({
          type: e,
          listener: t,
          optionsOrUseCapture: n,
          attachedListener: s,
          cleanup: i
        });
        h(this._fragmentFiber.child, false, Ip, e, s, r);
      }
      this._eventListeners = a;
    }
  };
  function Ip(e, t, n, r) {
    b(e).addEventListener(t, n, r);
    return false;
  }
  Fp.prototype.removeEventListener = function (e, t, n) {
    var r = this._eventListeners;
    if (r !== null && (t = Bp(r, e, t, n), t !== -1)) {
      var i = r[t];
      n = i.attachedListener;
      var a = i.cleanup;
      i = Rp(i.optionsOrUseCapture);
      h(this._fragmentFiber.child, false, Lp, e, n, i);
      r.splice(t, 1);
      if (a !== null) {
        a();
      }
    }
  };
  function Lp(e, t, n, r) {
    b(e).removeEventListener(t, n, r);
    return false;
  }
  function Rp(e) {
    if (e != null && typeof e != `boolean` && (e.once === true || e.signal instanceof AbortSignal)) {
      return {
        capture: e.capture,
        passive: e.passive
      };
    } else {
      return e;
    }
  }
  function zp(e) {
    if (e == null) {
      return `c=0`;
    } else if (typeof e == `boolean`) {
      return `c=${e ? `1` : `0`}`;
    } else {
      return `c=${e.capture ? `1` : `0`}`;
    }
  }
  function Bp(e, t, n, r) {
    if (e.length === 0) {
      return -1;
    }
    r = zp(r);
    for (var i = 0; i < e.length; i++) {
      var a = e[i];
      if (a.type === t && a.listener === n && zp(a.optionsOrUseCapture) === r) {
        return i;
      }
    }
    return -1;
  }
  Fp.prototype.dispatchEvent = function (e) {
    var t = g(this._fragmentFiber);
    if (t === null) {
      return true;
    }
    t = b(t);
    var n = this._eventListeners;
    if (n !== null && n.length > 0 || !e.bubbles) {
      var r = t.nodeType === 9 ? t.createComment(``) : document.createTextNode(``);
      if (n) {
        for (var i = 0; i < n.length; i++) {
          var a = n[i];
          r.addEventListener(a.type, a.attachedListener, Rp(a.optionsOrUseCapture));
        }
      }
      t.appendChild(r);
      e = r.dispatchEvent(e);
      if (n) {
        for (i = 0; i < n.length; i++) {
          a = n[i];
          r.removeEventListener(a.type, a.attachedListener, Rp(a.optionsOrUseCapture));
        }
      }
      t.removeChild(r);
      return e;
    }
    return t.dispatchEvent(e);
  };
  Fp.prototype.focus = function (e) {
    h(this._fragmentFiber.child, true, Vp, e, undefined, undefined);
  };
  function Vp(e, t) {
    return e.tag !== 6 && (e = b(e), pm(e, t));
  }
  Fp.prototype.focusLast = function (e) {
    var t = [];
    h(this._fragmentFiber.child, true, Hp, t, undefined, undefined);
    for (var n = t.length - 1; n >= 0 && !Vp(t[n], e); n--);
  };
  function Hp(e, t) {
    t.push(e);
    return false;
  }
  Fp.prototype.blur = function () {
    var e = g(this._fragmentFiber);
    if (e !== null) {
      e = b(e);
      e = lp(e).activeElement;
      if (e !== null) {
        h(this._fragmentFiber.child, false, Up, e, undefined, undefined);
      }
    }
  };
  function Up(e, t) {
    return e.tag !== 6 && (e = b(e), e === t || e.contains(t) ? (t.blur(), true) : false);
  }
  Fp.prototype.observeUsing = function (e) {
    if (this._observers === null) {
      this._observers = new Set();
    }
    this._observers.add(e);
    h(this._fragmentFiber.child, false, Wp, e, undefined, undefined);
  };
  function Wp(e, t) {
    return e.tag !== 6 && (e = b(e), t.observe(e), false);
  }
  Fp.prototype.unobserveUsing = function (e) {
    var t = this._observers;
    if (t !== null && t.has(e)) {
      t.delete(e);
      h(this._fragmentFiber.child, false, Gp, e, undefined, undefined);
      for (var n = t = 0; n < Kp.length; n++) {
        var r = Kp[n];
        if (r.fragmentInstance === this && r.observer === e) {
          e.unobserve(r.instance);
        } else {
          Kp[t++] = r;
        }
      }
      Kp.length = t;
    }
  };
  function Gp(e, t) {
    return e.tag !== 6 && (e = b(e), t.unobserve(e), false);
  }
  var Kp = [];
  var qp = false;
  function Jp(e, t, n) {
    Kp.push({
      fragmentInstance: e,
      observer: t,
      instance: n
    });
    if (!qp) {
      qp = true;
      mm(function () {
        qp = false;
        var e = Kp;
        Kp = [];
        for (var t = 0; t < e.length; t++) {
          var n = e[t];
          n.observer.unobserve(n.instance);
        }
      });
    }
  }
  Fp.prototype.getClientRects = function () {
    var e = [];
    h(this._fragmentFiber.child, false, Yp, e, undefined, undefined);
    return e;
  };
  function Yp(e, t) {
    if (e.tag === 6) {
      e = e.stateNode;
      var n = e.ownerDocument.createRange();
      n.selectNodeContents(e);
      t.push.apply(t, n.getClientRects());
    } else {
      e = b(e);
      t.push.apply(t, e.getClientRects());
    }
    return false;
  }
  Fp.prototype.getRootNode = function (e) {
    var t = g(this._fragmentFiber);
    if (t === null) {
      return this;
    } else {
      return b(t).getRootNode(e);
    }
  };
  Fp.prototype.compareDocumentPosition = function (e) {
    var t = g(this._fragmentFiber);
    if (t === null) {
      return Node.DOCUMENT_POSITION_DISCONNECTED;
    }
    var n = [];
    h(this._fragmentFiber.child, false, Hp, n, undefined, undefined);
    var r = b(t);
    if (n.length === 0) {
      n = r;
      if (_(this._fragmentFiber)) {
        a: {
          for (t = this._fragmentFiber.return; t !== null;) {
            if (t.tag === 4) {
              t = t.stateNode.containerInfo;
              break a;
            }
            if (t.tag === 3 || t.tag === 5 || t.tag === 27) {
              break;
            }
            t = t.return;
          }
          t = null;
        }
        if (t != null) {
          n = t;
        }
      }
      t = this._fragmentFiber;
      var i = r = n.compareDocumentPosition(e);
      if (n === e) {
        i = Node.DOCUMENT_POSITION_CONTAINS;
      } else if (r & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        n = v(t)[1];
        if (n === null) {
          i = Node.DOCUMENT_POSITION_PRECEDING;
        } else {
          e = b(n).compareDocumentPosition(e);
          i = e === 0 || e & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING;
        }
      }
      return i |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    t = b(n[0]);
    i = b(n[n.length - 1]);
    var a = _(this._fragmentFiber) ? t.parentElement : r;
    if (a == null) {
      return Node.DOCUMENT_POSITION_DISCONNECTED;
    }
    r = a.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    a = a.compareDocumentPosition(i) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var o = t.compareDocumentPosition(e);
    var s = i.compareDocumentPosition(e);
    var c = o & Node.DOCUMENT_POSITION_CONTAINED_BY || s & Node.DOCUMENT_POSITION_CONTAINED_BY;
    s = r && a && o & Node.DOCUMENT_POSITION_FOLLOWING && s & Node.DOCUMENT_POSITION_PRECEDING;
    t = r && t === e || a && i === e || c || s ? Node.DOCUMENT_POSITION_CONTAINED_BY : !r && t === e || !a && i === e ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : o;
    if (t & Node.DOCUMENT_POSITION_DISCONNECTED || t & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || Xp(t, this._fragmentFiber, n[0], n[n.length - 1], e)) {
      return t;
    } else {
      return Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
  };
  function Xp(e, t, n, r, i) {
    var a = Wt(i);
    if (e & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      if (n = !!a) {
        a: {
          while (a !== null) {
            if (a.tag === 7 && (a === t || a.alternate === t)) {
              n = true;
              break a;
            }
            a = a.return;
          }
          n = false;
        }
      }
      return n;
    }
    if (e & Node.DOCUMENT_POSITION_CONTAINS) {
      if (a === null) {
        a = i.ownerDocument;
        return i === a || i === a.documentElement || i === a.body;
      }
      a: {
        a = t;
        t = g(t);
        while (a !== null) {
          if ((a.tag === 5 || a.tag === 3 || a.tag === 27) && (a === t || a.alternate === t)) {
            a = true;
            break a;
          }
          a = a.return;
        }
        a = false;
      }
      return a;
    }
    if (e & Node.DOCUMENT_POSITION_PRECEDING) {
      if ((t = !!a) && !(t = a === n)) {
        t = ie(n, a, re);
        if (t === null) {
          t = false;
        } else {
          h(t, true, te, a, n);
          a = x;
          x = null;
          t = a !== null;
        }
      }
      return t;
    } else if (e & Node.DOCUMENT_POSITION_FOLLOWING) {
      if ((t = !!a) && !(t = a === r)) {
        t = ie(r, a, re);
        if (t === null) {
          t = false;
        } else {
          h(t, true, ne, a, r);
          a = x;
          ee = x = null;
          t = a !== null;
        }
      }
      return t;
    } else {
      return false;
    }
  }
  function Zp(e, t) {
    var n = e.ownerDocument.createRange();
    n.selectNodeContents(e);
    e = n.getBoundingClientRect();
    window.scrollTo(window.scrollX + e.left, t ? window.scrollY + e.top : window.scrollY + e.bottom - window.innerHeight);
  }
  Fp.prototype.scrollIntoView = function (e) {
    if (typeof e == `object`) {
      throw Error(s(566));
    }
    var t = [];
    h(this._fragmentFiber.child, false, Hp, t, undefined, undefined);
    var n = e !== false;
    if (t.length === 0) {
      var r = v(this._fragmentFiber);
      r = n ? r[1] || r[0] || g(this._fragmentFiber) : r[0] || r[1];
      if (r === null) {
        return;
      }
      if (r.tag === 6) {
        e = b(r);
        Zp(e, n);
        return;
      }
      r = b(r);
      if (r.nodeType !== 9) {
        if (r.nodeType === 11) {
          n = `host` in r ? r.host : null;
          if (n !== null) {
            n.scrollIntoView(e);
          }
          return;
        }
        r.scrollIntoView(e);
      }
    }
    for (r = n ? t.length - 1 : 0; r !== (n ? -1 : t.length);) {
      var i = t[r];
      if (i.tag === 6) {
        i = b(i);
        Zp(i, n);
      } else {
        b(i).scrollIntoView(e);
      }
      r += n ? -1 : 1;
    }
  };
  function Qp(e, t) {
    e = b(e);
    $p(e, t);
    return false;
  }
  function $p(e, t) {
    e.reactFragments ??= new Set();
    e.reactFragments.add(t);
  }
  function em(e, t) {
    var n = t._eventListeners;
    if (n !== null) {
      for (var r = 0; r < n.length; r++) {
        var i = n[r];
        e.addEventListener(i.type, i.attachedListener, Rp(i.optionsOrUseCapture));
      }
    }
    if (e.nodeType !== 3) {
      n = t._observers;
      if (n !== null) {
        n.forEach(function (n) {
          var r = 0;
          for (var i = 0; i < Kp.length; i++) {
            var a = Kp[i];
            if (a.fragmentInstance !== t || a.observer !== n || a.instance !== e) {
              Kp[r++] = a;
            }
          }
          Kp.length = r;
          n.observe(e);
        });
      }
      $p(e, t);
    }
  }
  function tm(e, t) {
    var n = t._eventListeners;
    if (n !== null) {
      for (var r = 0; r < n.length; r++) {
        var i = n[r];
        e.removeEventListener(i.type, i.attachedListener, Rp(i.optionsOrUseCapture));
      }
    }
    if (e.nodeType !== 3) {
      n = t._observers;
      if (n !== null) {
        n.forEach(function (n) {
          if (typeof n.rootMargin == `string`) {
            Jp(t, n, e);
          } else {
            n.unobserve(e);
          }
        });
      }
      if (e.reactFragments != null) {
        e.reactFragments.delete(t);
      }
    }
  }
  function nm(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
      var n = t;
      t = t.nextSibling;
      switch (n.nodeName) {
        case `HTML`:
        case `HEAD`:
        case `BODY`:
          nm(n);
          Ut(n);
          continue;
        case `SCRIPT`:
        case `STYLE`:
          continue;
        case `LINK`:
          if (n.rel.toLowerCase() === `stylesheet`) {
            continue;
          }
      }
      e.removeChild(n);
    }
  }
  function rm(e, t, n, r) {
    while (e.nodeType === 1) {
      var i = n;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!r && (e.nodeName !== `INPUT` || e.type !== `hidden`)) {
          break;
        }
      } else if (!r) {
        if (t === `input` && e.type === `hidden`) {
          var a = i.name == null ? null : `${i.name}`;
          if (i.type === `hidden` && e.getAttribute(`name`) === a) {
            return e;
          }
        } else {
          return e;
        }
      } else if (!e[Vt]) {
        switch (t) {
          case `meta`:
            if (!e.hasAttribute(`itemprop`)) {
              break;
            }
            return e;
          case `link`:
            a = e.getAttribute(`rel`);
            if (a === `stylesheet` && e.hasAttribute(`data-precedence`) || a !== i.rel || e.getAttribute(`href`) !== (i.href == null || i.href === `` ? null : i.href) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute(`title`) !== (i.title == null ? null : i.title)) {
              break;
            }
            return e;
          case `style`:
            if (e.hasAttribute(`data-precedence`)) {
              break;
            }
            return e;
          case `script`:
            a = e.getAttribute(`src`);
            if ((a !== (i.src == null ? null : i.src) || e.getAttribute(`type`) !== (i.type == null ? null : i.type) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute(`async`) && !e.hasAttribute(`itemprop`)) {
              break;
            }
            return e;
          default:
            return e;
        }
      }
      e = lm(e.nextSibling);
      if (e === null) {
        break;
      }
    }
    return null;
  }
  function im(e, t, n) {
    if (t === ``) {
      return null;
    }
    while (e.nodeType !== 3) {
      if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !n || (e = lm(e.nextSibling), e === null)) {
        return null;
      }
    }
    return e;
  }
  function am(e, t) {
    while (e.nodeType !== 8) {
      if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !t || (e = lm(e.nextSibling), e === null)) {
        return null;
      }
    }
    return e;
  }
  function om(e) {
    return e.data === `$?` || e.data === `$~`;
  }
  function sm(e) {
    return e.data === `$!` || e.data === `$?` && e.ownerDocument.readyState !== `loading`;
  }
  function cm(e, t) {
    var n = e.ownerDocument;
    if (e.data === `$~`) {
      e._reactRetry = t;
    } else if (e.data !== `$?` || n.readyState !== `loading`) {
      t();
    } else {
      function r() {
        t();
        n.removeEventListener(`DOMContentLoaded`, r);
      }
      n.addEventListener(`DOMContentLoaded`, r);
      e._reactRetry = r;
    }
  }
  function lm(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) {
        break;
      }
      if (t === 8) {
        t = e.data;
        if (t === `$` || t === `$!` || t === `$?` || t === `$~` || t === `&` || t === `F!` || t === `F`) {
          break;
        }
        if (t === `/$` || t === `/&`) {
          return null;
        }
      }
    }
    return e;
  }
  var um = null;
  function dm(e) {
    e = e.nextSibling;
    var t = 0;
    for (; e;) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === `/$` || n === `/&`) {
          if (t === 0) {
            return lm(e.nextSibling);
          }
          t--;
        } else if (n === `$` || n === `$!` || n === `$?` || n === `$~` || n === `&`) {
          t++;
        }
      }
      e = e.nextSibling;
    }
    return null;
  }
  function fm(e) {
    e = e.previousSibling;
    var t = 0;
    for (; e;) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === `$` || n === `$!` || n === `$?` || n === `$~` || n === `&`) {
          if (t === 0) {
            return e;
          }
          t--;
        } else if (n === `/$` || n === `/&`) {
          t++;
        }
      }
      e = e.previousSibling;
    }
    return null;
  }
  function pm(e, t) {
    function n() {
      r = true;
    }
    if (e.ownerDocument.activeElement === e) {
      return true;
    }
    var r = false;
    try {
      e.ownerDocument.addEventListener(`focus`, n, true);
      (e.focus || HTMLElement.prototype.focus).call(e, t);
    } finally {
      e.ownerDocument.removeEventListener(`focus`, n, true);
    }
    return r;
  }
  function mm(e) {
    yp(function () {
      yp(function (t) {
        return e(t);
      });
    });
  }
  function hm(e, t, n) {
    t = lp(n);
    switch (e) {
      case `html`:
        e = t.documentElement;
        if (!e) {
          throw Error(s(452));
        }
        return e;
      case `head`:
        e = t.head;
        if (!e) {
          throw Error(s(453));
        }
        return e;
      case `body`:
        e = t.body;
        if (!e) {
          throw Error(s(454));
        }
        return e;
      default:
        throw Error(s(451));
    }
  }
  function gm(e, t, n) {
    for (var r in n) {
      var i = n[r];
      if (n.hasOwnProperty(r) && i != null) {
        $(e, t, r, null, rp, i);
      }
    }
    if (n.dangerouslySetInnerHTML != null) {
      e.textContent = ``;
    }
    if (e.onclick === kn) {
      e.onclick = null;
    }
    Ut(e);
  }
  function _m(e) {
    for (var t = e.attributes; t.length;) {
      e.removeAttributeNode(t[0]);
    }
    Ut(e);
  }
  var vm = new Map();
  var ym = new Set();
  function bm(e) {
    if (typeof e.getRootNode == `function`) {
      var t = e.getRootNode();
      if (t.nodeType === 9 || t.nodeType === 11) {
        return t;
      }
    }
    if (e.nodeType === 9) {
      return e;
    } else {
      return e.ownerDocument;
    }
  }
  var xm = w.d;
  w.d = {
    f: Sm,
    r: Cm,
    D: Em,
    C: Dm,
    L: Om,
    m: km,
    X: jm,
    S: Am,
    M: Mm
  };
  function Sm() {
    var e = xm.f();
    var t = zd();
    return e || t;
  }
  function Cm(e) {
    var t = Gt(e);
    if (t !== null && t.tag === 5 && t.type === `form`) {
      cc(t);
    } else {
      xm.r(e);
    }
  }
  var wm = typeof document > `u` ? null : document;
  function Tm(e, t, n) {
    var r = wm;
    if (r && typeof t == `string` && t) {
      var i = mn(t);
      i = `link[rel="${e}"][href="${i}"]`;
      if (typeof n == `string`) {
        i += `[crossorigin="${n}"]`;
      }
      if (!ym.has(i)) {
        ym.add(i);
        e = {
          rel: e,
          crossOrigin: n,
          href: t
        };
        if (r.querySelector(i) === null) {
          t = r.createElement(`link`);
          np(t, `link`, e);
          D(t);
          r.head.appendChild(t);
        }
      }
    }
  }
  function Em(e) {
    xm.D(e);
    Tm(`dns-prefetch`, e, null);
  }
  function Dm(e, t) {
    xm.C(e, t);
    Tm(`preconnect`, e, t);
  }
  function Om(e, t, n) {
    xm.L(e, t, n);
    var r = wm;
    if (r && e && t) {
      var i = `link[rel="preload"][as="${mn(t)}"]`;
      if (t === `image` && n && n.imageSrcSet) {
        i += `[imagesrcset="${mn(n.imageSrcSet)}"]`;
        if (typeof n.imageSizes == `string`) {
          i += `[imagesizes="${mn(n.imageSizes)}"]`;
        }
      } else {
        i += `[href="${mn(e)}"]`;
      }
      var a = i;
      switch (t) {
        case `style`:
          a = Pm(e);
          break;
        case `script`:
          a = Rm(e);
      }
      if (!vm.has(a) && !(e = S({
        rel: `preload`,
        href: t === `image` && n && n.imageSrcSet ? undefined : e,
        as: t
      }, n), vm.set(a, e), r.querySelector(i) !== null || t === `style` && r.querySelector(Fm(a)) || t === `script` && r.querySelector(zm(a)))) {
        var o = r.createElement(`link`);
        np(o, `link`, e);
        if (t === `style`) {
          o[Ht] = true;
          o.onload = o.onerror = function () {
            Jt(o);
          };
        }
        D(o);
        r.head.appendChild(o);
      }
    }
  }
  function km(e, t) {
    xm.m(e, t);
    var n = wm;
    if (n && e) {
      var r = t && typeof t.as == `string` ? t.as : `script`;
      var i = `link[rel="modulepreload"][as="${mn(r)}"][href="${mn(e)}"]`;
      var a = i;
      switch (r) {
        case `audioworklet`:
        case `paintworklet`:
        case `serviceworker`:
        case `sharedworker`:
        case `worker`:
        case `script`:
          a = Rm(e);
      }
      if (!vm.has(a) && (e = S({
        rel: `modulepreload`,
        href: e
      }, t), vm.set(a, e), n.querySelector(i) === null)) {
        switch (r) {
          case `audioworklet`:
          case `paintworklet`:
          case `serviceworker`:
          case `sharedworker`:
          case `worker`:
          case `script`:
            if (n.querySelector(zm(a))) {
              return;
            }
        }
        r = n.createElement(`link`);
        np(r, `link`, e);
        D(r);
        n.head.appendChild(r);
      }
    }
  }
  function Am(e, t, n) {
    xm.S(e, t, n);
    var r = wm;
    if (r && e) {
      var i = qt(r).hoistableStyles;
      var a = Pm(e);
      t ||= `default`;
      var o = i.get(a);
      if (!o) {
        var s = {
          loading: 0,
          preload: null
        };
        if (o = r.querySelector(Fm(a))) {
          s.loading = 5;
        } else {
          e = S({
            rel: `stylesheet`,
            href: e,
            "data-precedence": t
          }, n);
          if (n = vm.get(a)) {
            Hm(e, n);
          }
          var c = o = r.createElement(`link`);
          D(c);
          np(c, `link`, e);
          c._p = new Promise(function (e, t) {
            c.onload = e;
            c.onerror = t;
          });
          c.addEventListener(`load`, function () {
            s.loading |= 1;
          });
          c.addEventListener(`error`, function () {
            s.loading |= 2;
          });
          s.loading |= 4;
          Vm(o, t, r);
        }
        o = {
          type: `stylesheet`,
          instance: o,
          count: 1,
          state: s
        };
        i.set(a, o);
      }
    }
  }
  function jm(e, t) {
    xm.X(e, t);
    var n = wm;
    if (n && e) {
      var r = qt(n).hoistableScripts;
      var i = Rm(e);
      var a = r.get(i);
      if (!a) {
        a = n.querySelector(zm(i));
        if (!a) {
          e = S({
            src: e,
            async: true
          }, t);
          if (t = vm.get(i)) {
            Um(e, t);
          }
          a = n.createElement(`script`);
          D(a);
          np(a, `link`, e);
          n.head.appendChild(a);
        }
        a = {
          type: `script`,
          instance: a,
          count: 1,
          state: null
        };
        r.set(i, a);
      }
    }
  }
  function Mm(e, t) {
    xm.M(e, t);
    var n = wm;
    if (n && e) {
      var r = qt(n).hoistableScripts;
      var i = Rm(e);
      var a = r.get(i);
      if (!a) {
        a = n.querySelector(zm(i));
        if (!a) {
          e = S({
            src: e,
            async: true,
            type: `module`
          }, t);
          if (t = vm.get(i)) {
            Um(e, t);
          }
          a = n.createElement(`script`);
          D(a);
          np(a, `link`, e);
          n.head.appendChild(a);
        }
        a = {
          type: `script`,
          instance: a,
          count: 1,
          state: null
        };
        r.set(i, a);
      }
    }
  }
  function Nm(e, t, n, r) {
    var i = (i = Pe.current) ? bm(i) : null;
    if (!i) {
      throw Error(s(446));
    }
    switch (e) {
      case `meta`:
      case `title`:
        return null;
      case `style`:
        if (typeof n.precedence == `string` && typeof n.href == `string`) {
          n = Pm(n.href);
          t = qt(i).hoistableStyles;
          r = t.get(n);
          if (!r) {
            r = {
              type: `style`,
              instance: null,
              count: 0,
              state: null
            };
            t.set(n, r);
          }
          return r;
        } else {
          return {
            type: `void`,
            instance: null,
            count: 0,
            state: null
          };
        }
      case `link`:
        if (n.rel === `stylesheet` && typeof n.href == `string` && typeof n.precedence == `string`) {
          e = Pm(n.href);
          var a = qt(i).hoistableStyles;
          var o = a.get(e);
          if (!o) {
            i = i.ownerDocument || i;
            o = {
              type: `stylesheet`,
              instance: null,
              count: 0,
              state: {
                loading: 0,
                preload: null
              }
            };
            a.set(e, o);
            if (a = i.querySelector(Fm(e))) {
              if (!a._p) {
                o.instance = a;
                o.state.loading = 5;
              }
            } else {
              a = vm.get(e);
              if (!a) {
                a = {
                  rel: `preload`,
                  as: `style`,
                  href: n.href,
                  crossOrigin: n.crossOrigin,
                  integrity: n.integrity,
                  media: n.media,
                  hrefLang: n.hrefLang,
                  referrerPolicy: n.referrerPolicy
                };
                vm.set(e, a);
              }
              Lm(i, e, a, o.state);
            }
          }
          if (t && r === null) {
            throw Error(s(528, ``));
          }
          return o;
        }
        if (t && r !== null) {
          throw Error(s(529, ``));
        }
        return null;
      case `script`:
        t = n.async;
        n = n.src;
        if (typeof n == `string` && t && typeof t != `function` && typeof t != `symbol`) {
          n = Rm(n);
          t = qt(i).hoistableScripts;
          r = t.get(n);
          if (!r) {
            r = {
              type: `script`,
              instance: null,
              count: 0,
              state: null
            };
            t.set(n, r);
          }
          return r;
        } else {
          return {
            type: `void`,
            instance: null,
            count: 0,
            state: null
          };
        }
      default:
        throw Error(s(444, e));
    }
  }
  function Pm(e) {
    return `href="${mn(e)}"`;
  }
  function Fm(e) {
    return `link[rel="stylesheet"][${e}]`;
  }
  function Im(e) {
    return S({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function Lm(e, t, n, r) {
    if (t = e.querySelector(`link[rel="preload"][as="style"][${t}]`)) {
      if (t[Ht] !== true) {
        r.loading = 1;
        return;
      }
    } else {
      t = e.createElement(`link`);
      t[Ht] = true;
      t.onload = t.onerror = Jt.bind(null, t);
      np(t, `link`, n);
      D(t);
      e.head.appendChild(t);
    }
    r.preload = t;
    t.addEventListener(`load`, function () {
      return r.loading |= 1;
    });
    t.addEventListener(`error`, function () {
      return r.loading |= 2;
    });
  }
  function Rm(e) {
    return `[src="${mn(e)}"]`;
  }
  function zm(e) {
    return `script[async]${e}`;
  }
  function Bm(e, t, n) {
    t.count++;
    if (t.instance === null) {
      switch (t.type) {
        case `style`:
          var r = e.querySelector(`style[data-href~="${mn(n.href)}"]`);
          if (r) {
            t.instance = r;
            D(r);
            return r;
          }
          var i = S({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          r = (e.ownerDocument || e).createElement(`style`);
          D(r);
          np(r, `style`, i);
          Vm(r, n.precedence, e);
          return t.instance = r;
        case `stylesheet`:
          i = Pm(n.href);
          var a = e.querySelector(Fm(i));
          if (a) {
            t.state.loading |= 4;
            t.instance = a;
            D(a);
            return a;
          }
          r = Im(n);
          if (i = vm.get(i)) {
            Hm(r, i);
          }
          a = (e.ownerDocument || e).createElement(`link`);
          D(a);
          var o = a;
          o._p = new Promise(function (e, t) {
            o.onload = e;
            o.onerror = t;
          });
          np(a, `link`, r);
          t.state.loading |= 4;
          Vm(a, n.precedence, e);
          return t.instance = a;
        case `script`:
          a = Rm(n.src);
          if (i = e.querySelector(zm(a))) {
            t.instance = i;
            D(i);
            return i;
          } else {
            r = n;
            if (i = vm.get(a)) {
              r = S({}, n);
              Um(r, i);
            }
            e = e.ownerDocument || e;
            i = e.createElement(`script`);
            D(i);
            np(i, `link`, r);
            e.head.appendChild(i);
            return t.instance = i;
          }
        case `void`:
          return null;
        default:
          throw Error(s(443, t.type));
      }
    } else if (t.type === `stylesheet` && !(t.state.loading & 4)) {
      r = t.instance;
      t.state.loading |= 4;
      Vm(r, n.precedence, e);
    }
    return t.instance;
  }
  function Vm(e, t, n) {
    for (var r = n.querySelectorAll(`link[rel="stylesheet"][data-precedence],style[data-precedence]`), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
      var s = r[o];
      if (s.dataset.precedence === t) {
        a = s;
      } else if (a !== i) {
        break;
      }
    }
    if (a) {
      a.parentNode.insertBefore(e, a.nextSibling);
    } else {
      t = n.nodeType === 9 ? n.head : n;
      t.insertBefore(e, t.firstChild);
    }
  }
  function Hm(e, t) {
    e.crossOrigin ??= t.crossOrigin;
    e.referrerPolicy ??= t.referrerPolicy;
    e.title ??= t.title;
  }
  function Um(e, t) {
    e.crossOrigin ??= t.crossOrigin;
    e.referrerPolicy ??= t.referrerPolicy;
    e.integrity ??= t.integrity;
  }
  var Wm = null;
  function Gm(e, t, n) {
    if (Wm === null) {
      var r = new Map();
      var i = Wm = new Map();
      i.set(n, r);
    } else {
      i = Wm;
      r = i.get(n);
      if (!r) {
        r = new Map();
        i.set(n, r);
      }
    }
    if (r.has(e)) {
      return r;
    }
    r.set(e, null);
    n = n.getElementsByTagName(e);
    i = 0;
    for (; i < n.length; i++) {
      var a = n[i];
      if (!a[Vt] && !a[Pt] && (e !== `link` || a.getAttribute(`rel`) !== `stylesheet`) && a.namespaceURI !== `http://www.w3.org/2000/svg`) {
        var o = a.getAttribute(t) || ``;
        o = e + o;
        var s = r.get(o);
        if (s) {
          s.push(a);
        } else {
          r.set(o, [a]);
        }
      }
    }
    return r;
  }
  function Km(e, t, n) {
    e = e.ownerDocument || e;
    e.head.insertBefore(n, t === `title` ? e.querySelector(`head > title`) : null);
  }
  function qm(e, t, n) {
    if (n === 1 || t.itemProp != null) {
      return false;
    }
    switch (e) {
      case `meta`:
      case `title`:
        return true;
      case `style`:
        if (typeof t.precedence != `string` || typeof t.href != `string` || t.href === ``) {
          break;
        }
        return true;
      case `link`:
        if (typeof t.rel != `string` || typeof t.href != `string` || t.href === `` || t.onLoad || t.onError) {
          break;
        }
        switch (t.rel) {
          case `stylesheet`:
            e = t.disabled;
            return typeof t.precedence == `string` && e == null;
          default:
            return true;
        }
      case `script`:
        if (t.async && typeof t.async != `function` && typeof t.async != `symbol` && !t.onLoad && !t.onError && t.src && typeof t.src == `string`) {
          return true;
        }
    }
    return false;
  }
  function Jm(e, t) {
    return e === `img` && t.src != null && t.src !== `` && t.onLoad == null && t.loading !== `lazy`;
  }
  function Ym(e) {
    return e.type !== `stylesheet` || !!(e.state.loading & 3);
  }
  function Xm(e) {
    return (e.width || 100) * (e.height || 100) * (typeof devicePixelRatio == `number` ? devicePixelRatio : 1) * 0.25;
  }
  function Zm(e, t) {
    if (typeof t.decode == `function`) {
      e.imgCount++;
      if (!t.complete) {
        e.imgBytes += Xm(t);
        e.suspenseyImages.push(t);
      }
      e = rh.bind(e);
      t.decode().then(e, e);
    }
  }
  function Qm(e, t, n, r) {
    if (n.type === `stylesheet` && (typeof r.media != `string` || matchMedia(r.media).matches !== false) && !(n.state.loading & 4)) {
      if (n.instance === null) {
        var i = Pm(r.href);
        var a = t.querySelector(Fm(i));
        if (a) {
          t = a._p;
          if (typeof t == `object` && t && typeof t.then == `function`) {
            e.count++;
            e = nh.bind(e);
            t.then(e, e);
          }
          n.state.loading |= 4;
          n.instance = a;
          D(a);
          return;
        }
        a = t.ownerDocument || t;
        r = Im(r);
        if (i = vm.get(i)) {
          Hm(r, i);
        }
        a = a.createElement(`link`);
        D(a);
        var o = a;
        o._p = new Promise(function (e, t) {
          o.onload = e;
          o.onerror = t;
        });
        np(a, `link`, r);
        n.instance = a;
      }
      if (e.stylesheets === null) {
        e.stylesheets = new Map();
      }
      e.stylesheets.set(n, t);
      if ((t = n.state.preload) && !(n.state.loading & 3)) {
        e.count++;
        n = nh.bind(e);
        t.addEventListener(`load`, n);
        t.addEventListener(`error`, n);
      }
    }
  }
  var $m = 0;
  function eh(e, t) {
    if (e.stylesheets && e.count === 0) {
      ah(e, e.stylesheets);
    }
    if (e.count > 0 || e.imgCount > 0) {
      return function (n) {
        var r = setTimeout(function () {
          if (e.stylesheets) {
            ah(e, e.stylesheets);
          }
          if (e.unsuspend) {
            var t = e.unsuspend;
            e.unsuspend = null;
            t();
          }
        }, 60000 + t);
        if (e.imgBytes > 0 && $m === 0) {
          $m = op() * 62500;
        }
        var i = setTimeout(function () {
          e.waitingForImages = false;
          if (e.count === 0 && (e.stylesheets && ah(e, e.stylesheets), e.unsuspend)) {
            var t = e.unsuspend;
            e.unsuspend = null;
            t();
          }
        }, (e.imgBytes > $m ? 50 : 800) + t);
        e.unsuspend = n;
        return function () {
          e.unsuspend = null;
          clearTimeout(r);
          clearTimeout(i);
        };
      };
    } else {
      return null;
    }
  }
  function th(e) {
    if (e.count === 0 && (e.imgCount === 0 || !e.waitingForImages)) {
      if (e.stylesheets) {
        ah(e, e.stylesheets);
      } else if (e.unsuspend) {
        var t = e.unsuspend;
        e.unsuspend = null;
        t();
      }
    }
  }
  function nh() {
    this.count--;
    th(this);
  }
  function rh() {
    this.imgCount--;
    th(this);
  }
  var ih = null;
  function ah(e, t) {
    e.stylesheets = null;
    if (e.unsuspend !== null) {
      e.count++;
      ih = new Map();
      t.forEach(oh, e);
      ih = null;
      nh.call(e);
    }
  }
  function oh(e, t) {
    if (!(t.state.loading & 4)) {
      var n = ih.get(e);
      if (n) {
        var r = n.get(null);
      } else {
        n = new Map();
        ih.set(e, n);
        for (var i = e.querySelectorAll(`link[data-precedence],style[data-precedence]`), a = 0; a < i.length; a++) {
          var o = i[a];
          if (o.nodeName === `LINK` || o.getAttribute(`media`) !== `not all`) {
            n.set(o.dataset.precedence, o);
            r = o;
          }
        }
        if (r) {
          n.set(null, r);
        }
      }
      i = t.instance;
      o = i.getAttribute(`data-precedence`);
      a = n.get(o) || r;
      if (a === r) {
        n.set(null, i);
      }
      n.set(o, i);
      this.count++;
      r = nh.bind(this);
      i.addEventListener(`load`, r);
      i.addEventListener(`error`, r);
      if (a) {
        a.parentNode.insertBefore(i, a.nextSibling);
      } else {
        e = e.nodeType === 9 ? e.head : e;
        e.insertBefore(i, e.firstChild);
      }
      t.state.loading |= 4;
    }
  }
  var sh = {
    $$typeof: fe,
    Provider: null,
    Consumer: null,
    _currentValue: Oe,
    _currentValue2: Oe,
    _threadCount: 0
  };
  function ch(e, t, n, r, i, a, o, s, c) {
    this.tag = 1;
    this.containerInfo = e;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = Ct(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Ct(0);
    this.hiddenUpdates = Ct(null);
    this.identifierPrefix = r;
    this.onUncaughtError = i;
    this.onCaughtError = a;
    this.onRecoverableError = o;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = c;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
  }
  function lh(e, t, n, r, i, a, o, s, c, l, u, d) {
    e = new ch(e, t, n, o, c, l, u, d, s);
    t = 1;
    if (a === true) {
      t |= 24;
    }
    a = Ui(3, null, null, t);
    e.current = a;
    a.stateNode = e;
    t = Ba();
    t.refCount++;
    e.pooledCache = t;
    t.refCount++;
    a.memoizedState = {
      element: r,
      isDehydrated: n,
      cache: t
    };
    Co(a);
    return e;
  }
  function uh(e) {
    if (e) {
      e = Vi;
      return e;
    } else {
      return Vi;
    }
  }
  function dh(e, t, n, r, i, a) {
    i = uh(i);
    if (r.context === null) {
      r.context = i;
    } else {
      r.pendingContext = i;
    }
    r = To(t);
    r.payload = {
      element: n
    };
    a = a === undefined ? null : a;
    if (a !== null) {
      r.callback = a;
    }
    n = Eo(e, r, t);
    if (n !== null) {
      Pd(n, e, t);
      Do(n, e, t);
    }
  }
  function fh(e, t) {
    e = e.memoizedState;
    if (e !== null && e.dehydrated !== null) {
      var n = e.retryLane;
      e.retryLane = n !== 0 && n < t ? n : t;
    }
  }
  function ph(e, t) {
    fh(e, t);
    if (e = e.alternate) {
      fh(e, t);
    }
  }
  function mh(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Ri(e, 67108864);
      if (t !== null) {
        Pd(t, e, 67108864);
      }
      ph(e, 67108864);
    }
  }
  function hh(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = jd();
      t = kt(t);
      var n = Ri(e, t);
      if (n !== null) {
        Pd(n, e, t);
      }
      ph(e, t);
    }
  }
  var gh = true;
  function _h(e, t, n, r) {
    var i = C.T;
    C.T = null;
    var a = w.p;
    try {
      w.p = 2;
      yh(e, t, n, r);
    } finally {
      w.p = a;
      C.T = i;
    }
  }
  function vh(e, t, n, r) {
    var i = C.T;
    C.T = null;
    var a = w.p;
    try {
      w.p = 8;
      yh(e, t, n, r);
    } finally {
      w.p = a;
      C.T = i;
    }
  }
  function yh(e, t, n, r) {
    if (gh) {
      var i = bh(r);
      if (i === null) {
        Kf(e, t, r, xh, n);
        Mh(e, r);
      } else if (Ph(i, e, t, n, r)) {
        r.stopPropagation();
      } else {
        Mh(e, r);
        if (t & 4 && jh.indexOf(e) > -1) {
          while (i !== null) {
            var a = Gt(i);
            if (a !== null) {
              switch (a.tag) {
                case 3:
                  a = a.stateNode;
                  if (a.current.memoizedState.isDehydrated) {
                    var o = _t(a.pendingLanes);
                    if (o !== 0) {
                      var s = a;
                      s.pendingLanes |= 2;
                      s.entangledLanes |= 2;
                      while (o) {
                        var c = 1 << 31 - ut(o);
                        s.entanglements[1] |= c;
                        o &= ~c;
                      }
                      Ef(a);
                      if (!(W & 6)) {
                        _d = Qe() + 500;
                        Df(0, false);
                      }
                    }
                  }
                  break;
                case 31:
                case 13:
                  s = Ri(a, 2);
                  if (s !== null) {
                    Pd(s, a, 2);
                  }
                  zd();
                  ph(a, 2);
              }
            }
            a = bh(r);
            if (a === null) {
              Kf(e, t, r, xh, n);
            }
            if (a === i) {
              break;
            }
            i = a;
          }
          if (i !== null) {
            r.stopPropagation();
          }
        } else {
          Kf(e, t, r, null, n);
        }
      }
    }
  }
  function bh(e) {
    e = jn(e);
    return Sh(e);
  }
  var xh = null;
  function Sh(e) {
    xh = null;
    e = Wt(e);
    if (e !== null) {
      var t = l(e);
      if (t === null) {
        e = null;
      } else {
        var n = t.tag;
        if (n === 13) {
          e = u(t);
          if (e !== null) {
            return e;
          }
          e = null;
        } else if (n === 31) {
          e = d(t);
          if (e !== null) {
            return e;
          }
          e = null;
        } else if (n === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated) {
            if (t.tag === 3) {
              return t.stateNode.containerInfo;
            } else {
              return null;
            }
          }
          e = null;
        } else if (t !== e) {
          e = null;
        }
      }
    }
    xh = e;
    return null;
  }
  function Ch(e) {
    switch (e) {
      case `beforetoggle`:
      case `cancel`:
      case `click`:
      case `close`:
      case `contextmenu`:
      case `copy`:
      case `cut`:
      case `auxclick`:
      case `dblclick`:
      case `dragend`:
      case `dragstart`:
      case `drop`:
      case `focusin`:
      case `focusout`:
      case `input`:
      case `invalid`:
      case `keydown`:
      case `keypress`:
      case `keyup`:
      case `mousedown`:
      case `mouseup`:
      case `paste`:
      case `pause`:
      case `play`:
      case `pointercancel`:
      case `pointerdown`:
      case `pointerup`:
      case `ratechange`:
      case `reset`:
      case `seeked`:
      case `submit`:
      case `toggle`:
      case `touchcancel`:
      case `touchend`:
      case `touchstart`:
      case `volumechange`:
      case `change`:
      case `selectionchange`:
      case `textInput`:
      case `compositionstart`:
      case `compositionend`:
      case `compositionupdate`:
      case `beforeblur`:
      case `afterblur`:
      case `beforeinput`:
      case `blur`:
      case `fullscreenchange`:
      case `fullscreenerror`:
      case `focus`:
      case `hashchange`:
      case `popstate`:
      case `select`:
      case `selectstart`:
        return 2;
      case `drag`:
      case `dragenter`:
      case `dragexit`:
      case `dragleave`:
      case `dragover`:
      case `mousemove`:
      case `mouseout`:
      case `mouseover`:
      case `pointermove`:
      case `pointerout`:
      case `pointerover`:
      case `resize`:
      case `scroll`:
      case `touchmove`:
      case `wheel`:
      case `mouseenter`:
      case `mouseleave`:
      case `pointerenter`:
      case `pointerleave`:
        return 8;
      case `message`:
        switch ($e()) {
          case et:
            return 2;
          case tt:
            return 8;
          case nt:
          case rt:
            return 32;
          case it:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var wh = false;
  var Th = null;
  var Eh = null;
  var Dh = null;
  var Oh = new Map();
  var kh = new Map();
  var Ah = [];
  var jh = `mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset`.split(` `);
  function Mh(e, t) {
    switch (e) {
      case `focusin`:
      case `focusout`:
        Th = null;
        break;
      case `dragenter`:
      case `dragleave`:
        Eh = null;
        break;
      case `mouseover`:
      case `mouseout`:
        Dh = null;
        break;
      case `pointerover`:
      case `pointerout`:
        Oh.delete(t.pointerId);
        break;
      case `gotpointercapture`:
      case `lostpointercapture`:
        kh.delete(t.pointerId);
    }
  }
  function Nh(e, t, n, r, i, a) {
    if (e === null || e.nativeEvent !== a) {
      e = {
        blockedOn: t,
        domEventName: n,
        eventSystemFlags: r,
        nativeEvent: a,
        targetContainers: [i]
      };
      if (t !== null) {
        t = Gt(t);
        if (t !== null) {
          mh(t);
        }
      }
      return e;
    } else {
      e.eventSystemFlags |= r;
      t = e.targetContainers;
      if (i !== null && t.indexOf(i) === -1) {
        t.push(i);
      }
      return e;
    }
  }
  function Ph(e, t, n, r, i) {
    switch (t) {
      case `focusin`:
        Th = Nh(Th, e, t, n, r, i);
        return true;
      case `dragenter`:
        Eh = Nh(Eh, e, t, n, r, i);
        return true;
      case `mouseover`:
        Dh = Nh(Dh, e, t, n, r, i);
        return true;
      case `pointerover`:
        var a = i.pointerId;
        Oh.set(a, Nh(Oh.get(a) || null, e, t, n, r, i));
        return true;
      case `gotpointercapture`:
        a = i.pointerId;
        kh.set(a, Nh(kh.get(a) || null, e, t, n, r, i));
        return true;
    }
    return false;
  }
  function Fh(e) {
    var t = Wt(e.target);
    if (t !== null) {
      var n = l(t);
      if (n !== null) {
        t = n.tag;
        if (t === 13) {
          t = u(n);
          if (t !== null) {
            e.blockedOn = t;
            Mt(e.priority, function () {
              hh(n);
            });
            return;
          }
        } else if (t === 31) {
          t = d(n);
          if (t !== null) {
            e.blockedOn = t;
            Mt(e.priority, function () {
              hh(n);
            });
            return;
          }
        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function Ih(e) {
    if (e.blockedOn !== null) {
      return false;
    }
    for (var t = e.targetContainers; t.length > 0;) {
      var n = bh(e.nativeEvent);
      if (n === null) {
        n = e.nativeEvent;
        var r = new n.constructor(n.type, n);
        An = r;
        n.target.dispatchEvent(r);
        An = null;
      } else {
        t = Gt(n);
        if (t !== null) {
          mh(t);
        }
        e.blockedOn = n;
        return false;
      }
      t.shift();
    }
    return true;
  }
  function Lh(e, t, n) {
    if (Ih(e)) {
      n.delete(t);
    }
  }
  function Rh() {
    wh = false;
    if (Th !== null && Ih(Th)) {
      Th = null;
    }
    if (Eh !== null && Ih(Eh)) {
      Eh = null;
    }
    if (Dh !== null && Ih(Dh)) {
      Dh = null;
    }
    Oh.forEach(Lh);
    kh.forEach(Lh);
  }
  function zh(e, n) {
    if (e.blockedOn === n) {
      e.blockedOn = null;
      if (!wh) {
        wh = true;
        t.unstable_scheduleCallback(t.unstable_NormalPriority, Rh);
      }
    }
  }
  var Bh = null;
  function Vh(e) {
    if (Bh !== e) {
      Bh = e;
      t.unstable_scheduleCallback(t.unstable_NormalPriority, function () {
        if (Bh === e) {
          Bh = null;
        }
        for (var t = 0; t < e.length; t += 3) {
          var n = e[t];
          var r = e[t + 1];
          var i = e[t + 2];
          if (typeof r != `function`) {
            if (Sh(r || n) === null) {
              continue;
            }
            break;
          }
          var a = Gt(n);
          if (a !== null) {
            e.splice(t, 3);
            t -= 3;
            oc(a, {
              pending: true,
              data: i,
              method: n.method,
              action: r
            }, r, i);
          }
        }
      });
    }
  }
  function Hh(e) {
    function t(t) {
      return zh(t, e);
    }
    if (Th !== null) {
      zh(Th, e);
    }
    if (Eh !== null) {
      zh(Eh, e);
    }
    if (Dh !== null) {
      zh(Dh, e);
    }
    Oh.forEach(t);
    kh.forEach(t);
    for (var n = 0; n < Ah.length; n++) {
      var r = Ah[n];
      if (r.blockedOn === e) {
        r.blockedOn = null;
      }
    }
    while (Ah.length > 0 && (n = Ah[0], n.blockedOn === null)) {
      Fh(n);
      if (n.blockedOn === null) {
        Ah.shift();
      }
    }
    n = (e.ownerDocument || e).$$reactFormReplay;
    if (n != null) {
      for (r = 0; r < n.length; r += 3) {
        var i = n[r];
        var a = n[r + 1];
        var o = i[Ft] || null;
        if (typeof a == `function`) {
          if (!o) {
            Vh(n);
          }
        } else if (o) {
          var s = null;
          if (a && a.hasAttribute(`formAction`)) {
            i = a;
            if (o = a[Ft] || null) {
              s = o.formAction;
            } else if (Sh(i) !== null) {
              continue;
            }
          } else {
            s = o.action;
          }
          if (typeof s == `function`) {
            n[r + 1] = s;
          } else {
            n.splice(r, 3);
            r -= 3;
          }
          Vh(n);
        }
      }
    }
  }
  function Uh() {
    function e(e) {
      if (e.canIntercept && e.info === `react-transition`) {
        e.intercept({
          handler: function () {
            return new Promise(function (e) {
              return i = e;
            });
          },
          focusReset: `manual`,
          scroll: `manual`
        });
      }
    }
    function t() {
      if (i !== null) {
        i();
        i = null;
      }
      if (!r) {
        setTimeout(n, 20);
      }
    }
    function n() {
      if (!r && !navigation.transition) {
        var e = navigation.currentEntry;
        if (e && e.url != null) {
          navigation.navigate(e.url, {
            state: e.getState(),
            info: `react-transition`,
            history: `replace`
          });
        }
      }
    }
    if (typeof navigation == `object`) {
      var r = false;
      var i = null;
      navigation.addEventListener(`navigate`, e);
      navigation.addEventListener(`navigatesuccess`, t);
      navigation.addEventListener(`navigateerror`, t);
      setTimeout(n, 100);
      return function () {
        r = true;
        navigation.removeEventListener(`navigate`, e);
        navigation.removeEventListener(`navigatesuccess`, t);
        navigation.removeEventListener(`navigateerror`, t);
        if (i !== null) {
          i();
          i = null;
        }
      };
    }
  }
  function Wh(e) {
    this._internalRoot = e;
  }
  Gh.prototype.render = Wh.prototype.render = function (e) {
    var t = this._internalRoot;
    if (t === null) {
      throw Error(s(409));
    }
    var n = t.current;
    dh(n, jd(), e, t, null, null);
  };
  Gh.prototype.unmount = Wh.prototype.unmount = function () {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      dh(e.current, 2, null, e, null, null);
      zd();
      t[It] = null;
    }
  };
  function Gh(e) {
    this._internalRoot = e;
  }
  Gh.prototype.unstable_scheduleHydration = function (e) {
    if (e) {
      var t = jt();
      e = {
        blockedOn: null,
        target: e,
        priority: t
      };
      for (var n = 0; n < Ah.length && t !== 0 && t < Ah[n].priority; n++);
      Ah.splice(n, 0, e);
      if (n === 0) {
        Fh(e);
      }
    }
  };
  var Kh = r.version;
  if (Kh !== `19.3.0`) {
    throw Error(s(527, Kh, `19.3.0`));
  }
  w.findDOMNode = function (e) {
    var t = e._reactInternals;
    if (t === undefined) {
      throw typeof e.render == `function` ? Error(s(188)) : (e = Object.keys(e).join(`,`), Error(s(268, e)));
    }
    e = p(t);
    e = e === null ? null : m(e);
    e = e === null ? null : e.stateNode;
    return e;
  };
  var qh = {
    bundleType: 0,
    version: `19.3.0`,
    rendererPackageName: `react-dom`,
    currentDispatcherRef: C,
    reconcilerVersion: `19.3.0`
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < `u`) {
    var Jh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Jh.isDisabled && Jh.supportsFiber) {
      try {
        st = Jh.inject(qh);
        ct = Jh;
      } catch {}
    }
  }
  e.createRoot = function (e, t) {
    if (!c(e)) {
      throw Error(s(299));
    }
    var n = false;
    var r = ``;
    var i = kc;
    var a = Ac;
    var o = jc;
    if (t != null) {
      if (t.unstable_strictMode === true) {
        n = true;
      }
      if (t.identifierPrefix !== undefined) {
        r = t.identifierPrefix;
      }
      if (t.onUncaughtError !== undefined) {
        i = t.onUncaughtError;
      }
      if (t.onCaughtError !== undefined) {
        a = t.onCaughtError;
      }
      if (t.onRecoverableError !== undefined) {
        o = t.onRecoverableError;
      }
    }
    t = lh(e, 1, false, null, null, n, r, null, i, a, o, Uh);
    e[It] = t.current;
    Wf(e);
    return new Wh(t);
  };
});
var c = t((e, t) => {
  function n() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < `u` && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == `function`) {
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (e) {
        console.error(e);
      }
    }
  }
  n();
  t.exports = s();
});
var l = e(n(), 1);
var u = `modulepreload`;
function d(e) {
  return `/${e}`;
}
var f = {};
function p(e, t, n) {
  let r = Promise.resolve();
  if (t && t.length > 0) {
    let e = document.getElementsByTagName(`link`);
    let i = document.querySelector(`meta[property=csp-nonce]`);
    let a = i?.nonce || i?.getAttribute(`nonce`);
    function o(e) {
      return Promise.all(e.map(e => Promise.resolve(e).then(e => ({
        status: `fulfilled`,
        value: e
      }), e => ({
        status: `rejected`,
        reason: e
      }))));
    }
    function s(e) {
      if (import.meta.resolve) {
        return import.meta.resolve(e);
      } else {
        return new URL(e, import.meta.url).href;
      }
    }
    r = o(t.map(t => {
      t = d(t, n);
      t = s(t);
      if (t in f) {
        return;
      }
      f[t] = true;
      let r = t.endsWith(`.css`);
      for (let n = e.length - 1; n >= 0; n--) {
        let i = e[n];
        if (i.href === t && (!r || i.rel === `stylesheet`)) {
          return;
        }
      }
      let i = document.createElement(`link`);
      i.rel = r ? `stylesheet` : u;
      if (!r) {
        i.as = `script`;
      }
      i.crossOrigin = ``;
      i.href = t;
      if (a) {
        i.setAttribute(`nonce`, a);
      }
      document.head.appendChild(i);
      if (r) {
        return new Promise((e, n) => {
          i.addEventListener(`load`, e);
          i.addEventListener(`error`, () => n(Error(`Unable to preload CSS for ${t}`)));
        });
      }
    }).filter(e => e !== undefined));
  }
  function i(e) {
    let t = new Event(`vite:preloadError`, {
      cancelable: true
    });
    t.payload = e;
    window.dispatchEvent(t);
    if (!t.defaultPrevented) {
      throw e;
    }
  }
  return r.then(t => {
    for (let e of t || []) {
      if (e.status === `rejected`) {
        i(e.reason);
      }
    }
    return e().catch(i);
  });
}
var m = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var h = /^[\\/]{2}/;
function g(e, t) {
  return t + e.replace(/\\/g, `/`);
}
var _ = `popstate`;
function v(e) {
  return typeof e == `object` && !!e && `pathname` in e && `search` in e && `hash` in e && `state` in e && `key` in e;
}
function y(e = {}) {
  function t(e, t) {
    let {
      pathname: n = `/`,
      search: r = ``,
      hash: i = ``
    } = ie(e.location.hash.substring(1));
    if (!n.startsWith(`/`) && !n.startsWith(`.`)) {
      n = `/${n}`;
    }
    return ne(``, {
      pathname: n,
      search: r,
      hash: i
    }, t.state && t.state.usr || null, t.state && t.state.key || `default`);
  }
  function n(e, t) {
    let n = e.document.querySelector(`base`);
    let r = ``;
    if (n && n.getAttribute(`href`)) {
      let t = e.location.href;
      let n = t.indexOf(`#`);
      r = n === -1 ? t : t.slice(0, n);
    }
    return `${r}#${typeof t == `string` ? t : re(t)}`;
  }
  function r(e, t) {
    x(e.pathname.charAt(0) === `/`, `relative pathnames are not supported in hash history.push(${JSON.stringify(t)})`);
  }
  return S(t, n, r, e);
}
function b(e, t) {
  if (e === false || e == null) {
    throw Error(t);
  }
}
function x(e, t) {
  if (!e) {
    if (typeof console < `u`) {
      console.warn(t);
    }
    try {
      throw Error(t);
    } catch {}
  }
}
function ee() {
  return Math.random().toString(36).substring(2, 10);
}
function te(e, t) {
  return {
    usr: e.state,
    key: e.key,
    idx: t,
    masked: e.mask ? {
      pathname: e.pathname,
      search: e.search,
      hash: e.hash
    } : undefined
  };
}
function ne(e, t, n = null, r, i) {
  return {
    pathname: typeof e == `string` ? e : e.pathname,
    search: ``,
    hash: ``,
    ...(typeof t == `string` ? ie(t) : t),
    state: n,
    key: t && t.key || r || ee(),
    mask: i
  };
}
function re({
  pathname: e = `/`,
  search: t = ``,
  hash: n = ``
}) {
  if (t && t !== `?`) {
    e += t.charAt(0) === `?` ? t : `?${t}`;
  }
  if (n && n !== `#`) {
    e += n.charAt(0) === `#` ? n : `#${n}`;
  }
  return e;
}
function ie(e) {
  let t = {};
  if (e) {
    let n = e.indexOf(`#`);
    if (n >= 0) {
      t.hash = e.substring(n);
      e = e.substring(0, n);
    }
    let r = e.indexOf(`?`);
    if (r >= 0) {
      t.search = e.substring(r);
      e = e.substring(0, r);
    }
    if (e) {
      t.pathname = e;
    }
  }
  return t;
}
function S(e, t, n, r = {}) {
  let {
    window: i = document.defaultView,
    v5Compat: a = false
  } = r;
  let o = i.history;
  let s = `POP`;
  let c = null;
  let l = u();
  l ?? (l = 0, o.replaceState({
    ...o.state,
    idx: l
  }, ``));
  function u() {
    return (o.state || {
      idx: null
    }).idx;
  }
  function d() {
    s = `POP`;
    let e = u();
    let t = e == null ? null : e - l;
    l = e;
    if (c) {
      c({
        action: s,
        location: h.location,
        delta: t
      });
    }
  }
  function f(e, t) {
    s = `PUSH`;
    let r = v(e) ? e : ne(h.location, e, t);
    if (n) {
      n(r, e);
    }
    l = u() + 1;
    let d = te(r, l);
    let f = h.createHref(r.mask || r);
    try {
      o.pushState(d, ``, f);
    } catch (e) {
      if (e instanceof DOMException && e.name === `DataCloneError`) {
        throw e;
      }
      i.location.assign(f);
    }
    if (a && c) {
      c({
        action: s,
        location: h.location,
        delta: 1
      });
    }
  }
  function p(e, t) {
    s = `REPLACE`;
    let r = v(e) ? e : ne(h.location, e, t);
    if (n) {
      n(r, e);
    }
    l = u();
    let i = te(r, l);
    let d = h.createHref(r.mask || r);
    o.replaceState(i, ``, d);
    if (a && c) {
      c({
        action: s,
        location: h.location,
        delta: 0
      });
    }
  }
  function m(e) {
    return ae(i, e);
  }
  let h = {
    get action() {
      return s;
    },
    get location() {
      return e(i, o);
    },
    listen(e) {
      if (c) {
        throw Error(`A history only accepts one active listener`);
      }
      i.addEventListener(_, d);
      c = e;
      return () => {
        i.removeEventListener(_, d);
        c = null;
      };
    },
    createHref(e) {
      return t(i, e);
    },
    createURL: m,
    encodeLocation(e) {
      let t = m(e);
      return {
        pathname: t.pathname,
        search: t.search,
        hash: t.hash
      };
    },
    push: f,
    replace: p,
    go(e) {
      return o.go(e);
    }
  };
  return h;
}
function ae(e, t, n = false) {
  let r = `http://localhost`;
  if (e) {
    r = e.location.origin === `null` ? e.location.href : e.location.origin;
  }
  b(r, `No window.location.(origin|href) available to create URL`);
  let i = typeof t == `string` ? t : re(t);
  i = i.replace(/ $/, `%20`);
  if (!n && h.test(i)) {
    i = r + i;
  }
  return new URL(i, r);
}
function oe(e, t, n = `/`) {
  return se(e, t, n, false);
}
function se(e, t, n, r, i) {
  let a = Ee((typeof t == `string` ? ie(t) : t).pathname || `/`, n);
  if (a == null) {
    return null;
  }
  let o = i ?? ce(e);
  let s = null;
  let c = Te(a);
  for (let e = 0; s == null && e < o.length; ++e) {
    s = xe(o[e], c, r);
  }
  return s;
}
function ce(e) {
  let t = le(e);
  de(t);
  return t;
}
function le(e, t = [], n = [], r = ``, i = false) {
  let a = (e, a, o = i, s) => {
    let c = {
      relativePath: s === undefined ? e.path || `` : s,
      caseSensitive: e.caseSensitive === true,
      childrenIndex: a,
      route: e
    };
    if (c.relativePath.startsWith(`/`)) {
      if (!c.relativePath.startsWith(r) && o) {
        return;
      }
      b(c.relativePath.startsWith(r), `Absolute route path "${c.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
      c.relativePath = c.relativePath.slice(r.length);
    }
    let l = T([r, c.relativePath]);
    let u = n.concat(c);
    if (e.children && e.children.length > 0) {
      b(e.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${l}".`);
      le(e.children, t, u, l, o);
    }
    if (e.path != null || e.index) {
      t.push({
        path: l,
        score: ye(l, e.index),
        routesMeta: u.map((e, t) => {
          let [n, r] = we(e.relativePath, e.caseSensitive, t === u.length - 1);
          return {
            ...e,
            matcher: n,
            compiledParams: r
          };
        })
      });
    }
  };
  e.forEach((e, t) => {
    if (e.path === `` || !e.path?.includes(`?`)) {
      a(e, t);
    } else {
      for (let n of ue(e.path)) {
        a(e, t, true, n);
      }
    }
  });
  return t;
}
function ue(e) {
  let t = e.split(`/`);
  if (t.length === 0) {
    return [];
  }
  let [n, ...r] = t;
  let i = n.endsWith(`?`);
  let a = n.replace(/\?$/, ``);
  if (r.length === 0) {
    if (i) {
      return [a, ``];
    } else {
      return [a];
    }
  }
  let o = ue(r.join(`/`));
  let s = [];
  s.push(...o.map(e => e === `` ? a : [a, e].join(`/`)));
  if (i) {
    s.push(...o);
  }
  return s.map(t => e.startsWith(`/`) && t === `` ? `/` : t);
}
function de(e) {
  e.sort((e, t) => e.score === t.score ? be(e.routesMeta.map(e => e.childrenIndex), t.routesMeta.map(e => e.childrenIndex)) : t.score - e.score);
}
var fe = /^:[\w-]+$/;
var pe = 3;
var me = 2;
var he = 1;
var ge = 10;
var _e = -2;
var ve = e => e === `*`;
function ye(e, t) {
  let n = e.split(`/`);
  let r = n.length;
  if (n.some(ve)) {
    r += _e;
  }
  if (t) {
    r += me;
  }
  return n.filter(e => !ve(e)).reduce((e, t) => e + (fe.test(t) ? pe : t === `` ? he : ge), r);
}
function be(e, t) {
  if (e.length === t.length && e.slice(0, -1).every((e, n) => e === t[n])) {
    return e[e.length - 1] - t[t.length - 1];
  } else {
    return 0;
  }
}
function xe(e, t, n = false) {
  let {
    routesMeta: r
  } = e;
  let i = {};
  let a = `/`;
  let o = [];
  for (let e = 0; e < r.length; ++e) {
    let s = r[e];
    let c = e === r.length - 1;
    let l = a === `/` ? t : t.slice(a.length) || `/`;
    let u = {
      path: s.relativePath,
      caseSensitive: s.caseSensitive,
      end: c
    };
    let d = s.matcher && s.compiledParams ? Ce(u, l, s.matcher, s.compiledParams) : Se(u, l);
    let f = s.route;
    if (!d && c && n && !r[r.length - 1].route.index) {
      d = Se({
        path: s.relativePath,
        caseSensitive: s.caseSensitive,
        end: false
      }, l);
    }
    if (!d) {
      return null;
    }
    Object.assign(i, d.params);
    o.push({
      params: i,
      pathname: T([a, d.pathname]),
      pathnameBase: Me(T([a, d.pathnameBase])),
      route: f
    });
    if (d.pathnameBase !== `/`) {
      a = T([a, d.pathnameBase]);
    }
  }
  return o;
}
function Se(e, t) {
  if (typeof e == `string`) {
    e = {
      path: e,
      caseSensitive: false,
      end: true
    };
  }
  let [n, r] = we(e.path, e.caseSensitive, e.end);
  return Ce(e, t, n, r);
}
function Ce(e, t, n, r) {
  let i = t.match(n);
  if (!i) {
    return null;
  }
  let a = i[0];
  let o = E(a, 1);
  let s = i.slice(1);
  return {
    params: r.reduce((e, {
      paramName: t,
      isOptional: n
    }, r) => {
      if (t === `*`) {
        let e = s[r] || ``;
        o = E(a.slice(0, a.length - e.length), 1);
      }
      let i = s[r];
      e[t] = n && !i ? undefined : (i || ``).replace(/%2F/g, `/`);
      return e;
    }, {}),
    pathname: a,
    pathnameBase: o,
    pattern: e
  };
}
function we(e, t = false, n = true) {
  x(e === `*` || !e.endsWith(`*`) || e.endsWith(`/*`), `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, `/*`)}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, `/*`)}".`);
  let r = [];
  let i = `^${e.replace(/\/*\*?$/, ``).replace(/^\/*/, `/`).replace(/[\\.*+^${}|()[\]]/g, `\\$&`).replace(/\/:([\w-]+)(\?)?/g, (e, t, n, i, a) => {
    r.push({
      paramName: t,
      isOptional: n != null
    });
    if (n) {
      let t = a.charAt(i + e.length);
      if (t && t !== `/`) {
        return `/([^\\/]*)`;
      } else {
        return `(?:/([^\\/]*))?`;
      }
    }
    return `/([^\\/]+)`;
  }).replace(/\/([\w-]+)\?(\/|$)/g, `(/$1)?$2`)}`;
  if (e.endsWith(`*`)) {
    r.push({
      paramName: `*`
    });
    i += e === `*` || e === `/*` ? `(.*)$` : `(?:\\/(.+)|\\/*)$`;
  } else if (n) {
    i += `\\/*$`;
  } else if (e !== `` && e !== `/`) {
    i += `(?:(?=\\/|$))`;
  }
  return [new RegExp(i, t ? undefined : `i`), r];
}
function Te(e) {
  try {
    return e.split(`/`).map(e => decodeURIComponent(e).replace(/\//g, `%2F`)).join(`/`);
  } catch (t) {
    x(false, `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`);
    return e;
  }
}
function Ee(e, t) {
  if (t === `/`) {
    return e;
  }
  if (!e.toLowerCase().startsWith(t.toLowerCase())) {
    return null;
  }
  let n = t.endsWith(`/`) ? t.length - 1 : t.length;
  let r = e.charAt(n);
  if (r && r !== `/`) {
    return null;
  } else {
    return e.slice(n) || `/`;
  }
}
function De(e, t = `/`) {
  let {
    pathname: n,
    search: r = ``,
    hash: i = ``
  } = typeof e == `string` ? ie(e) : e;
  let a;
  if (n) {
    n = je(n);
    a = n.startsWith(`/`) || n.startsWith(`\\`) ? C(n.substring(1), `/`) : C(n, t);
  } else {
    a = t;
  }
  return {
    pathname: a,
    search: Ne(r),
    hash: Pe(i)
  };
}
function C(e, t) {
  let n = E(t).split(`/`);
  e.split(`/`).forEach(e => {
    if (e === `..`) {
      if (n.length > 1) {
        n.pop();
      }
    } else if (e !== `.`) {
      n.push(e);
    }
  });
  if (n.length > 1) {
    return n.join(`/`);
  } else {
    return `/`;
  }
}
function w(e, t, n, r) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(r)}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function Oe(e) {
  return e.filter((e, t) => t === 0 || e.route.path && e.route.path.length > 0);
}
function ke(e) {
  let t = Oe(e);
  return t.map((e, n) => n === t.length - 1 ? e.pathname : e.pathnameBase);
}
function Ae(e, t, n, r = false) {
  let i;
  if (typeof e == `string`) {
    i = ie(e);
  } else {
    i = {
      ...e
    };
    b(!i.pathname || !i.pathname.includes(`?`), w(`?`, `pathname`, `search`, i));
    b(!i.pathname || !i.pathname.includes(`#`), w(`#`, `pathname`, `hash`, i));
    b(!i.search || !i.search.includes(`#`), w(`#`, `search`, `hash`, i));
  }
  let a = e === `` || i.pathname === ``;
  let o = a ? `/` : i.pathname;
  let s;
  if (o == null) {
    s = n;
  } else {
    let e = t.length - 1;
    if (!r && o.startsWith(`..`)) {
      let t = o.split(`/`);
      while (t[0] === `..`) {
        t.shift();
        --e;
      }
      i.pathname = t.join(`/`);
    }
    s = e >= 0 ? t[e] : `/`;
  }
  let c = De(i, s);
  let l = o && o !== `/` && o.endsWith(`/`);
  let u = (a || o === `.`) && n.endsWith(`/`);
  if (!c.pathname.endsWith(`/`) && (l || u)) {
    c.pathname += `/`;
  }
  return c;
}
var je = e => e.replace(/[\\/]{2,}/g, `/`);
var T = e => je(e.join(`/`));
function E(e, t = 0) {
  let n = e.length;
  while (n > t && e.charCodeAt(n - 1) === 47) {
    n--;
  }
  if (n === e.length) {
    return e;
  } else {
    return e.slice(0, n);
  }
}
var Me = e => E(e).replace(/^\/*/, `/`);
var Ne = e => !e || e === `?` ? `` : e.startsWith(`?`) ? e : `?${e}`;
var Pe = e => !e || e === `#` ? `` : e.startsWith(`#`) ? e : `#${e}`;
var Fe = class {
  constructor(e, t, n, r = false) {
    this.status = e;
    this.statusText = t || ``;
    this.internal = r;
    if (n instanceof Error) {
      this.data = n.toString();
      this.error = n;
    } else {
      this.data = n;
    }
  }
};
function Ie(e) {
  return e != null && typeof e.status == `number` && typeof e.statusText == `string` && typeof e.internal == `boolean` && `data` in e;
}
function Le(e) {
  return T(e.map(e => e.route.path).filter(Boolean)) || `/`;
}
var Re = typeof window < `u` && window.document !== undefined && window.document.createElement !== undefined;
function ze(e, t) {
  let n = e;
  if (typeof n != `string` || !m.test(n)) {
    return {
      absoluteURL: undefined,
      isExternal: false,
      to: n
    };
  }
  let r = n;
  let i = false;
  if (Re) {
    try {
      let e = new URL(window.location.href);
      let r = h.test(n) ? new URL(g(n, e.protocol)) : new URL(n);
      let a = Ee(r.pathname, t);
      if (r.origin === e.origin && a != null) {
        n = a + r.search + r.hash;
      } else {
        i = true;
      }
    } catch {
      x(false, `<Link to="${n}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
  }
  return {
    absoluteURL: r,
    isExternal: i,
    to: n
  };
}
Object.getOwnPropertyNames(Object.prototype).sort().join(`\0`);
var Be = new URL(`http://localhost`);
function Ve(e) {
  if (e.createURL) {
    return e.createURL(`/`);
  }
  try {
    return new URL(e.createHref(`/`), Be);
  } catch {
    return Be;
  }
}
function He(e, t) {
  return e.origin === t.origin && (e.origin !== `null` || e.protocol === t.protocol && e.host === t.host);
}
function Ue(e, t) {
  if (e.startsWith(`//`)) {
    return true;
  }
  let n = t.protocol.toLowerCase();
  if (e.toLowerCase().startsWith(n)) {
    return t.host === `` || e.slice(n.length).startsWith(`//`);
  } else {
    return false;
  }
}
function We(e, t, n, r) {
  let i = null;
  try {
    i = e == null ? null : new URL(e, n);
  } catch {}
  let a = new URL(t, n);
  let o = i != null && !He(i, n);
  let s = !He(a, n);
  if (r === `reject`) {
    if (o || s) {
      throw Error(`External navigation is not allowed`);
    }
  } else if (s && (i == null || !Ue(e, i) || !He(i, a))) {
    throw Error(`External navigation is not allowed`);
  }
}
var Ge = [`POST`, `PUT`, `PATCH`, `DELETE`];
new Set(Ge);
var Ke = [`GET`, ...Ge];
new Set(Ke);
var qe = [`about:`, `blob:`, `chrome:`, `chrome-untrusted:`, `content:`, `data:`, `devtools:`, `file:`, `filesystem:`, `javascript:`];
function Je(e) {
  try {
    return qe.includes(new URL(e).protocol);
  } catch {
    return false;
  }
}
var Ye = l.createContext(null);
Ye.displayName = `DataRouter`;
var Xe = l.createContext(null);
Xe.displayName = `DataRouterState`;
var Ze = l.createContext(false);
function Qe() {
  return l.useContext(Ze);
}
var $e = l.createContext({
  isTransitioning: false
});
$e.displayName = `ViewTransition`;
var et = l.createContext(new Map());
et.displayName = `Fetchers`;
var tt = l.createContext(null);
tt.displayName = `Await`;
var nt = l.createContext(null);
nt.displayName = `Navigation`;
var rt = l.createContext(null);
rt.displayName = `Location`;
var it = l.createContext({
  outlet: null,
  matches: [],
  isDataRoute: false
});
it.displayName = `Route`;
var at = l.createContext(null);
at.displayName = `RouteError`;
var ot = `REACT_ROUTER_ERROR`;
var st = `REDIRECT`;
var ct = `ROUTE_ERROR_RESPONSE`;
function lt(e) {
  if (e.startsWith(`${ot}:${st}:{`)) {
    try {
      let t = JSON.parse(e.slice(28));
      if (typeof t == `object` && t && typeof t.status == `number` && typeof t.statusText == `string` && typeof t.location == `string` && typeof t.reloadDocument == `boolean` && typeof t.replace == `boolean`) {
        return t;
      }
    } catch {}
  }
}
function ut(e) {
  if (e.startsWith(`${ot}:${ct}:{`)) {
    try {
      let t = JSON.parse(e.slice(40));
      if (typeof t == `object` && t && typeof t.status == `number` && typeof t.statusText == `string`) {
        return new Fe(t.status, t.statusText, t.data);
      }
    } catch {}
  }
}
function dt(e, {
  relative: t
} = {}) {
  b(ft(), `useHref() may be used only in the context of a <Router> component.`);
  let {
    basename: n,
    navigator: r
  } = l.useContext(nt);
  let {
    hash: i,
    pathname: a,
    search: o
  } = yt(e, {
    relative: t
  });
  let s = a;
  if (n !== `/`) {
    s = a === `/` ? n : T([n, a]);
  }
  return r.createHref({
    pathname: s,
    search: o,
    hash: i
  });
}
function ft() {
  return l.useContext(rt) != null;
}
function pt() {
  b(ft(), `useLocation() may be used only in the context of a <Router> component.`);
  return l.useContext(rt).location;
}
var mt = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function ht(e) {
  if (!l.useContext(nt).static) {
    l.useLayoutEffect(e);
  }
}
function gt() {
  let {
    isDataRoute: e
  } = l.useContext(it);
  if (e) {
    return It();
  } else {
    return _t();
  }
}
function _t() {
  b(ft(), `useNavigate() may be used only in the context of a <Router> component.`);
  let e = l.useContext(Ye);
  let {
    basename: t,
    navigator: n
  } = l.useContext(nt);
  let {
    matches: r
  } = l.useContext(it);
  let {
    pathname: i
  } = pt();
  let a = JSON.stringify(ke(r));
  let o = l.useRef(false);
  ht(() => {
    o.current = true;
  });
  return l.useCallback((r, s = {}) => {
    x(o.current, mt);
    if (!o.current) {
      return;
    }
    if (typeof r == `number`) {
      n.go(r);
      return;
    }
    let c = Ae(r, JSON.parse(a), i, s.relative === `path`);
    if (e == null && t !== `/`) {
      c.pathname = c.pathname === `/` ? t : T([t, c.pathname]);
    }
    We(typeof r == `string` ? r : re(r), n.createHref(c), Ve(n), `reject`);
    (s.replace ? n.replace : n.push)(c, s.state, s);
  }, [t, n, a, i, e]);
}
l.createContext(null);
function vt() {
  let {
    matches: e
  } = l.useContext(it);
  return e[e.length - 1]?.params ?? {};
}
function yt(e, {
  relative: t
} = {}) {
  let {
    matches: n
  } = l.useContext(it);
  let {
    pathname: r
  } = pt();
  let i = JSON.stringify(ke(n));
  return l.useMemo(() => Ae(e, JSON.parse(i), r, t === `path`), [e, i, r, t]);
}
function bt(e, t) {
  return xt(e, t);
}
function xt(e, t, n) {
  b(ft(), `useRoutes() may be used only in the context of a <Router> component.`);
  let {
    navigator: r
  } = l.useContext(nt);
  let {
    matches: i
  } = l.useContext(it);
  let a = i[i.length - 1];
  let o = a ? a.params : {};
  let s = a ? a.pathname : `/`;
  let c = a ? a.pathnameBase : `/`;
  let u = a && a.route;
  {
    let e = u && u.path || ``;
    Rt(s, !u || e.endsWith(`*`) || e.endsWith(`*?`), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${s}" (under <Route path="${e}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${e}"> to <Route path="${e === `/` ? `*` : `${e}/*`}">.`);
  }
  let d = pt();
  let f;
  if (t) {
    let e = typeof t == `string` ? ie(t) : t;
    b(c === `/` || e.pathname?.startsWith(c), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${c}" but pathname "${e.pathname}" was given in the \`location\` prop.`);
    f = e;
  } else {
    f = d;
  }
  let p = f.pathname || `/`;
  let m = p;
  if (c !== `/`) {
    let e = c.replace(/^\//, ``).split(`/`);
    m = `/${p.replace(/^\//, ``).split(`/`).slice(e.length).join(`/`)}`;
  }
  let h = n && n.state.matches.length ? n.state.matches.map(e => Object.assign(e, {
    route: n.manifest[e.route.id] || e.route
  })) : oe(e, {
    pathname: m
  });
  x(u || h != null, `No routes matched location "${f.pathname}${f.search}${f.hash}" `);
  x(h == null || h[h.length - 1].route.element !== undefined || h[h.length - 1].route.Component !== undefined || h[h.length - 1].route.lazy !== undefined, `Matched leaf route at location "${f.pathname}${f.search}${f.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
  let g = Ot(h && h.map(e => Object.assign({}, e, {
    params: Object.assign({}, o, e.params),
    pathname: T([c, r.encodeLocation ? r.encodeLocation(e.pathname.replace(/%/g, `%25`).replace(/\?/g, `%3F`).replace(/#/g, `%23`)).pathname : e.pathname]),
    pathnameBase: e.pathnameBase === `/` ? c : T([c, r.encodeLocation ? r.encodeLocation(e.pathnameBase.replace(/%/g, `%25`).replace(/\?/g, `%3F`).replace(/#/g, `%23`)).pathname : e.pathnameBase])
  })), i, n);
  if (t && g) {
    return l.createElement(rt.Provider, {
      value: {
        location: {
          pathname: `/`,
          search: ``,
          hash: ``,
          state: null,
          key: `default`,
          mask: undefined,
          ...f
        },
        navigationType: `POP`
      }
    }, g);
  } else {
    return g;
  }
}
function St() {
  let e = Ft();
  let t = Ie(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e);
  let n = e instanceof Error ? e.stack : null;
  let r = `rgba(200,200,200, 0.5)`;
  let i = {
    padding: `0.5rem`,
    backgroundColor: r
  };
  let a = {
    padding: `2px 4px`,
    backgroundColor: r
  };
  let o = null;
  console.error(`Error handled by React Router default ErrorBoundary:`, e);
  o = l.createElement(l.Fragment, null, l.createElement(`p`, null, `💿 Hey developer 👋`), l.createElement(`p`, null, `You can provide a way better UX than this when your app throws errors by providing your own `, l.createElement(`code`, {
    style: a
  }, `ErrorBoundary`), ` or`, ` `, l.createElement(`code`, {
    style: a
  }, `errorElement`), ` prop on your route.`));
  return l.createElement(l.Fragment, null, l.createElement(`h2`, null, `Unexpected Application Error!`), l.createElement(`h3`, {
    style: {
      fontStyle: `italic`
    }
  }, t), n ? l.createElement(`pre`, {
    style: i
  }, n) : null, o);
}
var Ct = l.createElement(St, null);
var wt = class extends l.Component {
  constructor(e) {
    super(e);
    this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return {
      error: e
    };
  }
  static getDerivedStateFromProps(e, t) {
    if (t.location !== e.location || t.revalidation !== `idle` && e.revalidation === `idle`) {
      return {
        error: e.error,
        location: e.location,
        revalidation: e.revalidation
      };
    } else {
      return {
        error: e.error === undefined ? t.error : e.error,
        location: t.location,
        revalidation: e.revalidation || t.revalidation
      };
    }
  }
  componentDidCatch(e, t) {
    if (this.props.onError) {
      this.props.onError(e, t);
    } else {
      console.error(`React Router caught the following error during render`, e);
    }
  }
  render() {
    let e = this.state.error;
    if (this.context && typeof e == `object` && e && `digest` in e && typeof e.digest == `string`) {
      let t = ut(e.digest);
      if (t) {
        e = t;
      }
    }
    let t = e === undefined ? this.props.children : l.createElement(it.Provider, {
      value: this.props.routeContext
    }, l.createElement(at.Provider, {
      value: e,
      children: this.props.component
    }));
    if (this.context) {
      return l.createElement(Et, {
        error: e
      }, t);
    } else {
      return t;
    }
  }
};
wt.contextType = Ze;
var Tt = new WeakMap();
function Et({
  children: e,
  error: t
}) {
  let {
    basename: n,
    navigator: r
  } = l.useContext(nt);
  if (typeof t == `object` && t && `digest` in t && typeof t.digest == `string`) {
    let e = lt(t.digest);
    if (e) {
      let i = Tt.get(t);
      if (i) {
        throw i;
      }
      let a = ze(e.location, n);
      let o = a.absoluteURL || a.to;
      We(e.location, o, Ve(r), `allow-explicit`);
      if (Je(o)) {
        throw Error(`Invalid redirect location`);
      }
      if (Re && !Tt.get(t)) {
        if (a.isExternal || e.reloadDocument) {
          window.location.href = o;
        } else {
          let n = Promise.resolve().then(() => window.__reactRouterDataRouter.navigate(a.to, {
            replace: e.replace
          }));
          Tt.set(t, n);
          throw n;
        }
      }
      return l.createElement(`meta`, {
        httpEquiv: `refresh`,
        content: `0;url=${o}`
      });
    }
  }
  return e;
}
function Dt({
  routeContext: e,
  match: t,
  children: n
}) {
  let r = l.useContext(Ye);
  if (r && r.static && r.staticContext && (t.route.errorElement || t.route.ErrorBoundary)) {
    r.staticContext._deepestRenderedBoundaryId = t.route.id;
  }
  return l.createElement(it.Provider, {
    value: e
  }, n);
}
function Ot(e, t = [], n) {
  let r = n?.state;
  if (e == null) {
    if (!r) {
      return null;
    }
    if (r.errors) {
      e = r.matches;
    } else if (t.length === 0 && !r.initialized && r.matches.length > 0) {
      e = r.matches;
    } else {
      return null;
    }
  }
  let i = e;
  let a = r?.errors;
  if (a != null) {
    let e = i.findIndex(e => e.route.id && a?.[e.route.id] !== undefined);
    b(e >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(a).join(`,`)}`);
    i = i.slice(0, Math.min(i.length, e + 1));
  }
  let o = false;
  let s = -1;
  if (n && r) {
    o = r.renderFallback;
    for (let e = 0; e < i.length; e++) {
      let t = i[e];
      if (t.route.HydrateFallback || t.route.hydrateFallbackElement) {
        s = e;
      }
      if (t.route.id) {
        let {
          loaderData: e,
          errors: a
        } = r;
        let c = t.route.loader && !e.hasOwnProperty(t.route.id) && (!a || a[t.route.id] === undefined);
        if (t.route.lazy || c) {
          if (n.isStatic) {
            o = true;
          }
          i = s >= 0 ? i.slice(0, s + 1) : [i[0]];
          break;
        }
      }
    }
  }
  let c = n?.onError;
  let u = r && c ? (e, t) => {
    c(e, {
      location: r.location,
      params: r.matches?.[0]?.params ?? {},
      pattern: Le(r.matches),
      errorInfo: t
    });
  } : undefined;
  return i.reduceRight((e, n, c) => {
    let d;
    let f = false;
    let p = null;
    let m = null;
    if (r) {
      d = a && n.route.id ? a[n.route.id] : undefined;
      p = n.route.errorElement || Ct;
      if (o) {
        if (s < 0 && c === 0) {
          Rt(`route-fallback`, false, "No `HydrateFallback` element provided to render during initial hydration");
          f = true;
          m = null;
        } else if (s === c) {
          f = true;
          m = n.route.hydrateFallbackElement || null;
        }
      }
    }
    let h = t.concat(i.slice(0, c + 1));
    let g = () => {
      let t;
      t = d ? p : f ? m : n.route.Component ? l.createElement(n.route.Component, null) : n.route.element ? n.route.element : e;
      return l.createElement(Dt, {
        match: n,
        routeContext: {
          outlet: e,
          matches: h,
          isDataRoute: r != null
        },
        children: t
      });
    };
    if (r && (n.route.ErrorBoundary || n.route.errorElement || c === 0)) {
      return l.createElement(wt, {
        location: r.location,
        revalidation: r.revalidation,
        component: p,
        error: d,
        children: g(),
        routeContext: {
          outlet: null,
          matches: h,
          isDataRoute: true
        },
        onError: u
      });
    } else {
      return g();
    }
  }, null);
}
function kt(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function At(e) {
  let t = l.useContext(Ye);
  b(t, kt(e));
  return t;
}
function jt(e) {
  let t = l.useContext(Xe);
  b(t, kt(e));
  return t;
}
function Mt(e) {
  let t = l.useContext(it);
  b(t, kt(e));
  return t;
}
function Nt(e) {
  let t = Mt(e);
  let n = t.matches[t.matches.length - 1];
  b(n.route.id, `${e} can only be used on routes that contain a unique "id"`);
  return n.route.id;
}
function Pt() {
  return Nt(`useRouteId`);
}
function Ft() {
  let e = l.useContext(at);
  let t = jt(`useRouteError`);
  let n = Nt(`useRouteError`);
  if (e === undefined) {
    return t.errors?.[n];
  } else {
    return e;
  }
}
function It() {
  let {
    router: e
  } = At(`useNavigate`);
  let t = Nt(`useNavigate`);
  let n = l.useRef(false);
  ht(() => {
    n.current = true;
  });
  return l.useCallback(async (r, i = {}) => {
    x(n.current, mt);
    if (n.current) {
      if (typeof r == `number`) {
        await e.navigate(r);
      } else {
        await e.navigate(r, {
          fromRouteId: t,
          ...i
        });
      }
    }
  }, [e, t]);
}
var Lt = {};
function Rt(e, t, n) {
  if (!t && !Lt[e]) {
    Lt[e] = true;
    x(false, n);
  }
}
l.memo(zt);
function zt({
  routes: e,
  manifest: t,
  future: n,
  state: r,
  isStatic: i,
  onError: a
}) {
  return xt(e, undefined, {
    manifest: t,
    state: r,
    isStatic: i,
    onError: a,
    future: n
  });
}
function Bt({
  to: e,
  replace: t,
  state: n,
  relative: r
}) {
  b(ft(), `<Navigate> may be used only in the context of a <Router> component.`);
  let {
    static: i,
    navigator: a
  } = l.useContext(nt);
  x(!i, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
  let {
    matches: o
  } = l.useContext(it);
  let {
    pathname: s
  } = pt();
  let c = gt();
  let u = Ae(e, ke(o), s, r === `path`);
  We(typeof e == `string` ? e : re(e), a.createHref(u), Ve(a), `reject`);
  let d = JSON.stringify(u);
  l.useEffect(() => {
    c(JSON.parse(d), {
      replace: t,
      state: n,
      relative: r
    });
  }, [c, d, r, t, n]);
  return null;
}
function Vt(e) {
  b(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function Ht({
  basename: e = `/`,
  children: t = null,
  location: n,
  navigationType: r = `POP`,
  navigator: i,
  static: a = false,
  useTransitions: o
}) {
  b(!ft(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
  let s = e.replace(/^\/*/, `/`);
  let c = l.useMemo(() => ({
    basename: s,
    navigator: i,
    static: a,
    useTransitions: o,
    future: {}
  }), [s, i, a, o]);
  if (typeof n == `string`) {
    n = ie(n);
  }
  let {
    pathname: u = `/`,
    search: d = ``,
    hash: f = ``,
    state: p = null,
    key: m = `default`,
    mask: h
  } = n;
  let g = l.useMemo(() => {
    let e = Ee(u, s);
    if (e == null) {
      return null;
    } else {
      return {
        location: {
          pathname: e,
          search: d,
          hash: f,
          state: p,
          key: m,
          mask: h
        },
        navigationType: r
      };
    }
  }, [s, u, d, f, p, m, r, h]);
  x(g != null, `<Router basename="${s}"> is not able to match the URL "${u}${d}${f}" because it does not start with the basename, so the <Router> won't render anything.`);
  if (g == null) {
    return null;
  } else {
    return l.createElement(nt.Provider, {
      value: c
    }, l.createElement(rt.Provider, {
      children: t,
      value: g
    }));
  }
}
function Ut({
  children: e,
  location: t
}) {
  return bt(Wt(e), t);
}
l.Component;
function Wt(e, t = []) {
  let n = [];
  l.Children.forEach(e, (e, r) => {
    if (!l.isValidElement(e)) {
      return;
    }
    let i = [...t, r];
    if (e.type === l.Fragment) {
      n.push.apply(n, Wt(e.props.children, i));
      return;
    }
    b(e.type === Vt, `[${typeof e.type == `string` ? e.type : e.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
    b(!e.props.index || !e.props.children, `An index route cannot have child routes.`);
    let a = {
      id: e.props.id || i.join(`-`),
      caseSensitive: e.props.caseSensitive,
      element: e.props.element,
      Component: e.props.Component,
      index: e.props.index,
      path: e.props.path,
      middleware: e.props.middleware,
      loader: e.props.loader,
      action: e.props.action,
      hydrateFallbackElement: e.props.hydrateFallbackElement,
      HydrateFallback: e.props.HydrateFallback,
      errorElement: e.props.errorElement,
      ErrorBoundary: e.props.ErrorBoundary,
      hasErrorBoundary: e.props.hasErrorBoundary === true || e.props.ErrorBoundary != null || e.props.errorElement != null,
      shouldRevalidate: e.props.shouldRevalidate,
      handle: e.props.handle,
      lazy: e.props.lazy
    };
    if (e.props.children) {
      a.children = Wt(e.props.children, i);
    }
    n.push(a);
  });
  return n;
}
var Gt = `get`;
var Kt = `application/x-www-form-urlencoded`;
function qt(e) {
  return typeof HTMLElement < `u` && e instanceof HTMLElement;
}
function D(e) {
  return qt(e) && e.tagName.toLowerCase() === `button`;
}
function Jt(e) {
  return qt(e) && e.tagName.toLowerCase() === `form`;
}
function Yt(e) {
  return qt(e) && e.tagName.toLowerCase() === `input`;
}
function Xt(e) {
  return !!e.metaKey || !!e.altKey || !!e.ctrlKey || !!e.shiftKey;
}
function Zt(e, t) {
  return e.button === 0 && (!t || t === `_self`) && !Xt(e);
}
function Qt(e = ``) {
  return new URLSearchParams(typeof e == `string` || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce((t, n) => {
    let r = e[n];
    return t.concat(Array.isArray(r) ? r.map(e => [n, e]) : [[n, r]]);
  }, []));
}
function $t(e, t) {
  let n = Qt(e);
  if (t) {
    t.forEach((e, r) => {
      if (!n.has(r)) {
        t.getAll(r).forEach(e => {
          n.append(r, e);
        });
      }
    });
  }
  return n;
}
var en = null;
function tn() {
  if (en === null) {
    try {
      new FormData(document.createElement(`form`), 0);
      en = false;
    } catch {
      en = true;
    }
  }
  return en;
}
var nn = new Set([`application/x-www-form-urlencoded`, `multipart/form-data`, `text/plain`]);
function O(e) {
  if (e != null && !nn.has(e)) {
    x(false, `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${Kt}"`);
    return null;
  } else {
    return e;
  }
}
function rn(e, t) {
  let n;
  let r;
  let i;
  let a;
  let o;
  if (Jt(e)) {
    let o = e.getAttribute(`action`);
    r = o ? Ee(o, t) : null;
    n = e.getAttribute(`method`) || Gt;
    i = O(e.getAttribute(`enctype`)) || Kt;
    a = new FormData(e);
  } else if (D(e) || Yt(e) && (e.type === `submit` || e.type === `image`)) {
    let o = e.form;
    if (o == null) {
      throw Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
    }
    let s = e.getAttribute(`formaction`) || o.getAttribute(`action`);
    r = s ? Ee(s, t) : null;
    n = e.getAttribute(`formmethod`) || o.getAttribute(`method`) || Gt;
    i = O(e.getAttribute(`formenctype`)) || O(o.getAttribute(`enctype`)) || Kt;
    a = new FormData(o, e);
    if (!tn()) {
      let {
        name: t,
        type: n,
        value: r
      } = e;
      if (n === `image`) {
        let e = t ? `${t}.` : ``;
        a.append(`${e}x`, `0`);
        a.append(`${e}y`, `0`);
      } else if (t) {
        a.append(t, r);
      }
    }
  } else if (qt(e)) {
    throw Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
  } else {
    n = Gt;
    r = null;
    i = Kt;
    o = e;
  }
  if (a && i === `text/plain`) {
    o = a;
    a = undefined;
  }
  return {
    action: r,
    method: n.toLowerCase(),
    encType: i,
    formData: a,
    body: o
  };
}
Object.getOwnPropertyNames(Object.prototype).sort().join(`\0`);
function an(e, t) {
  if (e === false || e == null) {
    throw Error(t);
  }
}
function on(e, t, n, r) {
  let i = typeof e == `string` ? new URL(e, typeof window > `u` ? `server://singlefetch/` : window.location.origin) : e;
  i.pathname = n ? i.pathname.endsWith(`/`) ? `${i.pathname}_.${r}` : `${i.pathname}.${r}` : i.pathname === `/` ? `_root.${r}` : t && Ee(i.pathname, t) === `/` ? `${E(t)}/_root.${r}` : `${E(i.pathname)}.${r}`;
  return i;
}
async function sn(e, t) {
  if (e.id in t) {
    return t[e.id];
  }
  try {
    let n = await p(() => import(e.module), []);
    t[e.id] = n;
    return n;
  } catch (t) {
    console.error(`Error loading route module \`${e.module}\`, reloading page...`);
    console.error(t);
    if (window.__reactRouterContext) {
      window.__reactRouterContext.isSpaMode;
    }
    window.location.reload();
    return new Promise(() => {});
  }
}
function cn(e) {
  return e != null && typeof e.page == `string`;
}
function ln(e) {
  if (e == null) {
    return false;
  } else if (e.href == null) {
    return e.rel === `preload` && typeof e.imageSrcSet == `string` && typeof e.imageSizes == `string`;
  } else {
    return typeof e.rel == `string` && typeof e.href == `string`;
  }
}
async function un(e, t, n) {
  return hn((await Promise.all(e.map(async e => {
    let r = t.routes[e.route.id];
    if (r) {
      let e = await sn(r, n);
      if (e.links) {
        return e.links();
      } else {
        return [];
      }
    }
    return [];
  }))).flat(1).filter(ln).filter(e => e.rel === `stylesheet` || e.rel === `preload`).map(e => e.rel === `stylesheet` ? {
    ...e,
    rel: `prefetch`,
    as: `style`
  } : {
    ...e,
    rel: `prefetch`
  }));
}
function dn(e, t, n, r, i, a) {
  let o = (e, t) => !n[t] || e.route.id !== n[t].route.id;
  let s = (e, t) => n[t].pathname !== e.pathname || n[t].route.path?.endsWith(`*`) && n[t].params[`*`] !== e.params[`*`];
  if (a === `assets`) {
    return t.filter((e, t) => o(e, t) || s(e, t));
  } else if (a === `data`) {
    return t.filter((t, a) => {
      let c = r.routes[t.route.id];
      if (!c || !c.hasLoader) {
        return false;
      }
      if (o(t, a) || s(t, a)) {
        return true;
      }
      if (t.route.shouldRevalidate) {
        let r = t.route.shouldRevalidate({
          currentUrl: new URL(i.pathname + i.search + i.hash, window.origin),
          currentParams: n[0]?.params || {},
          nextUrl: new URL(e, window.origin),
          nextParams: t.params,
          defaultShouldRevalidate: true
        });
        if (typeof r == `boolean`) {
          return r;
        }
      }
      return true;
    });
  } else {
    return [];
  }
}
function fn(e, t, {
  includeHydrateFallback: n
} = {}) {
  return pn(e.map(e => {
    let r = t.routes[e.route.id];
    if (!r) {
      return [];
    }
    let i = [r.module];
    if (r.clientActionModule) {
      i = i.concat(r.clientActionModule);
    }
    if (r.clientLoaderModule) {
      i = i.concat(r.clientLoaderModule);
    }
    if (n && r.hydrateFallbackModule) {
      i = i.concat(r.hydrateFallbackModule);
    }
    if (r.imports) {
      i = i.concat(r.imports);
    }
    return i;
  }).flat(1));
}
function pn(e) {
  return [...new Set(e)];
}
function mn(e) {
  let t = {};
  let n = Object.keys(e).sort();
  for (let r of n) {
    t[r] = e[r];
  }
  return t;
}
function hn(e, t) {
  let n = new Set();
  let r = new Set(t);
  return e.reduce((e, i) => {
    if (t && !cn(i) && i.as === `script` && i.href && r.has(i.href)) {
      return e;
    }
    let a = JSON.stringify(mn(i));
    if (!n.has(a)) {
      n.add(a);
      e.push({
        key: a,
        link: i
      });
    }
    return e;
  }, []);
}
function gn() {
  let e = l.useContext(Ye);
  an(e, `You must render this element inside a <DataRouterContext.Provider> element`);
  return e;
}
function _n() {
  let e = l.useContext(Xe);
  an(e, `You must render this element inside a <DataRouterStateContext.Provider> element`);
  return e;
}
var vn = l.createContext(undefined);
vn.displayName = `FrameworkContext`;
function yn() {
  let e = l.useContext(vn);
  an(e, `You must render this element inside a <HydratedRouter> element`);
  return e;
}
function bn(e, t) {
  let n = l.useContext(vn);
  let [r, i] = l.useState(false);
  let [a, o] = l.useState(false);
  let {
    onFocus: s,
    onBlur: c,
    onMouseEnter: u,
    onMouseLeave: d,
    onTouchStart: f
  } = t;
  let p = l.useRef(null);
  l.useEffect(() => {
    if (e === `render`) {
      o(true);
    }
    if (e === `viewport`) {
      let e = new IntersectionObserver(e => {
        e.forEach(e => {
          o(e.isIntersecting);
        });
      }, {
        threshold: 0.5
      });
      if (p.current) {
        e.observe(p.current);
      }
      return () => {
        e.disconnect();
      };
    }
  }, [e]);
  l.useEffect(() => {
    if (r) {
      let e = setTimeout(() => {
        o(true);
      }, 100);
      return () => {
        clearTimeout(e);
      };
    }
  }, [r]);
  let m = () => {
    i(true);
  };
  let h = () => {
    i(false);
    o(false);
  };
  if (n) {
    if (e === `intent`) {
      return [a, p, {
        onFocus: xn(s, m),
        onBlur: xn(c, h),
        onMouseEnter: xn(u, m),
        onMouseLeave: xn(d, h),
        onTouchStart: xn(f, m)
      }];
    } else {
      return [a, p, {}];
    }
  } else {
    return [false, p, {}];
  }
}
function xn(e, t) {
  return n => {
    if (e) {
      e(n);
    }
    if (!n.defaultPrevented) {
      t(n);
    }
  };
}
function Sn({
  page: e,
  ...t
}) {
  let n = Qe();
  let {
    nonce: r
  } = yn();
  let {
    router: i
  } = gn();
  let a = l.useMemo(() => oe(i.routes, e, i.basename), [i.routes, e, i.basename]);
  if (a) {
    if (t.nonce == null && r) {
      t = {
        ...t,
        nonce: r
      };
    }
    if (n) {
      return l.createElement(wn, {
        page: e,
        matches: a,
        ...t
      });
    } else {
      return l.createElement(Tn, {
        page: e,
        matches: a,
        ...t
      });
    }
  } else {
    return null;
  }
}
function Cn(e) {
  let {
    manifest: t,
    routeModules: n
  } = yn();
  let [r, i] = l.useState([]);
  l.useEffect(() => {
    let r = false;
    un(e, t, n).then(e => {
      if (!r) {
        i(e);
      }
    });
    return () => {
      r = true;
    };
  }, [e, t, n]);
  return r;
}
function wn({
  page: e,
  matches: t,
  ...n
}) {
  let r = pt();
  let {
    future: i
  } = yn();
  let {
    basename: a
  } = gn();
  let o = l.useMemo(() => {
    if (e === r.pathname + r.search + r.hash) {
      return [];
    }
    let n = on(e, a, i.v8_trailingSlashAwareDataRequests, `rsc`);
    let o = false;
    let s = [];
    for (let e of t) {
      if (typeof e.route.shouldRevalidate == `function`) {
        o = true;
      } else {
        s.push(e.route.id);
      }
    }
    if (o && s.length > 0) {
      n.searchParams.set(`_routes`, s.join(`,`));
    }
    return [n.pathname + n.search];
  }, [a, i.v8_trailingSlashAwareDataRequests, e, r, t]);
  return l.createElement(l.Fragment, null, o.map(e => l.createElement(`link`, {
    key: e,
    rel: `prefetch`,
    as: `fetch`,
    href: e,
    ...n
  })));
}
function Tn({
  page: e,
  matches: t,
  ...n
}) {
  let r = pt();
  let {
    future: i,
    manifest: a,
    routeModules: o
  } = yn();
  let {
    basename: s
  } = gn();
  let {
    loaderData: c,
    matches: u
  } = _n();
  let d = l.useMemo(() => dn(e, t, u, a, r, `data`), [e, t, u, a, r]);
  let f = l.useMemo(() => dn(e, t, u, a, r, `assets`), [e, t, u, a, r]);
  let p = l.useMemo(() => {
    if (e === r.pathname + r.search + r.hash) {
      return [];
    }
    let n = new Set();
    let l = false;
    t.forEach(e => {
      let t = a.routes[e.route.id];
      if (t && t.hasLoader) {
        if (!d.some(t => t.route.id === e.route.id) && e.route.id in c && o[e.route.id]?.shouldRevalidate || t.hasClientLoader) {
          l = true;
        } else {
          n.add(e.route.id);
        }
      }
    });
    if (n.size === 0) {
      return [];
    }
    let u = on(e, s, i.v8_trailingSlashAwareDataRequests, `data`);
    if (l && n.size > 0) {
      u.searchParams.set(`_routes`, t.filter(e => n.has(e.route.id)).map(e => e.route.id).join(`,`));
    }
    return [u.pathname + u.search];
  }, [s, i.v8_trailingSlashAwareDataRequests, c, r, a, d, t, e, o]);
  let m = l.useMemo(() => fn(f, a), [f, a]);
  let h = Cn(f);
  return l.createElement(l.Fragment, null, p.map(e => l.createElement(`link`, {
    key: e,
    rel: `prefetch`,
    as: `fetch`,
    href: e,
    ...n
  })), m.map(e => l.createElement(`link`, {
    key: e,
    rel: `modulepreload`,
    href: e,
    ...n
  })), h.map(({
    key: e,
    link: t
  }) => l.createElement(`link`, {
    key: e,
    nonce: n.nonce,
    ...t,
    crossOrigin: t.crossOrigin ?? n.crossOrigin
  })));
}
function En(...e) {
  return t => {
    e.forEach(e => {
      if (typeof e == `function`) {
        e(t);
      } else if (e != null) {
        e.current = t;
      }
    });
  };
}
l.Component;
var Dn = typeof window < `u` && window.document !== undefined && window.document.createElement !== undefined;
try {
  if (Dn) {
    window.__reactRouterVersion = `7.18.4`;
  }
} catch {}
function On({
  basename: e,
  children: t,
  useTransitions: n,
  window: r
}) {
  let i = l.useRef();
  i.current ??= y({
    window: r,
    v5Compat: true
  });
  let a = i.current;
  let [o, s] = l.useState({
    action: a.action,
    location: a.location
  });
  let c = l.useCallback(e => {
    if (n === false) {
      s(e);
    } else {
      l.startTransition(() => s(e));
    }
  }, [n]);
  l.useLayoutEffect(() => a.listen(c), [a, c]);
  return l.createElement(Ht, {
    basename: e,
    children: t,
    location: o.location,
    navigationType: o.action,
    navigator: a,
    useTransitions: n
  });
}
var kn = l.forwardRef(function ({
  onClick: e,
  discover: t = `render`,
  prefetch: n = `none`,
  relative: r,
  reloadDocument: i,
  replace: a,
  mask: o,
  state: s,
  target: c,
  to: u,
  preventScrollReset: d,
  viewTransition: f,
  defaultShouldRevalidate: p,
  ...h
}, g) {
  let {
    basename: _,
    navigator: v,
    useTransitions: y
  } = l.useContext(nt);
  let b = typeof u == `string` && m.test(u);
  let x = ze(u, _);
  u = x.to;
  let ee = dt(u, {
    relative: r
  });
  let te = pt();
  let ne = null;
  if (o) {
    let e = Ae(o, [], te.mask ? te.mask.pathname : `/`, true);
    if (_ !== `/`) {
      e.pathname = e.pathname === `/` ? _ : T([_, e.pathname]);
    }
    ne = v.createHref(e);
  }
  let [re, ie, S] = bn(n, h);
  let ae = Pn(u, {
    replace: a,
    mask: o,
    state: s,
    target: c,
    preventScrollReset: d,
    relative: r,
    viewTransition: f,
    defaultShouldRevalidate: p,
    useTransitions: y
  });
  function oe(t) {
    if (e) {
      e(t);
    }
    if (!t.defaultPrevented) {
      ae(t);
    }
  }
  let se = !x.isExternal && !i;
  let ce = l.createElement(`a`, {
    ...h,
    ...S,
    href: (se ? ne : undefined) || x.absoluteURL || ee,
    onClick: se ? oe : e,
    ref: En(g, ie),
    target: c,
    "data-discover": !b && t === `render` ? `true` : undefined
  });
  if (re && !b) {
    return l.createElement(l.Fragment, null, ce, l.createElement(Sn, {
      page: ee
    }));
  } else {
    return ce;
  }
});
kn.displayName = `Link`;
var An = l.forwardRef(function ({
  "aria-current": e = `page`,
  caseSensitive: t = false,
  className: n = ``,
  end: r = false,
  style: i,
  to: a,
  viewTransition: o,
  children: s,
  ...c
}, u) {
  let d = yt(a, {
    relative: c.relative
  });
  let f = pt();
  let p = l.useContext(Xe);
  let {
    navigator: m,
    basename: h
  } = l.useContext(nt);
  let g = p != null && Bn(d) && o === true;
  let _ = m.encodeLocation ? m.encodeLocation(d).pathname : d.pathname;
  let v = f.pathname;
  let y = p && p.navigation && p.navigation.location ? p.navigation.location.pathname : null;
  if (!t) {
    v = v.toLowerCase();
    y = y ? y.toLowerCase() : null;
    _ = _.toLowerCase();
  }
  if (y && h) {
    y = Ee(y, h) || y;
  }
  let b = _ !== `/` && _.endsWith(`/`) ? _.length - 1 : _.length;
  let x = v === _ || !r && v.startsWith(_) && v.charAt(b) === `/`;
  let ee = y != null && (y === _ || !r && y.startsWith(_) && y.charAt(_.length) === `/`);
  let te = {
    isActive: x,
    isPending: ee,
    isTransitioning: g
  };
  let ne = x ? e : undefined;
  let re;
  re = typeof n == `function` ? n(te) : [n, x ? `active` : null, ee ? `pending` : null, g ? `transitioning` : null].filter(Boolean).join(` `);
  let ie = typeof i == `function` ? i(te) : i;
  return l.createElement(kn, {
    ...c,
    "aria-current": ne,
    className: re,
    ref: u,
    style: ie,
    to: a,
    viewTransition: o
  }, typeof s == `function` ? s(te) : s);
});
An.displayName = `NavLink`;
var jn = l.forwardRef(({
  discover: e = `render`,
  fetcherKey: t,
  navigate: n,
  reloadDocument: r,
  replace: i,
  state: a,
  method: o = Gt,
  action: s,
  onSubmit: c,
  relative: u,
  preventScrollReset: d,
  viewTransition: f,
  defaultShouldRevalidate: p,
  ...h
}, g) => {
  let {
    useTransitions: _
  } = l.useContext(nt);
  let v = Rn();
  let y = zn(s, {
    relative: u
  });
  let b = o.toLowerCase() === `get` ? `get` : `post`;
  let x = typeof s == `string` && m.test(s);
  return l.createElement(`form`, {
    ref: g,
    method: b,
    action: y,
    onSubmit: r ? c : e => {
      if (c) {
        c(e);
      }
      if (e.defaultPrevented) {
        return;
      }
      e.preventDefault();
      let r = e.nativeEvent.submitter;
      let s = r?.getAttribute(`formmethod`) || o;
      let m = () => v(r || e.currentTarget, {
        fetcherKey: t,
        method: s,
        navigate: n,
        replace: i,
        state: a,
        relative: u,
        preventScrollReset: d,
        viewTransition: f,
        defaultShouldRevalidate: p
      });
      if (_ && n !== false) {
        l.startTransition(() => m());
      } else {
        m();
      }
    },
    ...h,
    "data-discover": !x && e === `render` ? `true` : undefined
  });
});
jn.displayName = `Form`;
function Mn(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function Nn(e) {
  let t = l.useContext(Ye);
  b(t, Mn(e));
  return t;
}
function Pn(e, {
  target: t,
  replace: n,
  mask: r,
  state: i,
  preventScrollReset: a,
  relative: o,
  viewTransition: s,
  defaultShouldRevalidate: c,
  useTransitions: u
} = {}) {
  let d = gt();
  let f = pt();
  let p = yt(e, {
    relative: o
  });
  return l.useCallback(m => {
    if (Zt(m, t)) {
      m.preventDefault();
      let t = n === undefined ? re(f) === re(p) : n;
      let h = () => d(e, {
        replace: t,
        mask: r,
        state: i,
        preventScrollReset: a,
        relative: o,
        viewTransition: s,
        defaultShouldRevalidate: c
      });
      if (u) {
        l.startTransition(() => h());
      } else {
        h();
      }
    }
  }, [f, d, p, n, r, i, t, e, a, o, s, c, u]);
}
function Fn(e) {
  x(typeof URLSearchParams < `u`, "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
  let t = l.useRef(Qt(e));
  let n = l.useRef(false);
  let r = pt();
  let i = l.useMemo(() => $t(r.search, n.current ? null : t.current), [r.search]);
  let a = gt();
  return [i, l.useCallback((e, t) => {
    let r = Qt(typeof e == `function` ? e(new URLSearchParams(i)) : e);
    n.current = true;
    a(`?${r}`, t);
  }, [a, i])];
}
var In = 0;
var Ln = () => `__${String(++In)}__`;
function Rn() {
  let {
    router: e
  } = Nn(`useSubmit`);
  let {
    basename: t
  } = l.useContext(nt);
  let n = Pt();
  let r = e.fetch;
  let i = e.navigate;
  return l.useCallback(async (e, a = {}) => {
    let {
      action: o,
      method: s,
      encType: c,
      formData: l,
      body: u
    } = rn(e, t);
    if (a.navigate === false) {
      let e = a.fetcherKey || Ln();
      await r(e, n, a.action || o, {
        defaultShouldRevalidate: a.defaultShouldRevalidate,
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: u,
        formMethod: a.method || s,
        formEncType: a.encType || c,
        flushSync: a.flushSync
      });
    } else {
      await i(a.action || o, {
        defaultShouldRevalidate: a.defaultShouldRevalidate,
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: u,
        formMethod: a.method || s,
        formEncType: a.encType || c,
        replace: a.replace,
        state: a.state,
        fromRouteId: n,
        flushSync: a.flushSync,
        viewTransition: a.viewTransition
      });
    }
  }, [r, i, t, n]);
}
function zn(e, {
  relative: t
} = {}) {
  let {
    basename: n
  } = l.useContext(nt);
  let r = l.useContext(it);
  b(r, `useFormAction must be used inside a RouteContext`);
  let [i] = r.matches.slice(-1);
  let a = {
    ...yt(e || `.`, {
      relative: t
    })
  };
  let o = pt();
  if (e == null) {
    a.search = o.search;
    let e = new URLSearchParams(a.search);
    let t = e.getAll(`index`);
    if (t.some(e => e === ``)) {
      e.delete(`index`);
      t.filter(e => e).forEach(t => e.append(`index`, t));
      let n = e.toString();
      a.search = n ? `?${n}` : ``;
    }
  }
  if ((!e || e === `.`) && i.route.index) {
    a.search = a.search ? a.search.replace(/^\?/, `?index&`) : `?index`;
  }
  if (n !== `/`) {
    a.pathname = a.pathname === `/` ? n : T([n, a.pathname]);
  }
  return re(a);
}
function Bn(e, {
  relative: t
} = {}) {
  let n = l.useContext($e);
  b(n != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
  let {
    basename: r
  } = Nn(`useViewTransitionState`);
  let i = yt(e, {
    relative: t
  });
  if (!n.isTransitioning) {
    return false;
  }
  let a = Ee(n.currentLocation.pathname, r) || n.currentLocation.pathname;
  let o = Ee(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return Se(i.pathname, o) != null || Se(i.pathname, a) != null;
}
export { Vt as a, gt as c, c as d, o as f, Bt as i, vt as l, kn as n, Ut as o, An as r, pt as s, On as t, Fn as u };